var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import logoIcon from "./assets/league-logo-icon.svg";
import benefitListDefaultIcon from "././assets/benefit_list_default.svg";
import listEmptyIcon from "././assets/list-empty.svg";
import webIcon from "././assets/web-icon.svg";
import androidIcon from "././assets/android-icon.svg";
import iosIcon from "././assets/ios-icon.svg";
import safariIcon from "././assets/safari-icon.svg";
import chromeIcon from "././assets/chrome-icon.svg";
import firefoxIcon from "././assets/firefox-icon.svg";
import requiredIcon from "././assets/required-icon.svg";
import dividerIcon from "././assets/divider-icon.svg";
import rewardPointIcon from "././assets/reward-program-points.svg";
import healthMetricIcon from "././assets/health-metric.svg";
import activityPinIcon from "././assets/activity-pin-icon.svg";
import copyIcon from "././assets/icon-copy.svg";
var CUSTOMER_SUPPORT_ASSETS_MAP = {
  LOGO_ICON: logoIcon,
  BENEFIT_LIST_DEFAULT_ICON: benefitListDefaultIcon,
  EMPTY_ICON: listEmptyIcon,
  WEB_ICON: webIcon,
  ANDROID_ICON: androidIcon,
  IOS_ICON: iosIcon,
  SAFARI_ICON: safariIcon,
  CHROME_ICON: chromeIcon,
  FIREFOX_ICON: firefoxIcon,
  REQUIRED_ICON: requiredIcon,
  DIVIDER_ICON: dividerIcon,
  REWARD_POINT_ICON: rewardPointIcon,
  HEALTH_METRIC_ICON: healthMetricIcon,
  ACTIVITY_PIN_ICON: activityPinIcon,
  ICON_COPY: copyIcon
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CUSTOMER_SUPPORT_ASSETS_MAP);
};

// src/components/page-layout/page-layout.component.tsx
import { StackLayout as StackLayout4, Divider as Divider2, Box as Box4 } from "@leagueplatform/genesis-core";

// src/components/page-layout/components/page-navigation/page-navigation.component.tsx
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { Box as Box2, Divider, Icon, StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { Link as Link2 } from "react-router-dom";

// src/config/customer-support.config.ts
import {
  useUnknownConfigProperty
} from "@leagueplatform/config";

// src/config/utils/get-normalized-config-value.util.ts
function getNormalizedConfigValue(config, path) {
  const keys = `${path}`.split(".");
  const finalValue = keys.reduce((current, key) => {
    if (typeof current !== "object" || current === null) {
      return void 0;
    }
    return current[key];
  }, config);
  const enableParam = keys[0];
  if (typeof config[enableParam] === "boolean") {
    return config[enableParam];
  }
  return finalValue;
}

// src/config/customer-support.config.ts
var defaultConfig = {
  faqLink: "https://help.league.com/",
  enableMemberOverview: true,
  enableActivityOverride: false,
  enableWalletInquiry: false,
  enableClaimsInquiry: false,
  enableAssessmentsAndDashboards: false,
  enablePageHeaderBanner: false,
  enableBiometricsV2: false,
  enableJourneyInquiry: false,
  claimsInquiry: {
    featureFlags: {
      shouldShowClaimDetails: false,
      shouldShowDownloadClaims: false,
      shouldShowFilterChips: false
    },
    filterableProperties: {
      status: [
        "pending",
        "approved",
        "partially_paid",
        "not_covered",
        "adjusted"
      ]
    },
    showClaimStatusDefinitions: true,
    showTotalCostOverviewAndAdditionalResources: true
  },
  impersonation: {
    enableImpersonateButton: false
  }
};
function useCustomerSupportConfig(path) {
  const config = useUnknownConfigProperty("customerSupport", defaultConfig);
  if (path) {
    return getNormalizedConfigValue(config, path);
  }
  return config;
}

// src/utils/base-path.util.ts
import { createContext, useContext } from "react";

// src/constants/customer-support.constants.ts
var CUSTOMER_SUPPORT_PAGES = {
  OVERVIEW: "overview",
  WALLET: "wallet",
  CLAIMS: "claims",
  JOURNEY: "journey",
  REWARDS_PROGRAMS: "rewards-programs",
  CHALLENGES: "challenges",
  STANDARD_PROGRAMS: "standard-programs",
  ASSESSMENTS_AND_DASHBOARDS: "assessments-and-dashboards"
};
var CUSTOMER_SUPPORT_ROUTES = {
  customerSupportOverview: CUSTOMER_SUPPORT_PAGES.OVERVIEW,
  customerSupportAssessmentsAndDashboards: `${CUSTOMER_SUPPORT_PAGES.ASSESSMENTS_AND_DASHBOARDS}`,
  customerSupportWallet: `${CUSTOMER_SUPPORT_PAGES.WALLET}`,
  customerSupportClaims: `${CUSTOMER_SUPPORT_PAGES.CLAIMS}`,
  customerSupportJourney: `${CUSTOMER_SUPPORT_PAGES.JOURNEY}`
};
var CUSTOMER_SUPPORT_SUB_ROUTES = {
  customerSupportBiometricDetails: `${CUSTOMER_SUPPORT_PAGES.ASSESSMENTS_AND_DASHBOARDS}/:biometricType`,
  customerSupportWalletDetails: `${CUSTOMER_SUPPORT_PAGES.WALLET}/:benefitId`,
  customerSupportClaimDetails: `${CUSTOMER_SUPPORT_PAGES.CLAIMS}/:claimId`,
  customerSupportJourneyDetails: `:page/:subPage`,
  customerSupportRewardDetails: `${CUSTOMER_SUPPORT_PAGES.JOURNEY}/${CUSTOMER_SUPPORT_PAGES.REWARDS_PROGRAMS}/:rewardId`,
  customerSupportStandardDetails: `${CUSTOMER_SUPPORT_PAGES.JOURNEY}/${CUSTOMER_SUPPORT_PAGES.STANDARD_PROGRAMS}/:programId/:userProgramId`,
  customerSupportChallengesDetails: `${CUSTOMER_SUPPORT_PAGES.JOURNEY}/${CUSTOMER_SUPPORT_PAGES.CHALLENGES}/:challengeId/:userChallengeId`,
  customerSupportDefault: `:page`
};
var CUSTOMER_SUPPORT_JOURNEY_ROUTES = {
  customerSupportRewardsPrograms: `${CUSTOMER_SUPPORT_PAGES.REWARDS_PROGRAMS}`,
  customerSupportChallenges: `${CUSTOMER_SUPPORT_PAGES.CHALLENGES}`,
  customerSupportStandardPrograms: `${CUSTOMER_SUPPORT_PAGES.STANDARD_PROGRAMS}`
};
var CS_TOKEN_CLAIM_KEY = {
  CS_TOKEN_CLAIM_KEY_MEMBER_ID: "https://el/latest_member_league_user_id",
  CS_TOKEN_CLAIM_KEY_AGENT_ID: "https://el/user_id",
  CS_TOKEN_CLAIM_KEY_MEMBER_USERNAME: "https://el/latest_member_username",
  CS_TOKEN_CLAIM_KEY_ECID: "https://el/member_ecid"
};
var CUSTOMER_SUPPORT_PAGE_PERMISSIONS = {
  OVERVIEW: [
    "customer_apps:read" /* CUSTOMER_APPS */,
    "user_sessions:read" /* USER_SESSIONS */
  ],
  WALLET: ["wallet:read" /* WALLET */],
  CLAIMS: ["claims:read" /* CLAIMS */],
  JOURNEY: ["journey:read" /* JOURNEY */],
  ASSESSMENTS_AND_DASHBOARDS: [
    "dqm:read" /* CONSENT_FORMS */,
    "dqm:read" /* HEALTH_RISK_ASSESSMENTS */,
    "health_profile:read" /* HEALTH_PROFILE */
  ],
  REWARDS_PROGRAMS: ["journey:read" /* JOURNEY */],
  CHALLENGES: ["journey:read" /* JOURNEY */],
  STANDARD_PROGRAMS: ["journey:read" /* JOURNEY */]
};
var VIEW_MORE_SESSIONS = {
  USER_SESSIONS_INITIAL_RECENT_SESSIONS: 5,
  JOURNEY_PROGRAM_INITIAL_RECENT_SESSIONS: 10
};
var CHALLENGE_PROGRESS_BAR = {
  CHALLENGE_PROGRESS_BAR_TOTAL: 100,
  CHALLENGE_PROGRESS_KEY: "challenge-progress"
};
var MODAL_POPOUT_WIDTH = 62;
var BIOMETRIC_API_FILTERS = {
  ALL: "all",
  INSTANT: "instant",
  DISPLAY_NUMBER: 40
};
var BIOMETRIC_TYPE = {
  WAIST_CIRCUMFERENCE: "waist_circumference",
  BMI: "bmi",
  BLOOD_PRESSURE: "blood_pressure",
  TOTAL_CHOLESTEROL: "total_cholesterol",
  TRIGLYCERIDES: "triglycerides",
  CHOLESTEROL_HDL: "cholesterol_HDL",
  CHOLESTEROL_LDL: "cholesterol_LDL",
  FASTING_BLOOD_GLUCOSE: "fasting_blood_glucose",
  NON_FASTING_BLOOD_GLUCOSE: "non_fasting_blood_glucose"
};
var MASONRY = {
  API_VERSION: 2,
  HEADER_CONTAINER_APP_ID: "cse_header",
  MODULE_KEY_CSE: "cse",
  CUSTOM_WIDGET_TYPE_BANNER: "cse_header_banner"
};
var PROGRAM_TYPES = {
  REWARD: "reward",
  STANDARD: "standard"
};
var ACTION_OVERRIDE_TYPES = {
  SHOW_DATE_PICKER: "showDatePicker",
  STATUS_UPDATED: "statusUpdated",
  POINTS_ONLY_UPDATED: "pointsOnly",
  COMPLETED_BY_BULK_OVERRIDE: "task-completed-by-bulk-override-process"
};
var BIOMETRIC_PAGINATION_NUMBERS = {
  TEN_ENTRIES: 10,
  TWENTY_ENTRIES: 20,
  THIRTY_ENTRIES: 30,
  FORTY_ENTRIES: 40
};

// src/utils/base-path.util.ts
var BasePathContext = createContext(void 0);
var BasePathProvider = BasePathContext.Provider;
var useBasePath = () => {
  const basePath = useContext(BasePathContext);
  return basePath != null ? basePath : "";
};
var KNOWN_ROUTE_SEGMENTS = Object.values(CUSTOMER_SUPPORT_PAGES);
function isSegmentBoundary(pathname, matchEnd) {
  return matchEnd === pathname.length || pathname[matchEnd] === "/";
}
function inferBasePath(pathname) {
  const matches = KNOWN_ROUTE_SEGMENTS.reduce(
    (acc, segment) => {
      const segmentPattern = `/${segment}`;
      const index = pathname.indexOf(segmentPattern);
      if (index !== -1 && isSegmentBoundary(pathname, index + segmentPattern.length)) {
        acc.push({ index });
      }
      return acc;
    },
    []
  );
  if (matches.length > 0) {
    const firstMatch = matches.sort((a, b) => a.index - b.index)[0];
    return pathname.substring(0, firstMatch.index) || "";
  }
  const trimmedPath = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  return trimmedPath === "/" ? "" : trimmedPath;
}

// src/components/page-layout/components/page-navigation/page-navigation-links.component.tsx
import React2 from "react";
import { Box, UtilityText, TextAction } from "@leagueplatform/genesis-core";
import { NavLink } from "react-router-dom";
import { useIntl } from "@leagueplatform/locales";

// src/hooks/use-analytic-dynamic-name.hook.ts
import { matchPath, useLocation } from "@leagueplatform/routing";
function getAnalyticsDynamicName(pathname) {
  if (pathname.endsWith(CUSTOMER_SUPPORT_ROUTES.customerSupportOverview)) {
    return {
      sub_product_area: "member overview" /* MEMBER_OVERVIEW */
    };
  }
  if (pathname.endsWith(
    CUSTOMER_SUPPORT_ROUTES.customerSupportAssessmentsAndDashboards
  )) {
    return {
      sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */
    };
  }
  if (pathname.endsWith(CUSTOMER_SUPPORT_ROUTES.customerSupportWallet)) {
    return {
      sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
      screen_name: "benefit summary" /* BENEFIT_SUMMARY */
    };
  }
  if (pathname.endsWith(CUSTOMER_SUPPORT_ROUTES.customerSupportClaims)) {
    return {
      sub_product_area: "claims" /* CLAIMS_PAGE */,
      screen_name: "claims summary" /* CLAIMS_SUMMARY */
    };
  }
  if (pathname.endsWith(
    CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportRewardsPrograms
  )) {
    return {
      sub_product_area: "journey" /* JOURNEY */,
      screen_name: "reward program summary" /* REWARD_SUMMARY */
    };
  }
  if (pathname.endsWith(CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportChallenges)) {
    return {
      sub_product_area: "journey" /* JOURNEY */,
      screen_name: "challenges summary" /* CHALLENGES_SUMMARY */
    };
  }
  if (pathname.endsWith(
    CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportStandardPrograms
  )) {
    return {
      sub_product_area: "journey" /* JOURNEY */,
      screen_name: "standard program summary" /* STANDARD_PROGRAM_SUMMARY */
    };
  }
  const pathPatterns = [
    {
      pattern: CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportWalletDetails,
      analytics: {
        sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
        screen_name: "benefit detail" /* BENEFIT_DETAIL */
      }
    },
    {
      pattern: CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportClaimDetails,
      analytics: {
        sub_product_area: "claims" /* CLAIMS_PAGE */,
        screen_name: "claims detail" /* CLAIMS_DETAIL */
      }
    },
    {
      pattern: CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportRewardDetails,
      analytics: {
        sub_product_area: "journey" /* JOURNEY */,
        screen_name: "reward program detail" /* REWARD_DETAIL */
      }
    },
    {
      pattern: CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportChallengesDetails,
      analytics: {
        sub_product_area: "journey" /* JOURNEY */,
        screen_name: "challenges detail" /* CHALLENGES_DETAIL */
      }
    },
    {
      pattern: CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportStandardDetails,
      analytics: {
        sub_product_area: "journey" /* JOURNEY */,
        screen_name: "standard program detail" /* STANDARD_PROGRAM_DETAIL */
      }
    }
  ];
  const matchedPattern = pathPatterns.find(({ pattern }) => {
    const normalizedPattern = pattern.startsWith("/") ? pattern : `/${pattern}`;
    const normalizedPathname = (pathname == null ? void 0 : pathname.startsWith("/")) ? pathname : `/${pathname}`;
    return matchPath(normalizedPattern, normalizedPathname);
  });
  if (matchedPattern) {
    return matchedPattern.analytics;
  }
  return null;
}
function useAnalyticsDynamicName() {
  const { pathname } = useLocation();
  return getAnalyticsDynamicName(pathname);
}

// src/components/page-layout/components/page-navigation/page-navigation-links.component.tsx
import { EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";

// src/hooks/use-track-analytics-event.hook.ts
import React from "react";
import { trackAnalyticsEvent } from "@leagueplatform/analytics";
var useTrackAnalyticsEvent = (partialParams) => React.useCallback(
  (eventName, props) => {
    trackAnalyticsEvent(eventName, __spreadValues(__spreadValues({
      product_area: "customer support" /* CUSTOMER_SUPPORT */
    }, partialParams), props));
  },
  [partialParams]
);

// src/components/page-layout/components/page-navigation/page-navigation-links.component.tsx
import { jsx } from "react/jsx-runtime";
function PageNavigationLink({
  goTo,
  title,
  icon,
  isExternal
}) {
  const { formatMessage } = useIntl();
  const attributes = isExternal ? { href: goTo, target: "_blank", rel: "noopener noreferrer" } : { to: goTo };
  const analyticsDetail = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({
    detail: isExternal ? "faq link out" /* FAQ_LINK */ : "member link" /* MEMBER_LINK */
  }, analyticsDetail));
  const sendButtonClickedAnalyticsEvent = React2.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME2.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "li",
      css: {
        width: "100%",
        padding: "$quarter 0",
        position: "relative"
      },
      children: /* @__PURE__ */ jsx(
        TextAction,
        __spreadProps(__spreadValues({}, attributes), {
          onClick: sendButtonClickedAnalyticsEvent,
          as: isExternal ? "a" : NavLink,
          css: {
            alignItems: "center",
            textDecoration: "none",
            padding: "$half $one",
            width: "100%",
            "&:hover": {
              backgroundColor: "$inputBackgroundHovered",
              textDecoration: "none"
            },
            "&:active, &:active p, &:active svg": {
              color: "$interactiveActionPrimary"
            },
            '&[aria-current="page"]::before': {
              content: "",
              width: "$quarter",
              height: "100%",
              position: "absolute",
              left: "0",
              top: "0",
              backgroundColor: "$interactiveActionPrimary",
              borderRadius: "$quarter"
            },
            '&[aria-current="page"] p, &[aria-current="page"] svg': {
              color: "$interactiveActionPrimary"
            },
            "& svg": {
              marginRight: "$threeQuarters",
              color: "$onSurfaceTextSubdued"
            }
          },
          icon,
          children: /* @__PURE__ */ jsx(
            UtilityText,
            {
              size: "base",
              emphasis: "emphasized",
              as: "p",
              css: {
                color: "$onSurfaceTextSubdued",
                padding: "$quarter"
              },
              children: formatMessage({ id: title })
            }
          )
        })
      )
    }
  );
}

// src/components/page-layout/components/page-navigation/page-navigation-sign-out.component.tsx
import React3 from "react";
import {
  StackLayout,
  TextAction as TextAction2,
  HeadingText,
  VisuallyHidden
} from "@leagueplatform/genesis-core";
import {
  LoadingIndicator,
  ErrorState
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { Link } from "react-router-dom";
import { EVENT_NAME as EVENT_NAME3 } from "@leagueplatform/analytics";

// src/hooks/use-customer-support-token-data.hook.ts
import { isProduction } from "@leagueplatform/core";
import { captureError } from "@leagueplatform/observability";
import { StandaloneAuth } from "@leagueplatform/auth-standalone";
import { useQuery } from "@tanstack/react-query";
var {
  CS_TOKEN_CLAIM_KEY_MEMBER_ID,
  CS_TOKEN_CLAIM_KEY_AGENT_ID,
  CS_TOKEN_CLAIM_KEY_MEMBER_USERNAME,
  CS_TOKEN_CLAIM_KEY_ECID
} = CS_TOKEN_CLAIM_KEY;
function getCustomerSupportTokenData() {
  return __async(this, null, function* () {
    const data = yield StandaloneAuth.client.getIdTokenClaims();
    const targetUserId = data == null ? void 0 : data[CS_TOKEN_CLAIM_KEY_MEMBER_ID];
    if (!data || isProduction() && targetUserId === "") {
      throw new Error("Missing target user ID");
    }
    return {
      targetUserId: data[CS_TOKEN_CLAIM_KEY_MEMBER_ID],
      agentId: data[CS_TOKEN_CLAIM_KEY_AGENT_ID],
      memberUsername: data[CS_TOKEN_CLAIM_KEY_MEMBER_USERNAME],
      ecid: data[CS_TOKEN_CLAIM_KEY_ECID]
    };
  });
}
function useCustomerSupportTokenData() {
  return useQuery(
    ["customerSupportTokenData"],
    getCustomerSupportTokenData,
    {
      staleTime: Infinity,
      onError: (error) => {
        captureError(
          new Error(
            `Failed to retrieve target user claims from ID token: ${error}`
          )
        );
      }
    }
  );
}
function useTargetUserId() {
  var _a, _b;
  const tokenData = useCustomerSupportTokenData();
  return (_b = (_a = tokenData.data) == null ? void 0 : _a.targetUserId) != null ? _b : "";
}
function useAgentId() {
  var _a, _b;
  const tokenData = useCustomerSupportTokenData();
  return (_b = (_a = tokenData.data) == null ? void 0 : _a.agentId) != null ? _b : "";
}
function useMemberUsername() {
  var _a, _b;
  const tokenData = useCustomerSupportTokenData();
  return (_b = (_a = tokenData.data) == null ? void 0 : _a.memberUsername) != null ? _b : "";
}
function useImpersonationClaims() {
  var _a, _b;
  const tokenData = useCustomerSupportTokenData();
  return {
    loginId: (_a = tokenData.data) == null ? void 0 : _a.memberUsername,
    ecid: (_b = tokenData.data) == null ? void 0 : _b.ecid
  };
}

// src/hooks/use-get-target-user-info.hook.ts
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { useGetUserProfile } from "@leagueplatform/web-common";
var QUERY_CACHE_AND_STALE_TIME = 15 * 1e3 * 60;
var useGetTargetUserInfo = (targetId) => {
  const userId = targetId;
  const { formatMessage } = useIntl2();
  const { data, isLoading, isError, isSuccess, error } = useGetUserProfile(
    {
      staleTime: QUERY_CACHE_AND_STALE_TIME,
      cacheTime: QUERY_CACHE_AND_STALE_TIME
    },
    userId
  );
  let fullName = "";
  let initials;
  let timeZone = "";
  let memberRelationship = "";
  let isPrimaryMember;
  if (isSuccess) {
    const {
      defaultTimezone,
      userProfile: { lastName, firstName }
    } = data;
    fullName = `${firstName} ${lastName}`;
    initials = `${firstName == null ? void 0 : firstName.charAt(0)}${lastName == null ? void 0 : lastName.charAt(0)}`;
    timeZone = defaultTimezone || "UTC";
    isPrimaryMember = data.isPrimaryMember;
    if (data.isPrimaryMember) {
      memberRelationship = formatMessage({ id: "POLICYHOLDER" });
    } else if (data.isPrimaryMember === false) {
      memberRelationship = formatMessage({ id: "DEPENDENT" });
    }
  }
  return {
    fullName,
    memberRelationship,
    isPrimaryMember,
    initials,
    timeZone,
    isLoading,
    isError,
    error
  };
};

// src/components/page-layout/components/page-navigation/page-navigation-sign-out.component.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
function PageNavigationSignOut() {
  const { formatMessage } = useIntl3();
  const agentId = useAgentId();
  const targetId = agentId;
  const { fullName, isLoading, isError, error } = useGetTargetUserInfo(targetId);
  const analyticDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({
    detail: "sign out" /* SIGN_OUT */
  }, analyticDetails));
  const sendButtonClickedAnalyticsEvent = React3.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  if (isLoading)
    return /* @__PURE__ */ jsx2(LoadingIndicator, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx2(
      ErrorState,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx2("br", {}) }
        )
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    StackLayout,
    {
      as: "li",
      css: {
        width: "100%",
        padding: "$quarter 0",
        flex: "0 0 0",
        marginTop: "$oneAndHalf"
      },
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      children: [
        /* @__PURE__ */ jsx2(HeadingText, { size: "xs", level: "2", children: fullName }),
        /* @__PURE__ */ jsx2(
          TextAction2,
          {
            onClick: sendButtonClickedAnalyticsEvent,
            to: "/sign-out",
            as: Link,
            icon: "interfaceSignOut",
            css: {
              color: "$onSurfaceTextSubdued",
              width: "$twoAndHalf",
              justifyContent: "center",
              "&:hover": {
                backgroundColor: "$inputBackgroundHovered",
                textDecoration: "none",
                color: "$onSurfaceTextPrimary"
              },
              "& svg": {
                padding: "$quarter"
              }
            },
            children: /* @__PURE__ */ jsx2(VisuallyHidden, { children: formatMessage({ id: "SIGN_OUT" }) })
          }
        )
      ]
    }
  );
}

// src/components/page-layout/components/page-navigation/page-navigation.component.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
function PageNavigation() {
  const { formatMessage } = useIntl4();
  const basePath = useBasePath();
  const icon = handleStaticAsset("LOGO_ICON" /* LOGO_ICON */);
  const { faqLink } = useCustomerSupportConfig();
  return /* @__PURE__ */ jsxs2(
    Box2,
    {
      id: "app_nav",
      as: "header",
      role: "banner",
      css: {
        height: "100%",
        width: "100%"
      },
      "aria-label": formatMessage({ id: "LEAGUE" }),
      "data-testid": "react_member_side_nav",
      children: [
        /* @__PURE__ */ jsx3(
          Box2,
          {
            css: {
              position: "absolute",
              top: "-150%",
              zIndex: "dropdown",
              "&:focus-within": {
                top: "0"
              }
            },
            children: /* @__PURE__ */ jsx3(
              Box2,
              {
                as: Link2,
                css: {
                  padding: "$half",
                  borderColor: "$onSurfaceBorderSubdued",
                  borderWidth: "$thin",
                  backgroundColor: "primaryBackgroundDefault"
                },
                to: "#main-content",
                children: formatMessage({ id: "SKIP_TO_CONTENT_MESSAGE" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs2(
          StackLayout2,
          {
            as: "nav",
            "aria-label": formatMessage({ id: "LEAGUE" }),
            verticalAlignment: "spaceBetween",
            children: [
              /* @__PURE__ */ jsxs2(
                StackLayout2,
                {
                  as: "ul",
                  "aria-label": formatMessage({ id: "MAIN_NAVIGATION_LIST_LABEL" }),
                  css: {
                    width: "100%"
                  },
                  children: [
                    /* @__PURE__ */ jsx3(Box2, { as: "li", css: { marginBottom: "$two" }, children: /* @__PURE__ */ jsx3(
                      Icon,
                      {
                        icon,
                        label: "provider-logo",
                        size: "$twoAndHalf"
                      }
                    ) }),
                    /* @__PURE__ */ jsx3(
                      PageNavigationLink,
                      {
                        goTo: basePath || ".",
                        title: "MEMBERS",
                        icon: "illustrativeHome2"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs2(
                StackLayout2,
                {
                  as: "ul",
                  "aria-label": formatMessage({ id: "MAIN_NAVIGATION_LIST_LABEL" }),
                  verticalAlignment: "bottom",
                  css: {
                    width: "100%"
                  },
                  children: [
                    /* @__PURE__ */ jsx3(
                      PageNavigationLink,
                      {
                        goTo: faqLink != null ? faqLink : "",
                        title: formatMessage({ id: "FAQ" }),
                        icon: "illustrativeDocument",
                        isExternal: true
                      }
                    ),
                    /* @__PURE__ */ jsx3(Divider, { "aria-hidden": true }),
                    /* @__PURE__ */ jsx3(PageNavigationSignOut, {})
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}

// src/components/page-layout/page-layout.component.tsx
import { useMatch } from "@leagueplatform/routing";

// src/components/survey-banner/survey-banner.component.tsx
import * as React4 from "react";
import {
  StatusBanner,
  ParagraphText,
  TextAction as TextAction3,
  StackLayout as StackLayout3,
  Button,
  Box as Box3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { useState } from "react";
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
function useToggleBanner() {
  const STORAGE_KEY = "surveyBannerDismissed";
  const [isBannerVisible, setIsBannerVisible] = useState(
    () => typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) !== "true" : true
  );
  const toggleBanner = React4.useCallback(() => {
    if (isBannerVisible) {
      setIsBannerVisible(false);
      localStorage.setItem(STORAGE_KEY, "true");
    } else {
      setIsBannerVisible(true);
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [isBannerVisible]);
  return { isBannerVisible, toggleBanner };
}
var SurveyBanner = () => {
  const { formatMessage } = useIntl5();
  const { impersonation } = useCustomerSupportConfig();
  const { isBannerVisible, toggleBanner } = useToggleBanner();
  if (!(impersonation == null ? void 0 : impersonation.enableImpersonateButton) || !impersonation.impersonationFeedbackUrl) {
    return null;
  }
  const bannerStyle = {
    position: "relative",
    transition: "max-height 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.3s",
    overflow: "hidden",
    maxHeight: isBannerVisible ? 500 : 0,
    // 500px is enough for content
    opacity: isBannerVisible ? 1 : 0,
    pointerEvents: isBannerVisible ? "auto" : "none"
  };
  return /* @__PURE__ */ jsxs3(Fragment, { children: [
    /* @__PURE__ */ jsx4(Box3, { style: bannerStyle, children: /* @__PURE__ */ jsx4(
      StatusBanner,
      {
        status: "brand",
        showIcon: true,
        title: formatMessage({ id: "FEEDBACK_SURVEY_TITLE" }),
        icon: "illustrativeChatHistory",
        onDismissClick: toggleBanner,
        children: /* @__PURE__ */ jsxs3(StackLayout3, { css: { padding: "$one 0" }, children: [
          /* @__PURE__ */ jsx4(ParagraphText, { css: { typography: "$subtitleTwo" }, children: formatMessage({ id: "FEEDBACK_SURVEY_DESCRIPTION" }) }),
          /* @__PURE__ */ jsx4(
            TextAction3,
            {
              as: "a",
              href: impersonation.impersonationFeedbackUrl,
              indicator: "externalLink",
              target: "_blank",
              children: formatMessage({ id: "FEEDBACK_SURVEY_LINK" })
            }
          )
        ] })
      }
    ) }),
    !isBannerVisible && /* @__PURE__ */ jsx4(
      Box3,
      {
        css: {
          position: "absolute",
          bottom: "$two",
          right: "$two"
        },
        children: /* @__PURE__ */ jsx4(
          Button,
          {
            priority: "secondary",
            size: "medium",
            icon: "illustrativeChatHistory",
            onClick: toggleBanner,
            children: formatMessage({ id: "FEEDBACK_SURVEY_SHOW_BANNER_BUTTON_TEXT" })
          }
        )
      }
    )
  ] });
};

// src/components/page-layout/page-layout.component.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var PageLayout = ({ children, mainCss }) => {
  const isJourney = Boolean(
    useMatch(CUSTOMER_SUPPORT_ROUTES.customerSupportJourney)
  );
  return /* @__PURE__ */ jsxs4(
    StackLayout4,
    {
      orientation: "horizontal",
      css: { height: "100vh" },
      verticalAlignment: "stretch",
      children: [
        /* @__PURE__ */ jsx5(
          StackLayout4,
          {
            css: {
              minWidth: "280px",
              flexGrow: 0,
              padding: "$two $oneAndHalf $twoAndHalf"
            },
            children: /* @__PURE__ */ jsx5(PageNavigation, {})
          }
        ),
        /* @__PURE__ */ jsx5(Divider2, { orientation: "vertical", "aria-hidden": true }),
        /* @__PURE__ */ jsxs4(StackLayout4, { orientation: "vertical", css: { flexGrow: 1, height: "auto" }, children: [
          /* @__PURE__ */ jsx5(
            Box4,
            {
              css: __spreadValues({
                overflowY: isJourney ? "hidden" : "auto",
                flexGrow: 1,
                padding: "$three",
                backgroundColor: "$surfaceBackgroundPrimary",
                width: "100%",
                position: "relative"
              }, mainCss),
              children
            }
          ),
          /* @__PURE__ */ jsx5(Box4, { css: { width: "100%" }, children: /* @__PURE__ */ jsx5(SurveyBanner, {}) })
        ] })
      ]
    }
  );
};

// src/pages/member-landing-page/components/page-header/page-header.component.tsx
import {
  Box as Box7,
  StackLayout as StackLayout8,
  HeadingText as HeadingText2,
  Card,
  StatusBadge,
  ParagraphText as ParagraphText3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator2,
  ErrorState as ErrorState2
} from "@leagueplatform/web-common-components";

// src/components/box-border/box-border.component.tsx
import { StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";
import { jsx as jsx6 } from "react/jsx-runtime";
var BoxBorder = ({ children, css: css2 }) => /* @__PURE__ */ jsx6(
  StackLayout5,
  {
    css: __spreadValues({
      borderColor: "$onSurfaceBorderSubdued",
      borderWidth: "$thin",
      borderStyle: "solid",
      borderRadius: "$medium",
      padding: "$one",
      width: "-webkit-fill-available",
      height: "fit-content"
    }, css2),
    children
  }
);

// src/pages/member-overview-page/components/impersonate-button/impersonate-button.component.tsx
import React5 from "react";
import { StackLayout as StackLayout6, Button as Button2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";

// src/hooks/use-get-entitlements.hook.ts
import { usePermissions, useGetPermissions } from "@leagueplatform/permissions";
function useEntitlementData() {
  return useGetPermissions();
}
function useEntitlements() {
  return usePermissions();
}

// src/pages/member-overview-page/components/impersonate-button/impersonate-button.component.tsx
import { EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";
import { jsx as jsx7 } from "react/jsx-runtime";
function useImpersonationRedirectUrl() {
  const { impersonation } = useCustomerSupportConfig();
  const claims = useImpersonationClaims();
  const canShowImpersonateButton = impersonation == null ? void 0 : impersonation.enableImpersonateButton;
  if (!canShowImpersonateButton) {
    return void 0;
  }
  const redirectUrl = impersonation == null ? void 0 : impersonation.impersonationRedirectUrl;
  if (typeof redirectUrl === "function") {
    return redirectUrl(claims.loginId, claims.ecid);
  }
  return redirectUrl;
}
function useImpersonationStartCallback() {
  const { impersonation } = useCustomerSupportConfig();
  const claims = useImpersonationClaims();
  const canShowImpersonateButton = (impersonation == null ? void 0 : impersonation.enableImpersonateButton) && (impersonation == null ? void 0 : impersonation.onImpersonationStart);
  if (!canShowImpersonateButton) {
    return void 0;
  }
  const callback = () => impersonation.onImpersonationStart(claims.loginId, claims.ecid);
  return callback;
}
function ImpersonateButton() {
  const { formatMessage } = useIntl6();
  const redirectUrl = useImpersonationRedirectUrl();
  const onImpersonationStart = useImpersonationStartCallback();
  const entitlements = useEntitlements();
  const hasImpersonatePermissions = entitlements.includes(
    "user_profile:impersonate" /* IMPERSONATION */
  );
  const analyticDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadProps(__spreadValues({}, analyticDetails), {
    detail: "launch impersonation session"
  }));
  const sendActionOverrideAnalyticsEvent = React5.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME4.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  const handleImpersonationClick = React5.useCallback(() => {
    if (onImpersonationStart) {
      onImpersonationStart();
      sendActionOverrideAnalyticsEvent();
    }
  }, [sendActionOverrideAnalyticsEvent, onImpersonationStart]);
  if (!redirectUrl && !onImpersonationStart || !hasImpersonatePermissions) {
    return null;
  }
  if (onImpersonationStart) {
    return /* @__PURE__ */ jsx7(StackLayout6, { horizontalAlignment: "end", "data-testid": "impersonate-button", children: /* @__PURE__ */ jsx7(Button2, { indicator: "newTabInternal", onClick: handleImpersonationClick, children: formatMessage({ id: "LAUNCH_IMPERSONATION_MODE" }) }) });
  }
  return /* @__PURE__ */ jsx7(StackLayout6, { horizontalAlignment: "end", "data-testid": "impersonate-button", children: /* @__PURE__ */ jsx7(
    Button2,
    {
      as: "a",
      href: redirectUrl,
      target: "_blank",
      indicator: "newTabInternal",
      onClick: sendActionOverrideAnalyticsEvent,
      children: formatMessage({ id: "LAUNCH_IMPERSONATION_MODE" })
    }
  ) });
}

// src/pages/member-landing-page/components/page-header/page-header.component.tsx
import { useMatch as useMatch2 } from "@leagueplatform/routing";

// src/pages/member-landing-page/components/page-header-tabs/page-header-tabs.component.tsx
import { Box as Box5, styled, StackLayout as StackLayout7, Tabs } from "@leagueplatform/genesis-core";
import { useLocation as useLocation4 } from "@leagueplatform/routing";

// src/hooks/use-page-header-tabs.hook.tsx
import { useState as useState3, useEffect, useCallback as useCallback3 } from "react";
import {
  useLocation as useLocation3,
  useNavigateLegacy as useNavigate2
} from "@leagueplatform/routing";
import { EVENT_NAME as EVENT_NAME6 } from "@leagueplatform/analytics";

// src/pages/member-journey-page/hooks/use-member-journey.hook.ts
import { useState as useState2, useCallback as useCallback2, useMemo } from "react";
import {
  useLocation as useLocation2,
  useNavigateLegacy as useNavigate
} from "@leagueplatform/routing";
import { EVENT_NAME as EVENT_NAME5 } from "@leagueplatform/analytics";
var useMemberJourney = () => {
  const navigate = useNavigate();
  const { pathname: currentTab } = useLocation2();
  const basePath = useBasePath();
  const analyticsDetails = useAnalyticsDynamicName();
  const isViewRewardProgramsEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableRewardsProgramsInquiry"
  );
  const isViewChallengesEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableChallengesInquiry"
  );
  const isViewStandardProgramsEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableStandardProgramsInquiry"
  );
  const journeyRoutes = useMemo(() => {
    const routes = [];
    if (isViewRewardProgramsEnabled) {
      routes.push({
        path: CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportRewardsPrograms,
        analytics: "rewards programs",
        tabName: "REWARDS_PROGRAMS"
      });
    }
    if (isViewChallengesEnabled) {
      routes.push({
        path: CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportChallenges,
        analytics: "challenges",
        tabName: "CHALLENGES"
      });
    }
    if (isViewStandardProgramsEnabled) {
      routes.push({
        path: CUSTOMER_SUPPORT_JOURNEY_ROUTES.customerSupportStandardPrograms,
        analytics: "standard programs",
        tabName: "STANDARD_PROGRAMS"
      });
    }
    return routes;
  }, [
    isViewRewardProgramsEnabled,
    isViewChallengesEnabled,
    isViewStandardProgramsEnabled
  ]);
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadProps(__spreadValues({}, analyticsDetails), {
    detail: "select tab" /* SELECT_TAB */
  }));
  let currentTabIndex = journeyRoutes.findIndex(
    (tab) => currentTab.includes(
      `/${CUSTOMER_SUPPORT_ROUTES.customerSupportJourney}/${tab.path}`
    )
  );
  if (currentTabIndex === -1) {
    currentTabIndex = 0;
  }
  const [tabIndex, setTabIndex] = useState2(currentTabIndex);
  const handleTabsChange = useCallback2(
    (index) => {
      var _a, _b;
      setTabIndex(index);
      sendAnalyticsEvent(EVENT_NAME5.NAVIGATION_TAB_CLICKED, {
        sub_detail: journeyRoutes[index].analytics
      });
      navigate(`${basePath}/${CUSTOMER_SUPPORT_PAGES.JOURNEY}/${(_b = (_a = journeyRoutes[index]) == null ? void 0 : _a.path) != null ? _b : ""}`);
    },
    [navigate, sendAnalyticsEvent, journeyRoutes, basePath]
  );
  return { tabIndex, handleTabsChange, journeyRoutes };
};

// src/hooks/use-customer-support-params.hook.ts
import { useParams } from "@leagueplatform/routing";
function useCustomerSupportParams() {
  return useParams();
}

// src/hooks/use-page-header-tabs.hook.tsx
var usePageHeaderTabs = (allowedRoutes) => {
  const navigate = useNavigate2();
  const { pathname: currentTab } = useLocation3();
  const { page, subPage } = useCustomerSupportParams();
  const { journeyRoutes } = useMemberJourney();
  const basePath = useBasePath();
  const currentTabIndex = allowedRoutes.findIndex(
    (route) => currentTab.includes(route.path)
  );
  const [tabIndex, setTabIndex] = useState3(currentTabIndex);
  const journeyRouteNoSubPage = page === CUSTOMER_SUPPORT_PAGES.JOURNEY && subPage === void 0;
  const journeyRouteHasSubPage = page === CUSTOMER_SUPPORT_PAGES.JOURNEY && subPage !== void 0;
  const journeyIndex = allowedRoutes.findIndex(
    (route) => route.path === CUSTOMER_SUPPORT_ROUTES.customerSupportJourney
  );
  const routeToBaseJourney = useCallback3(() => {
    setTabIndex(journeyIndex);
    navigate(`${basePath}/${CUSTOMER_SUPPORT_PAGES.JOURNEY}/${journeyRoutes[0].path}`, {
      replace: true
    });
  }, [navigate, journeyIndex, journeyRoutes, basePath]);
  const analyticsDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({
    detail: "select tab" /* SELECT_TAB */
  }, analyticsDetails));
  const handleTabsChange = useCallback3(
    (index) => {
      var _a, _b;
      setTabIndex(index);
      navigate(`${basePath}/${(_b = (_a = allowedRoutes[index]) == null ? void 0 : _a.path) != null ? _b : ""}`);
      sendAnalyticsEvent(EVENT_NAME6.NAVIGATION_TAB_CLICKED, {
        sub_detail: allowedRoutes[index].analytics
      });
    },
    [sendAnalyticsEvent, allowedRoutes, navigate, basePath]
  );
  useEffect(() => {
    if (!journeyRouteNoSubPage && !journeyRouteHasSubPage && currentTabIndex !== tabIndex && currentTabIndex !== -1) {
      setTabIndex(currentTabIndex);
    }
  }, [
    currentTabIndex,
    tabIndex,
    journeyRouteNoSubPage,
    journeyRouteHasSubPage,
    currentTab
  ]);
  useEffect(() => {
    if (journeyRouteNoSubPage) {
      routeToBaseJourney();
    } else if (journeyRouteHasSubPage && tabIndex !== journeyIndex) {
      setTabIndex(journeyIndex);
    }
  }, [
    journeyRouteNoSubPage,
    journeyRouteHasSubPage,
    routeToBaseJourney,
    journeyIndex,
    tabIndex
  ]);
  return { tabIndex, handleTabsChange };
};

// src/pages/member-landing-page/components/page-header-tabs/page-header-tabs.component.tsx
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var FlexedTabPanel = styled(Tabs.TabPanel, {
  padding: "$zero $zero $two",
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  width: "100%"
});
var StackedTabs = styled(Tabs.Root, {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%"
});
var FullWidthTabPanel = styled(Tabs.TabPanel, {
  width: "100%"
});
var PageHeaderTabs = ({ allowedRoutes }) => {
  var _a;
  const { pathname } = useLocation4();
  const isJourneyRoute = pathname.includes(
    CUSTOMER_SUPPORT_ROUTES.customerSupportJourney
  );
  const { tabIndex, handleTabsChange } = usePageHeaderTabs(allowedRoutes);
  return /* @__PURE__ */ jsxs5(
    StackedTabs,
    {
      defaultValue: allowedRoutes[0].label,
      value: (_a = allowedRoutes[tabIndex]) == null ? void 0 : _a.label,
      onValueChange: (tabName) => handleTabsChange(
        allowedRoutes.findIndex((tab) => tab.label === tabName)
      ),
      children: [
        /* @__PURE__ */ jsx8(
          Box5,
          {
            css: {
              marginBottom: "$one",
              paddingBottom: "$one",
              minHeight: "50px",
              position: "sticky",
              top: "$two",
              zIndex: "$sticky",
              backgroundColor: "$surfaceBackgroundPrimary"
            },
            children: /* @__PURE__ */ jsx8(Tabs.TabList, { tabDistribution: "hugContents", divider: true, children: allowedRoutes.map((route) => /* @__PURE__ */ jsx8(Tabs.Tab, { value: route.label, children: route.label }, `${route.label}-tab`)) })
          }
        ),
        /* @__PURE__ */ jsx8(
          StackLayout7,
          {
            orientation: "vertical",
            css: {
              overflowY: isJourneyRoute ? "hidden" : void 0,
              width: "100%"
            },
            children: allowedRoutes.map(
              (route, i) => isJourneyRoute && i === allowedRoutes.length - 1 ? /* @__PURE__ */ jsx8(
                FlexedTabPanel,
                {
                  "data-testid": "flexTab",
                  value: route.label,
                  children: route.content
                },
                `${route.label}-content`
              ) : /* @__PURE__ */ jsx8(
                FullWidthTabPanel,
                {
                  "data-testid": "styledTab",
                  value: route.label,
                  children: route.content
                },
                `${route.label}-content`
              )
            )
          }
        )
      ]
    }
  );
};

// src/pages/member-landing-page/components/header-banner-masonry/header-banner-masonry.component.tsx
import { useMemo as useMemo2 } from "react";
import { LegacyMasonry } from "@leagueplatform/masonry";
import { Box as Box6 } from "@leagueplatform/genesis-core";

// src/pages/member-landing-page/components/header-banner-masonry/status-banner-masonry-widget/status-banner-masonry-widget.component.tsx
import {
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import {
  Icon as Icon2,
  ParagraphText as ParagraphText2,
  StatusBanner as StatusBanner2
} from "@leagueplatform/genesis-core";
import { jsx as jsx9 } from "react/jsx-runtime";
var getGenesisStatus = (status2) => {
  switch (status2) {
    case "danger":
      return "error";
    default:
      return status2;
  }
};
var StatusBannerMasonryWidget = ({
  widget
}) => {
  var _a, _b, _c, _d;
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(widget, MASONRY.API_VERSION);
  if (!widgetData || !(widgetData == null ? void 0 : widgetData.attributes) || error || isLoading) {
    return null;
  }
  return /* @__PURE__ */ jsx9(
    StatusBanner2,
    {
      title: (_a = widgetData == null ? void 0 : widgetData.attributes) == null ? void 0 : _a.heading,
      status: getGenesisStatus((_b = widgetData == null ? void 0 : widgetData.attributes) == null ? void 0 : _b.current_label),
      icon: /* @__PURE__ */ jsx9(Icon2, { icon: (_c = widgetData == null ? void 0 : widgetData.attributes) == null ? void 0 : _c.image }),
      css: { marginBottom: "$two", minHeight: "80px" },
      children: /* @__PURE__ */ jsx9(ParagraphText2, { size: "sm", children: (_d = widgetData == null ? void 0 : widgetData.attributes) == null ? void 0 : _d.description })
    }
  );
};

// src/pages/member-landing-page/components/header-banner-masonry/header-banner-masonry.component.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var CustomBannerWidget = ({ widget }) => /* @__PURE__ */ jsx10(StatusBannerMasonryWidget, { widget });
var PageHeaderBanner = () => {
  const targetUserId = useTargetUserId();
  const HeaderBannerMasonry = useMemo2(
    () => new LegacyMasonry({
      appId: MASONRY.HEADER_CONTAINER_APP_ID,
      apiVersion: MASONRY.API_VERSION,
      customWidgetModules: [
        {
          moduleKey: MASONRY.MODULE_KEY_CSE,
          customWidgetsUI: [
            {
              type: MASONRY.CUSTOM_WIDGET_TYPE_BANNER,
              widget: CustomBannerWidget
            }
          ]
        }
      ],
      uiConfig: {
        // Don't show loading state
        CustomLoader: () => null,
        spinnerConfig: {
          containerHeight: "0px"
        }
      },
      apiParams: {
        memberId: targetUserId
      },
      analytics: {
        productArea: "",
        screenName: ""
      }
    }),
    [targetUserId]
  );
  if (!targetUserId) {
    return null;
  }
  return /* @__PURE__ */ jsx10(Box6, { css: { width: "100%" }, children: /* @__PURE__ */ jsx10(HeaderBannerMasonry.Provider, {}) });
};

// src/pages/member-landing-page/components/page-header/page-header.component.tsx
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var PageHeader = ({ allowedRoutes }) => {
  const { formatMessage } = useIntl7();
  const memberUsername = useMemberUsername();
  const targetUserId = useTargetUserId();
  const { fullName, memberRelationship, initials, isLoading, isError, error } = useGetTargetUserInfo(targetUserId);
  const { enablePageHeaderBanner } = useCustomerSupportConfig();
  const isJourney = Boolean(
    useMatch2(CUSTOMER_SUPPORT_ROUTES.customerSupportJourney)
  );
  if (isLoading)
    return /* @__PURE__ */ jsx11(LoadingIndicator2, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx11(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx11(
      ErrorState2,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx11("br", {}) }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsxs6(
    StackLayout8,
    {
      orientation: "vertical",
      css: {
        width: "100%",
        backgroundColor: "inherit",
        height: isJourney ? "100%" : "auto"
      },
      children: [
        enablePageHeaderBanner && /* @__PURE__ */ jsx11(PageHeaderBanner, {}),
        /* @__PURE__ */ jsxs6(
          StackLayout8,
          {
            orientation: "horizontal",
            horizontalAlignment: "spaceBetween",
            css: {
              alignItems: "center",
              paddingBottom: "$half",
              width: "100%",
              position: "sticky",
              top: "$minusThree",
              paddingTop: "$one",
              marginTop: "$minusOne",
              backgroundColor: "inherit",
              zIndex: "$sticky",
              flexGrow: 0
            },
            children: [
              /* @__PURE__ */ jsxs6(StackLayout8, { orientation: "horizontal", children: [
                /* @__PURE__ */ jsx11(
                  Card.Flat,
                  {
                    backgroundColor: "secondary",
                    css: {
                      marginRight: "$threeQuarters"
                    },
                    children: /* @__PURE__ */ jsx11(Card.Section, { padding: "$one", children: /* @__PURE__ */ jsx11(HeadingText2, { level: "display", size: "lg", children: initials }) })
                  }
                ),
                /* @__PURE__ */ jsxs6(Box7, { children: [
                  /* @__PURE__ */ jsxs6(StackLayout8, { orientation: "horizontal", verticalAlignment: "center", children: [
                    /* @__PURE__ */ jsx11(HeadingText2, { size: "xl", level: "1", css: { marginRight: "$half" }, children: fullName }),
                    memberRelationship && /* @__PURE__ */ jsx11(
                      StatusBadge,
                      {
                        label: memberRelationship,
                        status: "brand",
                        showLight: false
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx11(ParagraphText3, { emphasis: "base", size: "base", children: memberUsername })
                ] })
              ] }),
              /* @__PURE__ */ jsx11(ImpersonateButton, {})
            ]
          }
        ),
        !allowedRoutes.length ? /* @__PURE__ */ jsx11(LoadingIndicator2, {}) : /* @__PURE__ */ jsx11(PageHeaderTabs, { allowedRoutes })
      ]
    }
  );
};

// src/pages/member-landing-page/member-landing-page.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var MemberLandingPage = ({
  allowedRoutes
}) => /* @__PURE__ */ jsx12(PageLayout, { children: /* @__PURE__ */ jsx12(PageHeader, { allowedRoutes }) });

// src/customer-support.routes.tsx
import { useState as useState10 } from "react";
import {
  LoadingIndicator as LoadingIndicator35,
  ErrorState as ErrorState30
} from "@leagueplatform/web-common-components";
import { Routes, Route, Navigate, useLocation as useLocation7 } from "react-router-dom";
import { Box as Box50 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl87 } from "@leagueplatform/locales";

// src/hooks/use-customer-support-routes.hook.tsx
import { useIntl as useIntl86 } from "@leagueplatform/locales";

// src/pages/member-wallet-page/member-wallet-page.component.tsx
import { useState as useState4 } from "react";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout14,
  HeadingText as HeadingText4,
  Box as Box10,
  styled as styled3,
  VisuallyHidden as VisuallyHidden4
} from "@leagueplatform/genesis-core";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import {
  LoadingIndicator as LoadingIndicator3,
  ErrorState as ErrorState3
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";

// src/components/benefit-list-filters/components/search-filter.component.tsx
import React7, { useRef } from "react";
import { FormField, TextInput, Icon as Icon3 } from "@leagueplatform/genesis-core";
import { debounce } from "lodash-es";
import { EVENT_NAME as EVENT_NAME7 } from "@leagueplatform/analytics";
import { jsx as jsx13 } from "react/jsx-runtime";
var SearchFilter = ({
  name,
  placeholder,
  userSearchValue,
  showClearable
}) => {
  const textRef = useRef(null);
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit summary" /* BENEFIT_SUMMARY */
  });
  const handleClear = React7.useCallback(() => {
    textRef.current.value = "";
    userSearchValue("");
    sendAnalyticsEvent(EVENT_NAME7.BUTTON_CLICKED, {
      detail: "cancel search" /* CANCEL_SEARCH */
    });
  }, [sendAnalyticsEvent, userSearchValue]);
  const handleDebounce = React7.useMemo(
    () => debounce((value) => {
      sendAnalyticsEvent(EVENT_NAME7.BUTTON_CLICKED, {
        detail: "search" /* SEARCH */,
        sub_detail: value
      });
    }, 300),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx13(
    FormField,
    {
      id: name,
      label: placeholder,
      hideLabel: true,
      css: {
        maxWidth: "300px",
        ".GDS-text-input-wrapper": {
          padding: "$half",
          height: "$three"
        }
      },
      children: /* @__PURE__ */ jsx13(
        TextInput,
        {
          id: "textRef",
          name,
          placeholder,
          leadingContent: /* @__PURE__ */ jsx13(Icon3, { icon: "interfaceSearch" }),
          clearable: showClearable,
          ref: textRef,
          onChange: (e) => {
            const searchValue = e.target.value;
            handleDebounce(searchValue);
            userSearchValue(searchValue == null ? void 0 : searchValue.toLowerCase());
          },
          onClear: () => handleClear()
        }
      )
    }
  );
};

// src/components/benefit-list-filters/components/select-filter.component.tsx
import * as React8 from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { Select } from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME8 } from "@leagueplatform/analytics";
import { jsx as jsx14 } from "react/jsx-runtime";
var SelectFilter = ({
  options,
  filterBenefits
}) => {
  const { formatMessage } = useIntl8();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit summary" /* BENEFIT_SUMMARY */,
    detail: "filter" /* FILTER */
  });
  const sendButtonClickedAnalyticsEvent = React8.useCallback(
    (filterBy) => sendAnalyticsEvent(EVENT_NAME8.BUTTON_CLICKED, { sub_detail: filterBy }),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx14(
    Select,
    {
      "aria-label": formatMessage({ id: "FILTER_BY_STATUS" }),
      id: "table-select",
      options,
      onChange: (e) => {
        const filterBy = e.target.value;
        sendButtonClickedAnalyticsEvent(filterBy);
        filterBenefits(filterBy);
      },
      css: {
        select: {
          height: "$three"
        }
      }
    }
  );
};

// src/pages/member-wallet-page/hooks/use-member-wallet-page.hook.ts
import { useMemo as useMemo3 } from "react";

// src/pages/member-wallet-page/hooks/queries/use-wallet-items-sectioned-query.hook.ts
import {
  getWalletItemsSectioned,
  GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { useQuery as useQuery2 } from "@tanstack/react-query";
import { captureError as captureError2 } from "@leagueplatform/observability";
function useWalletItemsSectionedQuery(userId, options) {
  return useQuery2(
    [GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE, userId],
    () => getWalletItemsSectioned(userId),
    __spreadValues({
      staleTime: Infinity,
      onError(error) {
        captureError2(
          new Error(
            `Customer Support: Failed to get user wallet items sectioned (member id: ${userId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-wallet-page/util/parse-benefit-statuses.util.ts
import { intersection } from "lodash-es";
import {
  PILL_STATUS as PILL_STATUS2
} from "@leagueplatform/wallet-api";

// src/utils/normalize-status.util.ts
import { CARD_STATUS, PILL_STATUS } from "@leagueplatform/wallet-api";
import { UserHealthActivityStatus } from "@leagueplatform/health-journey-common";
import {
  USER_HEALTH_CAMPAIGN_STATUS,
  USER_HEALTH_GOAL_PROGRAM_STATUS
} from "@leagueplatform/health-journey-api";
import {
  UserConsentStatus,
  HealthRiskAssessmentsStatus,
  HealthGoalProgramsAdminStatus
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError3 } from "@leagueplatform/observability";
var normalizeBenefitStatus = (status2) => {
  switch (status2) {
    case CARD_STATUS.CREATED:
    case CARD_STATUS.READY:
    case CARD_STATUS.IN_WAITING_PERIOD:
      return PILL_STATUS.PENDING;
    case CARD_STATUS.INACTIVE_GRACE_PERIOD:
    case CARD_STATUS.INACTIVE:
      return PILL_STATUS.PAST;
    case CARD_STATUS.ACTIVE:
    case PILL_STATUS.ACTIVE:
      return CARD_STATUS.ACTIVE;
    default:
      captureError3(
        new Error(
          `Customer Support: Benefit status ${status2} is not supported`
        )
      );
      return "UNKNOWN";
  }
};
var normalizeRewardStatus = (status2) => {
  switch (status2) {
    case UserHealthActivityStatus.ACTIVE:
      return "active" /* ACTIVE */;
    case UserHealthActivityStatus.EXPIRED:
      return "expired" /* EXPIRED */;
    case USER_HEALTH_CAMPAIGN_STATUS.ENDED:
      return USER_HEALTH_CAMPAIGN_STATUS.ENDED;
    case UserHealthActivityStatus.COMPLETED:
      return "completed" /* COMPLETED */;
    case USER_HEALTH_CAMPAIGN_STATUS.SUSPENDED:
      return "suspended" /* SUSPENDED */;
    case USER_HEALTH_GOAL_PROGRAM_STATUS.SKIPPED:
    case UserHealthActivityStatus.REMOVED:
      return "skipped" /* SKIPPED */;
    case UserHealthActivityStatus.UPCOMING:
      return "upcoming" /* UPCOMING */;
    case UserHealthActivityStatus.ON_HOLD:
      return "on_hold" /* ON_HOLD */;
    default:
      captureError3(
        new Error(
          `Customer Support: Program status ${status2} is not supported`
        )
      );
      return "UNKNOWN";
  }
};
var normalizeAssessmentStatusLabel = (status2) => {
  switch (status2) {
    case UserConsentStatus.COMPLETED:
    case HealthRiskAssessmentsStatus.COMPLETED:
      return "COMPLETED";
    case HealthRiskAssessmentsStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case HealthRiskAssessmentsStatus.NOT_STARTED:
      return "NOT_STARTED";
    case UserConsentStatus.REJECTED:
      return "REJECTED";
    default:
      captureError3(
        new Error(
          `Customer Support: Assessment and dashboard status ${status2} is not supported`
        )
      );
      return "UNKNOWN";
  }
};
var normalizeStandardProgramStatusLabel = (status2) => {
  switch (status2) {
    case HealthGoalProgramsAdminStatus.ACTIVE:
      return "ACTIVE";
    case HealthGoalProgramsAdminStatus.COMPLETED:
      return "COMPLETED";
    case HealthGoalProgramsAdminStatus.QUIT:
      return "QUIT";
    case HealthGoalProgramsAdminStatus.UPCOMING:
      return "UPCOMING";
    default:
      captureError3(
        new Error(
          `Customer Support: Standard programs status ${status2} is not supported`
        )
      );
      return "UNKNOWN";
  }
};
var normalizeChallengesStatusLabel = (status2) => {
  switch (status2) {
    case "active":
      return "ACTIVE";
    case "completed":
      return "COMPLETED";
    case "quit":
      return "QUIT";
    case "ended":
      return "ENDED";
    case "enrolled":
      return "ENROLLED";
    case "upcoming":
      return "UPCOMING";
    case "expired":
      return "EXPIRED";
    case "suspended":
      return "SUSPENDED";
    case "received":
      return "RECEIVED";
    case "removed":
      return "REMOVED";
    case "on-hold":
      return "ON_HOLD";
    default:
      captureError3(
        new Error(
          `Customer Support: Challenges program status ${status2} is not supported`
        )
      );
      return "UNKNOWN";
  }
};

// src/pages/member-wallet-page/util/parse-benefit-statuses.util.ts
function parseBenefitStatuses(walletItemsSectioned) {
  var _a;
  if (!walletItemsSectioned) {
    return [];
  }
  const benefitsSections = (_a = walletItemsSectioned == null ? void 0 : walletItemsSectioned.find(
    (section) => section.section_id === "benefits"
  )) == null ? void 0 : _a.sections;
  const statuses = /* @__PURE__ */ new Set();
  if (benefitsSections) {
    benefitsSections.forEach((section) => {
      if (section.wallet_items) {
        section.wallet_items.forEach(
          (item) => statuses.add(normalizeBenefitStatus(item.status))
        );
      }
    });
  }
  return statuses && intersection(
    [PILL_STATUS2.ACTIVE, PILL_STATUS2.PENDING, PILL_STATUS2.PAST],
    Array.from(statuses)
  );
}

// src/pages/member-wallet-page/util/combine-benefits-sort.util.ts
var combineAllBenefitsAndSort = (statusArray = [], itemSections = []) => {
  var _a, _b;
  const mappedItemSections = itemSections.map((item) => {
    let filteredSections;
    if (item.sections) {
      filteredSections = item.sections.reduce(
        (prevSection, currentSection) => {
          const walletItems = (currentSection == null ? void 0 : currentSection.wallet_items) || [];
          return [...prevSection, ...walletItems];
        },
        []
      );
    }
    return __spreadProps(__spreadValues({}, item), {
      sections: filteredSections
    });
  });
  const getStatus = (item) => statusArray.indexOf(normalizeBenefitStatus(item.status));
  const sortedItemSections = (_b = (_a = mappedItemSections == null ? void 0 : mappedItemSections[0]) == null ? void 0 : _a.sections) == null ? void 0 : _b.map((benefit) => {
    const displayVendor = benefit.subtitle || benefit.vendor_name.text;
    return __spreadProps(__spreadValues({}, benefit), { displayVendor });
  }).sort(
    (a, b) => getStatus(a) - getStatus(b)
  );
  return sortedItemSections;
};

// src/pages/member-wallet-page/hooks/use-member-wallet-page.hook.ts
var useMemberWalletPage = (targetUserId) => {
  const userId = targetUserId;
  const { data, isLoading, isError, error } = useWalletItemsSectionedQuery(userId);
  const itemSectioned = useMemo3(() => (data == null ? void 0 : data.items_sectioned) || [], [data]);
  const parsedBenefitStatuses = useMemo3(
    () => parseBenefitStatuses(itemSectioned),
    [itemSectioned]
  );
  const sortedBenefitSections = useMemo3(
    () => combineAllBenefitsAndSort(parsedBenefitStatuses, itemSectioned),
    [parsedBenefitStatuses, itemSectioned]
  );
  return {
    sortedBenefitSections,
    parsedBenefitStatuses,
    isLoading,
    isError,
    error
  };
};

// src/components/benefit-list-filters/hooks/use-select-options.hook.ts
import { useMemo as useMemo4 } from "react";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
var useSelectOptions = (targetUserId) => {
  const { formatMessage } = useIntl9();
  const { parsedBenefitStatuses } = useMemberWalletPage(targetUserId);
  const options = parsedBenefitStatuses.map((value, index) => ({
    key: index.toString(),
    value,
    label: formatMessage({ id: value.toLocaleUpperCase() })
  }));
  const benefitSelectOptions = useMemo4(
    () => [
      {
        key: "",
        value: "",
        label: formatMessage({ id: "ALL_BENEFITS" })
      },
      ...options
    ],
    [formatMessage, options]
  );
  return { benefitSelectOptions };
};

// src/components/benefit-list-filters/utils/get-filter-benefits-list.util.ts
import { get } from "lodash-es";
var getFilterBenefitsList = (searchQuery, status2) => {
  const searchFilterOptions = ["name.text", "displayVendor"];
  const searchFiltered = (items) => items.filter((item) => {
    const normalizedSearchQuery = searchQuery.toLocaleLowerCase();
    const matchesStatus = status2 === "" || normalizeBenefitStatus(item.status) === status2;
    return matchesStatus && searchFilterOptions.some(
      (parameter) => get(item, parameter, "").toLocaleLowerCase().includes(normalizedSearchQuery)
    );
  });
  return searchFiltered;
};

// src/components/cs-table/cs-table-with-action/cs-table-with-action.component.tsx
import {
  Box as Box8,
  StackLayout as StackLayout9,
  UtilityText as UtilityText2,
  useClickableCard,
  Card as Card2,
  styled as styled2,
  VisuallyHidden as VisuallyHidden2,
  ParagraphText as ParagraphText4
} from "@leagueplatform/genesis-core";
import { jsx as jsx15, jsxs as jsxs7 } from "react/jsx-runtime";
var emptyCell = {
  id: "",
  name: "",
  value: "",
  lastColumn: false,
  columnWidth: "auto"
};
var tableBorderCSS = {
  borderTopColor: "$onSurfaceBorderSubdued",
  borderTopWidth: "$thin",
  borderTopStyle: "solid",
  cursor: "pointer",
  "&:last-child": {
    borderBottomColor: "$onSurfaceBorderSubdued",
    borderBottomWidth: "$thin",
    borderBottomStyle: "solid"
  },
  "thead &": {
    borderTop: "none"
  }
};
var getCellByColumnName = (cells, columnName) => cells.find((cell) => columnName === cell.name) || emptyCell;
var TableColumnHeader = ({
  id,
  name,
  value,
  lastColumn,
  columnWidth
}) => /* @__PURE__ */ jsx15(
  Box8,
  {
    as: value ? "th" : "td",
    "data-column": name,
    id,
    scope: "col",
    css: {
      padding: lastColumn ? "$half $one $half" : "$half",
      width: lastColumn ? "auto" : columnWidth
    },
    children: lastColumn ? /* @__PURE__ */ jsx15(VisuallyHidden2, { children: value }) : /* @__PURE__ */ jsx15(StackLayout9, { verticalAlignment: "center", horizontalAlignment: "start", children: /* @__PURE__ */ jsx15(
      UtilityText2,
      {
        css: {
          typography: "$label"
        },
        children: value
      }
    ) })
  },
  id
);
var TableRowCell = ({
  id,
  name,
  value,
  lastColumn,
  lastRowCustomCSS,
  columnWidth
}) => /* @__PURE__ */ jsx15(
  Box8,
  {
    "data-column": name,
    css: {
      height: "fit-content",
      padding: "$half",
      width: lastColumn ? lastRowCustomCSS : columnWidth
    },
    children: value
  },
  id
);
var EmptyRow = ({ colSpan, emptyRowText = "-" }) => /* @__PURE__ */ jsx15(Box8, { as: "tr", children: /* @__PURE__ */ jsx15(
  Box8,
  {
    as: "td",
    colSpan,
    css: { textAlign: "center", paddingY: "half", width: "100%" },
    children: emptyRowText
  }
) });
var TableCellClickArea = styled2(Card2.ClickArea, {
  padding: "$half $one $half $none",
  borderRadius: "$none",
  border: "$none",
  position: "relative",
  "&:focus-within": {
    boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner"
  },
  "&:hover": {
    border: "$none",
    backgroundColor: "$inputBackgroundHovered"
  }
});
var TableRow = ({
  id,
  cells,
  columns,
  lastRowCustomCSS,
  columnWidth
}) => {
  const { clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  return /* @__PURE__ */ jsx15(Box8, { as: "tr", css: tableBorderCSS, children: /* @__PURE__ */ jsx15(Box8, { colSpan: columns.length, as: "td", children: /* @__PURE__ */ jsx15(Card2.Flat, { css: { borderRadius: "$none", overflow: "unset" }, children: /* @__PURE__ */ jsx15(
    TableCellClickArea,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown,
      children: /* @__PURE__ */ jsx15(
        StackLayout9,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          css: {
            minHeight: "60px"
          },
          children: columns.map((column, index) => {
            const {
              id: cellId,
              name,
              value
            } = getCellByColumnName(cells, column.name);
            return /* @__PURE__ */ jsx15(
              TableRowCell,
              {
                id: cellId,
                name,
                value,
                columnId: column.id,
                lastRowCustomCSS,
                lastColumn: index === columns.length - 1 && true,
                columnWidth
              },
              cellId
            );
          })
        }
      )
    }
  ) }) }) }, id);
};
var CSTableWithAction = ({
  columns,
  rows,
  lastRowCustomCSS,
  noDataText,
  emptyRowText,
  columnWidth
}) => {
  const isFilteredListEmpty = (rows == null ? void 0 : rows.length) === 0;
  if (isFilteredListEmpty && noDataText) {
    return /* @__PURE__ */ jsx15(Box8, { children: /* @__PURE__ */ jsx15(ParagraphText4, { children: noDataText }) });
  }
  return /* @__PURE__ */ jsxs7(Box8, { as: "table", css: { width: "100%" }, children: [
    /* @__PURE__ */ jsx15(
      Box8,
      {
        as: "thead",
        css: {
          position: "sticky",
          zIndex: "$sticky",
          top: 0,
          background: "$surfaceBackgroundTertiary"
        },
        children: /* @__PURE__ */ jsx15(Box8, { as: "tr", css: tableBorderCSS, children: columns.map((column, index) => /* @__PURE__ */ jsx15(
          TableColumnHeader,
          {
            id: column.id,
            name: column.name,
            value: column.value,
            lastColumn: index + 1 === columns.length && true,
            columnWidth
          },
          column.id
        )) })
      }
    ),
    /* @__PURE__ */ jsx15(Box8, { as: "tbody", children: rows.length === 0 ? /* @__PURE__ */ jsx15(EmptyRow, { colSpan: columns.length, emptyRowText }) : rows.map(({ id, cells }) => /* @__PURE__ */ jsx15(
      TableRow,
      {
        id,
        cells,
        columns,
        lastRowCustomCSS,
        columnWidth
      },
      id
    )) })
  ] });
};

// src/utils/cs-table-with-action.utils.tsx
import {
  StackLayout as StackLayout13,
  ParagraphText as ParagraphText7,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";

// src/components/cs-table/cs-table-common/cs-table-status-badge/cs-table-status-badge.component.tsx
import { StackItem, StatusBadge as StatusBadge2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { jsx as jsx16 } from "react/jsx-runtime";
var CsTableStatusBadge = ({
  status: status2,
  label
}) => {
  const { formatMessage } = useIntl10();
  return /* @__PURE__ */ jsx16(StackItem, { children: /* @__PURE__ */ jsx16(
    StatusBadge2,
    {
      label: formatMessage({ id: label.toLocaleUpperCase() }),
      status: status2,
      css: {
        width: "fit-content",
        minWidth: "20%"
      }
    }
  ) });
};

// src/components/cs-table/cs-table-with-action/benefit-list-name/benefit-list-name.component.tsx
import {
  HeadingText as HeadingText3,
  Icon as Icon4,
  ParagraphText as ParagraphText5,
  StackItem as StackItem2,
  StackLayout as StackLayout10
} from "@leagueplatform/genesis-core";

// src/utils/customer-support.utils.ts
import {
  CARD_STATUS as CARD_STATUS3,
  PILL_STATUS as PILL_STATUS3
} from "@leagueplatform/wallet-api";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
var hasAction = (walletData, actionType) => walletData == null ? void 0 : walletData.some(
  (action) => (action == null ? void 0 : action.system_type) === actionType
);
var notActiveBenefitBannerDetails = (status2) => {
  switch (status2) {
    case CARD_STATUS3.CREATED:
    case CARD_STATUS3.READY:
    case CARD_STATUS3.IN_WAITING_PERIOD:
    case PILL_STATUS3.PENDING:
      return {
        status: status2,
        title: "PENDING_BENEFIT",
        description: "PENDING_BENEFIT_DESCRIPTION"
      };
    case PILL_STATUS3.PAST:
    case CARD_STATUS3.INACTIVE:
    case CARD_STATUS3.INACTIVE_GRACE_PERIOD:
      return {
        status: status2,
        title: "PAST_BENEFIT",
        description: "PAST_BENEFIT_DESCRIPTION"
      };
    default:
      return null;
  }
};
var icons = {
  ios: "IOS_ICON" /* IOS_ICON */,
  android: "ANDROID_ICON" /* ANDROID_ICON */,
  web: "WEB_ICON" /* WEB_ICON */,
  safari: "SAFARI_ICON" /* SAFARI_ICON */,
  chrome: "CHROME_ICON" /* CHROME_ICON */,
  firefox: "FIREFOX_ICON" /* FIREFOX_ICON */,
  default: "BENEFIT_LIST_DEFAULT_ICON" /* BENEFIT_LIST_DEFAULT_ICON */
};
function getProductIcon(productType) {
  if (!productType || !icons[productType]) {
    return handleStaticAsset2(
      "BENEFIT_LIST_DEFAULT_ICON" /* BENEFIT_LIST_DEFAULT_ICON */
    );
  }
  return handleStaticAsset2(icons[productType]);
}
var getShortDateTimeZone = (timeZone) => __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
  timeZone
});

// src/components/cs-table/cs-table-with-action/benefit-list-name/benefit-list-name.component.tsx
import { jsx as jsx17, jsxs as jsxs8 } from "react/jsx-runtime";
var BenefitListName = ({ benefit }) => {
  var _a;
  return /* @__PURE__ */ jsxs8(
    StackLayout10,
    {
      orientation: "horizontal",
      css: {
        flex: "0",
        marginRight: "$quarter",
        minWidth: "250px"
      },
      children: [
        /* @__PURE__ */ jsx17(
          StackItem2,
          {
            css: {
              padding: "$half",
              border: "$borderWidths$thin solid $onSurfaceBorderSubdued",
              borderRadius: "$circle",
              backgroundColor: "$interactiveBackgroundDefault",
              marginRight: "$half"
            },
            children: /* @__PURE__ */ jsx17(
              Icon4,
              {
                icon: ((_a = benefit.benefit_logo) == null ? void 0 : _a.src) || benefit.icon_url || getProductIcon(benefit.benefit_product_type),
                size: "$two"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs8(StackItem2, { children: [
          /* @__PURE__ */ jsx17(HeadingText3, { emphasis: "base", level: "display", size: "sm", children: benefit.name.text }),
          /* @__PURE__ */ jsx17(ParagraphText5, { emphasis: "subtle", size: "sm", children: benefit.displayVendor })
        ] })
      ]
    }
  );
};

// src/components/cs-table/cs-table-with-action/cs-table-item-link/cs-table-item-link.component.tsx
import React9 from "react";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { Link as RouteLink, useLocation as useLocation5 } from "react-router-dom";
import {
  Icon as Icon5,
  Box as Box9,
  StackItem as StackItem3,
  useClickableCard as useClickableCard2,
  StackLayout as StackLayout11
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME9 } from "@leagueplatform/analytics";
import { jsx as jsx18 } from "react/jsx-runtime";
var CSTableItemLink = ({
  parameter,
  ariaLabel,
  ariaCustom,
  analytics
}) => {
  const { formatMessage } = useIntl11();
  const { pathname } = useLocation5();
  const { primaryActionRef } = useClickableCard2();
  const analyticDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadProps(__spreadValues({}, analyticDetails), {
    detail: "select row" /* SELECT_ROW */,
    sub_detail: analytics
  }));
  const sendButtonClickedAnalyticsEvent = React9.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME9.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx18(StackItem3, { horizontalAlignment: "end", children: /* @__PURE__ */ jsx18(
    Box9,
    {
      onClick: sendButtonClickedAnalyticsEvent,
      ref: primaryActionRef,
      as: RouteLink,
      to: `${pathname}/${parameter}`,
      "aria-label": formatMessage(
        { id: ariaLabel },
        {
          from: ariaCustom
        }
      ),
      css: {
        '&[class*="GDS"]:focus, &:active': {
          outline: "none"
        },
        "&::before": {
          content: "",
          position: "absolute",
          width: "100%",
          height: "100%",
          left: "0",
          right: "0",
          bottom: "0",
          top: "0"
        }
      },
      children: /* @__PURE__ */ jsx18(
        StackLayout11,
        {
          horizontalAlignment: "end",
          verticalAlignment: "center",
          css: {
            height: "100%"
          },
          children: /* @__PURE__ */ jsx18(
            Icon5,
            {
              icon: "interfaceChevronRight",
              tint: "$onSurfaceIconPrimary",
              size: "$one"
            }
          )
        }
      )
    }
  ) });
};

// src/components/cs-table/cs-table.types.ts
var BenefitTableColumnNames = /* @__PURE__ */ ((BenefitTableColumnNames2) => {
  BenefitTableColumnNames2["Benefit"] = "benefit_title_case";
  BenefitTableColumnNames2["Status"] = "status";
  BenefitTableColumnNames2["CallToActionText"] = "call_to_action_text";
  return BenefitTableColumnNames2;
})(BenefitTableColumnNames || {});
var BenefitTableCellValues = /* @__PURE__ */ ((BenefitTableCellValues2) => {
  BenefitTableCellValues2["ClaimType"] = "claimType";
  BenefitTableCellValues2["Provider"] = "provider";
  BenefitTableCellValues2["StatusCell"] = "status";
  BenefitTableCellValues2["StartDate"] = "start_date";
  BenefitTableCellValues2["EndDate"] = "end_date";
  BenefitTableCellValues2["CallToAction"] = "call_to_action";
  return BenefitTableCellValues2;
})(BenefitTableCellValues || {});
var RewardProgramsColumnNames = /* @__PURE__ */ ((RewardProgramsColumnNames2) => {
  RewardProgramsColumnNames2["Program"] = "program";
  RewardProgramsColumnNames2["RewardsId"] = "rewards_id";
  RewardProgramsColumnNames2["StartDate"] = "start_date";
  RewardProgramsColumnNames2["EndDate"] = "end_date";
  RewardProgramsColumnNames2["RewardsStatus"] = "status";
  RewardProgramsColumnNames2["CallToActionLink"] = "call_to_action_text";
  return RewardProgramsColumnNames2;
})(RewardProgramsColumnNames || {});
var UserSessionsColumnNames = /* @__PURE__ */ ((UserSessionsColumnNames2) => {
  UserSessionsColumnNames2["Device"] = "device_title_case";
  UserSessionsColumnNames2["Platform"] = "platform";
  UserSessionsColumnNames2["AppVersion"] = "app_version";
  UserSessionsColumnNames2["LastAccessed"] = "last_accessed";
  return UserSessionsColumnNames2;
})(UserSessionsColumnNames || {});
var ConsentFormColumnNames = /* @__PURE__ */ ((ConsentFormColumnNames2) => {
  ConsentFormColumnNames2["FormName"] = "CS_FORM_NAME";
  ConsentFormColumnNames2["FormCompletionDate"] = "CS_COMPLETION_DATE";
  ConsentFormColumnNames2["FormValidationPeriod"] = "CS_VALIDATION_PERIOD";
  ConsentFormColumnNames2["FormStatus"] = "CS_FORM_STATUS";
  return ConsentFormColumnNames2;
})(ConsentFormColumnNames || {});
var HealthRiskAssessmentsColumnNames = /* @__PURE__ */ ((HealthRiskAssessmentsColumnNames2) => {
  HealthRiskAssessmentsColumnNames2["Name"] = "name";
  HealthRiskAssessmentsColumnNames2["CompletionDate"] = "completion_date";
  HealthRiskAssessmentsColumnNames2["Status"] = "status";
  return HealthRiskAssessmentsColumnNames2;
})(HealthRiskAssessmentsColumnNames || {});
var StandardProgramsColumnNames = /* @__PURE__ */ ((StandardProgramsColumnNames2) => {
  StandardProgramsColumnNames2["StandardProgram"] = "program";
  StandardProgramsColumnNames2["StandardProgramJoinedDate"] = "joined_date";
  StandardProgramsColumnNames2["StandardProgramEndDate"] = "end_date";
  StandardProgramsColumnNames2["StandardProgramStatus"] = "status";
  StandardProgramsColumnNames2["StandardCallToActionLink"] = "call_to_action_text";
  return StandardProgramsColumnNames2;
})(StandardProgramsColumnNames || {});
var ChallengesProgramNames = /* @__PURE__ */ ((ChallengesProgramNames2) => {
  ChallengesProgramNames2["Challenges"] = "challenges";
  ChallengesProgramNames2["ChallengesId"] = "challenges_id";
  ChallengesProgramNames2["ChallengesStartDate"] = "start_date";
  ChallengesProgramNames2["ChallengesEndDate"] = "end_date";
  ChallengesProgramNames2["ChallengesStatus"] = "status";
  ChallengesProgramNames2["ChallengesCallToActionLink"] = "call_to_action_text";
  return ChallengesProgramNames2;
})(ChallengesProgramNames || {});

// src/utils/map-status-colors.util.ts
import { CARD_STATUS as CARD_STATUS4, PILL_STATUS as PILL_STATUS4 } from "@leagueplatform/wallet-api";
import {
  UserHealthActivityStatus as UserHealthActivityStatus2,
  HEALTH_JOURNEY_ACTIVITY_STATUS
} from "@leagueplatform/health-journey-common";
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS2
} from "@leagueplatform/health-journey-api";
import {
  UserConsentStatus as UserConsentStatus2,
  HealthRiskAssessmentsStatus as HealthRiskAssessmentsStatus2,
  HealthGoalProgramsAdminStatus as HealthGoalProgramsAdminStatus2
} from "@leagueplatform/cse-customer-support-api";
var mapBenefitStatusColors = (status2) => {
  switch (status2) {
    case CARD_STATUS4.CREATED:
    case CARD_STATUS4.READY:
    case CARD_STATUS4.IN_WAITING_PERIOD:
    case PILL_STATUS4.PENDING:
      return "info" /* INFO */;
    case PILL_STATUS4.PAST:
    case CARD_STATUS4.INACTIVE:
    case CARD_STATUS4.INACTIVE_GRACE_PERIOD:
      return "warning" /* WARNING */;
    default:
      return "success" /* SUCCESS */;
  }
};
var mapJourneyStatusColors = (status2) => {
  switch (status2) {
    case UserHealthActivityStatus2.ACTIVE:
      return "info" /* INFO */;
    case UserHealthActivityStatus2.EXPIRED:
    case UserHealthActivityStatus2.REMOVED:
    case HEALTH_JOURNEY_ACTIVITY_STATUS.MISSED:
    case USER_HEALTH_CAMPAIGN_STATUS2.ENDED:
    case USER_HEALTH_CAMPAIGN_STATUS2.SUSPENDED:
    case UserHealthActivityStatus2.UPCOMING:
      return "neutral" /* NEUTRAL */;
    case UserHealthActivityStatus2.ON_HOLD:
      return "error" /* ERROR */;
    case UserHealthActivityStatus2.COMPLETED:
      return "success" /* SUCCESS */;
    default:
      return "neutral" /* NEUTRAL */;
  }
};
var mapAssessmentStatusColors = (status2) => {
  switch (status2) {
    case HealthRiskAssessmentsStatus2.IN_PROGRESS:
      return "warning" /* WARNING */;
    case HealthRiskAssessmentsStatus2.NOT_STARTED:
      return "error" /* ERROR */;
    case UserConsentStatus2.REJECTED:
      return "neutral" /* NEUTRAL */;
    case UserConsentStatus2.COMPLETED:
    case HealthRiskAssessmentsStatus2.COMPLETED:
      return "success" /* SUCCESS */;
    default:
      return "neutral" /* NEUTRAL */;
  }
};
var mapStandardProgramStatusColors = (status2) => {
  switch (status2) {
    case HealthGoalProgramsAdminStatus2.ACTIVE:
      return "info" /* INFO */;
    case HealthGoalProgramsAdminStatus2.QUIT:
    case HealthGoalProgramsAdminStatus2.UPCOMING:
      return "neutral" /* NEUTRAL */;
    case HealthGoalProgramsAdminStatus2.COMPLETED:
      return "success" /* SUCCESS */;
    default:
      return "neutral" /* NEUTRAL */;
  }
};
var mapChallengesStatusColors = (status2) => {
  switch (status2) {
    case "active":
    case "enrolled":
      return "info" /* INFO */;
    case "completed":
      return "success" /* SUCCESS */;
    case "on-hold":
      return "error" /* ERROR */;
    case "ended":
    case "quit":
    case "upcoming":
    case "expired":
    case "suspended":
    default:
      return "neutral" /* NEUTRAL */;
  }
};

// src/components/cs-table/cs-table-common/cs-table-item-date/cs-table-item-date.component.tsx
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout12,
  ParagraphText as ParagraphText6,
  VisuallyHidden as VisuallyHidden3
} from "@leagueplatform/genesis-core";
import { jsx as jsx19, jsxs as jsxs9 } from "react/jsx-runtime";
var CsTableItemDate = ({
  date,
  isLongDateFormat,
  timeZone,
  css: css2
}) => {
  const { formatDate, formatMessage } = useIntl12();
  if (date === "" || date === void 0)
    return /* @__PURE__ */ jsxs9(ParagraphText6, { size: "base", children: [
      /* @__PURE__ */ jsx19(VisuallyHidden3, { children: formatMessage({ id: "CS_NO_DATE_AVAILABLE" }) }),
      /* @__PURE__ */ jsx19("span", { "aria-hidden": true, children: "-" })
    ] });
  return /* @__PURE__ */ jsx19(StackLayout12, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx19(ParagraphText6, { size: "base", css: css2, children: isLongDateFormat ? formatDate(date, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
    timeZone
  }) : formatDate(date, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone
  }) }) });
};

// src/utils/cs-table-with-action.utils.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
function generateCell(rowIndex, name, value) {
  return {
    id: `${rowIndex}-${name}`,
    name,
    value
  };
}
var { Benefit, Status, CallToActionText } = BenefitTableColumnNames;
var generateBenefitListRow = (benefit, rowIndex) => {
  var _a, _b;
  const benefitStatusColor = mapBenefitStatusColors(
    benefit.status
  );
  return {
    id: `benefit-${rowIndex}`,
    cells: [
      generateCell(rowIndex, Benefit, /* @__PURE__ */ jsx20(BenefitListName, { benefit })),
      generateCell(
        rowIndex,
        Status,
        /* @__PURE__ */ jsx20(
          CsTableStatusBadge,
          {
            status: benefitStatusColor,
            label: normalizeBenefitStatus(benefit.status).toLocaleUpperCase()
          }
        )
      ),
      generateCell(
        rowIndex,
        CallToActionText,
        /* @__PURE__ */ jsx20(
          CSTableItemLink,
          {
            parameter: benefit == null ? void 0 : benefit.benefit_id,
            ariaLabel: "VIEW_BENEFIT_LABEL_HIDDEN",
            ariaCustom: benefit.name.text,
            analytics: `view ${(_a = benefit.name.text) == null ? void 0 : _a.toLowerCase()} ${(_b = benefit == null ? void 0 : benefit.displayVendor) == null ? void 0 : _b.toLowerCase()} benefit`
          }
        )
      )
    ]
  };
};
var generateBenefitListRows = (benefits) => benefits.reduce(
  (benefitRows, benefit, rowIndex) => [
    ...benefitRows,
    generateBenefitListRow(benefit, rowIndex)
  ],
  []
);
var {
  Program,
  RewardsId,
  StartDate,
  EndDate,
  RewardsStatus,
  CallToActionLink
} = RewardProgramsColumnNames;
var generateRewardListRow = (reward, rowIndex, timeZone) => {
  var _a;
  const rewardStatusColour = mapJourneyStatusColors(
    reward.attributes.status.toLocaleLowerCase()
  );
  const rewardStatusLabel = normalizeRewardStatus(
    reward.attributes.status.toLocaleLowerCase()
  );
  return {
    id: `reward-${rowIndex}`,
    cells: [
      generateCell(
        rowIndex,
        Program,
        /* @__PURE__ */ jsx20(
          StackLayout13,
          {
            orientation: "horizontal",
            verticalAlignment: "center",
            css: { flex: "0", marginRight: "$quarter" },
            children: /* @__PURE__ */ jsx20(UtilityText3, { emphasis: "emphasized", children: reward.attributes.programName })
          }
        )
      ),
      generateCell(
        rowIndex,
        RewardsId,
        /* @__PURE__ */ jsx20(StackLayout13, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx20(ParagraphText7, { size: "base", css: { wordBreak: "break-all" }, children: reward.attributes.externalCampaignId }) })
      ),
      generateCell(
        rowIndex,
        StartDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: reward.attributes.programStartDate,
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        EndDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: reward.attributes.programEndDate,
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        RewardsStatus,
        /* @__PURE__ */ jsx20(
          CsTableStatusBadge,
          {
            status: rewardStatusColour,
            label: rewardStatusLabel
          }
        )
      ),
      generateCell(
        rowIndex,
        CallToActionLink,
        /* @__PURE__ */ jsx20(
          CSTableItemLink,
          {
            parameter: reward.id,
            ariaCustom: reward.attributes.name,
            ariaLabel: "VIEW_REWARD_LABEL_HIDDEN",
            analytics: `view ${(_a = reward.attributes.name) == null ? void 0 : _a.toLowerCase()} program`
          }
        )
      )
    ]
  };
};
var generateRewardsListRows = (rewards, timeZone) => rewards.reduce(
  (rewardRows, reward, rowIndex) => [
    ...rewardRows,
    generateRewardListRow(reward, rowIndex, timeZone)
  ],
  []
);
var {
  StandardProgram,
  StandardProgramJoinedDate,
  StandardProgramEndDate,
  StandardProgramStatus,
  StandardCallToActionLink
} = StandardProgramsColumnNames;
var generateStandardProgramRow = (standardProgram, rowIndex, timeZone) => {
  var _a;
  return {
    id: `standard-program-${rowIndex}`,
    cells: [
      generateCell(
        rowIndex,
        StandardProgram,
        /* @__PURE__ */ jsx20(
          StackLayout13,
          {
            orientation: "horizontal",
            verticalAlignment: "center",
            css: { flex: "0", marginRight: "$quarter" },
            children: /* @__PURE__ */ jsx20(UtilityText3, { emphasis: "emphasized", children: standardProgram.name })
          }
        )
      ),
      generateCell(
        rowIndex,
        StandardProgramJoinedDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: standardProgram.startDate,
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        StandardProgramEndDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: standardProgram.endDate || "",
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        StandardProgramStatus,
        /* @__PURE__ */ jsx20(
          CsTableStatusBadge,
          {
            status: mapStandardProgramStatusColors(standardProgram.status),
            label: normalizeStandardProgramStatusLabel(standardProgram.status)
          }
        )
      ),
      generateCell(
        rowIndex,
        StandardCallToActionLink,
        /* @__PURE__ */ jsx20(
          CSTableItemLink,
          {
            parameter: `${standardProgram.programId}/${standardProgram.userProgramId}`,
            ariaCustom: standardProgram.name,
            ariaLabel: "VIEW_REWARD_LABEL_HIDDEN",
            analytics: `view ${(_a = standardProgram.name) == null ? void 0 : _a.toLowerCase()} program`
          }
        )
      )
    ]
  };
};
var generateStandardProgramsListRows = (standardPrograms, timeZone) => standardPrograms.reduce(
  (standardProgramRows, standardProgram, rowIndex) => [
    ...standardProgramRows,
    generateStandardProgramRow(standardProgram, rowIndex, timeZone)
  ],
  []
);
var {
  Challenges,
  ChallengesId,
  ChallengesCallToActionLink,
  ChallengesEndDate,
  ChallengesStartDate,
  ChallengesStatus
} = ChallengesProgramNames;
var generateChallengesProgramRow = (challenge, rowIndex, timeZone) => {
  var _a;
  return {
    id: `challenge-${rowIndex}`,
    cells: [
      generateCell(
        rowIndex,
        Challenges,
        /* @__PURE__ */ jsx20(
          StackLayout13,
          {
            orientation: "horizontal",
            verticalAlignment: "center",
            css: { flex: "0", marginRight: "$quarter" },
            children: /* @__PURE__ */ jsx20(UtilityText3, { emphasis: "emphasized", children: challenge.challenge.data.title })
          }
        )
      ),
      generateCell(
        rowIndex,
        ChallengesId,
        /* @__PURE__ */ jsx20(StackLayout13, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx20(UtilityText3, { css: { wordBreak: "break-all" }, children: challenge.challenge.data.externalCampaignId }) })
      ),
      generateCell(
        rowIndex,
        ChallengesStartDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: challenge.challenge.data.startDate,
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        ChallengesEndDate,
        /* @__PURE__ */ jsx20(
          CsTableItemDate,
          {
            date: challenge.displayDate || "",
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell(
        rowIndex,
        ChallengesStatus,
        /* @__PURE__ */ jsx20(
          CsTableStatusBadge,
          {
            status: mapChallengesStatusColors(challenge.status),
            label: normalizeChallengesStatusLabel(challenge.status)
          }
        )
      ),
      generateCell(
        rowIndex,
        ChallengesCallToActionLink,
        /* @__PURE__ */ jsx20(
          CSTableItemLink,
          {
            parameter: `${challenge.id}/${challenge.challenge.data.id}`,
            ariaCustom: challenge.challenge.data.title,
            ariaLabel: "VIEW_REWARD_LABEL_HIDDEN",
            analytics: `view ${(_a = challenge.challenge.data.title) == null ? void 0 : _a.toLowerCase()} challenge`
          }
        )
      )
    ]
  };
};
var generateChallengesProgramsListRows = (challenges, timeZone) => challenges.reduce(
  (challengesRow, challenge, rowIndex) => [
    ...challengesRow,
    generateChallengesProgramRow(challenge, rowIndex, timeZone)
  ],
  []
);

// src/pages/member-wallet-page/member-wallet-page.component.tsx
import { Fragment as Fragment2, jsx as jsx21, jsxs as jsxs10 } from "react/jsx-runtime";
var BenefitsBox = styled3(Box10, {
  marginTop: "$oneAndHalf",
  "&:focus": {
    boxShadow: "rgba(0, 0, 0, 0.5)",
    outline: "$interactiveFocusOuter"
  }
});
var { Benefit: Benefit2, Status: Status2, CallToActionText: CallToActionText2 } = BenefitTableColumnNames;
var { ClaimType, Provider, StatusCell, CallToAction } = BenefitTableCellValues;
var tableArray = [
  {
    column: Benefit2,
    rows: [ClaimType, Provider]
  },
  {
    column: Status2,
    rows: StatusCell
  },
  {
    column: CallToActionText2,
    rows: CallToAction
  }
];
var BENEFITS_HEADING_ID = "benefits-section";
var MemberWalletPage = ({ targetUserId }) => {
  const [searchQuery, setSearchQuery] = useState4("");
  const [selectQuery, setSelectQuery] = useState4("");
  const { formatMessage } = useIntl13();
  const { sortedBenefitSections, isLoading, isError, error } = useMemberWalletPage(targetUserId);
  const { benefitSelectOptions } = useSelectOptions(targetUserId);
  const searchFiltered = getFilterBenefitsList(searchQuery, selectQuery);
  const showSelectFilter = (benefitSelectOptions == null ? void 0 : benefitSelectOptions.length) > 2;
  const isBenefitsTableEmpty = (sortedBenefitSections == null ? void 0 : sortedBenefitSections.length) === 0 || sortedBenefitSections === void 0;
  const isSearchInputEmpty = !searchQuery;
  const columns = tableArray.map((column) => ({
    id: `column-${column.column}`,
    name: column.column,
    value: formatMessage({ id: column.column.toLocaleUpperCase() })
  }));
  let rows;
  if (sortedBenefitSections) {
    const generateRow = searchFiltered(sortedBenefitSections);
    rows = generateBenefitListRows(generateRow);
  }
  usePageViewAnalytics({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit summary" /* BENEFIT_SUMMARY */
  });
  if (isLoading)
    return /* @__PURE__ */ jsx21(LoadingIndicator3, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx21(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx21(
      ErrorState3,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx21("br", {}) }
        )
      }
    ) });
  }
  if (isBenefitsTableEmpty) {
    return /* @__PURE__ */ jsx21(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx21(
      ErrorState3,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "NO_BENEFITS_AVAILABLE_HEADING" }),
        imageSrc: handleStaticAsset3("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  }
  return /* @__PURE__ */ jsxs10(Fragment2, { children: [
    /* @__PURE__ */ jsx21(
      HeadingText4,
      {
        level: "2",
        size: "lg",
        id: BENEFITS_HEADING_ID,
        css: { marginBottom: "$one" },
        children: formatMessage({ id: "BENEFITS" })
      }
    ),
    /* @__PURE__ */ jsxs10(StackLayout14, { orientation: "horizontal", horizontalAlignment: "spaceBetween", children: [
      /* @__PURE__ */ jsx21(
        SearchFilter,
        {
          name: formatMessage({ id: "WALLET" }),
          placeholder: formatMessage({ id: "SEARCH_BENEFITS_PLACEHOLDER" }),
          userSearchValue: (search) => setSearchQuery(search),
          showClearable: !isSearchInputEmpty
        }
      ),
      showSelectFilter && /* @__PURE__ */ jsx21(
        SelectFilter,
        {
          options: benefitSelectOptions,
          filterBenefits: (filter) => setSelectQuery(filter)
        }
      )
    ] }),
    sortedBenefitSections && /* @__PURE__ */ jsxs10(
      BenefitsBox,
      {
        role: "region",
        "aria-labelledby": BENEFITS_HEADING_ID,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ jsx21(VisuallyHidden4, { children: /* @__PURE__ */ jsx21(Box10, { as: "span", "aria-atomic": "true", "aria-live": "polite", children: formatMessage(
            { id: "X_OF_Y_BENEFITS" },
            {
              visibleAmount: searchFiltered(sortedBenefitSections).length,
              totalAmount: sortedBenefitSections.length
            }
          ) }) }),
          /* @__PURE__ */ jsx21(
            CSTableWithAction,
            {
              columns,
              rows,
              lastRowCustomCSS: "60%",
              noDataText: formatMessage({ id: "NO_FILTERED_BENEFITS" }),
              columnWidth: "250px"
            }
          )
        ]
      }
    )
  ] });
};

// src/pages/member-journey-page/member-journey-page.component.tsx
import React11 from "react";
import { Box as Box12, HeadingText as HeadingText5, Tabs as Tabs2, styled as styled4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import {
  ErrorState as ErrorState7,
  LoadingIndicator as LoadingIndicator7
} from "@leagueplatform/web-common-components";

// src/pages/member-journey-page/components/challenges/challenges-component.tsx
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import { StackLayout as StackLayout15 } from "@leagueplatform/genesis-core";
import {
  ErrorState as ErrorState4,
  LoadingIndicator as LoadingIndicator4
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
import { usePageViewAnalytics as usePageViewAnalytics2 } from "@leagueplatform/analytics";
import { isEmpty } from "lodash-es";

// src/components/view-more-button/view-more-button.component.tsx
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { Button as Button3, Box as Box11, ParagraphText as ParagraphText8 } from "@leagueplatform/genesis-core";
import { Fragment as Fragment3, jsx as jsx22, jsxs as jsxs11 } from "react/jsx-runtime";
var ViewMoreButton = ({
  showCopy,
  onClick,
  hideButton
}) => {
  const { formatMessage } = useIntl14();
  return /* @__PURE__ */ jsxs11(Fragment3, { children: [
    /* @__PURE__ */ jsx22(
      Box11,
      {
        css: {
          padding: "$one $threeQuarters",
          display: hideButton ? "none" : "block"
        },
        children: /* @__PURE__ */ jsx22(Button3, { as: "button", priority: "tertiary", size: "medium", onClick, children: formatMessage({ id: "VIEW_MORE" }) })
      }
    ),
    /* @__PURE__ */ jsx22(
      ParagraphText8,
      {
        css: {
          typography: "$caption",
          display: hideButton && showCopy ? "block" : "none",
          marginTop: "$half"
        },
        children: formatMessage({ id: "CS_END_OF_LIST" })
      }
    )
  ] });
};

// src/hooks/use-display-more.hook.ts
import { EVENT_NAME as EVENT_NAME10 } from "@leagueplatform/analytics";
import { useEffect as useEffect2, useState as useState5, useCallback as useCallback5 } from "react";
var useDisplayMore = (initialLength, trackAnalytics, currentLength) => {
  const [sessionView, setSessionView] = useState5(initialLength);
  const hideButton = !!(currentLength && sessionView >= currentLength);
  const addMore = useCallback5(() => {
    trackAnalytics(EVENT_NAME10.BUTTON_CLICKED);
    if (currentLength && sessionView <= currentLength) {
      return setSessionView(sessionView + initialLength);
    }
    return sessionView;
  }, [currentLength, initialLength, sessionView, trackAnalytics]);
  useEffect2(() => {
    setSessionView(initialLength);
  }, [initialLength]);
  return { hideButton, addMore, sessionView };
};

// src/utils/query-status.utils.ts
var simulateIsIdle = (isLoading, isSuccess, data) => !isLoading && !isSuccess && !data;

// src/pages/member-journey-page/components/challenges/hooks/use-get-user-challenges-query.hook.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getUserChallenges,
  GET_USER_CHALLENGES
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError4 } from "@leagueplatform/observability";
function useGetUserChallenges(userId, options) {
  return useQuery3([GET_USER_CHALLENGES, userId], () => getUserChallenges(userId), __spreadValues({
    staleTime: Infinity,
    onError: (error) => {
      captureError4(
        new Error(
          `Customer Support: Failed to get user health goal programs summary (member id: ${userId}): ${error}`
        )
      );
    }
  }, options));
}

// src/pages/member-journey-page/components/challenges/challenges-component.tsx
import { jsx as jsx23, jsxs as jsxs12 } from "react/jsx-runtime";
var {
  Challenges: Challenges2,
  ChallengesId: ChallengesId2,
  ChallengesStartDate: ChallengesStartDate2,
  ChallengesEndDate: ChallengesEndDate2,
  ChallengesStatus: ChallengesStatus2,
  ChallengesCallToActionLink: ChallengesCallToActionLink2
} = ChallengesProgramNames;
var tableColumnArray = [
  Challenges2,
  ChallengesId2,
  ChallengesStartDate2,
  ChallengesEndDate2,
  ChallengesStatus2,
  ChallengesCallToActionLink2
];
var JourneyChallenges = ({
  timeZone,
  targetUserId
}) => {
  var _a, _b;
  const { formatMessage } = useIntl15();
  const userId = targetUserId;
  const { isError, isLoading, isSuccess, data, error } = useGetUserChallenges(userId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, data);
  const currentLength = (_b = (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.length) != null ? _b : 0;
  const initialLength = VIEW_MORE_SESSIONS.JOURNEY_PROGRAM_INITIAL_RECENT_SESSIONS;
  const showCopy = currentLength > initialLength;
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "challenges summary" /* CHALLENGES_SUMMARY */,
    detail: "view more sessions" /* VIEW_MORE_SESSIONS */
  });
  usePageViewAnalytics2({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "challenges summary" /* CHALLENGES_SUMMARY */
  });
  const {
    hideButton: hideViewMoreButton,
    addMore,
    sessionView
  } = useDisplayMore(initialLength, sendAnalyticsEvent, currentLength);
  if (isError)
    return /* @__PURE__ */ jsx23(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx23(
      ErrorState4,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx23("br", {}) }
        )
      }
    ) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx23(LoadingIndicator4, { inline: true });
  const challenges = data.data.map((challenge) => {
    if (challenge.status === "quit") {
      return __spreadValues({ displayDate: challenge.quitDate }, challenge);
    }
    return __spreadValues({ displayDate: challenge.challenge.data.endDate }, challenge);
  });
  const columns = tableColumnArray.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  const rows = generateChallengesProgramsListRows(
    challenges.slice(0, sessionView),
    timeZone
  );
  const isChallengesEmpty = isEmpty(challenges);
  if (isChallengesEmpty) {
    return /* @__PURE__ */ jsx23(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx23(
      ErrorState4,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "CS_NO_CHALLENGES" }),
        imageSrc: handleStaticAsset4("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  }
  return /* @__PURE__ */ jsxs12(StackLayout15, { children: [
    /* @__PURE__ */ jsx23(
      CSTableWithAction,
      {
        columns,
        rows,
        lastRowCustomCSS: "$one",
        columnWidth: "20%"
      }
    ),
    /* @__PURE__ */ jsx23(
      ViewMoreButton,
      {
        hideButton: hideViewMoreButton,
        showCopy,
        onClick: addMore
      }
    )
  ] });
};

// src/pages/member-journey-page/components/rewards-programs/rewards-programs.component.tsx
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator5,
  ErrorState as ErrorState5
} from "@leagueplatform/web-common-components";
import { usePageViewAnalytics as usePageViewAnalytics3 } from "@leagueplatform/analytics";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";

// src/pages/member-journey-page/components/rewards-programs/hooks/use-get-user-health-campaigns-query.hook.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
import {
  getUserHealthCampaigns,
  GET_USER_HEALTH_CAMPAIGNS
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError5 } from "@leagueplatform/observability";
function useGetUserHealthCampaignsQuery(userId, options) {
  return useQuery4(
    [GET_USER_HEALTH_CAMPAIGNS, userId],
    () => getUserHealthCampaigns(userId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError5(
          new Error(
            `Customer Support: Failed to get user health campaign data (member id: ${userId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-journey-page/components/rewards-programs/hooks/use-get-user-health-campaign.hook.ts
function useGetFormattedData({
  data,
  included
}) {
  if (!data.length)
    return data;
  [...data].map(
    (reward, i) => included.filter(
      (campaign) => reward.attributes.campaignId === campaign.id && Object.assign(data[i].attributes, {
        externalCampaignId: campaign.attributes.externalCampaignId,
        programName: campaign.attributes.name,
        programEndDate: campaign.attributes.endDate,
        programStartDate: campaign.attributes.startDate
      })
    )
  );
  return data;
}
function useGetUserHealthCampaigns(targetUserId) {
  const userId = targetUserId;
  return useGetUserHealthCampaignsQuery(userId, {
    select: useGetFormattedData
  });
}

// src/pages/member-journey-page/components/rewards-programs/rewards-programs.component.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var {
  Program: Program2,
  RewardsId: RewardsId2,
  StartDate: StartDate2,
  EndDate: EndDate2,
  RewardsStatus: RewardsStatus2,
  CallToActionLink: CallToActionLink2
} = RewardProgramsColumnNames;
var tableColumnArray2 = [
  Program2,
  RewardsId2,
  StartDate2,
  EndDate2,
  RewardsStatus2,
  CallToActionLink2
];
var RewardsPrograms = ({
  targetUserId,
  timeZone
}) => {
  const { formatMessage } = useIntl16();
  usePageViewAnalytics3({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program summary" /* REWARD_SUMMARY */
  });
  const {
    data: rewardPrograms,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetUserHealthCampaigns(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, rewardPrograms);
  if (isError)
    return /* @__PURE__ */ jsx24(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx24(
      ErrorState5,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx24("br", {}) }
        )
      }
    ) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx24(LoadingIndicator5, { inline: true });
  const isRewardsProgramEmpty = (rewardPrograms == null ? void 0 : rewardPrograms.length) === 0 || rewardPrograms === void 0;
  const columns = tableColumnArray2.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  let rows;
  if (rewardPrograms) {
    rows = generateRewardsListRows(rewardPrograms, timeZone);
  }
  if (isRewardsProgramEmpty) {
    return /* @__PURE__ */ jsx24(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx24(
      ErrorState5,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "NO_REWARDS_AVAILABLE_HEADING" }),
        imageSrc: handleStaticAsset5("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  }
  return /* @__PURE__ */ jsx24(
    CSTableWithAction,
    {
      columns,
      rows,
      lastRowCustomCSS: "$one",
      columnWidth: "20%"
    }
  );
};

// src/pages/member-journey-page/components/standard-programs/standard-programs.component.tsx
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import { StackLayout as StackLayout16 } from "@leagueplatform/genesis-core";
import { usePageViewAnalytics as usePageViewAnalytics4 } from "@leagueplatform/analytics";
import {
  ErrorState as ErrorState6,
  LoadingIndicator as LoadingIndicator6
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";

// src/pages/member-journey-page/components/standard-programs/hooks/use-get-user-health-goal-programs-for-admin.hook.ts
import {
  HealthGoalProgramsAdminStatus as HealthGoalProgramsAdminStatus3
} from "@leagueplatform/cse-customer-support-api";

// src/pages/member-journey-page/components/standard-programs/hooks/use-get-user-health-goal-programs-for-admin-query.hook.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
import {
  getUserHealthGoalProgramsForAdmin,
  GET_USER_HEALTH_GOAL_PROGRAMS_FOR_ADMIN
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError6 } from "@leagueplatform/observability";
function useGetUserHealthGoalProgramsForAdminQuery(userId, options) {
  return useQuery5(
    [GET_USER_HEALTH_GOAL_PROGRAMS_FOR_ADMIN, userId],
    () => getUserHealthGoalProgramsForAdmin(userId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError6(
          new Error(
            `Customer Support: Failed to get user health goal programs summary (member id: ${userId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-journey-page/components/standard-programs/hooks/use-get-user-health-goal-programs-for-admin.hook.ts
function getFormattedData({
  user_programs
}) {
  if (!user_programs.length)
    return user_programs;
  const programs = user_programs.map(
    (program) => {
      let endDate = program.end_date;
      if (program.status === HealthGoalProgramsAdminStatus3.QUIT) {
        endDate = program.quit_date;
      }
      return {
        endDate,
        name: program.name,
        programId: program.campaign_id,
        userProgramId: program.user_health_campaign_id,
        startDate: program.start_date,
        status: program.status
      };
    }
  );
  return programs;
}
function useGetUserHealthGoalProgramsForAdmin(targetUserId) {
  const userId = targetUserId;
  return useGetUserHealthGoalProgramsForAdminQuery(userId, {
    select: getFormattedData
  });
}

// src/pages/member-journey-page/components/standard-programs/standard-programs.component.tsx
import { jsx as jsx25, jsxs as jsxs13 } from "react/jsx-runtime";
var {
  StandardProgram: StandardProgram2,
  StandardProgramJoinedDate: StandardProgramJoinedDate2,
  StandardProgramEndDate: StandardProgramEndDate2,
  StandardProgramStatus: StandardProgramStatus2,
  StandardCallToActionLink: StandardCallToActionLink2
} = StandardProgramsColumnNames;
var tableColumnArray3 = [
  StandardProgram2,
  StandardProgramJoinedDate2,
  StandardProgramEndDate2,
  StandardProgramStatus2,
  StandardCallToActionLink2
];
var StandardPrograms = ({
  targetUserId,
  timeZone
}) => {
  var _a;
  const { formatMessage } = useIntl17();
  const {
    data: standardPrograms,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetUserHealthGoalProgramsForAdmin(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, standardPrograms);
  const currentLength = (_a = standardPrograms == null ? void 0 : standardPrograms.length) != null ? _a : 0;
  const initialLength = VIEW_MORE_SESSIONS.JOURNEY_PROGRAM_INITIAL_RECENT_SESSIONS;
  const showCopy = currentLength > initialLength;
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "standard program summary" /* STANDARD_PROGRAM_SUMMARY */,
    detail: "view more sessions" /* VIEW_MORE_SESSIONS */
  });
  usePageViewAnalytics4({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "standard program summary" /* STANDARD_PROGRAM_SUMMARY */
  });
  const {
    hideButton: hideViewMoreButton,
    addMore,
    sessionView
  } = useDisplayMore(initialLength, sendAnalyticsEvent, currentLength);
  if (isError)
    return /* @__PURE__ */ jsx25(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx25(
      ErrorState6,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx25("br", {}) }
        )
      }
    ) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx25(LoadingIndicator6, { inline: true });
  const isStandardProgramsEmpty = standardPrograms.length === 0 || standardPrograms === void 0;
  const columns = tableColumnArray3.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  const rows = generateStandardProgramsListRows(
    standardPrograms.slice(0, sessionView),
    timeZone
  );
  if (isStandardProgramsEmpty) {
    return /* @__PURE__ */ jsx25(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx25(
      ErrorState6,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "CS_NO_STANDARD_PROGRAMS" }),
        imageSrc: handleStaticAsset6("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  }
  return /* @__PURE__ */ jsxs13(StackLayout16, { children: [
    /* @__PURE__ */ jsx25(
      CSTableWithAction,
      {
        columns,
        rows,
        lastRowCustomCSS: "$one",
        columnWidth: "25%"
      }
    ),
    /* @__PURE__ */ jsx25(
      ViewMoreButton,
      {
        hideButton: hideViewMoreButton,
        showCopy,
        onClick: addMore
      }
    )
  ] });
};

// src/pages/member-journey-page/member-journey-page.component.tsx
import { jsx as jsx26, jsxs as jsxs14 } from "react/jsx-runtime";
var StyledTabPanel = styled4(Tabs2.TabPanel, {
  padding: "$zero $zero $two"
});
var StackedTabs2 = styled4(Tabs2.Root, {
  display: "flex",
  flexDirection: "column",
  overflowY: "hidden",
  width: "100%",
  height: "100%"
});
var MemberJourneyPage = ({ targetUserId }) => {
  const { formatMessage } = useIntl18();
  const { tabIndex, handleTabsChange, journeyRoutes } = useMemberJourney();
  const targetId = targetUserId;
  const { timeZone, isError, isLoading, error } = useGetTargetUserInfo(targetId);
  if (isError)
    return /* @__PURE__ */ jsx26(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx26(
      ErrorState7,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx26("br", {}) }
        )
      }
    ) });
  if (isLoading)
    return /* @__PURE__ */ jsx26(LoadingIndicator7, { inline: true });
  return /* @__PURE__ */ jsxs14(
    StackedTabs2,
    {
      defaultValue: journeyRoutes[0].tabName,
      value: journeyRoutes[tabIndex].tabName || journeyRoutes[0].tabName,
      onValueChange: (currentTabValue) => {
        const currentTabIndex = journeyRoutes.findIndex(
          (tab) => tab.tabName === currentTabValue
        );
        handleTabsChange(currentTabIndex);
      },
      children: [
        /* @__PURE__ */ jsxs14(Box12, { children: [
          /* @__PURE__ */ jsx26(HeadingText5, { level: "2", size: "lg", css: { marginBottom: "$one" }, children: formatMessage({ id: "JOURNEY" }) }),
          /* @__PURE__ */ jsx26(
            Tabs2.TabList,
            {
              tabDistribution: "hugContents",
              css: {
                marginBottom: "25px",
                borderBottom: "none",
                borderColor: "none"
              },
              children: journeyRoutes == null ? void 0 : journeyRoutes.map((tab) => /* @__PURE__ */ jsx26(Tabs2.Tab, { value: tab.tabName, children: formatMessage({ id: tab.tabName }) }, tab.tabName))
            }
          )
        ] }),
        /* @__PURE__ */ jsx26(
          Box12,
          {
            css: {
              overflowY: "auto"
            },
            children: journeyRoutes == null ? void 0 : journeyRoutes.map((routes, i) => /* @__PURE__ */ jsxs14(React11.Fragment, { children: [
              routes.tabName === "REWARDS_PROGRAMS" && /* @__PURE__ */ jsx26(StyledTabPanel, { value: journeyRoutes[i].tabName, children: /* @__PURE__ */ jsx26(
                RewardsPrograms,
                {
                  targetUserId,
                  timeZone
                }
              ) }),
              routes.tabName === "CHALLENGES" && /* @__PURE__ */ jsx26(StyledTabPanel, { value: journeyRoutes[i].tabName, children: /* @__PURE__ */ jsx26(
                JourneyChallenges,
                {
                  targetUserId,
                  timeZone
                }
              ) }),
              routes.tabName === "STANDARD_PROGRAMS" && /* @__PURE__ */ jsx26(StyledTabPanel, { value: journeyRoutes[i].tabName, children: /* @__PURE__ */ jsx26(
                StandardPrograms,
                {
                  targetUserId,
                  timeZone
                }
              ) })
            ] }, routes.tabName))
          }
        )
      ]
    }
  );
};

// src/pages/member-claims-page/member-claims-page.component.tsx
import { Box as Box13, Responsive } from "@leagueplatform/genesis-core";
import { usePageViewAnalytics as usePageViewAnalytics5 } from "@leagueplatform/analytics";
import {
  ClaimsErrorState as ClaimsErrorState2,
  ClaimsSummarySidebar
} from "@leagueplatform/claims-ui";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import { LoadingIndicator as LoadingIndicator10 } from "@leagueplatform/web-common-components";

// src/pages/member-claims-page/hooks/use-active-filter-count.hook.ts
import {
  useClaimsFilters,
  useSelectedDateRange
} from "@leagueplatform/claims-common";
function useActiveFilterCount() {
  const filters = useClaimsFilters();
  const selectedDateRange = useSelectedDateRange();
  let filterCount = Object.values(filters).filter(Boolean).length;
  if (selectedDateRange) {
    filterCount += 1;
  }
  return filterCount;
}

// src/pages/member-claims-page/components/claims-summary-sidebar-mobile/claims-summary-sidebar-mobile.container.tsx
import * as React12 from "react";
import { EVENT_NAME as EVENT_NAME11 } from "@leagueplatform/analytics";
import {
  ClaimsSummarySidebarMobile
} from "@leagueplatform/claims-ui";
import { jsx as jsx27 } from "react/jsx-runtime";
function ClaimsSummarySidebarMobileContainer({
  renderHelpfulLinks
}) {
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims summary" /* CLAIMS_SUMMARY */,
    detail: "helpful links" /* HELPFUL_LINKS */
  });
  const handleModalClose = React12.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME11.BUTTON_CLICKED, {
      sub_detail: "close"
    });
  }, [sendAnalyticsEvent]);
  const handleHelpfulLinksClick = React12.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME11.BUTTON_CLICKED);
  }, [sendAnalyticsEvent]);
  return /* @__PURE__ */ jsx27(
    ClaimsSummarySidebarMobile,
    {
      renderHelpfulLinks,
      onModalClose: handleModalClose,
      onHelpfulLinksClick: handleHelpfulLinksClick
    }
  );
}

// src/pages/member-claims-page/components/claims-helpful-links/claims-helpful-links.container.tsx
import * as React13 from "react";
import { EVENT_NAME as EVENT_NAME12 } from "@leagueplatform/analytics";
import { ClaimsHelpfulLinks } from "@leagueplatform/claims-ui";

// src/pages/member-claims-page/hooks/use-claims-config.hook.ts
function useClaimsConfig() {
  return useCustomerSupportConfig("claimsInquiry");
}

// src/pages/member-claims-page/hooks/use-download-claims-summary-query.hook.ts
import {
  GET_DOWNLOAD_CLAIMS_SUMMARY_PATH,
  getDownloadClaimsSummaryBlobAsFile
} from "@leagueplatform/claims-api";
import { useQuery as useQuery6 } from "@tanstack/react-query";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import {
  useSelectedDateRange as useSelectedDateRange2,
  selectStartEndDates
} from "@leagueplatform/claims-common";
function useDownloadClaimsSummaryQuery() {
  const selectedDateRange = useSelectedDateRange2();
  const { startDate, endDate } = selectStartEndDates(selectedDateRange);
  const userId = useTargetUserId();
  return useQuery6(
    [GET_DOWNLOAD_CLAIMS_SUMMARY_PATH, startDate, endDate, userId],
    () => getDownloadClaimsSummaryBlobAsFile(startDate, endDate, userId),
    {
      enabled: false,
      retry: false,
      cacheTime: 0,
      onError() {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "PLAIN_SOMETHING_WENT_WRONG",
          contentId: "CLAIMS_SUMMARY_DOWNLOAD_ERROR"
        });
      }
    }
  );
}

// src/pages/member-claims-page/components/claims-helpful-links/claims-helpful-links.container.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
function ClaimsHelpfulLinksContainer() {
  const { showClaimStatusDefinitions, featureFlags, filterableProperties } = useClaimsConfig();
  const { refetch: downloadClaimsSummary, isFetching: isDownloadingClaims } = useDownloadClaimsSummaryQuery();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims summary" /* CLAIMS_SUMMARY */,
    detail: "helpful links" /* HELPFUL_LINKS */
  });
  const handleDownloadClaimsClick = React13.useCallback(() => {
    downloadClaimsSummary();
    sendAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
      sub_detail: "download claims"
    });
  }, [downloadClaimsSummary, sendAnalyticsEvent]);
  const handleHowClaimsWorkToggle = React13.useCallback(
    (showHowClaimsWork) => {
      sendAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
        sub_detail: showHowClaimsWork ? "close" : "how claims work"
      });
    },
    [sendAnalyticsEvent]
  );
  const handleStatusDefinitionsToggle = React13.useCallback(
    (showDefinitions) => {
      sendAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
        sub_detail: showDefinitions ? "close" : "claims status definitions"
      });
    },
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx28(
    ClaimsHelpfulLinks,
    {
      showClaimStatusDefinitions: !!showClaimStatusDefinitions,
      showDownloadClaims: featureFlags.shouldShowDownloadClaims,
      claimStatuses: filterableProperties.status,
      onDownloadClaimsClick: handleDownloadClaimsClick,
      isDownloadingClaims,
      onHowClaimsWorkToggle: handleHowClaimsWorkToggle,
      onStatusDefinitionsToggle: handleStatusDefinitionsToggle
    }
  );
}

// src/pages/member-claims-page/components/claims-card-list/claims-card-list.container.tsx
import * as React14 from "react";
import { EVENT_NAME as EVENT_NAME13 } from "@leagueplatform/analytics";
import { ClaimsCardList, ClaimsErrorState } from "@leagueplatform/claims-ui";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { LoadingIndicator as LoadingIndicator8 } from "@leagueplatform/web-common-components";
import {
  formatClaimsSearchFilters,
  useSelectedFilters
} from "@leagueplatform/claims-common";

// src/pages/member-claims-page/hooks/use-post-claims-search-query.hook.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
import {
  postDeserializedClaimsSearch,
  POST_CLAIMS_SEARCH_PATH
} from "@leagueplatform/claims-api";
import { defaultsDeep } from "lodash-es";
var DEFAULT_VARIABLES = {
  body: {
    data: {
      id: "",
      type: "claims-search",
      attributes: { filters: [] }
    }
  }
};
function usePostClaimsSearchQuery(variables, options) {
  const userId = useTargetUserId();
  const mergedVariables = defaultsDeep(
    __spreadProps(__spreadValues({}, variables), { queryParams: { userId } }),
    DEFAULT_VARIABLES
  );
  return useQuery7(
    [POST_CLAIMS_SEARCH_PATH, variables],
    () => postDeserializedClaimsSearch(mergedVariables),
    __spreadValues({ staleTime: Infinity }, options)
  );
}

// src/pages/member-claims-page/components/claims-card-list/claims-card-list.container.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
function ClaimsCardListContainer() {
  const { formatMessage } = useIntl19();
  const selectedFilters = useSelectedFilters();
  const filters = React14.useMemo(
    () => formatClaimsSearchFilters(selectedFilters),
    [selectedFilters]
  );
  const {
    data: claims,
    isError,
    isLoading,
    error
  } = usePostClaimsSearchQuery(
    filters.length ? { body: { data: { attributes: { filters } } } } : void 0,
    {
      select: (_data) => _data.data
    }
  );
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims summary" /* CLAIMS_SUMMARY */,
    detail: "select claim"
  });
  const handleCardClick = React14.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME13.BUTTON_CLICKED);
  }, [sendAnalyticsEvent]);
  if (isLoading) {
    return /* @__PURE__ */ jsx29(LoadingIndicator8, { inline: true });
  }
  if (isError || !claims) {
    return /* @__PURE__ */ jsx29(ClaimsErrorState, { error });
  }
  const isClaimsListEmpty = claims.length === 0;
  const filterCount = selectedFilters.length;
  const isNoClaimsMatchFilters = isClaimsListEmpty && filterCount > 0;
  if (isNoClaimsMatchFilters) {
    return /* @__PURE__ */ jsx29(
      ClaimsErrorState,
      {
        error: null,
        heading: formatMessage({
          id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_HEADING"
        }),
        message: formatMessage(
          {
            id: "CLAIMS_LIST_NO_CLAIMS_MATCH_FILTER_MESSAGE"
          },
          { filterCount }
        )
      }
    );
  }
  if (isClaimsListEmpty) {
    return /* @__PURE__ */ jsx29(
      ClaimsErrorState,
      {
        error: null,
        heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
        message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" })
      }
    );
  }
  return /* @__PURE__ */ jsx29(
    ClaimsCardList,
    {
      claims,
      onCardClick: handleCardClick,
      claimsPath: CUSTOMER_SUPPORT_ROUTES.customerSupportClaims
    }
  );
}

// src/pages/member-claims-page/components/claims-filters/claims-filters.component.tsx
import * as React18 from "react";
import { LoadingIndicator as LoadingIndicator9 } from "@leagueplatform/web-common-components";
import {
  FilterDropdown,
  getFilterInputComponent
} from "@leagueplatform/claims-ui";
import { StackLayout as StackLayout17, UtilityText as UtilityText4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME14,
  PRODUCT_AREA as PRODUCT_AREA2,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA2,
  SCREEN_NAMES
} from "@leagueplatform/analytics";

// src/pages/member-claims-page/hooks/use-claims-filters-query.hook.ts
import { useQuery as useQuery8 } from "@tanstack/react-query";
import {
  GET_CLAIMS_FILTERS_PATH,
  getDeserializedClaimsFilters
} from "@leagueplatform/claims-api";
var DEFAULT_STALE_TIME = -1;
function useClaimsFiltersQuery(options) {
  const userId = useTargetUserId();
  return useQuery8(
    [GET_CLAIMS_FILTERS_PATH],
    () => getDeserializedClaimsFilters({ queryParams: { userId } }),
    __spreadValues({ staleTime: DEFAULT_STALE_TIME }, options)
  );
}

// src/pages/member-claims-page/components/claims-filters/hooks/use-filter-input.hook.ts
import * as React17 from "react";
import { useSelectedFilters as useSelectedFilters4 } from "@leagueplatform/claims-common";

// src/pages/member-claims-page/components/claims-filters/hooks/use-single-select-filter.hook.ts
import * as React15 from "react";
import {
  useAddSelectedFilter,
  useRemoveSelectedFilter,
  useSelectedFilters as useSelectedFilters2
} from "@leagueplatform/claims-common";
function useSingleSelectFilter() {
  const selectedFilters = useSelectedFilters2();
  const addSelectedFilter = useAddSelectedFilter();
  const removeFilter = useRemoveSelectedFilter();
  return React15.useCallback(
    (filter) => {
      const filterWithKey = selectedFilters.find((f) => f.key === filter.key);
      if (filterWithKey) {
        removeFilter(filterWithKey);
      }
      addSelectedFilter(filter);
    },
    [addSelectedFilter, removeFilter, selectedFilters]
  );
}

// src/pages/member-claims-page/components/claims-filters/hooks/use-multi-select-filter.hook.ts
import * as React16 from "react";
import {
  useAddSelectedFilter as useAddSelectedFilter2,
  useRemoveSelectedFilter as useRemoveSelectedFilter2,
  useSelectedFilters as useSelectedFilters3
} from "@leagueplatform/claims-common";
function useMultiSelectFilter() {
  const selectedFilters = useSelectedFilters3();
  const addSelectedFilter = useAddSelectedFilter2();
  const removeFilter = useRemoveSelectedFilter2();
  return React16.useCallback(
    (formattedFilters, filterKey) => {
      const allFiltersInKey = selectedFilters.filter(
        (f) => f.key === filterKey
      );
      const isRemoveFilterAction = allFiltersInKey.length > formattedFilters.length;
      if (isRemoveFilterAction) {
        const smallerSet = new Set(formattedFilters.map((obj) => obj.value));
        const removedFilter = allFiltersInKey.find(
          (filter) => !smallerSet.has(filter.value)
        );
        if (!removedFilter) {
          return;
        }
        removeFilter(removedFilter);
        return;
      }
      const newFilter = formattedFilters.filter((filter) => {
        const isNotNewFilter = allFiltersInKey.map((f) => f.value).includes(filter.value);
        if (isNotNewFilter)
          return false;
        return true;
      }).find((_, index) => index === 0);
      if (!newFilter) {
        return;
      }
      addSelectedFilter(newFilter);
    },
    [addSelectedFilter, removeFilter, selectedFilters]
  );
}

// src/pages/member-claims-page/components/claims-filters/utils/format-filter-value.util.ts
var formatFilterValue = (inputValue, filterKey, inputName) => inputValue.map((value) => ({ key: filterKey, value, label: inputName }));

// src/pages/member-claims-page/components/claims-filters/hooks/use-filter-input.hook.ts
function useFilterInput() {
  const selectedFilters = useSelectedFilters4();
  const handleSingleSelectFilter = useSingleSelectFilter();
  const handleMultiSelectFilter = useMultiSelectFilter();
  const handleFilterClick = React17.useCallback(
    (inputValue, filterKey, inputName) => {
      if (Array.isArray(inputValue)) {
        handleMultiSelectFilter(
          formatFilterValue(inputValue, filterKey, inputName),
          filterKey
        );
        return;
      }
      handleSingleSelectFilter({
        key: filterKey,
        value: inputValue,
        label: inputName
      });
    },
    [handleMultiSelectFilter, handleSingleSelectFilter]
  );
  return React17.useCallback(
    (value, key) => {
      var _a;
      const options = (_a = value.options) == null ? void 0 : _a.map(
        (option) => __spreadProps(__spreadValues({}, option), { id: option.value })
      );
      const filtersByKey = selectedFilters.filter((f) => f.key === key);
      const filterValue = filtersByKey.map((filter) => filter.value);
      return {
        filterValue,
        onClick: handleFilterClick,
        options,
        selectedFiltersLength: filtersByKey.length
      };
    },
    [handleFilterClick, selectedFilters]
  );
}

// src/pages/member-claims-page/components/claims-filters/claims-filters.component.tsx
import { jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
var FILTER_BY_TEXT_ID = "filter-by-id";
function ClaimsFilters() {
  const {
    isLoading,
    isError,
    data: filters
  } = useClaimsFiltersQuery({ select: (res) => res.data });
  const getFilterInputProps = useFilterInput();
  const { formatMessage } = useIntl20();
  const handleFilterDropdownClick = React18.useCallback((filterType) => {
    trackAnalyticsEvent2(EVENT_NAME14.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA2.CLAIMS,
      sub_product_area: SUB_PRODUCT_AREA2.SUMMARY,
      screen_name: SCREEN_NAMES.FILTERS,
      detail: `selected filter type: ${filterType}`
    });
  }, []);
  const handleFilterChange = React18.useCallback(
    (isSelected, filterType) => {
      trackAnalyticsEvent2(EVENT_NAME14.BUTTON_CLICKED, {
        product_area: PRODUCT_AREA2.CLAIMS,
        sub_product_area: SUB_PRODUCT_AREA2.SUMMARY,
        screen_name: SCREEN_NAMES.FILTERS,
        detail: isSelected ? `selected filter option: ${filterType}` : `unselected filter option: ${filterType}`
      });
    },
    []
  );
  if (isLoading) {
    return /* @__PURE__ */ jsx30(LoadingIndicator9, { inline: true });
  }
  if (isError || !(filters == null ? void 0 : filters.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs15(StackLayout17, { spacing: "$threeQuarters", children: [
    /* @__PURE__ */ jsx30(UtilityText4, { id: FILTER_BY_TEXT_ID, size: "eyebrow", children: formatMessage({ id: "FILTER_BY" }) }),
    /* @__PURE__ */ jsx30(
      StackLayout17,
      {
        orientation: "horizontal",
        spacing: "$half",
        css: {
          overflowX: "auto",
          maxWidth: "100%",
          paddingBlockEnd: "$half"
        },
        children: filters.map(({ value, label, key }) => {
          const {
            filterValue,
            onClick: handleFilterClick,
            options,
            selectedFiltersLength
          } = getFilterInputProps(value, key);
          const FilterInput = getFilterInputComponent(value.type);
          const isFilterHidden = FilterInput === null || (options == null ? void 0 : options.length) === 0;
          const dropdownLabel = selectedFiltersLength ? `${label} (${selectedFiltersLength})` : label;
          if (isFilterHidden) {
            return null;
          }
          return /* @__PURE__ */ jsx30(
            FilterDropdown,
            {
              label: dropdownLabel,
              labelById: FILTER_BY_TEXT_ID,
              onClick: () => {
                handleFilterDropdownClick(key);
              },
              children: /* @__PURE__ */ jsx30(
                FilterInput,
                {
                  onSubmit: (inputValue, inputName) => {
                    handleFilterClick(inputValue, key, inputName);
                    handleFilterChange(!!inputValue.length, key);
                  },
                  options,
                  label,
                  name: key,
                  value: filterValue
                }
              )
            },
            key
          );
        })
      }
    )
  ] });
}

// src/pages/member-claims-page/components/claims-selected-filters/claims-selected-filters.component.tsx
import {
  EVENT_NAME as EVENT_NAME15,
  SUB_PRODUCT_AREA as SUB_PRODUCT_AREA3,
  SCREEN_NAMES as SCREEN_NAMES2
} from "@leagueplatform/analytics";
import {
  useClearAllFilters,
  useRemoveSelectedFilter as useRemoveSelectedFilter3,
  useSelectedFilters as useSelectedFilters5
} from "@leagueplatform/claims-common";
import { FilterChip, FilterChipsLayout } from "@leagueplatform/claims-ui";
import { TextAction as TextAction4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import * as React19 from "react";
import { jsx as jsx31, jsxs as jsxs16 } from "react/jsx-runtime";
function ClaimsSelectedFilters() {
  const { formatMessage } = useIntl21();
  const selectedFilters = useSelectedFilters5();
  const removeFilter = useRemoveSelectedFilter3();
  const clearFilters = useClearAllFilters();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: SUB_PRODUCT_AREA3.CLAIMS,
    screen_name: SCREEN_NAMES2.FILTERS
  });
  const handleFilterChange = React19.useCallback(
    (filter) => {
      removeFilter(filter);
      sendAnalyticsEvent(EVENT_NAME15.BUTTON_CLICKED, {
        detail: `unselected filter option: ${filter.key}`
      });
    },
    [removeFilter, sendAnalyticsEvent]
  );
  const handleClearAllFilters = React19.useCallback(() => {
    clearFilters();
    sendAnalyticsEvent(EVENT_NAME15.BUTTON_CLICKED, {
      detail: "clear all"
    });
  }, [clearFilters, sendAnalyticsEvent]);
  if (!selectedFilters || !selectedFilters.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs16(FilterChipsLayout, { children: [
    selectedFilters.map((filter) => /* @__PURE__ */ jsx31(
      FilterChip,
      {
        label: filter.label,
        onClick: () => {
          handleFilterChange(filter);
        }
      },
      `filterchip-${filter.key}-${filter.value}`
    )),
    /* @__PURE__ */ jsx31(
      TextAction4,
      {
        as: "button",
        size: "medium",
        onClick: handleClearAllFilters,
        css: {
          whiteSpace: "nowrap"
        },
        children: formatMessage({ id: "CLEAR_ALL" })
      }
    )
  ] });
}

// src/pages/member-claims-page/member-claims-page.component.tsx
import { jsx as jsx32, jsxs as jsxs17 } from "react/jsx-runtime";
var MemberClaimsPage = () => {
  const { formatMessage } = useIntl22();
  usePageViewAnalytics5({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims summary" /* CLAIMS_SUMMARY */
  });
  const { data, isError, isLoading, error } = usePostClaimsSearchQuery(
    void 0,
    {
      select: (_data) => _data.data
    }
  );
  const filterCount = useActiveFilterCount();
  const isClaimsListEmpty = (data == null ? void 0 : data.length) === 0 && filterCount === 0;
  if (isLoading) {
    return /* @__PURE__ */ jsx32(LoadingIndicator10, {});
  }
  if (isError) {
    return /* @__PURE__ */ jsx32(ClaimsErrorState2, { error });
  }
  if (isClaimsListEmpty) {
    return /* @__PURE__ */ jsx32(
      ClaimsErrorState2,
      {
        error: null,
        heading: formatMessage({ id: "CLAIMS_LIST_EMPTY_HEADING" }),
        message: formatMessage({ id: "CLAIMS_LIST_EMPTY_MESSAGE" })
      }
    );
  }
  return /* @__PURE__ */ jsxs17(
    Box13,
    {
      css: {
        display: "flex",
        margin: "auto",
        flexDirection: "column",
        width: "100%",
        gap: "$one"
      },
      children: [
        /* @__PURE__ */ jsx32(Responsive, { down: "mobileLandscape", children: /* @__PURE__ */ jsx32(
          ClaimsSummarySidebarMobileContainer,
          {
            renderHelpfulLinks: /* @__PURE__ */ jsx32(ClaimsHelpfulLinksContainer, {})
          }
        ) }),
        /* @__PURE__ */ jsx32(ClaimsFilters, {}),
        /* @__PURE__ */ jsx32(ClaimsSelectedFilters, {}),
        /* @__PURE__ */ jsxs17(
          Box13,
          {
            css: {
              display: "grid",
              gap: "$oneAndHalf",
              gridTemplateColumns: "4fr 1fr",
              "@mobile": {
                gridTemplateColumns: "1fr"
              },
              position: "relative"
            },
            children: [
              /* @__PURE__ */ jsx32(ClaimsCardListContainer, {}),
              /* @__PURE__ */ jsx32(Responsive, { up: "mobileLandscape", children: /* @__PURE__ */ jsx32(ClaimsSummarySidebar, { children: /* @__PURE__ */ jsx32(ClaimsHelpfulLinksContainer, {}) }) })
            ]
          }
        )
      ]
    }
  );
};

// src/pages/member-claim-detail-page/member-claim-detail-page.component.tsx
import * as React22 from "react";
import {
  Box as Box14,
  Card as Card3,
  HeadingText as HeadingText6,
  Icon as Icon6,
  ParagraphText as ParagraphText9,
  Responsive as Responsive2,
  StackItem as StackItem4,
  StackLayout as StackLayout18
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME18, usePageViewAnalytics as usePageViewAnalytics6 } from "@leagueplatform/analytics";
import { useDownloadExplanationOfBenefits } from "@leagueplatform/claims-common";
import { useGoBack } from "@leagueplatform/web-common";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import {
  ClaimStatusPreview,
  ClaimUserCostCard,
  ClaimsBackButton,
  ClaimsErrorState as ClaimsErrorState3,
  ServiceDetails,
  TotalCostOverview
} from "@leagueplatform/claims-ui";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import { LoadingIndicator as LoadingIndicator11 } from "@leagueplatform/web-common-components";

// src/pages/member-claim-detail-page/hooks/use-get-claim-details-query.hook.ts
import { useQuery as useQuery9 } from "@tanstack/react-query";
import {
  getDeserializedClaimDetails,
  GET_CLAIM_DETAILS_PATH
} from "@leagueplatform/claims-api";
import { useParams as useParams2 } from "@leagueplatform/routing";
var STALE_TIME = 1e3 * 60 * 5;
function useGetClaimDetailsQuery() {
  const { claimId } = useParams2();
  const userId = useTargetUserId();
  return useQuery9(
    [GET_CLAIM_DETAILS_PATH, claimId],
    () => getDeserializedClaimDetails({
      pathParams: { claimId: claimId != null ? claimId : "" },
      queryParams: { userId }
    }),
    { staleTime: STALE_TIME }
  );
}

// src/pages/member-claim-detail-page/components/plan-progress-card/plan-progress-card.component.tsx
import * as React20 from "react";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import { SupportingCard } from "@leagueplatform/claims-ui";
import { EVENT_NAME as EVENT_NAME16 } from "@leagueplatform/analytics";
import { jsx as jsx33 } from "react/jsx-runtime";
function PlanProgressCard() {
  var _a;
  const { formatMessage } = useIntl23();
  const { data } = useGetClaimDetailsQuery();
  const walletRoute = CUSTOMER_SUPPORT_ROUTES.customerSupportWallet;
  const benefitId = (_a = data == null ? void 0 : data.benefit) == null ? void 0 : _a.id;
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims detail" /* CLAIMS_DETAIL */,
    detail: "view plan progress"
  });
  const handleCardClick = React20.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME16.BUTTON_CLICKED);
  }, [sendAnalyticsEvent]);
  return /* @__PURE__ */ jsx33(
    SupportingCard,
    {
      title: formatMessage({ id: "PLAN_PROGRESS" }),
      description: formatMessage({
        id: "CLAIMS_PLAN_PROGRESS_DESCRIPTION"
      }),
      routeCopy: formatMessage({ id: "VIEW_PLAN_PROGRESS" }),
      route: `${walletRoute}/${benefitId}`,
      onClick: handleCardClick
    }
  );
}

// src/pages/member-claim-detail-page/components/support-card/support-card.component.tsx
import * as React21 from "react";
import { EVENT_NAME as EVENT_NAME17 } from "@leagueplatform/analytics";
import { SupportingCard as SupportingCard2 } from "@leagueplatform/claims-ui";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import { jsx as jsx34 } from "react/jsx-runtime";
function SupportCard() {
  const { formatMessage } = useIntl24();
  const supportLink = useCustomerSupportConfig("claimsInquiry.supportLink");
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims detail" /* CLAIMS_DETAIL */,
    detail: "get support"
  });
  const handleCardClick = React21.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME17.BUTTON_CLICKED);
  }, [sendAnalyticsEvent]);
  if (!supportLink) {
    return null;
  }
  return /* @__PURE__ */ jsx34(
    SupportingCard2,
    {
      title: formatMessage({ id: "SUPPORT" }),
      description: formatMessage({
        id: "MESSAGE_WITH_A_MEMBER"
      }),
      routeCopy: formatMessage({ id: "GET_SUPPORT" }),
      route: supportLink,
      onClick: handleCardClick
    }
  );
}

// src/pages/member-claim-detail-page/member-claim-detail-page.component.tsx
import { jsx as jsx35, jsxs as jsxs18 } from "react/jsx-runtime";
var CLAIM_DETAILS_MAX_WIDTH = "1400px";
var MemberClaimDetailPage = () => {
  var _a;
  const targetUserId = useTargetUserId();
  usePageViewAnalytics6({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims detail" /* CLAIMS_DETAIL */
  });
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "claims" /* CLAIMS_PAGE */,
    screen_name: "claims detail" /* CLAIMS_DETAIL */
  });
  const {
    data: claimDetailsData,
    isLoading,
    isError,
    isSuccess,
    error
  } = useGetClaimDetailsQuery();
  const { refetch: downloadEOB, isFetching: isDownloadingEOB } = useDownloadExplanationOfBenefits(targetUserId);
  const { formatMessage } = useIntl25();
  const goBack = useGoBack(getModulePath(LEAGUE_MODULE_NAMES.claims));
  const { supportLink, showTotalCostOverviewAndAdditionalResources } = useCustomerSupportConfig("claimsInquiry");
  const hasSupportLink = Boolean(supportLink);
  const onEOBDownloadClick = React22.useCallback(() => {
    downloadEOB();
    sendAnalyticsEvent(EVENT_NAME18.BUTTON_CLICKED, {
      detail: "download explanation of benefits"
    });
  }, [downloadEOB, sendAnalyticsEvent]);
  const trackCostDetailsAnalytics = React22.useCallback(
    (tooltipLabel) => {
      sendAnalyticsEvent(EVENT_NAME18.BUTTON_CLICKED, {
        detail: formatMessage({ id: "VIEW_TOOLTIP" }, { tooltipLabel })
      });
    },
    [formatMessage, sendAnalyticsEvent]
  );
  const trackCostDetailsToggleAction = React22.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME18.BUTTON_CLICKED, {
      detail: "view show/hide cost details"
    });
  }, [sendAnalyticsEvent]);
  if (isLoading) {
    return /* @__PURE__ */ jsx35(PageLayout, { children: /* @__PURE__ */ jsx35(LoadingIndicator11, {}) });
  }
  if (isError || !isSuccess) {
    return /* @__PURE__ */ jsx35(PageLayout, { children: /* @__PURE__ */ jsx35(
      Box14,
      {
        css: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh"
        },
        children: /* @__PURE__ */ jsx35(ClaimsErrorState3, { error })
      }
    ) });
  }
  const isPending = claimDetailsData.status === "pending";
  const userCost = (_a = claimDetailsData.totals) == null ? void 0 : _a.owed;
  const showTotalCostOverviewSection = !isPending && showTotalCostOverviewAndAdditionalResources;
  const {
    status: status2,
    serviceDate,
    paidDate,
    providerName,
    providerServiceNetwork,
    patientName,
    identifier,
    claimType,
    services,
    groupId,
    totals,
    eob
  } = claimDetailsData;
  const showEobDownloadButton = Boolean(eob == null ? void 0 : eob.showDownloadButton);
  return /* @__PURE__ */ jsx35(PageLayout, { mainCss: { paddingY: 0, overflow: "auto", width: "100%" }, children: /* @__PURE__ */ jsx35(
    StackLayout18,
    {
      horizontalAlignment: "center",
      css: {
        width: "100%",
        padding: "$none $two",
        "@mobile": {
          padding: "$none"
        }
      },
      children: /* @__PURE__ */ jsxs18(
        Box14,
        {
          css: {
            position: "relative",
            maxWidth: CLAIM_DETAILS_MAX_WIDTH,
            width: "100%",
            padding: "59px $oneAndHalf",
            "@mobile": {
              padding: "32px $oneAndHalf",
              position: "static"
            }
          },
          children: [
            /* @__PURE__ */ jsx35(
              ClaimsBackButton,
              {
                as: "a",
                href: "#",
                onClick: (e) => {
                  e.preventDefault();
                  goBack();
                },
                width: "hugContents",
                id: "go-back",
                css: {
                  position: "absolute",
                  left: "-16px",
                  top: "57px",
                  "@mobile": {
                    display: "inline-block",
                    position: "static",
                    marginBottom: "$oneAndHalf"
                  }
                },
                children: /* @__PURE__ */ jsx35(
                  Icon6,
                  {
                    icon: "interfaceArrowLeft",
                    size: {
                      "@initial": "$oneAndHalf",
                      "@mobile": "$one"
                    },
                    tint: "$onSurfaceIconPrimary",
                    label: formatMessage({ id: "GO_BACK" })
                  }
                )
              }
            ),
            /* @__PURE__ */ jsxs18(StackLayout18, { horizontalAlignment: "stretch", spacing: "$twoAndHalf", children: [
              /* @__PURE__ */ jsxs18(
                StackLayout18,
                {
                  spacing: {
                    "@initial": "$oneAndHalf",
                    "@mobile": "$two",
                    "@mobileLandscape": "$two",
                    "@tablet": "$two"
                  },
                  horizontalAlignment: "stretch",
                  orientation: {
                    "@initial": "horizontal",
                    "@mobile": "vertical",
                    "@mobileLandscape": "vertical",
                    "@tablet": "vertical"
                  },
                  children: [
                    /* @__PURE__ */ jsx35(StackItem4, { growFactor: 2, children: /* @__PURE__ */ jsx35(
                      ClaimStatusPreview,
                      {
                        claimDate: serviceDate,
                        status: status2,
                        providerName,
                        providerServiceNetwork,
                        patientName,
                        identifier,
                        claimType,
                        groupId,
                        isPending,
                        showEobDownloadButton,
                        onEOBDownloadClick,
                        isFetching: isDownloadingEOB
                      }
                    ) }),
                    /* @__PURE__ */ jsx35(
                      Card3.Flat,
                      {
                        backgroundColor: "secondary",
                        css: { padding: "$oneAndHalf" },
                        children: /* @__PURE__ */ jsx35(ClaimUserCostCard, { isPending, userCost })
                      }
                    )
                  ]
                }
              ),
              showTotalCostOverviewSection && /* @__PURE__ */ jsxs18(StackLayout18, { horizontalAlignment: "stretch", children: [
                /* @__PURE__ */ jsx35(
                  HeadingText6,
                  {
                    level: "2",
                    size: "lg",
                    css: { marginBottom: "$half" },
                    children: formatMessage({ id: "TOTAL_COST_OVERVIEW" })
                  }
                ),
                /* @__PURE__ */ jsx35(
                  ParagraphText9,
                  {
                    size: "base",
                    emphasis: "subtle",
                    css: { paddingBottom: "$half" },
                    children: formatMessage({ id: "TOTAL_COST_DESCRIPTION" })
                  }
                ),
                /* @__PURE__ */ jsxs18(
                  StackLayout18,
                  {
                    spacing: "$oneAndHalf",
                    verticalAlignment: "stretch",
                    horizontalAlignment: "stretch",
                    orientation: "horizontal",
                    children: [
                      totals && /* @__PURE__ */ jsx35(StackItem4, { growFactor: 2, children: /* @__PURE__ */ jsx35(
                        Card3.Flat,
                        {
                          backgroundColor: "primary",
                          css: {
                            borderWidth: "$thin",
                            borderStyle: "solid",
                            borderColor: "$onSurfaceBorderSubdued"
                          },
                          children: /* @__PURE__ */ jsx35(Card3.Section, { children: /* @__PURE__ */ jsx35(
                            TotalCostOverview,
                            {
                              totals,
                              paidDate,
                              onCostDetailsClick: trackCostDetailsAnalytics
                            }
                          ) })
                        }
                      ) }),
                      /* @__PURE__ */ jsx35(
                        StackItem4,
                        {
                          growFactor: 1,
                          css: {
                            "@tablet": {
                              display: "none"
                            },
                            "@mobile": {
                              display: "none"
                            }
                          },
                          children: /* @__PURE__ */ jsx35(PlanProgressCard, {})
                        }
                      ),
                      hasSupportLink && /* @__PURE__ */ jsx35(
                        StackItem4,
                        {
                          growFactor: 1,
                          css: {
                            "@tablet": { display: "none" },
                            "@mobile": {
                              display: "none"
                            }
                          },
                          children: /* @__PURE__ */ jsx35(SupportCard, {})
                        }
                      )
                    ]
                  }
                )
              ] }),
              services && /* @__PURE__ */ jsxs18(StackLayout18, { spacing: "$half", horizontalAlignment: "stretch", children: [
                /* @__PURE__ */ jsx35(HeadingText6, { level: "2", size: "lg", children: formatMessage({ id: "CLAIMS_SERVICE_DETAILS_HEADING" }) }),
                /* @__PURE__ */ jsx35(ParagraphText9, { css: { color: "$onSurfaceTextSubdued" }, children: formatMessage({ id: "CLAIMS_SERVICE_DETAILS_SUBHEADING" }) }),
                /* @__PURE__ */ jsx35(
                  ServiceDetails,
                  {
                    services,
                    isPending,
                    claimType,
                    onCostDetailsClick: trackCostDetailsAnalytics,
                    onCostDetailsToggle: trackCostDetailsToggleAction
                  }
                )
              ] }),
              showTotalCostOverviewAndAdditionalResources && /* @__PURE__ */ jsx35(Responsive2, { down: "laptop", children: /* @__PURE__ */ jsxs18(
                StackLayout18,
                {
                  spacing: "$oneAndHalf",
                  verticalAlignment: "stretch",
                  horizontalAlignment: "stretch",
                  orientation: "vertical",
                  children: [
                    /* @__PURE__ */ jsx35(HeadingText6, { level: "2", size: "lg", children: formatMessage({
                      id: "CLAIMS_ADDITIONAL_RESOURCES_HEADING"
                    }) }),
                    /* @__PURE__ */ jsx35(StackItem4, { growFactor: 1, children: /* @__PURE__ */ jsx35(PlanProgressCard, {}) }),
                    hasSupportLink && /* @__PURE__ */ jsx35(StackItem4, { growFactor: 1, children: /* @__PURE__ */ jsx35(SupportCard, {}) })
                  ]
                }
              ) })
            ] })
          ]
        }
      )
    }
  ) });
};

// src/pages/member-biometric-detail-page/member-biometric-detail-page.component.tsx
import { useIntl as useIntl32 } from "@leagueplatform/locales";
import { usePageViewAnalytics as usePageViewAnalytics7 } from "@leagueplatform/analytics";

// src/components/detail-page-wrapper/detail-page-wrapper.component.tsx
import { Box as Box16, StackItem as StackItem5 } from "@leagueplatform/genesis-core";

// src/components/page-layout/components/side-details/side-details.component.tsx
import { Box as Box15 } from "@leagueplatform/genesis-core";
import { jsx as jsx36 } from "react/jsx-runtime";
var SideDetails = ({
  children
}) => /* @__PURE__ */ jsx36(
  Box15,
  {
    as: "aside",
    css: {
      width: "450px",
      paddingLeft: "$three",
      overflowY: "auto"
    },
    children
  }
);

// src/components/detail-page-wrapper/detail-page-wrapper.component.tsx
import { jsx as jsx37, jsxs as jsxs19 } from "react/jsx-runtime";
var DetailPageWrapper = ({
  sideDetailSection,
  mainSection,
  header
}) => /* @__PURE__ */ jsx37(PageLayout, { children: /* @__PURE__ */ jsxs19(
  StackItem5,
  {
    css: {
      flexDirection: "row",
      width: "100%",
      overflowY: "hidden",
      height: "100%"
    },
    children: [
      /* @__PURE__ */ jsxs19(
        StackItem5,
        {
          css: {
            flexDirection: "column",
            width: "100%",
            overflowY: "hidden"
          },
          children: [
            header,
            /* @__PURE__ */ jsx37(Box16, { css: { overflowY: "auto" }, children: mainSection })
          ]
        }
      ),
      /* @__PURE__ */ jsx37(SideDetails, { children: sideDetailSection })
    ]
  }
) });

// src/components/details-header/details-header.component.tsx
import * as React23 from "react";
import { useNavigate as useNavigate3 } from "@leagueplatform/routing";
import { useIntl as useIntl28 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout20,
  Divider as Divider3,
  HeadingText as HeadingText7,
  TextAction as TextAction5,
  StatusBadge as StatusBadge3,
  Box as Box18
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME19 } from "@leagueplatform/analytics";

// src/pages/member-standard-program-detail-page/components/standard-program-progress/standard-program-progress.component.tsx
import { useIntl as useIntl26 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";
import {
  StackLayout as StackLayout19,
  Icon as Icon7,
  UtilityText as UtilityText5,
  Box as Box17
} from "@leagueplatform/genesis-core";
import { jsx as jsx38, jsxs as jsxs20 } from "react/jsx-runtime";
var styledText = (msg) => /* @__PURE__ */ jsx38(
  UtilityText5,
  {
    css: {
      color: "$onSurfaceTextSuccess"
    },
    emphasis: "emphasized",
    "aria-hidden": true,
    children: msg
  }
);
var StandardProgramProgress = ({
  programProgress
}) => {
  const { formatMessage } = useIntl26();
  const icon = handleStaticAsset7(
    "ACTIVITY_PIN_ICON" /* ACTIVITY_PIN_ICON */
  );
  return /* @__PURE__ */ jsxs20(
    StackLayout19,
    {
      orientation: "horizontal",
      spacing: "$quarter",
      verticalAlignment: "center",
      css: {
        marginTop: "$threeQuarters"
      },
      children: [
        /* @__PURE__ */ jsx38(
          Box17,
          {
            css: {
              backgroundColor: "$surfaceBackgroundSecondary",
              borderRadius: "$circle",
              width: "calc($one + 1px)",
              height: "calc($one + 1px)",
              marginRight: "$quarter"
            },
            children: /* @__PURE__ */ jsx38(Icon7, { size: "$one", icon, "aria-hidden": "true" })
          }
        ),
        /* @__PURE__ */ jsx38(
          UtilityText5,
          {
            emphasis: "emphasized",
            "aria-describedby": formatMessage(
              { id: "CS_CURRENT_OVER_COMPLETED_ALT" },
              {
                current: programProgress.completed,
                total: programProgress.total
              }
            ),
            children: formatMessage(
              { id: "CS_CURRENT_OVER_COMPLETED" },
              {
                span: styledText,
                current: programProgress.completed,
                total: programProgress.total
              }
            )
          }
        )
      ]
    }
  );
};

// src/pages/member-challenges-detail-page/challenge-badge/challenge-badge.component.tsx
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import { Badge } from "@leagueplatform/web-common-components";
import { UtilityText as UtilityText6 } from "@leagueplatform/genesis-core";
import { jsx as jsx39 } from "react/jsx-runtime";
function ChallengeBadge({ isSoloChallenge }) {
  const { formatMessage } = useIntl27();
  return /* @__PURE__ */ jsx39(
    Badge,
    {
      css: {
        backgroundColor: "$warningBackgroundSubdued",
        borderRadius: "$small",
        marginBottom: "$one"
      },
      iconTextProps: {
        iconProps: {
          icon: isSoloChallenge ? "tinyStar" : "capabilityGroupChallenges",
          tint: "$warningIcon"
        },
        text: /* @__PURE__ */ jsx39(
          UtilityText6,
          {
            css: { typography: "$overline", textTransform: "uppercase" },
            children: formatMessage({
              id: isSoloChallenge ? "SOLO_CHALLENGE" : "GROUP_CHALLENGE"
            })
          }
        )
      }
    }
  );
}

// src/components/details-header/details-header.component.tsx
import { jsx as jsx40, jsxs as jsxs21 } from "react/jsx-runtime";
var BackButton = ({ onClick }) => {
  const { formatMessage } = useIntl28();
  return /* @__PURE__ */ jsx40(
    TextAction5,
    {
      onClick,
      as: "button",
      icon: "interfaceArrowLeft",
      css: {
        color: "$onSurfaceIconPrimary",
        width: "fit-content",
        margin: "$half"
      },
      children: formatMessage({ id: "BACK" })
    }
  );
};
var DetailsHeader = ({
  title,
  status: status2,
  policyDate,
  showPolicyDates,
  programProgress,
  isChallenge
}) => {
  const { formatMessage } = useIntl28();
  const navigate = useNavigate3();
  const analyticsDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({
    detail: "go back" /* BACK_BUTTON */
  }, analyticsDetails));
  const onClick = React23.useCallback(() => {
    sendAnalyticsEvent(EVENT_NAME19.BUTTON_CLICKED);
    return navigate(-1);
  }, [sendAnalyticsEvent, navigate]);
  return /* @__PURE__ */ jsxs21(
    Box18,
    {
      css: {
        height: "fit-content",
        flex: "none"
      },
      children: [
        /* @__PURE__ */ jsx40(Box18, { css: { marginBottom: "$oneAndHalf" }, children: /* @__PURE__ */ jsx40(BackButton, { onClick }) }),
        isChallenge && /* @__PURE__ */ jsx40(ChallengeBadge, { isSoloChallenge: isChallenge.isSoloChallenge }),
        /* @__PURE__ */ jsxs21(
          StackLayout20,
          {
            orientation: "horizontal",
            verticalAlignment: "center",
            css: {
              width: "100%"
            },
            children: [
              /* @__PURE__ */ jsx40(
                HeadingText7,
                {
                  level: "1",
                  size: "xxl",
                  css: { marginRight: "$threeQuarters" },
                  children: title
                }
              ),
              status2 && /* @__PURE__ */ jsx40(
                StatusBadge3,
                {
                  label: formatMessage({
                    id: normalizeBenefitStatus(status2).toUpperCase()
                  }),
                  status: mapBenefitStatusColors(status2)
                }
              )
            ]
          }
        ),
        showPolicyDates && /* @__PURE__ */ jsxs21(
          HeadingText7,
          {
            css: { marginTop: "$quarter" },
            emphasis: "subtle",
            level: "display",
            size: "sm",
            children: [
              formatMessage({ id: "POLICY_ACTIVE" }),
              ": ",
              policyDate == null ? void 0 : policyDate.startDate,
              " -",
              " ",
              policyDate == null ? void 0 : policyDate.endDate
            ]
          }
        ),
        programProgress && /* @__PURE__ */ jsx40(StandardProgramProgress, { programProgress }),
        /* @__PURE__ */ jsx40(Divider3, { css: { margin: "$one $none $oneAndHalf" } })
      ]
    }
  );
};

// src/pages/member-biometric-detail-page/components/biometric-section/biometrics-detail-section.component.tsx
import React25 from "react";
import {
  Box as Box19,
  Button as Button4,
  StackLayout as StackLayout21,
  UtilityText as UtilityText7
} from "@leagueplatform/genesis-core";
import {
  ErrorState as ErrorState8,
  LoadingIndicator as LoadingIndicator12
} from "@leagueplatform/web-common-components";

// src/pages/member-assessments-dashboards-page/components/biometrics/hooks/use-get-health-metrics-v2-query.hook.ts
import {
  useQuery as useQuery10,
  useInfiniteQuery
} from "@tanstack/react-query";
import { captureError as captureError7 } from "@leagueplatform/observability";
import {
  getHealthMetricsV2,
  getHealthMetricsByPaginationLink
} from "@leagueplatform/dashboard-api";
var GET_HEALTH_METRICS_MESSAGE_TYPE = "v2/health-metrics";
function useGetHealthMetricsV2(params, options) {
  return useQuery10(
    [GET_HEALTH_METRICS_MESSAGE_TYPE, params],
    () => getHealthMetricsV2(params),
    __spreadValues({
      staleTime: Infinity,
      onError(error) {
        captureError7(
          new Error(
            `Customer Support: Unable to fetch v2/health-metrics/${params}: ${error}`
          ),
          {
            context: {
              parameters: {
                api: JSON.stringify(params)
              }
            }
          }
        );
      }
    }, options)
  );
}
function useInfiniteHealthMetricsV2(params) {
  return useInfiniteQuery(
    [GET_HEALTH_METRICS_MESSAGE_TYPE, params],
    (_0) => __async(this, [_0], function* ({ pageParam }) {
      if (pageParam) {
        return getHealthMetricsByPaginationLink(pageParam);
      }
      return getHealthMetricsV2(__spreadProps(__spreadValues({}, params), {
        interval: "all"
      }));
    }),
    {
      getNextPageParam(lastPage) {
        var _a, _b;
        if (!((_a = lastPage == null ? void 0 : lastPage.links) == null ? void 0 : _a.next)) {
          return void 0;
        }
        const { next } = lastPage.links;
        const userId = (_b = params.filter) == null ? void 0 : _b.userId;
        const filteredURL = `${next}&filter[userId]=${userId}`;
        return filteredURL.slice(next.indexOf("/v2/"));
      }
    }
  );
}

// src/pages/member-biometric-detail-page/components/biometric-section/biometrics-detail-section.component.tsx
import { useIntl as useIntl30 } from "@leagueplatform/locales";

// src/utils/get-health-metric-display-value.ts
function getHealthMetricDisplayValue({
  value,
  label
}) {
  const values = label != null ? label : value;
  if (Array.isArray(values)) {
    return values.join("-");
  }
  if (values === null) {
    return "-";
  }
  return values.toString();
}

// src/utils/get-health-metric-unit-display-value.ts
function getHealthMetricUnitDisplayValue(value, unit) {
  const { symbol, namePlural, name } = unit;
  if (symbol) {
    return symbol;
  }
  if (namePlural && value != 1) {
    return namePlural;
  }
  return name;
}

// src/utils/get-value-unit-display-label.ts
function getValueUnitDisplayLabel({
  unitOptions,
  value,
  label
}) {
  const displayValue = getHealthMetricDisplayValue({ value, label });
  const unit = getHealthMetricUnitDisplayValue(displayValue, unitOptions);
  if (displayValue.includes(";")) {
    const arrayOfSubUnits = displayValue == null ? void 0 : displayValue.split(";").map((str) => str.split("|"));
    return arrayOfSubUnits;
  }
  return [[displayValue, unit]];
}

// src/pages/member-biometric-detail-page/components/biometric-section/biometrics-detail-section.component.tsx
import { EVENT_NAME as EVENT_NAME21 } from "@leagueplatform/analytics";

// src/pages/member-biometric-detail-page/components/biometric-dropdown/biometric-dropdown.component.tsx
import * as React24 from "react";
import { useIntl as useIntl29 } from "@leagueplatform/locales";
import { Select as Select2 } from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME20 } from "@leagueplatform/analytics";
import { jsx as jsx41 } from "react/jsx-runtime";
var BiometricDropdown = ({
  loadResultsBy
}) => {
  const { formatMessage } = useIntl29();
  const paginationOptions = Object.keys(BIOMETRIC_PAGINATION_NUMBERS).map(
    (value) => ({
      key: value,
      value,
      label: formatMessage(
        { id: "NUMBER_OF_ENTRIES" },
        { number: BIOMETRIC_PAGINATION_NUMBERS[value] }
      )
    })
  );
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    screen_name: "biometrics detail" /* BIOMETRICS_DETAIL */,
    detail: "pagination" /* PAGINATION */
  });
  const sendButtonClickedAnalyticsEvent = React24.useCallback(
    (selectedOption) => sendAnalyticsEvent(EVENT_NAME20.BUTTON_CLICKED, {
      sub_detail: selectedOption
    }),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx41(
    Select2,
    {
      css: {
        width: "150px"
      },
      "aria-label": formatMessage({ id: "FILTER" }),
      id: "paginate-by-number",
      options: paginationOptions,
      defaultValue: BIOMETRIC_PAGINATION_NUMBERS[0],
      onChange: (e) => {
        const paginateResultsBy = e.target.value;
        const numberToPaginate = BIOMETRIC_PAGINATION_NUMBERS[paginateResultsBy];
        sendButtonClickedAnalyticsEvent(numberToPaginate);
        loadResultsBy(numberToPaginate);
      }
    }
  );
};

// src/pages/member-biometric-detail-page/components/biometric-section/biometrics-detail-section.component.tsx
import { jsx as jsx42, jsxs as jsxs22 } from "react/jsx-runtime";
var BiometricsDetailSection = ({
  metric
}) => {
  const { formatMessage, formatDate } = useIntl30();
  const [paginateBy, setPaginateBy] = React25.useState(
    Object.values(BIOMETRIC_PAGINATION_NUMBERS)[0]
  );
  const targetUserId = useTargetUserId();
  const targetId = targetUserId;
  const { timeZone } = useGetTargetUserInfo(targetId);
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    screen_name: "biometrics detail" /* BIOMETRICS_DETAIL */,
    detail: "pagination" /* PAGINATION */
  });
  const sendButtonClickedAnalyticsEvent = React25.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME21.BUTTON_CLICKED, {
      sub_detail: "Load More"
    }),
    [sendAnalyticsEvent]
  );
  const {
    isLoading,
    isError,
    isRefetching,
    isSuccess,
    data: healthMetrics,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    error
  } = useInfiniteHealthMetricsV2({
    filter: {
      type: metric,
      userId: targetUserId
    },
    fields: { type: ["type", "value", "source", "unit", "timestamp"] },
    page: { size: paginateBy }
  });
  const isIdle = simulateIsIdle(isLoading, isSuccess, healthMetrics);
  if (isError)
    return /* @__PURE__ */ jsx42(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx42(
      ErrorState8,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx42("br", {}) }
        )
      }
    ) });
  const allMetricConfigs = healthMetrics == null ? void 0 : healthMetrics.pages[0].data[0].configs.data;
  const firstConfigName = allMetricConfigs == null ? void 0 : allMetricConfigs[0].name;
  const displayConfigName = Boolean(allMetricConfigs == null ? void 0 : allMetricConfigs.length) && !(allMetricConfigs == null ? void 0 : allMetricConfigs.every(
    (metricConfig) => metricConfig.name === firstConfigName
  ));
  return /* @__PURE__ */ jsxs22(
    StackLayout21,
    {
      orientation: "vertical",
      css: { flex: "none", height: "fit-content" },
      children: [
        /* @__PURE__ */ jsxs22(StackLayout21, { orientation: "horizontal", verticalAlignment: "center", children: [
          /* @__PURE__ */ jsx42(UtilityText7, { css: { typography: "$subtitleOne", marginRight: "$one" }, children: formatMessage({ id: "SHOW" }) }),
          /* @__PURE__ */ jsx42(
            BiometricDropdown,
            {
              loadResultsBy: (paginateNumber) => setPaginateBy(paginateNumber)
            }
          )
        ] }),
        isLoading || isIdle ? /* @__PURE__ */ jsx42(LoadingIndicator12, {}) : /* @__PURE__ */ jsxs22(Box19, { as: "ul", css: { width: "100%", paddingTop: "$half" }, children: [
          healthMetrics == null ? void 0 : healthMetrics.pages.map(
            (page) => {
              var _a, _b;
              return (_b = (_a = page.data[0].values) == null ? void 0 : _a.data) == null ? void 0 : _b.map((dataMetric) => {
                var _a2, _b2;
                const { id, source, timestamp, config } = dataMetric;
                return /* @__PURE__ */ jsxs22(
                  StackLayout21,
                  {
                    as: "li",
                    orientation: "horizontal",
                    verticalAlignment: "center",
                    css: {
                      padding: "$one $none",
                      borderBottom: "1px solid $onSurfaceBorderSubdued"
                    },
                    children: [
                      /* @__PURE__ */ jsxs22(StackLayout21, { children: [
                        /* @__PURE__ */ jsx42(UtilityText7, { as: "p", css: { typography: "$subtitleOne" }, children: (((_b2 = (_a2 = dataMetric == null ? void 0 : dataMetric.config) == null ? void 0 : _a2.data) == null ? void 0 : _b2.unit) ? getValueUnitDisplayLabel({
                          value: dataMetric == null ? void 0 : dataMetric.value,
                          label: dataMetric == null ? void 0 : dataMetric.label,
                          unitOptions: dataMetric.config.data.unit
                        }) : [["-", ""]]).map(
                          ([displayValue, displayUnit], index) => {
                            var _a3, _b3;
                            return (
                              // eslint-disable-next-line react/no-array-index-key
                              /* @__PURE__ */ jsxs22("span", { children: [
                                displayValue,
                                " ",
                                displayUnit,
                                " ",
                                displayConfigName ? ` (${(_b3 = (_a3 = config == null ? void 0 : config.data) == null ? void 0 : _a3.name) == null ? void 0 : _b3.toLocaleLowerCase()})` : null
                              ] }, `${index} + ${dataMetric.type}`)
                            );
                          }
                        ) }),
                        /* @__PURE__ */ jsx42(
                          UtilityText7,
                          {
                            css: { typography: "$label" },
                            emphasis: "subtle",
                            children: source
                          }
                        )
                      ] }),
                      /* @__PURE__ */ jsx42(
                        StackLayout21,
                        {
                          orientation: "horizontal",
                          horizontalAlignment: "end",
                          verticalAlignment: "center",
                          spacing: "$half",
                          children: /* @__PURE__ */ jsx42(
                            UtilityText7,
                            {
                              as: "p",
                              css: {
                                paddingTop: "$half",
                                paddingBottom: "$half",
                                typography: "$bodyOneSecondary"
                              },
                              children: formatDate(timestamp, getShortDateTimeZone(timeZone))
                            }
                          )
                        }
                      )
                    ]
                  },
                  id
                );
              });
            }
          ),
          hasNextPage && /* @__PURE__ */ jsx42(StackLayout21, { css: { padding: "$half" }, children: /* @__PURE__ */ jsx42(
            Button4,
            {
              priority: "tertiary",
              size: "medium",
              css: { typography: "$buttonTwo" },
              disabled: isFetchingNextPage,
              onClick: () => {
                fetchNextPage();
                sendButtonClickedAnalyticsEvent();
              },
              loading: isRefetching,
              children: formatMessage({ id: "LOAD_MORE" })
            }
          ) })
        ] })
      ]
    }
  );
};

// src/components/side-detail-card/side-detail-card.component.tsx
import { Box as Box22 } from "@leagueplatform/genesis-core";

// src/components/details-side-header/details-side-header.component.tsx
import {
  HeadingText as HeadingText8,
  StackLayout as StackLayout23,
  StatusBadge as StatusBadge4,
  Box as Box20,
  ParagraphText as ParagraphText10
} from "@leagueplatform/genesis-core";

// src/components/tooltip/tooltip.component.tsx
import * as React26 from "react";
import { EVENT_NAME as EVENT_NAME22 } from "@leagueplatform/analytics";
import { StackLayout as StackLayout22, Popover, Button as Button5 } from "@leagueplatform/genesis-core";
import { jsx as jsx43, jsxs as jsxs23 } from "react/jsx-runtime";
var Tooltip = ({ tooltip, analyticDetails }) => {
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: analyticDetails.screenName,
    detail: "tooltip" /* TOOLTIP */,
    sub_detail: analyticDetails.subDetail
  });
  const sendButtonClickedAnalyticsEvent = React26.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME22.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx43(StackLayout22, { verticalAlignment: "center", css: { marginLeft: "$half" }, children: /* @__PURE__ */ jsxs23(Popover.Root, { children: [
    /* @__PURE__ */ jsx43(Popover.Trigger, { children: /* @__PURE__ */ jsx43(
      Button5,
      {
        icon: "statusInformationCircle",
        quiet: true,
        hideLabel: true,
        priority: "secondary",
        size: "small",
        onClick: sendButtonClickedAnalyticsEvent,
        children: tooltip
      }
    ) }),
    /* @__PURE__ */ jsx43(
      Popover.Content,
      {
        align: "center",
        avoidCollisions: true,
        showCloseButton: false,
        side: "top",
        css: {
          width: "40rem"
        },
        children: tooltip
      }
    )
  ] }) });
};

// src/components/details-side-header/details-side-header.component.tsx
import { jsx as jsx44, jsxs as jsxs24 } from "react/jsx-runtime";
var DetailsSideHeader = ({
  header,
  tooltip,
  member,
  memberUsername
}) => /* @__PURE__ */ jsxs24(Box20, { css: { paddingBottom: "$half" }, children: [
  member && /* @__PURE__ */ jsx44(
    StatusBadge4,
    {
      css: { marginBottom: "$half" },
      label: member,
      status: "info",
      showLight: false
    }
  ),
  header && /* @__PURE__ */ jsxs24(StackLayout23, { orientation: "horizontal", verticalAlignment: "center", children: [
    /* @__PURE__ */ jsx44(HeadingText8, { level: "2", size: "md", children: header }),
    tooltip && /* @__PURE__ */ jsx44(
      Tooltip,
      {
        tooltip,
        analyticDetails: {
          screenName: "benefit detail" /* BENEFIT_DETAIL */,
          subDetail: "member action" /* MEMBER_ACTION */
        }
      }
    )
  ] }),
  memberUsername && /* @__PURE__ */ jsx44(ParagraphText10, { css: { marginTop: "$half" }, emphasis: "base", size: "base", children: memberUsername })
] });

// src/pages/member-wallet-detail-page/components/benefit-dependents/benefit-dependents.component.tsx
import * as React27 from "react";
import {
  StackLayout as StackLayout24,
  StatusBadge as StatusBadge5,
  Box as Box21,
  ParagraphText as ParagraphText11,
  Select as Select3
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME23 } from "@leagueplatform/analytics";

// src/pages/member-wallet-detail-page/hooks/use-selected-member.hook.ts
import { create } from "zustand";
var useSelectedMemberStore = create((set) => ({
  selectedMember: void 0,
  setSelectedMember: (member) => {
    set(() => ({ selectedMember: member }));
  }
}));
var useSelectedMember = () => {
  const targetUserId = useTargetUserId();
  const selectedMember = useSelectedMemberStore(
    (state) => state.selectedMember
  );
  const { fullName } = useGetTargetUserInfo(targetUserId);
  const newMember = {
    id: targetUserId,
    name: fullName
  };
  if (!selectedMember && fullName !== "") {
    useSelectedMemberStore.setState(() => ({ selectedMember: newMember }));
    return newMember;
  }
  return selectedMember;
};
var useSetSelectedMember = () => useSelectedMemberStore((state) => state.setSelectedMember);

// src/pages/member-wallet-detail-page/components/benefit-dependents/benefit-dependents.component.tsx
import { jsx as jsx45, jsxs as jsxs25 } from "react/jsx-runtime";
var BenefitDependentsHeader = ({
  allMemberData
}) => {
  const member = useSelectedMember();
  const setMember = useSetSelectedMember();
  const userToDisplay = allMemberData.find(
    (users) => users.value === (member == null ? void 0 : member.id)
  );
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit detail" /* BENEFIT_DETAIL */,
    detail: "select user" /* SELECT_USER */
  });
  const sendButtonClickedAnalyticsEvent = React27.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME23.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsxs25(Box21, { css: { paddingBottom: "$half", width: "100%" }, children: [
    userToDisplay && /* @__PURE__ */ jsx45(
      StatusBadge5,
      {
        css: { marginBottom: "$half" },
        label: userToDisplay.relationship,
        status: "info",
        showLight: false
      }
    ),
    /* @__PURE__ */ jsx45(StackLayout24, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx45(
      Select3,
      {
        onChange: (e) => {
          var _a, _b;
          setMember({
            id: e.currentTarget.value,
            name: (_b = (_a = allMemberData.find(
              (users) => users.value === e.currentTarget.value
            )) == null ? void 0 : _a.label) != null ? _b : ""
          });
          sendButtonClickedAnalyticsEvent();
        },
        options: allMemberData,
        defaultValue: member == null ? void 0 : member.id,
        css: { width: "100%" }
      }
    ) }),
    (userToDisplay == null ? void 0 : userToDisplay.memberUsername) && /* @__PURE__ */ jsx45(ParagraphText11, { css: { marginTop: "$half" }, emphasis: "base", size: "base", children: userToDisplay.memberUsername })
  ] });
};

// src/components/side-detail-card/side-detail-card.component.tsx
import { jsx as jsx46, jsxs as jsxs26 } from "react/jsx-runtime";
var SideDetailCard = ({
  header,
  member,
  memberUsername,
  tooltip,
  children,
  allMemberData
}) => /* @__PURE__ */ jsx46(Box22, { css: { marginBottom: "$one" }, children: /* @__PURE__ */ jsxs26(BoxBorder, { children: [
  allMemberData ? /* @__PURE__ */ jsx46(BenefitDependentsHeader, { allMemberData }) : /* @__PURE__ */ jsx46(
    DetailsSideHeader,
    {
      header,
      tooltip,
      member,
      memberUsername
    }
  ),
  children
] }) });

// src/pages/member-biometric-detail-page/components/biometric-side-detail/biometrics-side-detail.component.tsx
import {
  ErrorState as ErrorState9,
  LoadingIndicator as LoadingIndicator13
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl31 } from "@leagueplatform/locales";
import { jsx as jsx47 } from "react/jsx-runtime";
var BiometricsSideDetail = () => {
  const { formatMessage } = useIntl31();
  const targetUserId = useTargetUserId();
  const memberUsername = useMemberUsername();
  const targetId = targetUserId;
  const { fullName, memberRelationship, isLoading, isError, error } = useGetTargetUserInfo(targetId);
  if (isLoading)
    return /* @__PURE__ */ jsx47(LoadingIndicator13, { inline: true });
  if (isError)
    return /* @__PURE__ */ jsx47(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx47(
      ErrorState9,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx47("br", {}) }
        )
      }
    ) });
  return /* @__PURE__ */ jsx47(
    SideDetailCard,
    {
      header: fullName,
      member: memberRelationship,
      memberUsername
    }
  );
};

// src/pages/member-biometric-detail-page/member-biometric-detail-page.component.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var MemberBiometricDetailPage = () => {
  var _a;
  const { formatMessage } = useIntl32();
  const { biometricType } = useCustomerSupportParams();
  const cleanBiometricName = (_a = biometricType == null ? void 0 : biometricType.replace(/-/g, "_")) != null ? _a : "";
  usePageViewAnalytics7({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    screen_name: "biometrics detail" /* BIOMETRICS_DETAIL */
  });
  return /* @__PURE__ */ jsx48(
    DetailPageWrapper,
    {
      header: /* @__PURE__ */ jsx48(
        DetailsHeader,
        {
          title: formatMessage({ id: cleanBiometricName.toLocaleUpperCase() })
        }
      ),
      mainSection: /* @__PURE__ */ jsx48(BiometricsDetailSection, { metric: cleanBiometricName }),
      sideDetailSection: /* @__PURE__ */ jsx48(BiometricsSideDetail, {})
    }
  );
};

// src/pages/member-overview-page/member-overview-page.component.tsx
import { StackLayout as StackLayout31 } from "@leagueplatform/genesis-core";
import { usePageViewAnalytics as usePageViewAnalytics8 } from "@leagueplatform/analytics";

// src/pages/member-overview-page/components/user-sessions/user-sessions.component.tsx
import { useIntl as useIntl34 } from "@leagueplatform/locales";
import { StackLayout as StackLayout28, HeadingText as HeadingText9 } from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator14,
  ErrorState as ErrorState10
} from "@leagueplatform/web-common-components";

// src/components/cs-table/cs-table-no-action/cs-table-no-action.component.tsx
import { Box as Box23, StackLayout as StackLayout25, UtilityText as UtilityText8 } from "@leagueplatform/genesis-core";
import { jsx as jsx49, jsxs as jsxs27 } from "react/jsx-runtime";
var emptyCell2 = {
  id: "",
  name: "",
  value: "",
  columnWidth: "auto"
};
var tableBorderCSS2 = {
  borderTopColor: "$onSurfaceBorderSubdued",
  borderTopWidth: "$thin",
  borderTopStyle: "solid",
  "&:last-child": {
    borderBottomColor: "$onSurfaceBorderSubdued",
    borderBottomWidth: "$thin",
    borderBottomStyle: "solid"
  },
  "thead &": {
    borderTop: "none"
  }
};
var getCellByColumnName2 = (cells, columnName) => cells.find((cell) => columnName === cell.name) || emptyCell2;
var TableColumnHeader2 = ({
  id,
  name,
  value,
  columnWidth
}) => /* @__PURE__ */ jsx49(
  Box23,
  {
    as: value ? "th" : "td",
    "data-column": name,
    id,
    scope: "col",
    css: {
      padding: "$half",
      width: columnWidth
    },
    children: /* @__PURE__ */ jsx49(StackLayout25, { verticalAlignment: "center", horizontalAlignment: "start", children: /* @__PURE__ */ jsx49(
      UtilityText8,
      {
        css: {
          typography: "$label"
        },
        children: value
      }
    ) })
  },
  id
);
var TableRowCell2 = ({
  id,
  name,
  value,
  columnWidth,
  rowHeight = "$four"
}) => /* @__PURE__ */ jsx49(
  Box23,
  {
    "data-column": name,
    as: "td",
    css: {
      verticalAlign: "middle",
      paddingTop: "$half",
      paddingBottom: "$half",
      paddingRight: "$half",
      width: columnWidth
    },
    children: /* @__PURE__ */ jsx49(
      StackLayout25,
      {
        orientation: "horizontal",
        css: {
          minHeight: rowHeight,
          alignItems: "center",
          height: "fit-content"
        },
        children: value || "-"
      }
    )
  },
  id
);
var TableRow2 = ({
  id,
  cells,
  columns,
  columnWidth,
  rowHeight
}) => /* @__PURE__ */ jsx49(Box23, { as: "tr", css: tableBorderCSS2, children: columns.map((column) => {
  const {
    id: cellId,
    name,
    value
  } = getCellByColumnName2(cells, column.name);
  return /* @__PURE__ */ jsx49(
    TableRowCell2,
    {
      id: cellId,
      name,
      value,
      columnId: column.id,
      columnWidth,
      rowHeight
    },
    cellId
  );
}) }, id);
var EmptyRow2 = ({ colSpan, emptyRowText = "-" }) => /* @__PURE__ */ jsx49(Box23, { as: "tr", children: /* @__PURE__ */ jsx49(
  Box23,
  {
    as: "td",
    colSpan,
    css: { textAlign: "center", paddingY: "half", width: "100%" },
    children: emptyRowText
  }
) });
var CSTable = ({
  columns,
  rows,
  emptyRowText,
  columnWidth,
  rowHeight
}) => /* @__PURE__ */ jsxs27(Box23, { as: "table", css: { width: "100%" }, children: [
  /* @__PURE__ */ jsx49(
    Box23,
    {
      as: "thead",
      css: {
        position: "sticky",
        zIndex: "$sticky",
        top: "$five",
        background: "$surfaceBackgroundTertiary"
      },
      children: /* @__PURE__ */ jsx49(Box23, { as: "tr", css: tableBorderCSS2, children: columns.map((column) => /* @__PURE__ */ jsx49(
        TableColumnHeader2,
        {
          id: column.id,
          name: column.name,
          value: column.value,
          columnWidth
        },
        column.id
      )) })
    }
  ),
  /* @__PURE__ */ jsx49(Box23, { as: "tbody", children: rows.length === 0 ? /* @__PURE__ */ jsx49(EmptyRow2, { colSpan: columns.length, emptyRowText }) : rows.map(({ id, cells }) => /* @__PURE__ */ jsx49(
    TableRow2,
    {
      id,
      cells,
      columns,
      columnWidth,
      rowHeight
    },
    id
  )) })
] });

// src/utils/cs-table-no-action.utils.tsx
import {
  StackLayout as StackLayout27,
  ParagraphText as ParagraphText14,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";

// src/components/date-period/date-period.component.tsx
import { ParagraphText as ParagraphText12, VisuallyHidden as VisuallyHidden5 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl33 } from "@leagueplatform/locales";
import { jsx as jsx50, jsxs as jsxs28 } from "react/jsx-runtime";
var DatePeriod = ({
  startDate,
  endDate,
  timeZone
}) => {
  const { formatDate, formatMessage } = useIntl33();
  if (!startDate || !endDate)
    return /* @__PURE__ */ jsxs28(ParagraphText12, { size: "base", children: [
      /* @__PURE__ */ jsx50(VisuallyHidden5, { children: formatMessage({ id: "CS_NO_DATE_AVAILABLE" }) }),
      /* @__PURE__ */ jsx50("span", { "aria-hidden": true, children: "-" })
    ] });
  const validationPeriodEnded = /* @__PURE__ */ new Date() > new Date(endDate);
  const startDateFormatted = formatDate(startDate, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone
  });
  const endDateFormatted = formatDate(endDate, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone
  });
  if (validationPeriodEnded) {
    return /* @__PURE__ */ jsx50(ParagraphText12, { size: "base", children: formatMessage(
      { id: "CS_VALIDATION_PERIOD_ENDED" },
      { date: endDateFormatted }
    ) });
  }
  return /* @__PURE__ */ jsxs28(ParagraphText12, { size: "base", children: [
    startDateFormatted,
    " - ",
    endDateFormatted
  ] });
};

// src/components/cs-table/cs-table-no-action/user-sessions-device/user-sessions-device.component.tsx
import {
  Box as Box24,
  Icon as Icon8,
  ParagraphText as ParagraphText13,
  StackLayout as StackLayout26
} from "@leagueplatform/genesis-core";

// src/pages/member-overview-page/utils/get-session-device-icon.util.ts
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
var getPhoneDeviceIcon = (osVersion) => {
  if (osVersion == null ? void 0 : osVersion.includes("iOS")) {
    return handleStaticAsset8("IOS_ICON" /* IOS_ICON */);
  }
  if (osVersion == null ? void 0 : osVersion.includes("Android")) {
    return handleStaticAsset8("ANDROID_ICON" /* ANDROID_ICON */);
  }
  return handleStaticAsset8("WEB_ICON" /* WEB_ICON */);
};
var getWebDeviceIcon = (browser) => {
  if (browser == null ? void 0 : browser.includes("Safari")) {
    return handleStaticAsset8("SAFARI_ICON" /* SAFARI_ICON */);
  }
  if (browser == null ? void 0 : browser.includes("Chrome")) {
    return handleStaticAsset8("CHROME_ICON" /* CHROME_ICON */);
  }
  if (browser == null ? void 0 : browser.includes("Firefox")) {
    return handleStaticAsset8("FIREFOX_ICON" /* FIREFOX_ICON */);
  }
  return handleStaticAsset8("WEB_ICON" /* WEB_ICON */);
};

// src/components/cs-table/cs-table-no-action/user-sessions-device/user-sessions-device.component.tsx
import { Fragment as Fragment4, jsx as jsx51, jsxs as jsxs29 } from "react/jsx-runtime";
var getDeviceIcon = (attributes) => {
  if (attributes.platform === "Web") {
    return getWebDeviceIcon(attributes.browserInfo);
  }
  return getPhoneDeviceIcon(attributes.osVersion);
};
var ShowIcon = ({ iconPath }) => /* @__PURE__ */ jsx51(
  Box24,
  {
    css: {
      border: "$borderWidths$thin solid $onSurfaceBorderSubdued",
      borderRadius: "$circle",
      width: "calc($two + 2px)",
      height: "calc($two + 2px)",
      marginRight: "$half"
    },
    children: /* @__PURE__ */ jsx51(Icon8, { icon: iconPath, size: "$two" })
  }
);
var UserSessionsDevice = ({ attributes }) => /* @__PURE__ */ jsxs29(Fragment4, { children: [
  /* @__PURE__ */ jsx51(ShowIcon, { iconPath: getDeviceIcon(attributes) }),
  /* @__PURE__ */ jsx51(StackLayout26, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx51(ParagraphText13, { size: "base", css: { wordBreak: "break-all" }, children: attributes.platform === "Web" ? `${attributes.osVersion} - ${attributes.browserInfo}` : `${attributes.device} - ${attributes.osVersion}- ${attributes.browserInfo}` }) })
] });

// src/utils/cs-table-no-action.utils.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
var { FormName, FormCompletionDate, FormValidationPeriod, FormStatus } = ConsentFormColumnNames;
function generateCell2(rowIndex, name, value) {
  return {
    id: `${rowIndex}-${name}`,
    name,
    value
  };
}
var generateConsentListRow = (consent, rowIndex, timeZone) => ({
  id: `consent-form-${rowIndex}`,
  cells: [
    generateCell2(
      rowIndex,
      FormName,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(ParagraphText14, { size: "base", children: consent.attributes.name }) })
    ),
    generateCell2(
      rowIndex,
      FormCompletionDate,
      /* @__PURE__ */ jsx52(
        CsTableItemDate,
        {
          date: consent.attributes.completionDate || "",
          isLongDateFormat: true,
          timeZone
        }
      )
    ),
    generateCell2(
      rowIndex,
      FormValidationPeriod,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(
        DatePeriod,
        {
          startDate: consent.attributes.validationPeriodStart,
          endDate: consent.attributes.validationPeriodEnd,
          timeZone
        }
      ) })
    ),
    generateCell2(
      rowIndex,
      FormStatus,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(
        CsTableStatusBadge,
        {
          status: mapAssessmentStatusColors(consent.attributes.status),
          label: normalizeAssessmentStatusLabel(consent.attributes.status)
        }
      ) })
    )
  ]
});
var generateConsentFormListRows = (consentForms, timeZone) => consentForms.reduce(
  (consentFormRows, consentForm, rowIndex) => [
    ...consentFormRows,
    generateConsentListRow(consentForm, rowIndex, timeZone)
  ],
  []
);
var { Name, CompletionDate, Status: Status3 } = HealthRiskAssessmentsColumnNames;
var generateHealthRiskAssessmentsCell = (rowIndex, name, value) => ({
  id: `${rowIndex}-${name}`,
  name,
  value
});
var generateHealthRiskAssessmentsListRow = (healthRiskAssessment, rowIndex, timeZone) => ({
  id: `health-risk-assessment-${rowIndex}`,
  cells: [
    generateHealthRiskAssessmentsCell(
      rowIndex,
      Name,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(ParagraphText14, { size: "base", children: healthRiskAssessment.attributes.name }) })
    ),
    generateHealthRiskAssessmentsCell(
      rowIndex,
      CompletionDate,
      /* @__PURE__ */ jsx52(
        CsTableItemDate,
        {
          date: healthRiskAssessment.attributes.completionDate || "",
          isLongDateFormat: true,
          timeZone
        }
      )
    ),
    generateHealthRiskAssessmentsCell(
      rowIndex,
      Status3,
      /* @__PURE__ */ jsx52(
        CsTableStatusBadge,
        {
          status: mapAssessmentStatusColors(
            healthRiskAssessment.attributes.status
          ),
          label: normalizeAssessmentStatusLabel(
            healthRiskAssessment.attributes.status
          )
        }
      )
    )
  ]
});
var generateHealthRiskAssessmentsListRows = (healthRiskAssessments, timeZone) => healthRiskAssessments.reduce(
  (healthRiskAssessmentRows, healthRiskAssessment, rowIndex) => [
    ...healthRiskAssessmentRows,
    generateHealthRiskAssessmentsListRow(
      healthRiskAssessment,
      rowIndex,
      timeZone
    )
  ],
  []
);
var { Device, Platform, AppVersion, LastAccessed } = UserSessionsColumnNames;
var generateUserSessionsCell = (rowIndex, name, value) => ({
  id: `${rowIndex}-${name}`,
  name,
  value
});
var generateUserSessionsListRow = (userSession, rowIndex, timeZone) => ({
  id: `user-session-${rowIndex}`,
  cells: [
    generateUserSessionsCell(
      rowIndex,
      Device,
      /* @__PURE__ */ jsx52(UserSessionsDevice, { attributes: userSession.attributes })
    ),
    generateUserSessionsCell(
      rowIndex,
      Platform,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(ParagraphText14, { size: "base", css: { wordBreak: "break-all" }, children: userSession.attributes.platform || "-" }) })
    ),
    generateUserSessionsCell(
      rowIndex,
      AppVersion,
      /* @__PURE__ */ jsx52(StackLayout27, { orientation: "horizontal", verticalAlignment: "center", children: /* @__PURE__ */ jsx52(ParagraphText14, { size: "base", css: { wordBreak: "break-all" }, children: userSession.attributes.appVersion || "-" }) })
    ),
    generateUserSessionsCell(
      rowIndex,
      LastAccessed,
      /* @__PURE__ */ jsx52(
        CsTableItemDate,
        {
          date: userSession.attributes.loginDate,
          isLongDateFormat: true,
          timeZone
        }
      )
    )
  ]
});
var generateUserSessionsListRows = (userSessions, timeZone) => userSessions.reduce(
  (userSessionRows, userSession, rowIndex) => [
    ...userSessionRows,
    generateUserSessionsListRow(userSession, rowIndex, timeZone)
  ],
  []
);
function generateChallengesActivityRow(activity, columns, rowIndex, timeZone) {
  return {
    id: `challenge-activity-${rowIndex}`,
    cells: [
      generateCell2(
        rowIndex,
        columns[0].name,
        /* @__PURE__ */ jsx52(
          CsTableItemDate,
          {
            css: { typography: "$bodyTwo" },
            date: activity.displayDate,
            isLongDateFormat: false,
            timeZone
          }
        )
      ),
      generateCell2(
        rowIndex,
        columns[1].name,
        /* @__PURE__ */ jsx52(UtilityText9, { css: { typography: "$bodyTwo" }, children: activity.name })
      ),
      generateCell2(
        rowIndex,
        columns[2].name,
        /* @__PURE__ */ jsx52(UtilityText9, { css: { typography: "$bodyTwo", wordBreak: "break-word" }, children: activity.id })
      ),
      generateCell2(
        rowIndex,
        columns[3].name,
        /* @__PURE__ */ jsx52(
          CsTableStatusBadge,
          {
            status: mapChallengesStatusColors(activity.status),
            label: normalizeChallengesStatusLabel(activity.status)
          }
        )
      )
    ]
  };
}
function generateChallengesActivityListRows(activities, columns, timeZone) {
  return activities.reduce(
    (row, activity, rowIndex) => [
      ...row,
      generateChallengesActivityRow(activity, columns, rowIndex, timeZone)
    ],
    []
  );
}

// src/pages/member-overview-page/hooks/use-get-user-sessions-query.hook.ts
import { useQuery as useQuery11 } from "@tanstack/react-query";
import {
  getUserSessions,
  GET_USER_SESSIONS
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError8 } from "@leagueplatform/observability";
function useGetUserSessions(targetUserId) {
  const userId = targetUserId;
  return useQuery11([GET_USER_SESSIONS, userId], () => getUserSessions(userId), {
    staleTime: Infinity,
    onError(error) {
      captureError8(
        new Error(
          `Customer Support: Failed to get user sessions: (member id: ${userId}): ${error}`
        )
      );
    }
  });
}

// src/pages/member-overview-page/components/user-sessions/user-sessions.component.tsx
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
import { jsx as jsx53, jsxs as jsxs30 } from "react/jsx-runtime";
var { Device: Device2, Platform: Platform2, AppVersion: AppVersion2, LastAccessed: LastAccessed2 } = UserSessionsColumnNames;
var tableColumArray = [Device2, Platform2, AppVersion2, LastAccessed2];
var UserSessions = () => {
  var _a;
  const { formatMessage } = useIntl34();
  const targetUserId = useTargetUserId();
  const { timeZone } = useGetTargetUserInfo(targetUserId);
  const {
    data: userSessions,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetUserSessions(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, userSessions);
  const currentLength = (_a = userSessions == null ? void 0 : userSessions.length) != null ? _a : 0;
  const initialLength = VIEW_MORE_SESSIONS.USER_SESSIONS_INITIAL_RECENT_SESSIONS;
  const showCopy = currentLength > initialLength;
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "member overview" /* MEMBER_OVERVIEW */,
    detail: "view more sessions" /* VIEW_MORE_SESSIONS */
  });
  const { hideButton, addMore, sessionView } = useDisplayMore(
    initialLength,
    sendAnalyticsEvent,
    currentLength
  );
  const columns = tableColumArray.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  let rows = [];
  if (userSessions)
    rows = generateUserSessionsListRows(
      userSessions.slice(0, sessionView),
      timeZone
    );
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx53(LoadingIndicator14, { inline: true });
  if (isError)
    return /* @__PURE__ */ jsx53(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx53(
      ErrorState10,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx53("br", {}) }
        )
      }
    ) });
  if (!userSessions || userSessions.length === 0) {
    return /* @__PURE__ */ jsx53(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx53(
      ErrorState10,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "NO_RECENT_SESSIONS" }),
        imageSrc: handleStaticAsset9("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  }
  return /* @__PURE__ */ jsxs30(StackLayout28, { orientation: "vertical", spacing: "$one", children: [
    /* @__PURE__ */ jsx53(HeadingText9, { level: "2", size: "lg", children: formatMessage({ id: "RECENT_SESSIONS" }) }),
    /* @__PURE__ */ jsx53(CSTable, { columns, rows, columnWidth: "auto" }),
    /* @__PURE__ */ jsx53(
      ViewMoreButton,
      {
        hideButton,
        showCopy,
        onClick: addMore
      }
    )
  ] });
};

// src/pages/member-overview-page/components/recommended-device/recommended-device.component.tsx
import { useIntl as useIntl35 } from "@leagueplatform/locales";
import { StatusBanner as StatusBanner3, ParagraphText as ParagraphText15, Box as Box25 } from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator15,
  ErrorState as ErrorState11
} from "@leagueplatform/web-common-components";

// src/pages/member-overview-page/hooks/use-get-recommended-device.query.ts
import { useQuery as useQuery12 } from "@tanstack/react-query";
import { captureError as captureError9 } from "@leagueplatform/observability";
import {
  getRecommendedDevice,
  GET_RECOMMENDED_DEVICE
} from "@leagueplatform/cse-customer-support-api";
function useGetRecommendedDeviceQuery(options) {
  const result = useQuery12([GET_RECOMMENDED_DEVICE], () => getRecommendedDevice(), __spreadValues({
    staleTime: Infinity
  }, options));
  if (result.isError) {
    captureError9(
      new Error(
        `Customer Support: Failed to get recommended device: ${result.error}`
      )
    );
  }
  return result;
}

// src/pages/member-overview-page/hooks/use-get-recommended-device.hook.ts
function useGetRecommendedDevice() {
  return useGetRecommendedDeviceQuery({
    select: (response) => response.data
  });
}

// src/pages/member-overview-page/components/recommended-device/recommended-device.component.tsx
import { jsx as jsx54, jsxs as jsxs31 } from "react/jsx-runtime";
var strong = (msg) => /* @__PURE__ */ jsx54("strong", { children: msg });
var RecommendedDevice = () => {
  const { formatMessage } = useIntl35();
  const { data, isError, isLoading, isSuccess, error } = useGetRecommendedDevice();
  const isIdle = simulateIsIdle(isLoading, isSuccess, data);
  if (isError) {
    return /* @__PURE__ */ jsx54(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx54(
      ErrorState11,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx54("br", {}) }
        )
      }
    ) });
  }
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx54(LoadingIndicator15, { inline: true });
  const [primary, secondary] = data;
  const hasAppVersions = primary && secondary;
  return /* @__PURE__ */ jsx54(
    StatusBanner3,
    {
      status: "neutral",
      title: formatMessage({ id: "RECOMMENDED_DEVICE_TITLE" }),
      css: { marginTop: "$two" },
      children: /* @__PURE__ */ jsxs31(Box25, { as: "ul", css: { marginTop: "$one" }, children: [
        /* @__PURE__ */ jsx54(Box25, { as: "li", children: /* @__PURE__ */ jsx54(ParagraphText15, { css: { marginBottom: "$none" }, size: "sm", children: formatMessage(
          { id: "RECOMMENDED_DEVICE_DESCRIPTION_WEB_BROWSERS" },
          { strong }
        ) }) }),
        hasAppVersions && /* @__PURE__ */ jsx54(Box25, { as: "li", children: /* @__PURE__ */ jsx54(ParagraphText15, { size: "sm", children: formatMessage(
          { id: "RECOMMENDED_DEVICE_DESCRIPTION_APP_VERSION" },
          {
            strong,
            primaryName: primary.name,
            secondaryName: secondary.name,
            primaryCurrentVersion: primary.currentVersion,
            secondaryCurrentVersion: secondary.currentVersion
          }
        ) }) })
      ] })
    }
  );
};

// src/pages/member-overview-page/components/member-identification/member-identification.component.tsx
import { HeadingText as HeadingText11, StackLayout as StackLayout30 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl37 } from "@leagueplatform/locales";

// src/components/copiable-item/copiable-item.component.tsx
import {
  Button as Button6,
  HeadingText as HeadingText10,
  Icon as Icon9,
  StackLayout as StackLayout29,
  UtilityText as UtilityText10,
  VisuallyHidden as VisuallyHidden6
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl36 } from "@leagueplatform/locales";

// src/components/copy-icon/copy-icon.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
function CopyIcon() {
  return /* @__PURE__ */ jsx55("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx55(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.25 2.25C8.25 1.83579 8.58579 1.5 9 1.5H16.629C16.8277 1.50008 17.0183 1.57903 17.1588 1.7195L20.0305 4.59116C20.171 4.73172 20.2499 4.92244 20.25 5.12116V15.75C20.25 16.1642 19.9142 16.5 19.5 16.5H17.25V11.1208C17.2499 10.5245 17.0129 9.95247 16.5913 9.53067L13.7192 6.6585C13.2974 6.23697 12.7253 6.00013 12.129 6H8.25V2.25ZM6.75 6V2.25C6.75 1.00736 7.75736 0 9 0H16.629C17.2253 0.000127316 17.7974 0.236973 18.2192 0.6585L21.0913 3.53067C21.5129 3.95247 21.7499 4.52452 21.75 5.12084V15.75C21.75 16.9926 20.7426 18 19.5 18H17.25V21.75C17.25 22.9926 16.2426 24 15 24H4.5C3.25736 24 2.25 22.9926 2.25 21.75V8.25C2.25 7.00736 3.25736 6 4.5 6H6.75ZM15.75 17.25V11.1212C15.7499 10.9224 15.671 10.7317 15.5305 10.5912L12.6588 7.7195C12.5183 7.57903 12.3277 7.50008 12.129 7.5H7.5H4.5C4.08579 7.5 3.75 7.83579 3.75 8.25V21.75C3.75 22.1642 4.08579 22.5 4.5 22.5H15C15.4142 22.5 15.75 22.1642 15.75 21.75V17.25Z",
      fill: "currentColor"
    }
  ) });
}

// src/hooks/use-copy-value-callback.hook.ts
import * as React28 from "react";
import { TOAST_STATUS as TOAST_STATUS2, toastActions as toastActions2 } from "@leagueplatform/toast-messages";
import { EVENT_NAME as EVENT_NAME24 } from "@leagueplatform/analytics";
import { merge } from "lodash-es";
var DEFAULT_COPY_VALUE_CONFIG = {
  showToast: true,
  toastTextId: "COMMON_PROPERTY_COPIED_TO_CLIPBOARD"
};
var RECENTLY_COPIED_TIMEOUT = 2e3;
function useCopyValueCallback(value, config) {
  const { valueLabel, showToast } = merge(DEFAULT_COPY_VALUE_CONFIG, config);
  const [isRecentlyCopied, setIsRecentlyCopied] = React28.useState(false);
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "member overview" /* MEMBER_OVERVIEW */
  });
  const sendButtonClickedAnalyticsEvent = React28.useCallback(
    (userSelection, message) => sendAnalyticsEvent(EVENT_NAME24.BUTTON_CLICKED, {
      detail: `${"copy" /* COPY */} ${userSelection == null ? void 0 : userSelection.toLowerCase()}`,
      sub_detail: message
    }),
    [sendAnalyticsEvent]
  );
  const callback = React28.useCallback(() => __async(this, null, function* () {
    try {
      yield navigator.clipboard.writeText(value);
      setIsRecentlyCopied(true);
      setTimeout(() => {
        setIsRecentlyCopied(false);
      }, RECENTLY_COPIED_TIMEOUT);
      if (showToast) {
        toastActions2.add({
          type: TOAST_STATUS2.SUCCESS,
          textId: "COMMON_PROPERTY_COPIED_TO_CLIPBOARD",
          values: {
            property: valueLabel != null ? valueLabel : value
          }
        });
        sendButtonClickedAnalyticsEvent(valueLabel, "success" /* SUCCESS */);
      }
    } catch (e) {
      if (showToast) {
        toastActions2.add({
          type: TOAST_STATUS2.ERROR,
          textId: "COMMON_ERROR_COPYING_PROPERTY_TO_CLIPBOARD",
          values: {
            property: valueLabel != null ? valueLabel : value
          }
        });
        sendButtonClickedAnalyticsEvent(valueLabel, "error" /* ERROR */);
      }
    }
  }), [value, valueLabel, showToast, sendButtonClickedAnalyticsEvent]);
  return { callback, isRecentlyCopied };
}

// src/components/copiable-item/copiable-item.component.tsx
import { jsx as jsx56, jsxs as jsxs32 } from "react/jsx-runtime";
function CopiableItem({ heading, value }) {
  const { formatMessage } = useIntl36();
  const { callback: handleCopyValueClick, isRecentlyCopied } = useCopyValueCallback(value, {
    valueLabel: heading
  });
  const icon = isRecentlyCopied ? "interfaceCheckmark" : /* @__PURE__ */ jsx56(CopyIcon, {});
  return /* @__PURE__ */ jsxs32(StackLayout29, { css: { flexBasis: "50%" }, spacing: "$half", children: [
    /* @__PURE__ */ jsx56(
      HeadingText10,
      {
        level: "3",
        size: "lg",
        css: { typography: "$label", color: "$onSurfaceTextSubdued" },
        children: heading
      }
    ),
    /* @__PURE__ */ jsxs32(
      StackLayout29,
      {
        orientation: "horizontal",
        spacing: "$quarter",
        verticalAlignment: "center",
        css: {
          position: "relative"
        },
        children: [
          /* @__PURE__ */ jsx56(UtilityText10, { css: { typography: "$bodyTwo" }, children: value }),
          /* @__PURE__ */ jsxs32(
            Button6,
            {
              size: "small",
              priority: "secondary",
              quiet: true,
              onClick: handleCopyValueClick,
              css: {
                position: "absolute",
                left: "100%",
                marginLeft: "$quarter",
                padding: "$half",
                "& > span": {
                  height: "$one"
                }
              },
              children: [
                /* @__PURE__ */ jsx56(Icon9, { icon, size: "$one" }),
                /* @__PURE__ */ jsx56(VisuallyHidden6, { children: formatMessage({ id: "COPY_PROPERTY" }, { property: heading }) })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/pages/member-overview-page/components/member-identification/member-identification.component.tsx
import { jsx as jsx57, jsxs as jsxs33 } from "react/jsx-runtime";
function MemberIdentification() {
  const { formatMessage } = useIntl37();
  const userId = useTargetUserId();
  const memberUsername = useMemberUsername();
  return /* @__PURE__ */ jsxs33(
    StackLayout30,
    {
      orientation: "vertical",
      spacing: "$one",
      horizontalAlignment: "stretch",
      children: [
        /* @__PURE__ */ jsx57(HeadingText11, { level: "2", size: "lg", children: formatMessage({ id: "CS_MEMBER_IDENTIFICATION" }) }),
        /* @__PURE__ */ jsxs33(StackLayout30, { orientation: "vertical", spacing: "$oneAndHalf", children: [
          /* @__PURE__ */ jsx57(
            CopiableItem,
            {
              heading: formatMessage({ id: "USERNAME" }),
              value: memberUsername
            }
          ),
          /* @__PURE__ */ jsx57(
            CopiableItem,
            {
              heading: formatMessage({ id: "USER_ID" }),
              value: userId
            }
          )
        ] })
      ]
    }
  );
}

// src/pages/member-overview-page/member-overview-page.component.tsx
import { Fragment as Fragment5, jsx as jsx58, jsxs as jsxs34 } from "react/jsx-runtime";
var MemberOverviewPage = ({
  canShowRecommendedDevice,
  canShowUserSessions
}) => {
  usePageViewAnalytics8({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "member overview" /* MEMBER_OVERVIEW */
  });
  const isViewMemberIdEnabled = useCustomerSupportConfig(
    "enableMemberOverview.enableMemberIdentification"
  );
  const isViewMemberSessionsEnabled = useCustomerSupportConfig("enableMemberOverview.enableMemberSessions") && canShowUserSessions;
  const isViewAppVersionsEnabled = useCustomerSupportConfig("enableMemberOverview.enableAppVersions") && canShowRecommendedDevice;
  return /* @__PURE__ */ jsxs34(Fragment5, { children: [
    /* @__PURE__ */ jsxs34(
      StackLayout31,
      {
        spacing: "$twoAndHalf",
        horizontalAlignment: "stretch",
        css: { height: "auto" },
        children: [
          !!isViewMemberIdEnabled && /* @__PURE__ */ jsx58(MemberIdentification, {}),
          !!isViewMemberSessionsEnabled && /* @__PURE__ */ jsx58(UserSessions, {})
        ]
      }
    ),
    !!isViewAppVersionsEnabled && /* @__PURE__ */ jsx58(RecommendedDevice, {})
  ] });
};

// src/pages/member-rewards-detail-page/member-rewards-detail-page.component.tsx
import {
  LoadingIndicator as LoadingIndicator19,
  ErrorState as ErrorState16
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl52 } from "@leagueplatform/locales";
import { usePageViewAnalytics as usePageViewAnalytics9 } from "@leagueplatform/analytics";

// src/pages/member-rewards-detail-page/hooks/use-get-user-health-campaign-by-id-query.hook.ts
import {
  GET_USER_CAMPAIGNS_MESSAGE_TYPE,
  getUserHealthCampaignById
} from "@leagueplatform/health-journey-api";
import { useQuery as useQuery13 } from "@tanstack/react-query";
import { captureError as captureError10 } from "@leagueplatform/observability";
function useGetUserHealthCampaignById(userHealthCampaignId, options) {
  return useQuery13(
    [GET_USER_CAMPAIGNS_MESSAGE_TYPE, userHealthCampaignId],
    // we always want health campaign data & activities so they're set to true
    () => getUserHealthCampaignById(userHealthCampaignId, true, true),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError10(
          new Error(
            `Customer Support: Failed to get reward program(id: ${userHealthCampaignId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-rewards-detail-page/hooks/use-get-rewards-detail-page.hook.ts
function useGetRewardsDetailPage() {
  const { rewardId, programId } = useCustomerSupportParams();
  const userHealthCampaignId = rewardId || programId;
  return useGetUserHealthCampaignById(userHealthCampaignId != null ? userHealthCampaignId : "", {
    select: (data) => data == null ? void 0 : data.data
  });
}

// src/pages/member-rewards-detail-page/components/reward-side-details/reward-side-details.component.tsx
import { useIntl as useIntl40 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator16,
  ErrorState as ErrorState12
} from "@leagueplatform/web-common-components";
import { UtilityText as UtilityText12, StatusBadge as StatusBadge6 } from "@leagueplatform/genesis-core";

// src/components/side-date-with-icon/side-date-with-icon.component.tsx
import {
  Box as Box26,
  HeadingText as HeadingText12,
  Icon as Icon10,
  StackLayout as StackLayout32,
  UtilityText as UtilityText11
} from "@leagueplatform/genesis-core";
import { jsx as jsx59, jsxs as jsxs35 } from "react/jsx-runtime";
var ShowDate = ({ details }) => {
  let displayedDate = details.formattedStartDate;
  if (details.formattedEndDate) {
    displayedDate += ` - `;
  }
  return /* @__PURE__ */ jsxs35(StackLayout32, { orientation: "horizontal", css: { marginBottom: "$one" }, children: [
    /* @__PURE__ */ jsx59(
      Icon10,
      {
        icon: "illustrativeCalendar",
        tint: "$onSurfaceIconPrimary",
        css: { marginRight: "$one" }
      }
    ),
    /* @__PURE__ */ jsxs35(Box26, { children: [
      /* @__PURE__ */ jsx59(
        HeadingText12,
        {
          emphasis: "base",
          level: "display",
          size: "sm",
          css: { typography: "$subtitleTwo" },
          children: details.label
        }
      ),
      /* @__PURE__ */ jsx59(StackLayout32, { orientation: "vertical", children: /* @__PURE__ */ jsxs35(UtilityText11, { css: { typography: "$bodyTwo" }, children: [
        displayedDate,
        /* @__PURE__ */ jsx59("br", {}),
        details == null ? void 0 : details.formattedEndDate
      ] }) })
    ] })
  ] });
};

// src/pages/member-rewards-detail-page/hooks/use-get-formatted-date-details.hook.ts
import { useIntl as useIntl38 } from "@leagueplatform/locales";
var useGetFormattedDateDetails = (rewardProgram, timeZone) => {
  const { formatMessage, formatDate } = useIntl38();
  const dateToDisplay = getShortDateTimeZone(timeZone);
  const formattedDateData = [
    {
      label: formatMessage({ id: "ACTIVE_PERIOD" }),
      formattedStartDate: formatMessage(
        { id: "START_DAY_AT_TIME" },
        {
          day: formatDate(rewardProgram.campaign.data.startDate, dateToDisplay)
        }
      ),
      formattedEndDate: formatMessage(
        { id: "END_DAY_AT_TIME" },
        {
          day: formatDate(rewardProgram.campaign.data.endDate, dateToDisplay)
        }
      )
    },
    {
      label: formatMessage({ id: "VISIBILITY_PERIOD" }),
      formattedStartDate: formatMessage(
        { id: "START_DAY_AT_TIME" },
        {
          day: formatDate(rewardProgram.campaign.data.startDate, dateToDisplay)
        }
      ),
      formattedEndDate: formatMessage(
        { id: "END_DAY_AT_TIME" },
        {
          day: formatDate(rewardProgram.visibilityEndDate, dateToDisplay)
        }
      )
    },
    {
      label: formatMessage({ id: "JOINED_DATE" }),
      formattedStartDate: formatDate(rewardProgram.joinedDate, dateToDisplay)
    }
  ];
  return formattedDateData.filter(
    (displayString) => displayString.formattedStartDate
  );
};

// src/hooks/use-program-status-styles.hook.ts
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS3,
  USER_HEALTH_GOAL_PROGRAM_STATUS as USER_HEALTH_GOAL_PROGRAM_STATUS3
} from "@leagueplatform/health-journey-api";
import { useIntl as useIntl39 } from "@leagueplatform/locales";
var useProgramStatusStyles = (rewardStatus, timeZone, completionDate, endDate, quitDate, isSoloChallenge) => {
  const { formatMessage, formatDate } = useIntl39();
  const dateToDisplay = getShortDateTimeZone(timeZone);
  if (rewardStatus === USER_HEALTH_CAMPAIGN_STATUS3.ENDED) {
    const badgeStatus = "neutral";
    if (!endDate || isSoloChallenge) {
      return {
        badgeStatus,
        text: formatMessage({
          id: "ENDED"
        })
      };
    }
    return {
      badgeStatus,
      text: formatMessage(
        {
          id: "ENDED_ON_DATE"
        },
        {
          date: formatDate(endDate, dateToDisplay)
        }
      )
    };
  }
  if (rewardStatus === USER_HEALTH_GOAL_PROGRAM_STATUS3.QUIT) {
    const badgeStatus = "neutral";
    if (!quitDate || isSoloChallenge) {
      return {
        badgeStatus,
        text: formatMessage({
          id: "QUIT"
        })
      };
    }
    return {
      badgeStatus,
      text: formatMessage(
        {
          id: "QUIT_DATE"
        },
        {
          date: formatDate(quitDate, dateToDisplay)
        }
      )
    };
  }
  if (rewardStatus === USER_HEALTH_CAMPAIGN_STATUS3.COMPLETED) {
    const badgeStatus = "success";
    if (!completionDate || isSoloChallenge) {
      return {
        badgeStatus,
        text: formatMessage({
          id: "COMPLETED"
        })
      };
    }
    return {
      badgeStatus,
      text: formatMessage(
        {
          id: "COMPLETED_ON_DATE"
        },
        {
          date: formatDate(completionDate, dateToDisplay)
        }
      )
    };
  }
  if (rewardStatus === USER_HEALTH_CAMPAIGN_STATUS3.ON_HOLD) {
    const badgeStatus = "error";
    return {
      badgeStatus,
      text: formatMessage({
        id: "ON_HOLD"
      })
    };
  }
  return null;
};

// src/pages/member-rewards-detail-page/components/reward-side-details/reward-side-details.component.tsx
import { Fragment as Fragment6, jsx as jsx60, jsxs as jsxs36 } from "react/jsx-runtime";
var RewardSideDetails = ({
  rewardProgram,
  targetUserId,
  memberUsername
}) => {
  const { formatMessage } = useIntl40();
  const targetId = targetUserId;
  const { fullName, memberRelationship, timeZone, isLoading, isError, error } = useGetTargetUserInfo(targetId);
  const formattedDateData = useGetFormattedDateDetails(rewardProgram, timeZone);
  const {
    campaign,
    status: rewardStatus,
    completionDate,
    endDate
  } = rewardProgram;
  const showProgramStatusBadge = useProgramStatusStyles(
    rewardStatus,
    timeZone,
    completionDate,
    endDate
  );
  const { externalCampaignId, id: leagueId } = campaign.data;
  if (isLoading)
    return /* @__PURE__ */ jsx60(LoadingIndicator16, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx60(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx60(
      ErrorState12,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx60("br", {}) }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsxs36(Fragment6, { children: [
    /* @__PURE__ */ jsx60(
      SideDetailCard,
      {
        header: fullName,
        member: memberRelationship,
        memberUsername
      }
    ),
    /* @__PURE__ */ jsx60(SideDetailCard, { header: formatMessage({ id: "PROGRAM_DATES" }), children: /* @__PURE__ */ jsxs36(Fragment6, { children: [
      formattedDateData.map((details) => /* @__PURE__ */ jsx60(ShowDate, { details }, details.label)),
      showProgramStatusBadge && /* @__PURE__ */ jsx60(
        StatusBadge6,
        {
          status: showProgramStatusBadge.badgeStatus,
          label: showProgramStatusBadge.text
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs36(SideDetailCard, { header: formatMessage({ id: "IDENTIFICATION" }), children: [
      /* @__PURE__ */ jsx60(UtilityText12, { children: formatMessage(
        { id: "CS_REWARDS_ID_UNDERSCORE" },
        {
          rewardId: externalCampaignId
        }
      ) }),
      /* @__PURE__ */ jsx60(UtilityText12, { children: formatMessage(
        { id: "CS_LEAGUE_ID_UNDERSCORE" },
        {
          leagueId
        }
      ) })
    ] })
  ] });
};

// src/pages/member-rewards-detail-page/components/reward-program/reward-program-section.component.tsx
import { useEffect as useEffect3 } from "react";
import { useIntl as useIntl51 } from "@leagueplatform/locales";
import { captureError as captureError14 } from "@leagueplatform/observability";
import { ErrorState as ErrorState15 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset13 } from "@leagueplatform/asset-config";
import { Box as Box33 } from "@leagueplatform/genesis-core";

// src/components/program-detail-description/program-detail-description.component.tsx
import linkifyHtml from "linkify-html";
import { useIntl as useIntl41 } from "@leagueplatform/locales";
import {
  TextAction as TextAction6,
  Box as Box27,
  styled as styled5,
  StackItem as StackItem6
} from "@leagueplatform/genesis-core";
import { HtmlToReact } from "@leagueplatform/web-common";

// src/hooks/use-should-show-more.hook.ts
import * as React29 from "react";
import { EVENT_NAME as EVENT_NAME25 } from "@leagueplatform/analytics";
function useShowMore(description) {
  const MAX_LENGTH = 13;
  const [showText, setShowText] = React29.useState(false);
  const textLength = description.split(" ").length;
  const cutText = description.split(" ", MAX_LENGTH).join(" ");
  const richText = showText ? description : cutText;
  const shouldShowShowMore = textLength > MAX_LENGTH;
  const analyticsDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({}, analyticsDetails));
  const sendButtonClickedAnalyticsEvent = React29.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME25.BUTTON_CLICKED, {
      detail: showText ? "view less" /* VIEW_LESS */ : "view more" /* VIEW_MORE */
    }),
    [sendAnalyticsEvent, showText]
  );
  const toggleShowMore = React29.useCallback(
    (currentValue) => {
      sendButtonClickedAnalyticsEvent();
      return setShowText(!currentValue);
    },
    [sendButtonClickedAnalyticsEvent]
  );
  return {
    shouldShowShowMore,
    isShowingMore: showText,
    text: richText,
    toggleShowMore
  };
}

// src/components/program-detail-description/program-detail-description.component.tsx
import { jsx as jsx61, jsxs as jsxs37 } from "react/jsx-runtime";
var StyledLink = styled5("a", {
  color: "inherit",
  textDecoration: "underline"
});
var StyledH3 = styled5("h3", {
  marginBottom: "$one",
  typography: "$headingTwo",
  marginTop: "$one"
});
var StyledH4 = styled5("h4", {
  marginBottom: "$half",
  typography: "$subtitleOne"
});
var StyledP = styled5("p", {
  margin: "$none",
  typography: "$bodyOne"
});
var ProgramDetailDescription = ({
  description
}) => {
  const { formatMessage } = useIntl41();
  const linkifyOptions = {
    defaultProtocol: "https",
    attributes: {
      rel: "noopener noreferrer"
    }
  };
  const RichTextOptions = {
    a: {
      component: StyledLink,
      props: {
        target: "_blank"
      }
    },
    h3: {
      component: StyledH3,
      props: {
        as: "h2"
      }
    },
    h4: {
      component: StyledH4,
      props: {
        as: "h3"
      }
    },
    p: {
      component: StyledP
    }
  };
  const { shouldShowShowMore, isShowingMore, text, toggleShowMore } = useShowMore(description);
  return /* @__PURE__ */ jsxs37(
    Box27,
    {
      css: {
        marginBottom: "$twoAndHalf"
      },
      children: [
        /* @__PURE__ */ jsx61(
          HtmlToReact,
          {
            htmlString: linkifyHtml(text, linkifyOptions),
            options: RichTextOptions
          }
        ),
        /* @__PURE__ */ jsx61(StackItem6, { css: { width: "fit-content" }, children: shouldShowShowMore && /* @__PURE__ */ jsx61(
          TextAction6,
          {
            css: { margin: "$one $none $none $half" },
            as: "button",
            onClick: () => toggleShowMore(!!isShowingMore),
            children: formatMessage({ id: isShowingMore ? "VIEW_LESS" : "VIEW_MORE" })
          }
        ) })
      ]
    }
  );
};

// src/pages/member-rewards-detail-page/components/reward-program/components/reward-program-tier/reward-program-tier.component.tsx
import { Box as Box32, HeadingText as HeadingText18, StackLayout as StackLayout41 } from "@leagueplatform/genesis-core";

// src/components/activity-card-link/activity-card-link.component.tsx
import React35, { useState as useState8 } from "react";
import { useIntl as useIntl49 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset11 } from "@leagueplatform/asset-config";
import {
  StackLayout as StackLayout38,
  HeadingText as HeadingText16,
  Icon as Icon13,
  StatusBadge as StatusBadge8,
  UtilityText as UtilityText16,
  Modal as Modal4,
  Card as Card5,
  useClickableCard as useClickableCard3,
  TextAction as TextAction7,
  Box as Box30,
  styled as styled7
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME30 } from "@leagueplatform/analytics";

// src/pages/member-rewards-detail-page/components/reward-activity-detail/reward-activity-detail.component.tsx
import { Modal as Modal2 } from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator17,
  ErrorState as ErrorState13
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl47 } from "@leagueplatform/locales";

// src/components/activity-detail/activity-detail.component.tsx
import React34 from "react";
import { useIntl as useIntl46 } from "@leagueplatform/locales";
import {
  HeadingText as HeadingText15,
  Modal,
  StackLayout as StackLayout37,
  StatusBadge as StatusBadge7,
  UtilityText as UtilityText15,
  styled as styled6,
  Button as Button8,
  Icon as Icon12,
  Spinner as Spinner2,
  Box as Box29,
  StatusBanner as StatusBanner4,
  ParagraphText as ParagraphText18
} from "@leagueplatform/genesis-core";
import { IconText } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";
import { UserHealthActivityStatus as UserHealthActivityStatus6 } from "@leagueplatform/health-journey-common";
import { HtmlToReact as HtmlToReact2 } from "@leagueplatform/web-common";
import { EVENT_NAME as EVENT_NAME29 } from "@leagueplatform/analytics";

// src/components/updated-icon/updated-icon.component.tsx
import { Icon as Icon11, ParagraphText as ParagraphText16, StackLayout as StackLayout33 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl42 } from "@leagueplatform/locales";
import { jsx as jsx62, jsxs as jsxs38 } from "react/jsx-runtime";
function UpdatedIcon({ copy }) {
  const { formatMessage } = useIntl42();
  return /* @__PURE__ */ jsxs38(
    StackLayout33,
    {
      orientation: "horizontal",
      spacing: "$half",
      verticalAlignment: "center",
      css: { marginBottom: "$half", minWidth: "40%" },
      children: [
        /* @__PURE__ */ jsx62(Icon11, { icon: "statusSuccessStatus", size: "$oneAndHalf", tint: "$successIcon" }),
        /* @__PURE__ */ jsx62(
          ParagraphText16,
          {
            css: {
              typography: "$subtitleTwo",
              color: "$successIcon",
              whiteSpace: "nowrap"
            },
            children: formatMessage({ id: copy })
          }
        )
      ]
    }
  );
}

// src/components/activity-detail/components/challenge-progress.component.tsx
import { ProgressBar } from "@leagueplatform/web-common-components";
import {
  StackLayout as StackLayout34,
  UtilityText as UtilityText13,
  StackItem as StackItem7,
  Card as Card4,
  HeadingText as HeadingText13
} from "@leagueplatform/genesis-core";
import { Fragment as Fragment7, jsx as jsx63, jsxs as jsxs39 } from "react/jsx-runtime";
var ActivityChallengeProgress = ({
  currentProgress,
  currentText,
  suffixText,
  title
}) => {
  const { CHALLENGE_PROGRESS_BAR_TOTAL } = CHALLENGE_PROGRESS_BAR;
  const StyledPrefix = /* @__PURE__ */ jsxs39(Fragment7, { children: [
    /* @__PURE__ */ jsx63(
      UtilityText13,
      {
        size: "sm",
        emphasis: "emphasized",
        css: { color: "$onSurfaceTextSuccess" },
        children: currentText
      }
    ),
    /* @__PURE__ */ jsx63(UtilityText13, { size: "sm", children: suffixText })
  ] });
  return /* @__PURE__ */ jsx63(Card4.Elevated, { css: { width: "75%", marginTop: "$one" }, children: /* @__PURE__ */ jsx63(Card4.Section, { padding: "$one $oneAndHalf", children: /* @__PURE__ */ jsxs39(StackLayout34, { orientation: "vertical", spacing: "$half", children: [
    /* @__PURE__ */ jsx63(HeadingText13, { size: "sm", level: "3", children: title }),
    /* @__PURE__ */ jsx63(
      StackLayout34,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$quarter",
        children: /* @__PURE__ */ jsx63(
          UtilityText13,
          {
            size: "sm",
            emphasis: "emphasized",
            css: { color: "$onSurfaceTextSuccess" },
            children: StyledPrefix
          }
        )
      }
    ),
    /* @__PURE__ */ jsx63(
      StackLayout34,
      {
        orientation: "horizontal",
        horizontalAlignment: "stretch",
        verticalAlignment: "center",
        css: {
          width: "100%"
        },
        children: /* @__PURE__ */ jsx63(StackItem7, { growFactor: 1, children: /* @__PURE__ */ jsx63(
          ProgressBar,
          {
            total: CHALLENGE_PROGRESS_BAR_TOTAL,
            current: currentProgress,
            customBarFillColor: "success.border.default",
            customBarBackgroundColor: "interactive.border.disabled"
          }
        ) })
      }
    )
  ] }) }) });
};

// src/components/activity-detail/components/activity-details.component.tsx
import React31 from "react";
import { useIntl as useIntl43 } from "@leagueplatform/locales";
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS4
} from "@leagueplatform/health-journey-api";
import {
  StackLayout as StackLayout35,
  ParagraphText as ParagraphText17,
  Box as Box28,
  Spinner
} from "@leagueplatform/genesis-core";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT2 } from "@leagueplatform/web-common";
import { DatePicker } from "@leagueplatform/web-common-components";
import { EVENT_NAME as EVENT_NAME26 } from "@leagueplatform/analytics";

// src/utils/activity-status.util.ts
import { UserHealthActivityStatus as UserHealthActivityStatus3 } from "@leagueplatform/health-journey-common";
var getActivityStatus = (status2) => {
  let isCompleted = false;
  let isActive = false;
  let isMissed = false;
  switch (status2) {
    case UserHealthActivityStatus3.EXPIRED:
    case UserHealthActivityStatus3.REMOVED:
      isMissed = true;
      break;
    case UserHealthActivityStatus3.COMPLETED:
      isCompleted = true;
      break;
    case UserHealthActivityStatus3.ACTIVE:
    case UserHealthActivityStatus3.UPCOMING:
      isActive = true;
      break;
    default:
  }
  return { isCompleted, isActive, isMissed };
};

// src/components/activity-detail/hooks/use-calendar-date.hook.ts
import React30 from "react";
import { parseAbsolute, today } from "@internationalized/date";
function useCalendarDate(timeZone, startDate, endDate) {
  let startDateCalendar;
  let endDateCalendar;
  const todaysDate = today(timeZone);
  if (endDate)
    endDateCalendar = parseAbsolute(endDate, timeZone);
  if (startDate)
    startDateCalendar = parseAbsolute(startDate, timeZone);
  let endDateAfterTodayDate;
  if (endDateCalendar) {
    endDateAfterTodayDate = todaysDate.compare(endDateCalendar);
  }
  if (endDateAfterTodayDate && endDateAfterTodayDate < 0) {
    endDateCalendar = todaysDate;
  }
  const [date, setDate] = React30.useState(startDateCalendar);
  return {
    date,
    startDateCalendar,
    endDateCalendar,
    setDate
  };
}

// src/components/activity-detail/components/activity-details.component.tsx
import { jsx as jsx64, jsxs as jsxs40 } from "react/jsx-runtime";
var formatActivityDetailsArray = ({
  startDateLabel,
  endDateLabel,
  completionDateLabel,
  pointsLabel,
  activityIdLabel,
  startDateValue,
  endDateValue,
  completionDateValue,
  isCompleted,
  pointsValue,
  activityId,
  completionDateMessage,
  isActionOverrideSuccess,
  isActionOverrideLoading,
  shouldShowDatePicker,
  noPointsEarned,
  responseType,
  serviceDate,
  serviceDateLabel
}) => {
  const isStatusUpdated = responseType === ACTION_OVERRIDE_TYPES.STATUS_UPDATED;
  const bothUpdated = responseType === ACTION_OVERRIDE_TYPES.STATUS_UPDATED || responseType === ACTION_OVERRIDE_TYPES.POINTS_ONLY_UPDATED;
  const showPointsAssignedLabel = isActionOverrideSuccess && bothUpdated && !noPointsEarned;
  const showDateUpdatedLabel = isActionOverrideSuccess && isStatusUpdated;
  const displayPointsValue = () => {
    if (isActionOverrideLoading && bothUpdated) {
      return /* @__PURE__ */ jsx64(Spinner, { loading: true, size: "16px" });
    }
    return pointsValue;
  };
  const displayCompletionDate = () => {
    if (!isActionOverrideSuccess && !isActionOverrideLoading && shouldShowDatePicker) {
      return ACTION_OVERRIDE_TYPES.SHOW_DATE_PICKER;
    }
    if (isActionOverrideLoading && isStatusUpdated) {
      return /* @__PURE__ */ jsx64(Spinner, { loading: true, size: "16px" });
    }
    if (isCompleted) {
      return `${completionDateValue}${completionDateMessage != null ? completionDateMessage : ""}`;
    }
    return "-";
  };
  return [
    {
      label: startDateLabel,
      value: startDateValue
    },
    {
      label: endDateLabel,
      value: endDateValue
    },
    {
      label: serviceDateLabel && serviceDateLabel,
      value: serviceDateLabel && serviceDate
    },
    {
      label: completionDateLabel,
      value: displayCompletionDate(),
      updated: showDateUpdatedLabel ? "DATE_UPDATED" : null
    },
    {
      label: pointsLabel,
      value: displayPointsValue(),
      updated: showPointsAssignedLabel ? "POINTS_ASSIGNED" : null
    },
    {
      label: activityIdLabel,
      value: activityId
    }
  ].filter((activityDetail) => activityDetail.value);
};
var ActivityDetails = ({
  startDate,
  endDate,
  reward,
  timeZone,
  status: status2,
  dateCompleted,
  startDateLabel,
  endDateLabel,
  serviceDate,
  showEndDate = true,
  showPoints = true,
  isWaiverCredit,
  waiverCompletedBy,
  isActionOverrideLoading,
  isActionOverrideSuccess,
  isActionOverrideVisible,
  isActionOverrideNotAllowedError,
  responseType,
  selectedDate,
  userActivityId,
  showServiceDate
}) => {
  var _a;
  const { formatMessage, formatDate } = useIntl43();
  const { date, startDateCalendar, endDateCalendar, setDate } = useCalendarDate(
    timeZone,
    startDate,
    endDate
  );
  const noPointsEarned = (reward == null ? void 0 : reward.earnedValue) === 0 || isActionOverrideNotAllowedError;
  const activityStatusNotCompleted = status2 !== USER_HEALTH_CAMPAIGN_STATUS4.COMPLETED;
  const completionDateLabel = !isActionOverrideSuccess && isActionOverrideVisible && activityStatusNotCompleted ? formatMessage({ id: "COMPLETION_DATE_REQUIRED" }) : formatMessage({ id: "COMPLETION_DATE" });
  const { isMissed, isCompleted } = getActivityStatus(status2);
  const activityDetails = formatActivityDetailsArray({
    startDateLabel: startDateLabel != null ? startDateLabel : formatMessage({ id: "START_DATE" }),
    endDateLabel: endDateLabel != null ? endDateLabel : formatMessage({ id: "END_DATE" }),
    completionDateLabel,
    serviceDateLabel: showServiceDate ? formatMessage({ id: "SERVICE_DATE" }) : void 0,
    pointsLabel: formatMessage({ id: "POINTS" }),
    activityIdLabel: formatMessage({ id: "ACTIVITY_ID" }),
    startDateValue: startDate ? formatDate(startDate, getShortDateTimeZone(timeZone)) : "-",
    endDateValue: showEndDate ? formatDate(endDate, getShortDateTimeZone(timeZone)) : void 0,
    completionDateValue: (_a = formatDate(dateCompleted, getShortDateTimeZone(timeZone))) != null ? _a : "-",
    isCompleted,
    serviceDate: serviceDate ? formatDate(serviceDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT2), {
      timeZone: "UTC"
    })) : "-",
    pointsValue: showPoints ? formatMessage(
      {
        id: isCompleted && isWaiverCredit && "ACTIVITY_POINTS_UPDATED_WAIVER_CREDIT" || isCompleted && "ACTIVITY_POINTS_EARNED_AVAILABLE" || isMissed && "ACTIVITY_POINTS_MISSED" || "ACTIVITY_POINTS_EARNED_AVAILABLE"
      },
      {
        earned: reward == null ? void 0 : reward.earnedValue,
        available: reward == null ? void 0 : reward.availableValue
      }
    ) : void 0,
    activityId: userActivityId,
    completionDateMessage: waiverCompletedBy ? ` ${formatMessage(
      { id: "ACTION_OVERRIDE_COMPLETED_BY" },
      { waiverCompletedBy }
    )}` : void 0,
    isActionOverrideSuccess,
    isActionOverrideLoading,
    shouldShowDatePicker: isActionOverrideVisible && activityStatusNotCompleted,
    noPointsEarned,
    responseType
  });
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program summary" /* REWARD_SUMMARY */,
    detail: "select date" /* SELECT_DATE */
  });
  const sendDatePickerAnalyticsEvent = React31.useCallback(
    (value) => sendAnalyticsEvent(EVENT_NAME26.BUTTON_CLICKED, {
      sub_detail: value
    }),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsx64(
    StackLayout35,
    {
      as: "table",
      orientation: "vertical",
      horizontalAlignment: "spaceBetween",
      css: {
        width: "100%",
        padding: "$oneAndHalf $none"
      },
      children: /* @__PURE__ */ jsx64(Box28, { as: "tbody", children: activityDetails.map((activityDetail) => /* @__PURE__ */ jsxs40(
        StackLayout35,
        {
          as: "tr",
          orientation: "horizontal",
          verticalAlignment: "center",
          css: {
            paddingBottom: "$half"
          },
          children: [
            /* @__PURE__ */ jsx64(
              ParagraphText17,
              {
                as: "th",
                size: "sm",
                css: {
                  marginRight: "$half",
                  width: "30%",
                  textAlign: "left"
                },
                children: activityDetail.label
              }
            ),
            /* @__PURE__ */ jsxs40(
              StackLayout35,
              {
                orientation: "horizontal",
                verticalAlignment: "center",
                as: "td",
                children: [
                  activityDetail.value === ACTION_OVERRIDE_TYPES.SHOW_DATE_PICKER ? /* @__PURE__ */ jsx64(
                    DatePicker,
                    {
                      label: formatMessage({ id: "MDY_DATE_FIELD_PLACEHOLDER" }),
                      granularity: "day",
                      value: date,
                      onChange: (value) => {
                        setDate(value || void 0);
                        sendDatePickerAnalyticsEvent(value);
                        return selectedDate(value);
                      },
                      minValue: startDateCalendar,
                      maxValue: endDateCalendar
                    }
                  ) : /* @__PURE__ */ jsx64(
                    ParagraphText17,
                    {
                      emphasis: "subtle",
                      size: "sm",
                      css: {
                        marginRight: "$one",
                        wordBreak: "break-all",
                        flexBasis: "60%",
                        flexGrow: "1"
                      },
                      children: activityDetail.value
                    }
                  ),
                  activityDetail.updated && /* @__PURE__ */ jsx64(UpdatedIcon, { copy: activityDetail.updated })
                ]
              }
            )
          ]
        },
        activityDetail.label
      )) })
    }
  );
};

// src/components/activity-detail/components/action-override.component.tsx
import * as React32 from "react";
import { useIntl as useIntl44 } from "@leagueplatform/locales";
import {
  Button as Button7,
  HeadingText as HeadingText14,
  StackLayout as StackLayout36,
  UtilityText as UtilityText14
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME27 } from "@leagueplatform/analytics";
import { jsx as jsx65, jsxs as jsxs41 } from "react/jsx-runtime";
var ActionOverride = ({
  buttonText,
  title,
  hideActionOverride,
  handleClick
}) => {
  const { formatMessage } = useIntl44();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program summary" /* REWARD_SUMMARY */,
    detail: buttonText,
    sub_detail: "cancel action" /* CANCEL_ACTION */
  });
  const sendActionOverrideAnalyticsEvent = React32.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME27.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsxs41(
    StackLayout36,
    {
      horizontalAlignment: "center",
      verticalAlignment: "center",
      css: {
        padding: "$three"
      },
      children: [
        /* @__PURE__ */ jsx65(
          HeadingText14,
          {
            level: "2",
            size: "md",
            css: {
              typography: "$headingTwo",
              textAlign: "center",
              marginBottom: "$oneAndHalf"
            },
            children: title
          }
        ),
        /* @__PURE__ */ jsx65(UtilityText14, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "THIS_ACTION_CANNOT_BE_UNDONE" }) }),
        /* @__PURE__ */ jsx65(
          Button7,
          {
            css: { margin: "$twoAndHalf $none $oneAndHalf" },
            onClick: handleClick,
            children: buttonText
          }
        ),
        /* @__PURE__ */ jsx65(
          Button7,
          {
            priority: "tertiary",
            quiet: true,
            size: "medium",
            onClick: () => {
              hideActionOverride();
              sendActionOverrideAnalyticsEvent();
            },
            children: formatMessage({ id: "CANCEL" })
          }
        )
      ]
    }
  );
};

// src/components/activity-detail/hooks/use-get-action-override.hook.ts
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS5
} from "@leagueplatform/health-journey-api";
import { UserHealthActivityStatus as UserHealthActivityStatus4 } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl45 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT3 } from "@leagueplatform/web-common";
function getOverrideButtonCopyIdForStatus(status2, showPointsLabel) {
  switch (status2) {
    case USER_HEALTH_CAMPAIGN_STATUS5.ACTIVE:
    case UserHealthActivityStatus4.EXPIRED:
      return "MARK_AS_COMPLETE";
    case USER_HEALTH_CAMPAIGN_STATUS5.COMPLETED:
      if (showPointsLabel) {
        return "ASSIGN_POINTS";
      }
      return null;
    default:
      return null;
  }
}
function getOverrideTitleCopyIdForStatus(status2, showPointsLabel) {
  switch (status2) {
    case USER_HEALTH_CAMPAIGN_STATUS5.ACTIVE:
      return "CS_AGENT_COMPLETE_ACTIVITY";
    case USER_HEALTH_CAMPAIGN_STATUS5.COMPLETED:
      if (showPointsLabel) {
        return "CS_AGENT_ASSIGN_ACTIVITY_POINTS";
      }
      return null;
    case UserHealthActivityStatus4.EXPIRED:
      return "CS_AGENT_COMPLETE_ACTIVITY_DATE";
    default:
      return null;
  }
}
var useGetActionOverride = (showPoints, name, status2, reward, dateSelectedByAgent) => {
  const { formatMessage, formatDate } = useIntl45();
  const earnedValue = (reward == null ? void 0 : reward.earnedValue) || 0;
  const availableValue = (reward == null ? void 0 : reward.availableValue) || 0;
  const showPointsLabel = showPoints && earnedValue < availableValue;
  let actionOverrideButton;
  let actionOverrideTitle;
  if (status2) {
    const buttonCopyId = getOverrideButtonCopyIdForStatus(
      status2,
      showPointsLabel
    );
    if (buttonCopyId) {
      actionOverrideButton = formatMessage({ id: buttonCopyId });
    }
    const titleCopyId = getOverrideTitleCopyIdForStatus(
      status2,
      showPointsLabel
    );
    if (titleCopyId) {
      actionOverrideTitle = formatMessage(
        { id: titleCopyId },
        {
          activity: name,
          date: formatDate(dateSelectedByAgent, SHORT_DATE_FORMAT3),
          points: availableValue
        }
      );
    }
  }
  return {
    actionOverrideButton,
    actionOverrideTitle
  };
};

// src/components/activity-detail/hooks/use-is-action-override-visible.hook.ts
import isPast from "date-fns/isPast";
function useIsActionOverrideVisible(buttonCopy) {
  const entitlements = useEntitlements();
  const { enableActivityOverride } = useCustomerSupportConfig();
  const hasJourneyWriteEntitlement = entitlements.includes(
    "journey_activity:write" /* JOURNEY_WRITE */
  );
  const { data: campaign } = useGetRewardsDetailPage();
  const isVisibilityEnded = campaign ? isPast(new Date(campaign.visibilityEndDate)) : true;
  return Boolean(
    enableActivityOverride && hasJourneyWriteEntitlement && buttonCopy && !isVisibilityEnded
  );
}

// src/components/activity-detail/hooks/use-post-action-override.hook.ts
import React33 from "react";
import {
  setUserHealthActivityById,
  GET_USER_CAMPAIGNS_MESSAGE_TYPE as GET_USER_CAMPAIGNS_MESSAGE_TYPE2
} from "@leagueplatform/health-journey-api";
import { useParams as useParams3 } from "@leagueplatform/routing";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { captureError as captureError12 } from "@leagueplatform/observability";
import { EVENT_NAME as EVENT_NAME28 } from "@leagueplatform/analytics";

// src/components/activity-detail/hooks/use-get-user-health-activity-by-id-query.hook.ts
import { useQuery as useQuery14 } from "@tanstack/react-query";
import {
  getUserHealthActivityById
} from "@leagueplatform/health-journey-api";
import { captureError as captureError11 } from "@leagueplatform/observability";
var GET_USER_HEALTH_ACTIVITY_DATA_KEY = "userHealthActivityData";
var useGetUserHealthActivityByIdData = (userHealthActivityId, userId, options) => useQuery14(
  [GET_USER_HEALTH_ACTIVITY_DATA_KEY, userHealthActivityId],
  () => getUserHealthActivityById(
    userHealthActivityId,
    void 0,
    void 0,
    userId
  ),
  __spreadValues({
    staleTime: Infinity,
    onError: (error) => {
      captureError11(
        new Error(
          `Customer Support: Failed to get activity detail information by id (id: ${userHealthActivityId}): ${error}`
        )
      );
    }
  }, options)
);

// src/components/activity-detail/hooks/use-post-action-override.hook.ts
var usePostActionOverride = ({
  userHealthActivityId
}) => {
  const { rewardId } = useParams3();
  const queryClient = useQueryClient();
  const userHealthCampaignId = rewardId;
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program summary" /* REWARD_SUMMARY */,
    detail: "submit request" /* SUBMIT_REQUEST */
  });
  const sendOverridePostRequestAnalyticsEvent = React33.useCallback(
    (detail) => sendAnalyticsEvent(EVENT_NAME28.BUTTON_CLICKED, {
      sub_detail: detail
    }),
    [sendAnalyticsEvent]
  );
  return useMutation(
    ({ userActivityId, requestBody }) => setUserHealthActivityById({
      userActivityId,
      requestBody
    }),
    {
      onSuccess: () => {
        sendOverridePostRequestAnalyticsEvent("success" /* SUCCESS */);
        return Promise.all([
          queryClient.invalidateQueries([
            GET_USER_HEALTH_ACTIVITY_DATA_KEY,
            userHealthActivityId
          ]),
          queryClient.invalidateQueries([
            GET_USER_CAMPAIGNS_MESSAGE_TYPE2,
            userHealthCampaignId
          ])
        ]);
      },
      onError: (error) => {
        sendOverridePostRequestAnalyticsEvent("error" /* ERROR */);
        captureError12(
          new Error(`CSE activity override was not completed: ${error}`)
        );
      }
    }
  );
};

// src/components/activity-detail/utils/get-action-override-response-body.ts
import {
  USER_HEALTH_CAMPAIGN_STATUS as USER_HEALTH_CAMPAIGN_STATUS6
} from "@leagueplatform/health-journey-api";
import { UserHealthActivityStatus as UserHealthActivityStatus5 } from "@leagueplatform/health-journey-common";
function getActionOverrideResponseBody(status2, dateSelectedByAgent) {
  const responseReward = {
    reward: {
      action: "award"
    }
  };
  const completeResponse = {
    status: "completed"
  };
  switch (status2) {
    case USER_HEALTH_CAMPAIGN_STATUS6.ACTIVE:
      return {
        requestBody: completeResponse,
        type: ACTION_OVERRIDE_TYPES.STATUS_UPDATED
      };
    case USER_HEALTH_CAMPAIGN_STATUS6.COMPLETED:
      return {
        requestBody: responseReward,
        type: ACTION_OVERRIDE_TYPES.POINTS_ONLY_UPDATED
      };
    case UserHealthActivityStatus5.EXPIRED:
      if (dateSelectedByAgent) {
        const dateResponse = __spreadProps(__spreadValues({}, completeResponse), {
          dateCompleted: dateSelectedByAgent
        });
        return {
          requestBody: dateResponse,
          type: ACTION_OVERRIDE_TYPES.STATUS_UPDATED
        };
      }
      return null;
    default:
      return null;
  }
}

// src/components/activity-detail/activity-detail.component.tsx
import { Fragment as Fragment8, jsx as jsx66, jsxs as jsxs42 } from "react/jsx-runtime";
var StyledH1 = styled6("h1", {
  margin: "$none $none $one",
  typography: "$headingThree",
  fontFamily: "$headings"
});
var LineBreak = styled6("br", {
  display: "none"
});
var HTMLOptions = {
  h1: {
    component: StyledH1,
    props: {
      as: "h3"
    }
  },
  br: {
    component: LineBreak
  }
};
function ActionOverrideSection({
  onButtonClick,
  isLoading,
  isError,
  isSuccess,
  buttonCopy,
  isExpiredActivity,
  isActiveActivity
}) {
  const { formatMessage } = useIntl46();
  return /* @__PURE__ */ jsxs42(StackLayout37, { css: { marginBottom: "$two" }, children: [
    isExpiredActivity && /* @__PURE__ */ jsx66(ParagraphText18, { css: { typography: "$bodyTwo", paddingBottom: "$one" }, children: formatMessage({
      id: "CS_ACTIVITY_OVERRIDE_DATE_PERIOD_EXPIRED"
    }) }),
    isActiveActivity && /* @__PURE__ */ jsx66(ParagraphText18, { css: { typography: "$bodyTwo", paddingBottom: "$one" }, children: formatMessage({
      id: "CS_ACTIVITY_OVERRIDE_DATE_PERIOD_ACTIVE"
    }) }),
    !isSuccess && /* @__PURE__ */ jsx66(Button8, { onClick: onButtonClick, loading: isLoading, children: buttonCopy }),
    isError && /* @__PURE__ */ jsxs42(
      StackLayout37,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        css: { marginTop: "$half" },
        children: [
          /* @__PURE__ */ jsx66(
            Icon12,
            {
              css: { marginRight: "$quarter" },
              icon: "statusErrorStatusFilled",
              tint: "$warningIcon"
            }
          ),
          /* @__PURE__ */ jsx66(
            UtilityText15,
            {
              css: {
                color: "$criticalIcon",
                typography: "$caption"
              },
              children: formatMessage({ id: "ERROR_UPDATING_DATA" })
            }
          )
        ]
      }
    )
  ] });
}
function ChallengeProgressSection({
  challengeProgress
}) {
  const { formatMessage } = useIntl46();
  return /* @__PURE__ */ jsxs42(
    StackLayout37,
    {
      orientation: "vertical",
      horizontalAlignment: "spaceBetween",
      css: {
        width: "100%",
        padding: "$twoAndHalf $none $none"
      },
      children: [
        /* @__PURE__ */ jsx66(HeadingText15, { level: "3", size: "xl", children: formatMessage({ id: "ACTIVE_ELIGIBLE_CHALLENGES" }) }),
        challengeProgress.map((progress) => {
          const { currentProgress, goal, progressPercentage, title, unit } = progress.componentAttributes;
          return /* @__PURE__ */ jsx66(Box29, { children: /* @__PURE__ */ jsx66(
            ActivityChallengeProgress,
            {
              currentProgress: progressPercentage,
              currentText: currentProgress.toLocaleString(),
              suffixText: ` / ${goal.toLocaleString()} ${unit}`,
              title
            }
          ) }, title);
        })
      ]
    }
  );
}
var ActivityDetail = ({
  timeZone,
  challengeProgress,
  iconUrl,
  richText,
  startDate,
  endDate,
  dateCompleted,
  reward,
  required,
  status: status2,
  name,
  startDateLabel,
  endDateLabel,
  userActivityId,
  isWaiverCredit = false,
  waiverCompletedBy,
  serviceDate,
  showEndDate = true,
  showPoints = true,
  showServiceDate = true
}) => {
  var _a;
  const { formatMessage } = useIntl46();
  const { enableActivityOverride } = useCustomerSupportConfig();
  const [showConfirmation, setShowConfirmation] = React34.useState(false);
  const [dateSelectedByAgent, setDateSelectedByAgent] = React34.useState(startDate);
  const [responseType, setResponseType] = React34.useState("");
  const requiredIcon2 = handleStaticAsset10(
    "REWARD_POINT_ICON" /* REWARD_POINT_ICON */
  );
  const {
    mutate: postActionOverride,
    isSuccess: isActionOverrideSuccess,
    isLoading: isActionOverrideLoading,
    isError: isActionOverrideError,
    error: actionOverrideError
  } = usePostActionOverride({
    userHealthActivityId: userActivityId
  });
  const isActionOverrideNotAllowedError = ((_a = actionOverrideError == null ? void 0 : actionOverrideError.response) == null ? void 0 : _a.status) === 409;
  const isActionOverrideRegularError = isActionOverrideError && !isActionOverrideNotAllowedError;
  const { isMissed } = getActivityStatus(status2);
  const hasChallengeProgress = challengeProgress && challengeProgress.length > 0;
  const actionOverrideCopy = useGetActionOverride(
    showPoints,
    name,
    status2,
    reward,
    dateSelectedByAgent
  );
  const isActionOverrideVisible = useIsActionOverrideVisible(
    actionOverrideCopy == null ? void 0 : actionOverrideCopy.actionOverrideButton
  );
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program summary" /* REWARD_SUMMARY */,
    detail: actionOverrideCopy.actionOverrideButton
  });
  const sendOverrideConfirmationAnalyticsEvent = React34.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME29.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  const callActionOverride = React34.useCallback(() => {
    setShowConfirmation(false);
    const response = getActionOverrideResponseBody(status2, dateSelectedByAgent);
    sendAnalyticsEvent(EVENT_NAME29.BUTTON_CLICKED, {
      sub_detail: response
    });
    if (response == null ? void 0 : response.type)
      setResponseType(response.type);
    if ((response == null ? void 0 : response.requestBody) && userActivityId) {
      return postActionOverride({
        userActivityId,
        requestBody: response.requestBody
      });
    }
    return null;
  }, [
    status2,
    dateSelectedByAgent,
    sendAnalyticsEvent,
    userActivityId,
    postActionOverride
  ]);
  const isStatusUpdated = responseType === ACTION_OVERRIDE_TYPES.STATUS_UPDATED;
  const isExpiredActivity = status2 === UserHealthActivityStatus6.EXPIRED;
  const isActiveActivity = status2 === UserHealthActivityStatus6.ACTIVE;
  const setDateFromAgent = (date) => setDateSelectedByAgent(date == null ? void 0 : date.toAbsoluteString());
  const callOverrideConfirmation = () => {
    setShowConfirmation(!showConfirmation);
    sendOverrideConfirmationAnalyticsEvent();
  };
  if (enableActivityOverride && showConfirmation) {
    return /* @__PURE__ */ jsx66(
      ActionOverride,
      {
        hideActionOverride: () => setShowConfirmation(false),
        buttonText: (actionOverrideCopy == null ? void 0 : actionOverrideCopy.actionOverrideButton) || "",
        title: (actionOverrideCopy == null ? void 0 : actionOverrideCopy.actionOverrideTitle) || "",
        handleClick: () => callActionOverride()
      }
    );
  }
  return /* @__PURE__ */ jsxs42(Fragment8, { children: [
    isActionOverrideNotAllowedError && /* @__PURE__ */ jsx66(
      StatusBanner4,
      {
        showIcon: true,
        status: "warning",
        title: formatMessage({ id: "OVERRIDE_IS_NOT_ALLOWED_TITLE" }),
        css: { marginBottom: "$two" },
        children: /* @__PURE__ */ jsx66(ParagraphText18, { children: formatMessage({ id: "OVERRIDE_IS_NOT_ALLOWED_BODY" }) })
      }
    ),
    /* @__PURE__ */ jsx66(Modal.Title, { children: /* @__PURE__ */ jsx66(HeadingText15, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: name }) }),
    /* @__PURE__ */ jsx66(Modal.Description, { children: /* @__PURE__ */ jsxs42(StackLayout37, { children: [
      /* @__PURE__ */ jsxs42(StackLayout37, { orientation: "horizontal", children: [
        status2 && /* @__PURE__ */ jsx66(
          StatusBadge7,
          {
            status: mapJourneyStatusColors(status2),
            label: formatMessage({
              id: normalizeRewardStatus(status2).toUpperCase()
            }),
            css: { marginRight: "$one" }
          }
        ),
        isActionOverrideSuccess && isStatusUpdated && /* @__PURE__ */ jsx66(UpdatedIcon, { copy: "ACTIVITY_STATUS_UPDATED" }),
        isActionOverrideLoading && isStatusUpdated && /* @__PURE__ */ jsx66(Spinner2, { loading: true, size: "16px", css: { marginRight: "$one" } }),
        required && /* @__PURE__ */ jsx66(
          IconText,
          {
            iconProps: {
              icon: iconUrl || requiredIcon2
            },
            text: /* @__PURE__ */ jsx66(
              UtilityText15,
              {
                as: "p",
                css: {
                  typography: "$bodyTwo",
                  color: isMissed ? "$onSurfaceTextSubdued" : "inherit"
                },
                children: formatMessage({ id: "REQUIRED" })
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ jsx66(
        ActivityDetails,
        {
          startDate,
          endDate,
          startDateLabel,
          endDateLabel,
          showEndDate,
          showPoints,
          reward,
          dateCompleted,
          status: status2,
          timeZone,
          isWaiverCredit,
          waiverCompletedBy,
          isActionOverrideLoading,
          isActionOverrideSuccess,
          isActionOverrideVisible,
          isActionOverrideNotAllowedError,
          responseType,
          selectedDate: setDateFromAgent,
          userActivityId,
          serviceDate,
          showServiceDate
        }
      ),
      isActionOverrideVisible && /* @__PURE__ */ jsx66(
        ActionOverrideSection,
        {
          onButtonClick: callOverrideConfirmation,
          buttonCopy: actionOverrideCopy.actionOverrideButton,
          isLoading: isActionOverrideLoading,
          isSuccess: isActionOverrideSuccess,
          isError: isActionOverrideRegularError,
          isExpiredActivity,
          isActiveActivity
        }
      ),
      /* @__PURE__ */ jsx66(StackLayout37, { children: /* @__PURE__ */ jsx66(HtmlToReact2, { htmlString: richText, options: HTMLOptions }) }),
      hasChallengeProgress && /* @__PURE__ */ jsx66(ChallengeProgressSection, { challengeProgress })
    ] }) })
  ] });
};

// src/components/activity-detail/utils/map-user-health-activity-to-activity-details.utils.ts
var mapUserHealthActivity = (activity) => {
  var _a;
  const { CHALLENGE_PROGRESS_KEY } = CHALLENGE_PROGRESS_BAR;
  let flattenedComponents = {};
  const progressGroup = [];
  (_a = activity.pages) == null ? void 0 : _a[0].components.forEach((component) => {
    const { componentType, componentAttributes } = component;
    if (componentType === CHALLENGE_PROGRESS_KEY) {
      progressGroup.push({ componentAttributes });
    }
    flattenedComponents = __spreadValues(__spreadValues({}, flattenedComponents), componentAttributes);
  });
  const activityMap = {
    richText: flattenedComponents.richText || "",
    challengeProgress: progressGroup || []
  };
  return activityMap;
};

// src/pages/member-rewards-detail-page/components/reward-activity-detail/hooks/use-get-activity-detail.hook.ts
function useGetFormattedPrograms({
  data
}) {
  var _a, _b;
  const {
    startDate,
    endDate,
    dateCompleted,
    required,
    reward,
    status: status2,
    name,
    iconUrl,
    overrideEntry,
    id: userActivityId,
    pages
  } = data;
  const serviceDate = (_b = (_a = pages == null ? void 0 : pages[0]) == null ? void 0 : _a.components.filter(
    (badge) => {
      var _a2;
      return ((_a2 = badge.componentAttributes) == null ? void 0 : _a2.badgeType) === "service-date";
    }
  )[0]) == null ? void 0 : _b.componentAttributes.effectiveServiceDate;
  const formattedPageFields = mapUserHealthActivity(data);
  const activityModalFields = __spreadValues({
    startDate,
    endDate,
    dateCompleted,
    required,
    reward,
    status: status2,
    name,
    iconUrl,
    overrideEntry,
    userActivityId,
    serviceDate
  }, formattedPageFields);
  return activityModalFields;
}
var useGetActivityDetailPage = (activityId, targetUserId) => {
  const userId = targetUserId;
  return useGetUserHealthActivityByIdData(activityId, userId, {
    select: useGetFormattedPrograms
  });
};

// src/pages/member-rewards-detail-page/components/reward-activity-detail/reward-activity-detail.component.tsx
import { jsx as jsx67 } from "react/jsx-runtime";
var RewardActivityDetail = ({
  activityId,
  targetUserId,
  timeZone
}) => {
  const { formatMessage } = useIntl47();
  const {
    data: activityModalFields,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetActivityDetailPage(activityId, targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, activityModalFields);
  if (isError) {
    return /* @__PURE__ */ jsx67(Modal2.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx67(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx67(
      ErrorState13,
      {
        error,
        headingString: formatMessage({
          id: "SOMETHING_WENT_WRONG_HEADING"
        }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx67("br", {}) }
        )
      }
    ) }) });
  }
  if (isLoading || isIdle) {
    return /* @__PURE__ */ jsx67(Modal2.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx67(LoadingIndicator17, {}) });
  }
  const {
    challengeProgress,
    iconUrl,
    richText,
    startDate,
    endDate,
    dateCompleted,
    reward,
    required,
    status: status2,
    name,
    overrideEntry,
    userActivityId,
    serviceDate
  } = activityModalFields;
  const isWaiverCredit = Boolean(
    (overrideEntry == null ? void 0 : overrideEntry.pointsAssignedBy) && (overrideEntry == null ? void 0 : overrideEntry.pointsAssignedBy) !== targetUserId
  );
  let waiverCompletedBy;
  if ((overrideEntry == null ? void 0 : overrideEntry.completedBy) === ACTION_OVERRIDE_TYPES.COMPLETED_BY_BULK_OVERRIDE) {
    waiverCompletedBy = "bulk";
  } else if ((overrideEntry == null ? void 0 : overrideEntry.completedBy) && overrideEntry.completedBy !== targetUserId) {
    waiverCompletedBy = "waiver";
  }
  return /* @__PURE__ */ jsx67(Modal2.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx67(
    ActivityDetail,
    {
      timeZone,
      userActivityId,
      challengeProgress,
      iconUrl,
      richText,
      startDate,
      endDate,
      dateCompleted,
      reward,
      required,
      status: status2,
      name,
      isWaiverCredit,
      waiverCompletedBy,
      serviceDate
    }
  ) });
};

// src/pages/member-standard-program-detail-page/components/standard-program-activity-detail/standard-program-activity-detail.component.tsx
import { useIntl as useIntl48 } from "@leagueplatform/locales";
import { Modal as Modal3 } from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator18,
  ErrorState as ErrorState14
} from "@leagueplatform/web-common-components";

// src/pages/member-standard-program-detail-page/utils/get-activity-description.util.ts
function getActivityDescription(activity) {
  var _a, _b, _c, _d;
  let richText = (_a = activity.richTextDescription) != null ? _a : "";
  if (richText === "") {
    const pages = (_c = (_b = activity.activityInfo) == null ? void 0 : _b.pages) != null ? _c : [];
    for (let i = 0; i < pages.length; i += 1) {
      const richTextComponent = pages[i].components.find(
        (component) => component.componentType === "rich-text"
      );
      if (richTextComponent) {
        richText = (_d = richTextComponent.componentAttributes.richtext) != null ? _d : richTextComponent.componentAttributes.richText;
        break;
      }
    }
    richText = richText.replace(/<h[0-6]>.*<\/h[0-6]>/g, "").trim();
  }
  return richText;
}

// src/pages/member-standard-program-detail-page/hooks/use-get-admin-get-user-health-activity-query.hook.ts
import { useQuery as useQuery15 } from "@tanstack/react-query";
import {
  getUserHealthActivityForAdmin,
  ADMIN_GET_USER_HEALTH_ACTIVITY
} from "@leagueplatform/cse-customer-support-api";
import { captureError as captureError13 } from "@leagueplatform/observability";
function useGetUserHealthActivityForAdmin(userId, activityId, options) {
  return useQuery15(
    [ADMIN_GET_USER_HEALTH_ACTIVITY, userId, activityId],
    () => getUserHealthActivityForAdmin(userId, activityId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError13(
          new Error(
            `Customer Support: Failed to get user health goal activity summary (member id: ${userId} ${activityId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-standard-program-detail-page/hooks/use-get-activity-details.hook.ts
function useGetActivityDetails(targetUserId, activityId) {
  const userId = targetUserId;
  return useGetUserHealthActivityForAdmin(userId, activityId, {
    select: (data) => {
      const startDate = data.startDate === "0001-01-01T00:00:00Z" ? "" : data.startDate;
      return __spreadProps(__spreadValues({}, data), { startDate });
    }
  });
}

// src/pages/member-standard-program-detail-page/components/standard-program-activity-detail/standard-program-activity-detail.component.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
var StandardProgramActivityDetail = ({
  activityId,
  targetUserId,
  timeZone
}) => {
  const { formatMessage } = useIntl48();
  const {
    data: activity,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetActivityDetails(targetUserId, activityId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, activity);
  if (isError) {
    return /* @__PURE__ */ jsx68(Modal3.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx68(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx68(
      ErrorState14,
      {
        error,
        headingString: formatMessage({
          id: "SOMETHING_WENT_WRONG_HEADING"
        }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx68("br", {}) }
        )
      }
    ) }) });
  }
  if (isLoading || isIdle) {
    return /* @__PURE__ */ jsx68(Modal3.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx68(LoadingIndicator18, { inline: true }) });
  }
  const richText = getActivityDescription(activity);
  return /* @__PURE__ */ jsx68(Modal3.Content, { layout: "right", width: `${MODAL_POPOUT_WIDTH}rem`, children: /* @__PURE__ */ jsx68(
    ActivityDetail,
    {
      timeZone,
      name: activity.name,
      status: activity.status,
      dateCompleted: activity.completedDate,
      richText,
      showPoints: false,
      showEndDate: false,
      startDateLabel: formatMessage({ id: "JOINED_DATE" }),
      startDate: activity.startDate,
      userActivityId: activityId,
      showServiceDate: false
    }
  ) });
};

// src/components/activity-card-link/activity-card-link.component.tsx
import { Fragment as Fragment9, jsx as jsx69, jsxs as jsxs43 } from "react/jsx-runtime";
var LinkClickArea = styled7(Card5.ClickArea, {
  "&:focus-within": {
    boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner"
  }
});
var ActivityCardLink = ({
  id,
  required,
  name,
  status: status2,
  reward,
  dateCompleted,
  program
}) => {
  const { formatMessage, formatDate } = useIntl49();
  const [modalOpen, setModalOpen] = useState8(false);
  const targetUserId = useTargetUserId();
  const targetId = targetUserId;
  const { timeZone } = useGetTargetUserInfo(targetId);
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard3();
  const { isMissed, isCompleted } = getActivityStatus(status2);
  const analyticDetails = useAnalyticsDynamicName();
  const sendAnalyticsEvent = useTrackAnalyticsEvent(__spreadValues({
    detail: "view activity details" /* VIEW_ACTIVITY_DETAILS */
  }, analyticDetails));
  const sendModalTriggerAnalyticsEvent = React35.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME30.BUTTON_CLICKED, {
      sub_detail: name
    }),
    [sendAnalyticsEvent, name]
  );
  return /* @__PURE__ */ jsx69(
    Box30,
    {
      as: "li",
      css: {
        marginTop: "$half",
        marginBottom: "$half",
        listStyleType: "none"
      },
      children: /* @__PURE__ */ jsxs43(
        Modal4.Root,
        {
          open: modalOpen,
          onOpenChange: () => {
            setModalOpen((previous) => !previous);
          },
          children: [
            /* @__PURE__ */ jsx69(Card5.Flat, { children: /* @__PURE__ */ jsx69(
              LinkClickArea,
              {
                ref: clickAreaRef,
                onCardMouseDown,
                onCardMouseUp,
                children: /* @__PURE__ */ jsx69(Card5.Section, { css: { padding: "$one" }, children: /* @__PURE__ */ jsxs43(
                  StackLayout38,
                  {
                    orientation: "horizontal",
                    horizontalAlignment: "center",
                    verticalAlignment: "center",
                    css: {
                      width: "100%",
                      minHeight: "4.4rem"
                    },
                    children: [
                      /* @__PURE__ */ jsxs43(StackLayout38, { children: [
                        /* @__PURE__ */ jsxs43(
                          StackLayout38,
                          {
                            orientation: "horizontal",
                            horizontalAlignment: "center",
                            verticalAlignment: "center",
                            children: [
                              /* @__PURE__ */ jsx69(Modal4.Trigger, { children: /* @__PURE__ */ jsx69(
                                TextAction7,
                                {
                                  as: "button",
                                  ref: primaryActionRef,
                                  onClick: sendModalTriggerAnalyticsEvent,
                                  "aria-label": formatMessage({
                                    id: "OPEN_ACTIVITY_DETAILS_ARIA"
                                  }),
                                  css: {
                                    '&[class*="GDS"]:focus, &:active': {
                                      outline: "none"
                                    }
                                  },
                                  children: /* @__PURE__ */ jsx69(
                                    HeadingText16,
                                    {
                                      level: "3",
                                      size: "xs",
                                      css: { textAlign: "left" },
                                      children: name
                                    }
                                  )
                                }
                              ) }),
                              required && /* @__PURE__ */ jsxs43(
                                StackLayout38,
                                {
                                  orientation: "horizontal",
                                  horizontalAlignment: "center",
                                  verticalAlignment: "center",
                                  css: {
                                    marginLeft: "$half"
                                  },
                                  children: [
                                    /* @__PURE__ */ jsx69(
                                      Icon13,
                                      {
                                        icon: handleStaticAsset11(
                                          "REQUIRED_ICON" /* REQUIRED_ICON */
                                        ),
                                        size: "$one",
                                        css: {
                                          margin: "$zero $half"
                                        }
                                      }
                                    ),
                                    /* @__PURE__ */ jsx69(
                                      UtilityText16,
                                      {
                                        size: "sm",
                                        css: {
                                          marginLeft: "$half"
                                        },
                                        children: formatMessage({ id: "REQUIRED" })
                                      }
                                    )
                                  ]
                                }
                              )
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsxs43(
                          StackLayout38,
                          {
                            orientation: "horizontal",
                            horizontalAlignment: "center",
                            verticalAlignment: "center",
                            css: {
                              marginTop: "$half"
                            },
                            children: [
                              reward && /* @__PURE__ */ jsx69(UtilityText16, { size: "xs", children: formatMessage(
                                {
                                  id: isCompleted && "ACTIVITY_POINTS_EARNED" || isMissed && "ACTIVITY_POINTS_MISSED" || "ACTIVITY_POINTS_ACTIVE"
                                },
                                {
                                  earned: reward.earnedValue,
                                  available: reward.availableValue
                                }
                              ) }),
                              isCompleted && program === PROGRAM_TYPES.REWARD && /* @__PURE__ */ jsxs43(Fragment9, { children: [
                                /* @__PURE__ */ jsx69(
                                  Icon13,
                                  {
                                    css: { marginRight: "$one", marginLeft: "$one" },
                                    size: "$half",
                                    "aria-hidden": "true",
                                    icon: handleStaticAsset11(
                                      "DIVIDER_ICON" /* DIVIDER_ICON */
                                    )
                                  }
                                ),
                                /* @__PURE__ */ jsx69(UtilityText16, { size: "xs", children: formatDate(
                                  dateCompleted,
                                  getShortDateTimeZone(timeZone)
                                ) })
                              ] }),
                              isCompleted && program === PROGRAM_TYPES.STANDARD && /* @__PURE__ */ jsx69(UtilityText16, { size: "xs", children: formatMessage(
                                { id: "COMPLETED_DATE" },
                                {
                                  date: formatDate(
                                    dateCompleted,
                                    getShortDateTimeZone(timeZone)
                                  )
                                }
                              ) })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx69(
                          UtilityText16,
                          {
                            size: "xs",
                            css: { marginTop: "$half", wordBreak: "break-all" },
                            children: formatMessage(
                              {
                                id: "ACTIVITY_ID_WITH_ID"
                              },
                              {
                                id
                              }
                            )
                          }
                        )
                      ] }),
                      status2 && /* @__PURE__ */ jsx69(
                        StatusBadge8,
                        {
                          status: mapJourneyStatusColors(status2),
                          label: formatMessage({
                            id: normalizeRewardStatus(status2).toUpperCase()
                          })
                        }
                      )
                    ]
                  }
                ) })
              }
            ) }),
            modalOpen && program === PROGRAM_TYPES.REWARD && /* @__PURE__ */ jsx69(
              RewardActivityDetail,
              {
                activityId: id,
                targetUserId,
                timeZone
              }
            ),
            modalOpen && program === PROGRAM_TYPES.STANDARD && /* @__PURE__ */ jsx69(
              StandardProgramActivityDetail,
              {
                activityId: id,
                targetUserId,
                timeZone
              }
            )
          ]
        }
      )
    }
  );
};

// src/pages/member-rewards-detail-page/components/reward-point/reward-point.component.tsx
import { useIntl as useIntl50 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset12 } from "@leagueplatform/asset-config";
import { StackLayout as StackLayout39, Icon as Icon14, UtilityText as UtilityText17 } from "@leagueplatform/genesis-core";
import { jsx as jsx70, jsxs as jsxs44 } from "react/jsx-runtime";
var RewardPoint = ({
  size,
  currentValue,
  maxValue,
  iconUrl,
  altText
}) => {
  const { formatMessage } = useIntl50();
  const rewardPointIcon2 = handleStaticAsset12(
    "REWARD_POINT_ICON" /* REWARD_POINT_ICON */
  );
  const styledText2 = (msg) => /* @__PURE__ */ jsx70(
    UtilityText17,
    {
      css: {
        color: "$onSurfaceTextSuccess"
      },
      emphasis: "emphasized",
      size,
      "aria-hidden": true,
      children: msg
    }
  );
  return /* @__PURE__ */ jsxs44(
    StackLayout39,
    {
      orientation: "horizontal",
      spacing: "$quarter",
      verticalAlignment: "center",
      horizontalAlignment: "end",
      role: "definition",
      "aria-label": altText || formatMessage(
        { id: "POINTS_OVER_TOTAL_ALT" },
        {
          current: currentValue,
          total: maxValue
        }
      ),
      children: [
        /* @__PURE__ */ jsx70(
          Icon14,
          {
            size: "$one",
            icon: iconUrl || rewardPointIcon2,
            css: {
              marginRight: size === "base" ? "$half" : "$none"
            }
          }
        ),
        /* @__PURE__ */ jsx70(UtilityText17, { size, emphasis: "emphasized", "aria-hidden": true, children: formatMessage(
          { id: "POINTS_OVER_TOTAL" },
          {
            span: styledText2,
            current: currentValue,
            total: maxValue
          }
        ) })
      ]
    }
  );
};

// src/pages/member-rewards-detail-page/components/reward-program/components/reward-program-group/reward-program-group.component.tsx
import { Box as Box31, StackLayout as StackLayout40, HeadingText as HeadingText17 } from "@leagueplatform/genesis-core";
import { jsx as jsx71, jsxs as jsxs45 } from "react/jsx-runtime";
var RewardProgramGroup = ({
  relatedCampaign
}) => {
  var _a;
  const campaign = relatedCampaign.campaign.data;
  const { campaignProgress } = relatedCampaign;
  const activities = (_a = relatedCampaign.userHealthActivities) == null ? void 0 : _a.data;
  return /* @__PURE__ */ jsxs45(Box31, { css: { marginBottom: "$oneAndHalf", listStyleType: "none" }, as: "li", children: [
    /* @__PURE__ */ jsxs45(
      StackLayout40,
      {
        orientation: "horizontal",
        horizontalAlignment: "spaceBetween",
        verticalAlignment: "center",
        css: { marginBottom: "$half" },
        children: [
          /* @__PURE__ */ jsx71(HeadingText17, { level: "3", size: "sm", children: campaign.name }),
          /* @__PURE__ */ jsx71(
            RewardPoint,
            {
              size: "sm",
              currentValue: campaignProgress.current,
              maxValue: campaignProgress.threshold,
              iconUrl: campaignProgress.iconUrl
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx71(Box31, { as: "ul", children: activities && activities.map((activity) => {
      const { id, required, name, status: status2, reward, dateCompleted } = activity;
      return /* @__PURE__ */ jsx71(
        ActivityCardLink,
        {
          id,
          required,
          name,
          status: status2,
          reward,
          dateCompleted,
          program: PROGRAM_TYPES.REWARD
        },
        id
      );
    }) })
  ] });
};

// src/pages/member-rewards-detail-page/components/reward-program/components/reward-program-tier/reward-program-tier.component.tsx
import { jsx as jsx72, jsxs as jsxs46 } from "react/jsx-runtime";
var RewardProgramTier = ({
  relatedCampaign
}) => {
  var _a;
  const {
    campaign,
    userHealthCampaigns,
    userHealthActivities,
    campaignProgress
  } = relatedCampaign;
  const showGroups = userHealthCampaigns;
  const activities = userHealthActivities == null ? void 0 : userHealthActivities.data;
  return /* @__PURE__ */ jsxs46(Box32, { css: { marginBottom: "$two", listStyleType: "none" }, as: "li", children: [
    /* @__PURE__ */ jsxs46(
      StackLayout41,
      {
        orientation: "horizontal",
        horizontalAlignment: "spaceBetween",
        verticalAlignment: "center",
        css: { marginBottom: "$oneAndHalf" },
        children: [
          /* @__PURE__ */ jsx72(HeadingText18, { level: "2", size: "xl", children: campaign.data.name }),
          /* @__PURE__ */ jsx72(
            RewardPoint,
            {
              size: "base",
              currentValue: campaignProgress.current,
              maxValue: campaignProgress.threshold,
              iconUrl: campaignProgress.iconUrl
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxs46(Box32, { as: "ul", children: [
      showGroups && ((_a = userHealthCampaigns == null ? void 0 : userHealthCampaigns.data) == null ? void 0 : _a.map((group) => /* @__PURE__ */ jsx72(RewardProgramGroup, { relatedCampaign: group }, group.id))),
      activities && (activities == null ? void 0 : activities.map((activity) => {
        const { id, required, name, status: status2, reward, dateCompleted } = activity;
        return /* @__PURE__ */ jsx72(
          ActivityCardLink,
          {
            id,
            required,
            name,
            status: status2,
            reward,
            dateCompleted,
            program: PROGRAM_TYPES.REWARD
          },
          id
        );
      }))
    ] })
  ] });
};

// src/pages/member-rewards-detail-page/components/reward-program/reward-program-section.component.tsx
import { Fragment as Fragment10, jsx as jsx73, jsxs as jsxs47 } from "react/jsx-runtime";
var RewardProgramSection = ({
  rewardProgram
}) => {
  var _a, _b;
  const { formatMessage } = useIntl51();
  const { userHealthCampaigns, campaign, userHealthActivities } = rewardProgram;
  const { displayGlobalProgress } = campaign.data;
  const healthCampaignsData = userHealthCampaigns == null ? void 0 : userHealthCampaigns.data;
  const showGroups = healthCampaignsData && displayGlobalProgress;
  const showTiers = healthCampaignsData && !displayGlobalProgress;
  const activities = userHealthActivities == null ? void 0 : userHealthActivities.data;
  const noProgramData = !showGroups && !showTiers && !activities;
  const richTextDescription = (_b = (_a = rewardProgram.campaign) == null ? void 0 : _a.data) == null ? void 0 : _b.richTextDescription;
  useEffect3(() => {
    if (noProgramData) {
      captureError14(
        new Error(
          `Customer Support: Reward program(id:${rewardProgram.id}) progress data isn't provided`
        )
      );
    }
  }, [noProgramData, rewardProgram.id]);
  if (noProgramData)
    return /* @__PURE__ */ jsx73(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx73(
      ErrorState15,
      {
        error: null,
        hideButton: true,
        headingString: formatMessage({ id: "CS_NO_REWARD_ACTIVITIES" }),
        imageSrc: handleStaticAsset13("EMPTY_ICON" /* EMPTY_ICON */)
      }
    ) });
  return /* @__PURE__ */ jsxs47(Fragment10, { children: [
    richTextDescription && /* @__PURE__ */ jsx73(ProgramDetailDescription, { description: richTextDescription }),
    /* @__PURE__ */ jsxs47(Box33, { as: "ul", children: [
      showTiers && (healthCampaignsData == null ? void 0 : healthCampaignsData.map((tier) => /* @__PURE__ */ jsx73(RewardProgramTier, { relatedCampaign: tier }, tier.id))),
      showGroups && (healthCampaignsData == null ? void 0 : healthCampaignsData.map((group) => /* @__PURE__ */ jsx73(RewardProgramGroup, { relatedCampaign: group }, group.id))),
      activities && activities.map((activity) => {
        const { id, required, name, status: status2, reward, dateCompleted } = activity;
        return /* @__PURE__ */ jsx73(
          ActivityCardLink,
          {
            id,
            required,
            name,
            status: status2,
            reward,
            dateCompleted,
            program: PROGRAM_TYPES.REWARD
          },
          id
        );
      })
    ] })
  ] });
};

// src/pages/member-rewards-detail-page/member-rewards-detail-page.component.tsx
import { jsx as jsx74 } from "react/jsx-runtime";
var MemberRewardsDetailPage = ({
  targetUserId,
  memberUsername
}) => {
  const { formatMessage } = useIntl52();
  const {
    data: rewardProgramData,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetRewardsDetailPage();
  const isIdle = simulateIsIdle(isLoading, isSuccess, rewardProgramData);
  usePageViewAnalytics9({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "reward program detail" /* REWARD_DETAIL */
  });
  if (isError)
    return /* @__PURE__ */ jsx74(PageLayout, { children: /* @__PURE__ */ jsx74(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx74(
      ErrorState16,
      {
        error,
        headingString: formatMessage({
          id: "SOMETHING_WENT_WRONG_HEADING"
        }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx74("br", {}) }
        )
      }
    ) }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx74(PageLayout, { children: /* @__PURE__ */ jsx74(LoadingIndicator19, { inline: true }) });
  return /* @__PURE__ */ jsx74(
    DetailPageWrapper,
    {
      header: /* @__PURE__ */ jsx74(DetailsHeader, { title: rewardProgramData.campaign.data.name }),
      mainSection: /* @__PURE__ */ jsx74(RewardProgramSection, { rewardProgram: rewardProgramData }),
      sideDetailSection: /* @__PURE__ */ jsx74(
        RewardSideDetails,
        {
          rewardProgram: rewardProgramData,
          targetUserId,
          memberUsername
        }
      )
    }
  );
};

// src/pages/member-wallet-detail-page/member-wallet-detail-page.component.tsx
import {
  LoadingIndicator as LoadingIndicator23,
  ErrorState as ErrorState21
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl66 } from "@leagueplatform/locales";
import { usePageViewAnalytics as usePageViewAnalytics10 } from "@leagueplatform/analytics";
import { Box as Box44 } from "@leagueplatform/genesis-core";

// src/pages/member-wallet-detail-page/hooks/use-get-detailed-wallet-data.hook.ts
import { SYSTEM_TYPES } from "@leagueplatform/wallet-api";

// src/pages/member-wallet-detail-page/hooks/use-get-wallet-details-query.hook.ts
import { useQuery as useQuery16 } from "@tanstack/react-query";
import {
  GET_WALLET_MESSAGE_TYPE,
  getWalletBenefitCard
} from "@leagueplatform/wallet-api";
import { captureError as captureError15 } from "@leagueplatform/observability";
function useGetWalletDetailQuery(userId, benefitId, dependentId, options) {
  return useQuery16(
    [`${GET_WALLET_MESSAGE_TYPE}`, userId, benefitId, dependentId],
    () => getWalletBenefitCard(userId, benefitId, dependentId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError15(
          new Error(
            `Customer Support: Failed to get user wallet benefit data (member id: ${userId}) (benefit id: ${benefitId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-wallet-detail-page/hooks/use-get-detailed-wallet-data.hook.ts
function selectWalletData({
  content_actions,
  activation_date,
  full_name,
  formatted_start_date,
  formatted_end_date,
  description,
  show_user_benefit_live_balances,
  content_configuration,
  status: status2,
  insurance,
  provider_name,
  product_type,
  type
}) {
  let hasCardInfo = false;
  if (content_actions) {
    hasCardInfo = hasAction(content_actions, SYSTEM_TYPES.CardInfo);
  }
  const showAlertsBanner = notActiveBenefitBannerDetails(status2);
  const walletData = {
    activationDate: activation_date,
    benefitName: full_name,
    date: {
      startDate: formatted_start_date,
      endDate: formatted_end_date
    },
    description,
    showUserLiveBalances: show_user_benefit_live_balances,
    showPolicyInformation: hasCardInfo,
    showCostAndCoverage: content_configuration == null ? void 0 : content_configuration.show_cost_and_coverage,
    showPolicyDates: content_configuration == null ? void 0 : content_configuration.show_policy_dates,
    status: status2,
    policyInformation: insurance,
    provider: {
      name: provider_name,
      type: product_type
    },
    type,
    showAlertsBanner
  };
  return walletData;
}
function useGetDetailedWalletData(targetUserId, benefitId) {
  const userId = targetUserId;
  return useGetWalletDetailQuery(userId, benefitId, void 0, {
    select: selectWalletData
  });
}

// src/pages/member-wallet-detail-page/components/benefit-side-details/benefit-side-details.component.tsx
import { useIntl as useIntl58 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout45,
  UtilityText as UtilityText21,
  Icon as Icon16,
  HeadingText as HeadingText20,
  StackItem as StackItem10
} from "@leagueplatform/genesis-core";
import {
  ErrorState as ErrorState18,
  LoadingIndicator as LoadingIndicator20
} from "@leagueplatform/web-common-components";

// src/pages/member-wallet-detail-page/components/benefit-side-details/benefit-side-details-dependent.component.tsx
import { useIntl as useIntl57 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout44,
  UtilityText as UtilityText20,
  Icon as Icon15,
  StackItem as StackItem9,
  Spinner as Spinner3
} from "@leagueplatform/genesis-core";
import { ErrorState as ErrorState17 } from "@leagueplatform/web-common-components";

// src/pages/member-wallet-detail-page/components/benefit-card/benefit-card.component.tsx
import React37 from "react";
import { useIntl as useIntl55 } from "@leagueplatform/locales";
import {
  Box as Box36,
  UtilityText as UtilityText19,
  TextAction as TextAction8,
  Modal as Modal6,
  StackItem as StackItem8
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME31 } from "@leagueplatform/analytics";

// src/components/customer-support-modal/customer-support-modal.component.tsx
import { useIntl as useIntl54 } from "@leagueplatform/locales";
import {
  HeadingText as HeadingText19,
  Box as Box35,
  StackLayout as StackLayout43,
  Modal as Modal5,
  Button as Button9
} from "@leagueplatform/genesis-core";
import { HtmlToReact as HtmlToReact3 } from "@leagueplatform/web-common";

// src/components/card-image/card-image.component.tsx
import { useIntl as useIntl53 } from "@leagueplatform/locales";
import {
  Box as Box34,
  UtilityText as UtilityText18,
  StackLayout as StackLayout42,
  Card as Card6
} from "@leagueplatform/genesis-core";
import {
  Box as CommonsBox,
  css,
  genesisStyled
} from "@leagueplatform/genesis-commons";
import { jsx as jsx75, jsxs as jsxs48 } from "react/jsx-runtime";
var HTMLCard = genesisStyled(CommonsBox)(
  css({
    ".card.styled": css({
      cursor: "default",
      color: "onSurface.text.primary",
      fontSize: "body2",
      borderRadius: 18,
      borderColor: "onSurface.border.subdued",
      boxShadow: "card",
      padding: "one",
      height: "auto",
      minHeight: "168px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "half",
      ".row": {
        padding: 0,
        position: "relative"
      },
      ".details": css({
        position: "initial",
        display: "flex",
        flexWrap: "wrap",
        gap: "half"
      }),
      ".cardholder": {
        position: "initial"
      },
      ".description": {
        position: "initial"
      },
      h1: css({
        marginBottom: 0,
        color: "inherit",
        fontWeight: "medium",
        fontSize: "body2"
      }),
      h2: css({
        marginBottom: 0,
        color: "inherit",
        fontWeight: "medium",
        fontSize: "body2"
      }),
      ".light": css({
        color: "onSurface.text.subdued"
      }),
      ".medium": css({
        color: "inherit"
      }),
      ".col": css({
        marginRight: "half",
        flexShrink: "1",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        ".label": css({
          color: "onSurface.text.subdued",
          fontSize: "10px",
          whiteSpace: "normal"
        }),
        ".value, .name": css({
          lineHeight: "normal",
          fontSize: "caption",
          color: "inherit"
        }),
        ".name": css({
          fontWeight: "medium",
          lineHeight: "normal",
          fontSize: "caption",
          color: "inherit"
        })
      }),
      ".dark": css({
        fontSize: "caption",
        color: "inherit"
      }),
      ".balance .value": {
        lineHeight: "52px"
      },
      ".title": {
        position: "initial",
        width: "100%",
        color: "inherit",
        div: css({
          fontSize: "caption"
        })
      },
      ".disclaimer": {
        fontSize: "10px",
        color: "onSurface.text.subdued",
        position: "initial"
      },
      ".effective-dates": {
        position: "initial",
        maxWidth: "80%"
      },
      ".effective-dates p": {
        fontSize: "10px",
        color: "onSurface.text.subdued"
      },
      ".logos": {
        width: "20%",
        right: "6%",
        padding: 0,
        position: "absolute"
      },
      ".logo": {
        marginTop: "3%",
        height: "10%"
      }
    })
  })
);
var CardImage = ({ cardImage }) => {
  const { formatMessage } = useIntl53();
  return /* @__PURE__ */ jsx75(
    StackLayout42,
    {
      orientation: "horizontal",
      verticalAlignment: "bottom",
      horizontalAlignment: "center",
      css: { flexWrap: "wrap" },
      children: cardImage.map((card) => /* @__PURE__ */ jsx75(Box34, { children: /* @__PURE__ */ jsxs48(Card6.Flat, { css: { maxWidth: "385px" }, children: [
        card.type === "url" || card.type === "base64" ? /* @__PURE__ */ jsx75(
          Card6.Image,
          {
            css: { width: "100%" },
            image: card.src,
            imageAlt: card.description
          }
        ) : /* @__PURE__ */ jsx75(
          HTMLCard,
          {
            minHeight: 168,
            width: 280,
            dangerouslySetInnerHTML: {
              __html: card.src
            }
          }
        ),
        /* @__PURE__ */ jsx75(Card6.Section, { children: /* @__PURE__ */ jsx75(UtilityText18, { children: formatMessage({ id: card.title }) }) })
      ] }) }, card.src))
    }
  );
};

// src/components/customer-support-modal/customer-support-modal.component.tsx
import { jsx as jsx76, jsxs as jsxs49 } from "react/jsx-runtime";
var CustomerSupportModal = ({
  title,
  description,
  cardImage
}) => {
  const { formatMessage } = useIntl54();
  return /* @__PURE__ */ jsx76(
    Modal5.Content,
    {
      showCloseButton: false,
      padding: "$none",
      width: { "@initial": 900, "@tablet": "100%" },
      children: /* @__PURE__ */ jsxs49(
        Box35,
        {
          css: {
            padding: "$four"
          },
          children: [
            /* @__PURE__ */ jsxs49(
              StackLayout43,
              {
                orientation: "horizontal",
                horizontalAlignment: "spaceBetween",
                verticalAlignment: "center",
                css: { marginBottom: "$oneAndHalf" },
                children: [
                  title && /* @__PURE__ */ jsx76(Modal5.Title, { children: /* @__PURE__ */ jsx76(HeadingText19, { level: "3", size: "xl", children: title }) }),
                  /* @__PURE__ */ jsx76(Modal5.Close, { children: /* @__PURE__ */ jsx76(
                    Button9,
                    {
                      priority: "tertiary",
                      quiet: true,
                      icon: "tinyClose",
                      hideLabel: true,
                      size: "small",
                      children: formatMessage({ id: "CLOSE" })
                    }
                  ) })
                ]
              }
            ),
            description && /* @__PURE__ */ jsx76(Modal5.Description, { children: /* @__PURE__ */ jsx76(Box35, { children: typeof description === "string" ? /* @__PURE__ */ jsx76(HtmlToReact3, { htmlString: description }) : description }) }),
            cardImage && /* @__PURE__ */ jsx76(CardImage, { cardImage })
          ]
        }
      )
    }
  );
};

// src/pages/member-wallet-detail-page/components/benefit-card/utils/get-wallet-card-headers.utils.ts
function getWalletCardHeaders(cardImage) {
  if (!cardImage)
    return [];
  const _a = cardImage, { actions } = _a, strippedCardImage = __objRest(_a, ["actions"]);
  const newCardObject = __spreadValues({}, strippedCardImage);
  Object.keys(newCardObject).map((card) => {
    const title = `DIGITAL_CARD_${card.toUpperCase()}`;
    newCardObject[card].title = title;
    return newCardObject;
  });
  const cardFaces = [cardImage == null ? void 0 : cardImage.front, cardImage == null ? void 0 : cardImage.back].filter(
    (face) => !!face
  );
  return cardFaces;
}

// src/pages/member-wallet-detail-page/components/benefit-card/benefit-card.component.tsx
import { jsx as jsx77, jsxs as jsxs50 } from "react/jsx-runtime";
var BenefitCard = ({ cardImage }) => {
  const { formatMessage } = useIntl55();
  const cards = getWalletCardHeaders(cardImage);
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit detail" /* BENEFIT_DETAIL */,
    detail: "view digital card" /* VIEW_DIGITAL_CARD */
  });
  const sendButtonClickedAnalyticsEvent = React37.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME31.BUTTON_CLICKED),
    [sendAnalyticsEvent]
  );
  if (!cardImage)
    return /* @__PURE__ */ jsx77(Box36, { css: { marginTop: "$half" }, children: /* @__PURE__ */ jsx77(UtilityText19, { size: "sm", children: formatMessage({ id: "NO_DIGITAL_CARD" }) }) });
  return /* @__PURE__ */ jsx77(Box36, { css: { marginTop: "$half" }, children: /* @__PURE__ */ jsxs50(Modal6.Root, { children: [
    /* @__PURE__ */ jsxs50(StackItem8, { children: [
      /* @__PURE__ */ jsx77(UtilityText19, { css: { typography: "$bodyTwo", marginBottom: "$one" }, children: formatMessage({ id: "DIGITAL_CARD_DEFINITION" }) }),
      /* @__PURE__ */ jsx77(Modal6.Trigger, { children: /* @__PURE__ */ jsx77(
        TextAction8,
        {
          as: "button",
          css: { width: "fit-content" },
          onClick: sendButtonClickedAnalyticsEvent,
          children: formatMessage({ id: "VIEW_CARD" })
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx77(
      CustomerSupportModal,
      {
        title: formatMessage({ id: "DIGITAL_CARD" }),
        cardImage: cards
      }
    )
  ] }) });
};

// src/pages/member-wallet-detail-page/hooks/use-benefit-side-details.hook.ts
import { useIntl as useIntl56 } from "@leagueplatform/locales";
function selectWalletDetails({
  categorized_actions,
  card_images,
  dependents,
  member_first_name,
  member_last_name,
  targetUserId,
  memberUsername,
  memberRelationship,
  dependentLabel
}) {
  const allMemberData = [
    {
      relationship: memberRelationship,
      label: `${member_first_name} ${member_last_name}`,
      value: targetUserId,
      memberUsername
    }
  ];
  if (dependents && dependents.length > 0) {
    dependents.map((dependent) => {
      const dependentData = {
        relationship: dependentLabel,
        label: `${dependent.first_name} ${dependent.last_name}`,
        value: dependent.dependent_id
      };
      return allMemberData.push(dependentData);
    });
  }
  const sideDetailData = {
    categorizedActions: categorized_actions,
    cardImage: card_images,
    allMemberData
  };
  return sideDetailData;
}
function useBenefitSideDetails(targetUserId, benefitId, memberUsername, dependentId) {
  const { formatMessage } = useIntl56();
  const userId = targetUserId;
  const dependentLabel = formatMessage({ id: "DEPENDENT" });
  const { memberRelationship } = useGetTargetUserInfo(targetUserId);
  return useGetWalletDetailQuery(userId, benefitId, dependentId, {
    select: (data) => selectWalletDetails(__spreadProps(__spreadValues({}, data), {
      targetUserId,
      memberUsername,
      memberRelationship,
      dependentLabel
    }))
  });
}

// src/pages/member-wallet-detail-page/components/benefit-side-details/benefit-side-details-dependent.component.tsx
import { jsx as jsx78, jsxs as jsxs51 } from "react/jsx-runtime";
var BenefitSideDetailsDependent = () => {
  const { formatMessage } = useIntl57();
  const targetUserId = useTargetUserId();
  const memberUsername = useMemberUsername();
  const member = useSelectedMember();
  const dependentId = (member == null ? void 0 : member.id) === targetUserId ? void 0 : member == null ? void 0 : member.id;
  const { benefitId } = useCustomerSupportParams();
  const {
    data: walletSideDetails,
    isLoading,
    isError,
    isSuccess,
    error
  } = useBenefitSideDetails(
    targetUserId,
    benefitId != null ? benefitId : "",
    memberUsername,
    dependentId
  );
  const isIdle = simulateIsIdle(isLoading, isSuccess, walletSideDetails);
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx78(SideDetailCard, { children: /* @__PURE__ */ jsx78(StackItem9, { horizontalAlignment: "center", css: { width: "100%" }, children: /* @__PURE__ */ jsx78(Spinner3, { loading: true }) }) });
  if (isError)
    return /* @__PURE__ */ jsx78(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx78(
      ErrorState17,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx78("br", {}) }
        )
      }
    ) });
  const { cardImage } = walletSideDetails;
  return /* @__PURE__ */ jsx78(SideDetailCard, { header: formatMessage({ id: "DIGITAL_CARD" }), children: /* @__PURE__ */ jsx78(BenefitCard, { cardImage }) });
};

// src/pages/member-wallet-detail-page/components/benefit-side-details/benefit-side-details.component.tsx
import { Fragment as Fragment11, jsx as jsx79, jsxs as jsxs52 } from "react/jsx-runtime";
var BenefitListDetails = ({
  details,
  icon
}) => /* @__PURE__ */ jsxs52(StackLayout45, { orientation: "horizontal", css: { padding: "$half $none $half" }, children: [
  icon && /* @__PURE__ */ jsx79(Icon16, { icon, size: "2rem", css: { paddingRight: "$half" } }),
  /* @__PURE__ */ jsx79(UtilityText21, { size: "sm", css: { alignSelf: "center" }, children: details })
] });
var BenefitSideDetails = () => {
  const { formatMessage } = useIntl58();
  const targetUserId = useTargetUserId();
  const memberUsername = useMemberUsername();
  const { isPrimaryMember } = useGetTargetUserInfo(targetUserId);
  const { benefitId } = useCustomerSupportParams();
  const {
    data: walletSideDetails,
    isLoading,
    isError,
    isSuccess,
    error
  } = useBenefitSideDetails(targetUserId, benefitId != null ? benefitId : "", memberUsername);
  const isIdle = simulateIsIdle(isLoading, isSuccess, walletSideDetails);
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx79(LoadingIndicator20, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx79(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx79(
      ErrorState18,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx79("br", {}) }
        )
      }
    ) });
  }
  const { allMemberData, categorizedActions } = walletSideDetails;
  const dependents = allMemberData == null ? void 0 : allMemberData.filter(
    (dependent) => (dependent == null ? void 0 : dependent.relationship) !== formatMessage({ id: "POLICYHOLDER" })
  );
  const policyholder = walletSideDetails.allMemberData[0];
  return /* @__PURE__ */ jsxs52(Fragment11, { children: [
    dependents.length !== 0 && allMemberData.length > 1 ? /* @__PURE__ */ jsx79(SideDetailCard, { allMemberData: walletSideDetails.allMemberData }) : /* @__PURE__ */ jsx79(
      SideDetailCard,
      {
        header: policyholder.label,
        member: policyholder.relationship,
        memberUsername: policyholder.memberUsername
      }
    ),
    dependents.length > 0 && isPrimaryMember && /* @__PURE__ */ jsx79(SideDetailCard, { header: formatMessage({ id: "DEPENDENTS" }), children: dependents.map((dependent) => /* @__PURE__ */ jsx79(
      BenefitListDetails,
      {
        details: dependent.label,
        icon: "illustrativePerson"
      },
      `${dependent.value}-${dependent.label}`
    )) }),
    /* @__PURE__ */ jsx79(BenefitSideDetailsDependent, {}),
    categorizedActions && categorizedActions.length > 0 && /* @__PURE__ */ jsx79(
      SideDetailCard,
      {
        header: formatMessage({ id: "MEMBER_ACTIONS" }),
        tooltip: formatMessage({ id: "QUICK_LINKS_AGENT" }),
        children: categorizedActions.map((action) => /* @__PURE__ */ jsxs52(StackItem10, { children: [
          /* @__PURE__ */ jsx79(
            HeadingText20,
            {
              size: "sm",
              level: "3",
              css: { typography: "$subtitleOne" },
              children: action.title
            }
          ),
          action.actions.map((benefit) => /* @__PURE__ */ jsx79(BenefitListDetails, { details: benefit.name }, benefit.name))
        ] }, action.title))
      }
    )
  ] });
};

// src/pages/member-wallet-detail-page/components/wallet-detailed-benefits/wallet-detailed-benefits-container.tsx
import { useIntl as useIntl64 } from "@leagueplatform/locales";
import { HtmlToReact as HtmlToReact5 } from "@leagueplatform/web-common";
import { Box as Box42, HeadingText as HeadingText25 } from "@leagueplatform/genesis-core";

// src/pages/member-wallet-detail-page/components/live-balance/get-user-live-balances.component.tsx
import React39 from "react";
import {
  Box as Box38,
  HeadingText as HeadingText22,
  ParagraphText as ParagraphText20,
  StackLayout as StackLayout47,
  Tabs as Tabs3,
  UtilityText as UtilityText23,
  Popover as Popover2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl60 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator21,
  ErrorState as ErrorState19,
  PillTab,
  PillTabList,
  PillTabs
} from "@leagueplatform/web-common-components";
import {
  SHORT_DATE_AND_TIME_FORMAT,
  NUMERIC_YEAR_MONTH_DAY,
  HtmlToReact as HtmlToReact4
} from "@leagueplatform/web-common";
import { EVENT_NAME as EVENT_NAME32 } from "@leagueplatform/analytics";

// src/pages/member-wallet-detail-page/components/live-balance/hooks/use-get-user-live-balances-query.hook.ts
import { useQuery as useQuery17 } from "@tanstack/react-query";
import {
  getUserBenefitLiveBalances,
  GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { captureError as captureError16 } from "@leagueplatform/observability";
var DEFAULT_API_VERSION = 2;
function useGetUserBenefitLiveBalancesQuery({
  userId,
  benefitId,
  dependentId,
  apiVersion = DEFAULT_API_VERSION
}, options) {
  return useQuery17(
    [
      GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE,
      userId,
      benefitId,
      dependentId,
      apiVersion
    ],
    () => getUserBenefitLiveBalances(userId, benefitId, dependentId, apiVersion),
    __spreadValues({
      staleTime: Infinity,
      onError(error) {
        captureError16(
          new Error(
            `Customer Support: Failed to get user live balances (member id: ${userId}) (benefit id: ${benefitId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-wallet-detail-page/components/live-balance/hooks/use-get-user-live-balances.hook.ts
function useGetUserLiveBalances() {
  const userId = useTargetUserId();
  const { benefitId } = useCustomerSupportParams();
  const member = useSelectedMember();
  const dependentId = (member == null ? void 0 : member.id) === userId ? void 0 : member == null ? void 0 : member.id;
  return useGetUserBenefitLiveBalancesQuery(
    { userId, benefitId: benefitId != null ? benefitId : "", dependentId },
    {
      select: (data) => {
        const inNetwork = data.in_network;
        const outOfNetwork = data.out_of_network;
        const noNetwork = data.no_network;
        const isNoNetworkUser = !!noNetwork;
        const plans = isNoNetworkUser ? [
          {
            id: "NO_NETWORK" /* NO_NETWORK */,
            network: noNetwork
          }
        ] : [
          {
            id: "IN_NETWORK" /* IN_NETWORK */,
            // if network is null or undefined make it an empty array
            network: inNetwork != null ? inNetwork : []
          },
          {
            id: "OUT_OF_NETWORK" /* OUT_OF_NETWORK */,
            network: outOfNetwork != null ? outOfNetwork : []
          }
        ];
        return {
          accumulationPeriod: data.accumulation_period,
          carrierName: data.carrier_name,
          inNetwork: data.in_network,
          lastUpdated: data.last_updated,
          noNetwork: data.no_network,
          outOfNetwork: data.out_of_network,
          plans
        };
      }
    }
  );
}

// src/pages/member-wallet-detail-page/components/live-balance/components/live-balance-item/live-balance-item.component.tsx
import React38 from "react";
import { useIntl as useIntl59 } from "@leagueplatform/locales";
import {
  Box as Box37,
  HeadingText as HeadingText21,
  ParagraphText as ParagraphText19,
  UtilityText as UtilityText22,
  VisuallyHidden as VisuallyHidden7,
  StackLayout as StackLayout46
} from "@leagueplatform/genesis-core";
import { jsx as jsx80, jsxs as jsxs53 } from "react/jsx-runtime";
var LiveBalanceItem = ({
  networkName,
  balanceName,
  paid_amount: paidAmount,
  remaining_amount: remainingAmount,
  limit,
  headingLevel = "4",
  category,
  version = 1
}) => {
  const { formatMoney, formatMessage } = useIntl59();
  const percentage = `${paidAmount.M / limit.M * 100}%`;
  const member = useSelectedMember();
  const parseCategory = React38.useCallback(() => {
    if (!category) {
      return void 0;
    }
    if (version === 2) {
      return balanceName;
    }
    if (category === "individual" && version === 1) {
      return formatMessage(
        { id: "INDIVIDUAL_BALANCE" },
        {
          membersFullName: (member == null ? void 0 : member.name) || formatMessage({ id: "INDIVIDUAL" }),
          balance: balanceName
        }
      );
    }
    return formatMessage(
      { id: "FAMILY_BALANCE" },
      {
        balance: balanceName
      }
    );
  }, [balanceName, category, formatMessage, member == null ? void 0 : member.name, version]);
  const title = parseCategory();
  return /* @__PURE__ */ jsxs53(
    StackLayout46,
    {
      css: {
        backgroundColor: "$surfaceBackgroundPrimary",
        borderColor: "$onSurfaceBorderSubdued",
        borderRadius: "$small",
        borderStyle: "solid",
        borderWidth: "$thin",
        padding: "$one"
      },
      children: [
        title && /* @__PURE__ */ jsxs53(
          HeadingText21,
          {
            size: headingLevel === "4" ? "md" : "lg",
            level: headingLevel,
            css: { marginBottom: "$threeQuarters" },
            children: [
              networkName && /* @__PURE__ */ jsx80(
                UtilityText22,
                {
                  emphasis: "emphasized",
                  size: "eyebrow",
                  css: { marginBottom: "$one", display: "block" },
                  children: networkName
                }
              ),
              title
            ]
          }
        ),
        /* @__PURE__ */ jsx80(
          UtilityText22,
          {
            as: "p",
            css: { typography: "$subtitleOne", marginBottom: "$half" },
            children: formatMessage(
              { id: "LIVE_BALANCE_REMAINING" },
              { amount: formatMoney(remainingAmount) }
            )
          }
        ),
        /* @__PURE__ */ jsxs53(
          Box37,
          {
            css: {
              backgroundColor: "$surfaceBackgroundTertiary",
              border: "1px solid $onSurfaceBorderSubdued",
              borderRadius: "$pill",
              height: "$half",
              maxWidth: "400px",
              overflow: "hidden",
              width: "100%",
              marginBottom: "$threeQuarters"
            },
            children: [
              /* @__PURE__ */ jsx80(VisuallyHidden7, { children: formatMessage({ id: "PERCENTAGE_USED" }, { percentage }) }),
              /* @__PURE__ */ jsx80(
                Box37,
                {
                  css: {
                    backgroundColor: "$decorativeBrandSecondaryDefault",
                    borderRadius: "$pill",
                    height: "100%",
                    minWidth: "$half",
                    width: percentage
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx80(ParagraphText19, { css: { typography: "$bodyTwo" }, children: formatMessage(
          { id: "LIVE_BALANCE_SPEND" },
          {
            spentAmount: formatMoney(paidAmount),
            totalAmount: formatMoney(limit, {
              minimumFractionDigits: 0
            })
          }
        ) })
      ]
    }
  );
};

// src/pages/member-wallet-detail-page/components/live-balance/get-user-live-balances.component.tsx
import { Fragment as Fragment12, jsx as jsx81, jsxs as jsxs54 } from "react/jsx-runtime";
var ACCUMULATION_PERIOD_DATE_FORMAT = __spreadProps(__spreadValues({}, NUMERIC_YEAR_MONTH_DAY), {
  timeZone: "UTC"
});
var strong2 = (msg) => /* @__PURE__ */ jsx81(Box38, { as: "strong", children: msg });
function UserLiveBalances() {
  const { formatDate, formatMessage } = useIntl60();
  const member = useSelectedMember();
  const { isLoading, data, isError, isSuccess, error } = useGetUserLiveBalances();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit detail" /* BENEFIT_DETAIL */
  });
  const sendButtonClickedAnalyticsEvent = React39.useCallback(
    (value) => sendAnalyticsEvent(EVENT_NAME32.BUTTON_CLICKED, {
      detail: "plan toggle" /* PLAN_TOGGLE */,
      sub_detail: value === "IN_NETWORK" ? "in network" /* IN_NETWORK */ : "out of network" /* OUT_OF_NETWORK */
    }),
    [sendAnalyticsEvent]
  );
  const sendTooltipAnalyticsEvent = React39.useCallback(
    (value) => sendAnalyticsEvent(EVENT_NAME32.BUTTON_CLICKED, {
      detail: "tooltip" /* TOOLTIP */,
      sub_detail: value == null ? void 0 : value.toLowerCase()
    }),
    [sendAnalyticsEvent]
  );
  if (isLoading)
    return /* @__PURE__ */ jsx81(LoadingIndicator21, { inline: true });
  if (isError || !isSuccess) {
    return /* @__PURE__ */ jsx81(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx81(
      ErrorState19,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx81("br", {}) }
        )
      }
    ) });
  }
  const { plans, accumulationPeriod, lastUpdated, carrierName } = data;
  return /* @__PURE__ */ jsx81(Box38, { children: /* @__PURE__ */ jsxs54(
    PillTabs,
    {
      defaultValue: plans[0].id,
      onValueChange: sendButtonClickedAnalyticsEvent,
      children: [
        /* @__PURE__ */ jsxs54(
          StackLayout47,
          {
            orientation: "horizontal",
            horizontalAlignment: "spaceBetween",
            children: [
              /* @__PURE__ */ jsxs54(Box38, { children: [
                /* @__PURE__ */ jsx81(HeadingText22, { level: "2", size: "xl", css: { marginBottom: "$half" }, children: formatMessage({ id: "PLAN_PROGRESS" }) }),
                accumulationPeriod && /* @__PURE__ */ jsx81(HeadingText22, { size: "xs", level: "display", emphasis: "subtle", children: formatMessage(
                  { id: "ACCUMULATION_PERIOD" },
                  {
                    start: formatDate(
                      accumulationPeriod.start,
                      ACCUMULATION_PERIOD_DATE_FORMAT
                    ),
                    end: formatDate(
                      accumulationPeriod.end,
                      ACCUMULATION_PERIOD_DATE_FORMAT
                    ),
                    strong: strong2
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsx81(Box38, { css: { width: "fit-content" }, children: /* @__PURE__ */ jsx81(PillTabList, { children: plans.map((tab) => /* @__PURE__ */ jsx81(PillTab, { value: tab.id, children: formatMessage({ id: tab.id }) }, tab.id)) }) })
            ]
          }
        ),
        plans.map((plan) => {
          var _a, _b;
          const NETWORK_NAME = formatMessage({ id: plan.id });
          const LAST_UPDATED = formatMessage(
            { id: "LAST_UPDATED_CARRIER_DATE" },
            {
              date: formatDate(lastUpdated, SHORT_DATE_AND_TIME_FORMAT),
              carrier: carrierName
            }
          );
          return /* @__PURE__ */ jsxs54(
            Tabs3.TabPanel,
            {
              value: plan.id,
              css: { padding: "$none" },
              children: [
                ((_a = plan.network) == null ? void 0 : _a.length) === 0 && /* @__PURE__ */ jsx81(Box38, { as: "section", css: { display: "flex" }, children: /* @__PURE__ */ jsx81(ParagraphText20, { css: { marginTop: "$one" }, children: formatMessage(
                  { id: "NETWORK_MISSING_COVERAGE_ADMIN" },
                  { network: NETWORK_NAME }
                ) }) }),
                ((_b = plan.network) == null ? void 0 : _b.length) > 0 && /* @__PURE__ */ jsx81(Fragment12, { children: plan.network.map((network) => /* @__PURE__ */ jsxs54(React39.Fragment, { children: [
                  /* @__PURE__ */ jsx81(
                    HeadingText22,
                    {
                      level: "3",
                      size: "lg",
                      css: { margin: "$oneAndHalf $none $one" },
                      children: network.title
                    }
                  ),
                  network.categories.map((category) => /* @__PURE__ */ jsxs54(
                    Box38,
                    {
                      css: { marginBottom: "$two" },
                      children: [
                        /* @__PURE__ */ jsxs54(
                          StackLayout47,
                          {
                            orientation: "horizontal",
                            verticalAlignment: "center",
                            children: [
                              /* @__PURE__ */ jsx81(
                                ParagraphText20,
                                {
                                  css: {
                                    typography: "$subtitleTwo",
                                    color: "$onSurfaceTextSubdued",
                                    paddingRight: "$half"
                                  },
                                  children: category.type === "individual" ? member == null ? void 0 : member.name : category.title
                                }
                              ),
                              /* @__PURE__ */ jsxs54(Popover2.Root, { children: [
                                /* @__PURE__ */ jsx81(
                                  Popover2.Trigger,
                                  {
                                    label: category.definition.title,
                                    icon: "tinyHelper",
                                    priority: "secondary",
                                    quiet: true,
                                    hideLabel: true,
                                    size: "small",
                                    css: {
                                      padding: "$none",
                                      border: "none",
                                      alignSelf: "flex-start"
                                    },
                                    onClick: () => {
                                      var _a2;
                                      return sendTooltipAnalyticsEvent(
                                        (_a2 = category == null ? void 0 : category.definition) == null ? void 0 : _a2.title
                                      );
                                    }
                                  }
                                ),
                                /* @__PURE__ */ jsx81(
                                  Popover2.Content,
                                  {
                                    side: "right",
                                    css: { maxWidth: "320px" },
                                    showCloseButton: false,
                                    children: /* @__PURE__ */ jsxs54(StackLayout47, { children: [
                                      category.definition.title && /* @__PURE__ */ jsx81(HeadingText22, { size: "md", level: "4", children: category.definition.title }),
                                      /* @__PURE__ */ jsx81(
                                        HtmlToReact4,
                                        {
                                          htmlString: category.definition.description,
                                          options: {
                                            p: {
                                              component: ParagraphText20,
                                              props: { size: "sm" }
                                            }
                                          }
                                        }
                                      )
                                    ] })
                                  }
                                )
                              ] })
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx81(
                          StackLayout47,
                          {
                            orientation: "horizontal",
                            css: {
                              flexWrap: "wrap",
                              width: "100%",
                              gap: "$two"
                            },
                            children: category.balances.map((balance) => /* @__PURE__ */ jsx81(Box38, { css: { flexGrow: 1 }, children: /* @__PURE__ */ jsx81(
                              LiveBalanceItem,
                              {
                                balanceName: balance.title,
                                limit: balance.limit,
                                paid_amount: balance.paid_amount,
                                remaining_amount: balance.remaining_amount,
                                category: category.type,
                                version: 2
                              }
                            ) }, balance.title))
                          }
                        ),
                        /* @__PURE__ */ jsx81(
                          UtilityText23,
                          {
                            css: {
                              typography: "$caption",
                              marginTop: "$quarter",
                              color: "$onSurfaceTextSubdued"
                            },
                            children: LAST_UPDATED
                          }
                        )
                      ]
                    },
                    category.title
                  ))
                ] }, network.title)) })
              ]
            },
            plan.id
          );
        })
      ]
    }
  ) });
}

// src/pages/member-wallet-detail-page/components/provider-services/provider-service.component.tsx
import { useIntl as useIntl62 } from "@leagueplatform/locales";
import {
  Box as Box40,
  StackLayout as StackLayout49,
  HeadingText as HeadingText23,
  ParagraphText as ParagraphText22
} from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator22,
  ErrorState as ErrorState20
} from "@leagueplatform/web-common-components";

// src/pages/member-wallet-detail-page/components/provider-services/hooks/use-get-provider-services-query.hook.ts
import { useQuery as useQuery18 } from "@tanstack/react-query";
import {
  getProviderServices,
  GET_PROVIDER_SERVICES_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { captureError as captureError17 } from "@leagueplatform/observability";
function useGetProviderServices(userId, benefitId, options) {
  return useQuery18(
    [GET_PROVIDER_SERVICES_MESSAGE_TYPE, userId, benefitId],
    () => getProviderServices(userId, benefitId),
    __spreadValues({
      staleTime: Infinity,
      onError(error) {
        captureError17(
          new Error(
            `Customer Support: Failed to get user provider services (member id: ${userId}) (benefit id: ${benefitId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-wallet-detail-page/components/provider-services/utils/select-coverage-network.util.ts
function selectCoverageNetworks({
  provider_services
}) {
  var _a, _b;
  const networks = [
    {
      label: "IN_NETWORK",
      services: (_a = provider_services == null ? void 0 : provider_services.in_network) != null ? _a : []
    },
    {
      label: "OUT_OF_NETWORK",
      services: (_b = provider_services == null ? void 0 : provider_services.out_of_network) != null ? _b : []
    }
  ];
  return networks;
}

// src/pages/member-wallet-detail-page/components/provider-services/hooks/use-provider-services.hook.ts
function useProviderServices(targetUserId, benefitId) {
  const userId = targetUserId;
  return useGetProviderServices(userId, benefitId, {
    select: selectCoverageNetworks
  });
}

// src/pages/member-wallet-detail-page/components/provider-services/components/provider-services-table.component.tsx
import { useIntl as useIntl61 } from "@leagueplatform/locales";
import {
  Box as Box39,
  ParagraphText as ParagraphText21,
  StackLayout as StackLayout48,
  UtilityText as UtilityText24,
  styled as styled8
} from "@leagueplatform/genesis-core";

// src/pages/member-wallet-detail-page/components/provider-services/hooks/use-get-headers-index.hook.ts
import { useMemo as useMemo6 } from "react";
function useGetHeadersIndex(tableData) {
  const headers = useMemo6(() => [], []);
  useMemo6(() => {
    tableData.map(
      (service) => {
        var _a;
        return (_a = service.providers) == null ? void 0 : _a.forEach(
          (provider, index) => headers.push({ title: provider.title, headerIndex: index })
        );
      }
    );
  }, [tableData, headers]);
  const uniqueHeaders = headers.reduce(
    (curr, acc) => {
      if (!curr.some((obj) => obj.title === acc.title)) {
        curr.push(acc);
      }
      return curr;
    },
    []
  );
  useMemo6(() => {
    [...tableData].map((prev, index) => {
      var _a;
      (_a = prev.providers) == null ? void 0 : _a.map(
        (a, i) => uniqueHeaders.forEach(
          (header) => {
            var _a2;
            return a.title === header.title && Object.assign(((_a2 = tableData[index].providers) == null ? void 0 : _a2[i]) || {}, {
              headerIndex: header.headerIndex
            });
          }
        )
      );
      return tableData;
    });
  }, [tableData, uniqueHeaders]);
  return {
    uniqueHeaders,
    dataWithIndex: tableData
  };
}

// src/pages/member-wallet-detail-page/components/provider-services/components/provider-services-table.component.tsx
import { jsx as jsx82, jsxs as jsxs55 } from "react/jsx-runtime";
var TableColumnHeader3 = ({ firstColumn, value }) => /* @__PURE__ */ jsx82(
  Box39,
  {
    as: "th",
    css: {
      borderColor: "$onSurfaceBorderSubdued",
      borderWidth: "$thin",
      borderStyle: "solid",
      textAlign: firstColumn ? "left" : "center",
      padding: "$half"
    },
    children: /* @__PURE__ */ jsx82(UtilityText24, { emphasis: "emphasized", size: "sm", children: value })
  }
);
var StyledTableCell = styled8("td", {
  borderColor: "$onSurfaceBorderSubdued",
  borderWidth: "$thin",
  borderStyle: "solid",
  padding: "$half"
});
var ParagraphTextWrapper = ({ text }) => /* @__PURE__ */ jsx82(ParagraphText21, { emphasis: "subtle", size: "sm", children: text });
var ProviderServicesTable = ({
  tableData
}) => {
  const { formatMessage } = useIntl61();
  const { uniqueHeaders, dataWithIndex } = useGetHeadersIndex(tableData);
  return /* @__PURE__ */ jsxs55(Box39, { as: "table", css: { marginBottom: "$twoAndHalf", width: "100%" }, children: [
    /* @__PURE__ */ jsx82(Box39, { as: "thead", children: /* @__PURE__ */ jsxs55(Box39, { as: "tr", children: [
      /* @__PURE__ */ jsx82(
        TableColumnHeader3,
        {
          firstColumn: true,
          value: formatMessage({ id: "SERVICE" })
        }
      ),
      uniqueHeaders.map((header) => /* @__PURE__ */ jsx82(
        TableColumnHeader3,
        {
          firstColumn: false,
          value: header.title
        },
        header.title
      ))
    ] }) }),
    /* @__PURE__ */ jsx82(Box39, { as: "tbody", children: dataWithIndex.map((coverage) => /* @__PURE__ */ jsxs55(Box39, { as: "tr", children: [
      /* @__PURE__ */ jsx82(StyledTableCell, { children: /* @__PURE__ */ jsx82(ParagraphTextWrapper, { text: coverage.service_name }) }),
      uniqueHeaders.map((header) => {
        const findCellItem = coverage.providers.find(
          (item) => item.headerIndex === header.headerIndex
        );
        return /* @__PURE__ */ jsx82(
          StyledTableCell,
          {
            children: /* @__PURE__ */ jsx82(StackLayout48, { horizontalAlignment: "center", children: /* @__PURE__ */ jsx82(
              ParagraphTextWrapper,
              {
                text: findCellItem ? findCellItem.description : "-"
              }
            ) })
          },
          findCellItem ? `${header.title}${findCellItem.description}${coverage.service_name}` : `${header.title}${coverage.service_name}${header.headerIndex}`
        );
      })
    ] }, coverage.service_name)) })
  ] });
};

// src/pages/member-wallet-detail-page/components/provider-services/provider-service.component.tsx
import { Fragment as Fragment13, jsx as jsx83, jsxs as jsxs56 } from "react/jsx-runtime";
var ProviderServices = ({ targetUserId }) => {
  const { formatMessage } = useIntl62();
  const { benefitId } = useCustomerSupportParams();
  const { isLoading, data, isError, error } = useProviderServices(
    targetUserId,
    benefitId != null ? benefitId : ""
  );
  if (isLoading)
    return /* @__PURE__ */ jsx83(LoadingIndicator22, {});
  if (isError) {
    return /* @__PURE__ */ jsx83(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx83(
      ErrorState20,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx83("br", {}) }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsxs56(Fragment13, { children: [
    /* @__PURE__ */ jsxs56(
      StackLayout49,
      {
        orientation: "horizontal",
        css: { marginBottom: "$oneAndHalf" },
        children: [
          /* @__PURE__ */ jsx83(HeadingText23, { level: "2", size: "xl", children: formatMessage({ id: "COVERAGE_COSTS" }) }),
          /* @__PURE__ */ jsx83(
            Tooltip,
            {
              tooltip: formatMessage({ id: "COVERAGE_AND_COSTS_TOOLTIP" }),
              analyticDetails: {
                screenName: "benefit detail" /* BENEFIT_DETAIL */,
                subDetail: "cost and coverage" /* COST_COVERAGE */
              }
            }
          )
        ]
      }
    ),
    data && data.map((network) => {
      var _a;
      return /* @__PURE__ */ jsxs56(Box40, { children: [
        /* @__PURE__ */ jsx83(
          HeadingText23,
          {
            level: "3",
            size: "lg",
            css: { marginBottom: "$threeQuarters" },
            children: formatMessage({ id: network.label })
          }
        ),
        ((_a = network == null ? void 0 : network.services) == null ? void 0 : _a.length) ? /* @__PURE__ */ jsx83(ProviderServicesTable, { tableData: network.services }) : /* @__PURE__ */ jsx83(ParagraphText22, { css: { marginBottom: "$twoAndHalf" }, children: formatMessage(
          { id: "NETWORK_MISSING_COVERAGE_ADMIN" },
          { network: formatMessage({ id: network.label }) }
        ) })
      ] }, network.label);
    })
  ] });
};

// src/pages/member-wallet-detail-page/components/policy-information/policy-information.component.tsx
import { useMemo as useMemo7 } from "react";
import { useIntl as useIntl63 } from "@leagueplatform/locales";
import {
  Box as Box41,
  HeadingText as HeadingText24,
  ParagraphText as ParagraphText23,
  StackLayout as StackLayout50
} from "@leagueplatform/genesis-core";
import { jsx as jsx84, jsxs as jsxs57 } from "react/jsx-runtime";
var formatCardDetailsArray = (memberIdLabel, groupIdLabel, insurance) => [
  {
    label: memberIdLabel,
    value: insurance == null ? void 0 : insurance.member_policy_number
  },
  {
    label: groupIdLabel,
    value: insurance == null ? void 0 : insurance.provider_policy_number
  },
  {
    label: "RxBIN",
    value: insurance == null ? void 0 : insurance.rx_bin
  },
  {
    label: "RxPCN",
    value: insurance == null ? void 0 : insurance.rx_pcn
  },
  {
    label: "RxGROUP",
    value: insurance == null ? void 0 : insurance.rx_group
  },
  {
    label: "RxID",
    value: insurance == null ? void 0 : insurance.rx_id
  },
  {
    label: "RxCarrier",
    value: insurance == null ? void 0 : insurance.rx_carrier
  }
].filter((cardDetail) => cardDetail.value);
var PolicyInformation = ({ insurance }) => {
  const { formatMessage } = useIntl63();
  const cardDetails = useMemo7(
    () => formatCardDetailsArray(
      formatMessage({ id: "MEMBER_ID" }),
      formatMessage({ id: "GROUP_ID" }),
      insurance || {}
    ),
    [insurance, formatMessage]
  );
  return /* @__PURE__ */ jsxs57(Box41, { css: { paddingBottom: "$twoAndHalf" }, children: [
    /* @__PURE__ */ jsx84(HeadingText24, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: formatMessage({ id: "POLICY_INFORMATION" }) }),
    !cardDetails.length ? /* @__PURE__ */ jsx84(ParagraphText23, { children: formatMessage({ id: "POLICY_INFORMATION_UNAVAILABLE" }) }) : /* @__PURE__ */ jsx84(
      StackLayout50,
      {
        as: "table",
        orientation: "horizontal",
        horizontalAlignment: "spaceBetween",
        css: {
          flex: "0 0 50%",
          flexWrap: "wrap",
          gap: "$oneAndHalf"
        },
        children: cardDetails.map((card) => /* @__PURE__ */ jsxs57(
          StackLayout50,
          {
            as: "tr",
            orientation: "horizontal",
            horizontalAlignment: "spaceBetween",
            verticalAlignment: "center",
            css: {
              flex: "2 1 47%",
              borderBottomColor: "$onSurfaceBorderSubdued",
              borderBottomWidth: "$thin",
              borderBottomStyle: "solid"
            },
            children: [
              /* @__PURE__ */ jsx84(
                ParagraphText23,
                {
                  as: "th",
                  emphasis: "subtle",
                  size: "sm",
                  css: { padding: "$one $zero" },
                  children: card.label
                }
              ),
              /* @__PURE__ */ jsx84(ParagraphText23, { as: "td", size: "sm", css: { marginBottom: "$half" }, children: card.value })
            ]
          },
          `policy-info-${card.label}`
        ))
      }
    )
  ] });
};

// src/pages/member-wallet-detail-page/components/wallet-detailed-benefits/wallet-detailed-benefits-container.tsx
import { Fragment as Fragment14, jsx as jsx85, jsxs as jsxs58 } from "react/jsx-runtime";
var WalletDetailedBenefitsContainer = ({
  walletData
}) => {
  const { formatMessage } = useIntl64();
  const targetUserId = useTargetUserId();
  const { enableWalletInquiry } = useCustomerSupportConfig();
  return /* @__PURE__ */ jsxs58(Box42, { children: [
    walletData.description && /* @__PURE__ */ jsxs58(Fragment14, { children: [
      /* @__PURE__ */ jsx85(HeadingText25, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: formatMessage({ id: "ABOUT_THIS_BENEFIT" }) }),
      /* @__PURE__ */ jsx85(HtmlToReact5, { htmlString: walletData.description })
    ] }),
    walletData.showPolicyInformation && /* @__PURE__ */ jsx85(PolicyInformation, { insurance: walletData.policyInformation }),
    walletData.showCostAndCoverage && /* @__PURE__ */ jsx85(ProviderServices, { targetUserId }),
    enableWalletInquiry && walletData.showUserLiveBalances && /* @__PURE__ */ jsx85(UserLiveBalances, {})
  ] });
};

// src/pages/member-wallet-detail-page/components/benefit-alert-banner/benefit-alert-banner.component.tsx
import { useIntl as useIntl65 } from "@leagueplatform/locales";
import { Box as Box43, StatusBanner as StatusBanner5, UtilityText as UtilityText25 } from "@leagueplatform/genesis-core";
import { jsx as jsx86 } from "react/jsx-runtime";
var BenefitsAlertBanner = ({ content }) => {
  const { formatMessage } = useIntl65();
  return /* @__PURE__ */ jsx86(Box43, { css: { marginBottom: "$oneAndHalf" }, children: /* @__PURE__ */ jsx86(
    StatusBanner5,
    {
      status: mapBenefitStatusColors(content.status),
      title: formatMessage({ id: content.title }),
      children: /* @__PURE__ */ jsx86(UtilityText25, { size: "sm", children: formatMessage({ id: content.description }) })
    }
  ) });
};

// src/pages/member-wallet-detail-page/member-wallet-detail-page.component.tsx
import { Fragment as Fragment15, jsx as jsx87, jsxs as jsxs59 } from "react/jsx-runtime";
var MemberWalletDetailPage = () => {
  const { formatMessage } = useIntl66();
  const { benefitId } = useCustomerSupportParams();
  const targetUserId = useTargetUserId();
  const {
    data: walletData,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetDetailedWalletData(targetUserId, benefitId != null ? benefitId : "");
  const isIdle = simulateIsIdle(isLoading, isSuccess, walletData);
  usePageViewAnalytics10({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "wallet inquiry" /* WALLET_PAGE */,
    screen_name: "benefit detail" /* BENEFIT_DETAIL */
  });
  if (isLoading || isIdle) {
    return /* @__PURE__ */ jsx87(PageLayout, { children: /* @__PURE__ */ jsx87(Box44, { css: { minHeight: "100vh" }, children: /* @__PURE__ */ jsx87(LoadingIndicator23, {}) }) });
  }
  if (isError) {
    return /* @__PURE__ */ jsx87(PageLayout, { children: /* @__PURE__ */ jsx87(
      BoxBorder,
      {
        css: { width: "100%", alignItems: "center", minHeight: "100vh" },
        children: /* @__PURE__ */ jsx87(
          ErrorState21,
          {
            error,
            headingString: formatMessage({
              id: "SOMETHING_WENT_WRONG_HEADING"
            }),
            bodyString: formatMessage(
              { id: "SOMETHING_WENT_WRONG_BODY" },
              { br: /* @__PURE__ */ jsx87("br", {}) }
            )
          }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsx87(
    DetailPageWrapper,
    {
      header: /* @__PURE__ */ jsx87(
        DetailsHeader,
        {
          title: walletData.benefitName,
          status: walletData.status,
          policyDate: walletData.date,
          showPolicyDates: walletData.showPolicyDates
        }
      ),
      mainSection: /* @__PURE__ */ jsxs59(Fragment15, { children: [
        walletData.showAlertsBanner && /* @__PURE__ */ jsx87(BenefitsAlertBanner, { content: walletData.showAlertsBanner }),
        /* @__PURE__ */ jsx87(WalletDetailedBenefitsContainer, { walletData })
      ] }),
      sideDetailSection: /* @__PURE__ */ jsx87(BenefitSideDetails, {})
    }
  );
};

// src/pages/member-assessments-dashboards-page/member-assessments-dashboards-page.component.tsx
import {
  ErrorState as ErrorState23,
  LoadingIndicator as LoadingIndicator28
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl78 } from "@leagueplatform/locales";
import { usePageViewAnalytics as usePageViewAnalytics11 } from "@leagueplatform/analytics";

// src/pages/member-assessments-dashboards-page/components/biometrics/biometrics.component.tsx
import { HeadingText as HeadingText30, StackLayout as StackLayout56 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl72 } from "@leagueplatform/locales";

// src/pages/member-assessments-dashboards-page/components/biometrics/biometrics-content.component.tsx
import {
  ParagraphText as ParagraphText25,
  StackItem as StackItem11,
  StackLayout as StackLayout55
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl71 } from "@leagueplatform/locales";
import { LoadingIndicator as LoadingIndicator25 } from "@leagueplatform/web-common-components";

// src/pages/member-assessments-dashboards-page/components/biometrics/hooks/use-get-latest-health-metrics.hook.ts
import { handleStaticAsset as handleStaticAsset14 } from "@leagueplatform/asset-config";
function getFormattedData2({
  data
}) {
  const healthMetrics = data.map((metric) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    let value = (_a = metric.values.data[0]) == null ? void 0 : _a.value;
    if (metric.id === BIOMETRIC_TYPE.BLOOD_PRESSURE && ((_b = metric.values.data[0]) == null ? void 0 : _b.value) !== void 0 && ((_c = metric.values.data[1]) == null ? void 0 : _c.value) !== void 0) {
      value = `${(_d = metric.values.data[0]) == null ? void 0 : _d.value}/${(_e = metric.values.data[1]) == null ? void 0 : _e.value}`;
    }
    return {
      name: metric.metricDisplayName,
      id: metric.id,
      value,
      // images are optional from the response, so setting our backup here
      image: ((_f = metric.values.data[0]) == null ? void 0 : _f.imageUrl) || handleStaticAsset14(
        "HEALTH_METRIC_ICON" /* HEALTH_METRIC_ICON */
      ),
      measurementSymbol: (_g = metric.values.data[0]) == null ? void 0 : _g.config.data.unit.symbol,
      measurementName: (_h = metric.values.data[0]) == null ? void 0 : _h.config.data.unit.name,
      timeStamp: (_i = metric.values.data[0]) == null ? void 0 : _i.timestamp
    };
  });
  return healthMetrics;
}
function useGetLatestHealthMetrics(params) {
  return useGetHealthMetricsV2(params, {
    select: getFormattedData2
  });
}

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-list-wrapper/biometric-card-list-wrapper.component.tsx
import { styled as styled10 } from "@leagueplatform/genesis-core";

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-trigger/biometric-card-trigger.component.tsx
import React41 from "react";
import {
  HeadingText as HeadingText26,
  TextAction as TextAction9,
  Card as Card7,
  useClickableCard as useClickableCard4
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME33 } from "@leagueplatform/analytics";
import { NavLink as NavLink2, useLocation as useLocation6 } from "react-router-dom";

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-data/biometric-card-data.component.tsx
import { UtilityText as UtilityText26, StackLayout as StackLayout51, Icon as Icon17 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl67 } from "@leagueplatform/locales";
import { jsx as jsx88, jsxs as jsxs60 } from "react/jsx-runtime";
var BiometricCardData = ({
  metric
}) => {
  const targetId = useTargetUserId();
  const { timeZone } = useGetTargetUserInfo(targetId);
  const { value, measurementSymbol, measurementName, timeStamp, image } = metric;
  const { formatDate } = useIntl67();
  const date = formatDate(timeStamp, getShortDateTimeZone(timeZone));
  const measurement = measurementSymbol || measurementName;
  return /* @__PURE__ */ jsxs60(
    StackLayout51,
    {
      "data-testid": "biometric-card-data",
      orientation: "horizontal",
      css: { width: "100%" },
      children: [
        /* @__PURE__ */ jsx88(Icon17, { icon: image }),
        /* @__PURE__ */ jsxs60(
          StackLayout51,
          {
            orientation: "horizontal",
            verticalAlignment: "bottom",
            css: { width: "100%", marginLeft: "$half" },
            children: [
              /* @__PURE__ */ jsxs60(StackLayout51, { orientation: "horizontal", verticalAlignment: "bottom", children: [
                /* @__PURE__ */ jsx88(
                  UtilityText26,
                  {
                    css: {
                      typography: "$headingTwo",
                      marginRight: "$half",
                      lineHeight: "$none"
                    },
                    children: value
                  }
                ),
                /* @__PURE__ */ jsx88(UtilityText26, { css: { typography: "$caption" }, children: measurement })
              ] }),
              /* @__PURE__ */ jsx88(UtilityText26, { css: { typography: "$caption" }, children: date })
            ]
          }
        )
      ]
    }
  );
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-trigger/biometric-card-trigger.component.tsx
import { jsx as jsx89, jsxs as jsxs61 } from "react/jsx-runtime";
var BiometricCardTrigger = ({ metric }) => {
  const { pathname } = useLocation6();
  const cleanUrl = metric.id.replace(/_/g, "-");
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard4();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    detail: "view biometric details" /* VIEW_BIOMETRIC_DETAILS */
  });
  const sendPageTriggerAnalyticsEvent = React41.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME33.BUTTON_CLICKED, {
      sub_detail: metric.name
    }),
    [sendAnalyticsEvent, metric]
  );
  return /* @__PURE__ */ jsx89(Card7.Flat, { css: { width: "100%" }, children: /* @__PURE__ */ jsx89(
    Card7.ClickArea,
    {
      ref: clickAreaRef,
      onCardMouseDown,
      onCardMouseUp,
      children: /* @__PURE__ */ jsxs61(BoxBorder, { children: [
        /* @__PURE__ */ jsx89(
          TextAction9,
          {
            as: NavLink2,
            to: `${pathname}/${cleanUrl}`,
            ref: primaryActionRef,
            onClick: sendPageTriggerAnalyticsEvent,
            css: {
              textAlign: "left"
            },
            children: /* @__PURE__ */ jsx89(
              HeadingText26,
              {
                emphasis: "base",
                level: "3",
                size: "sm",
                css: { marginBottom: "$one" },
                children: metric.name
              }
            )
          }
        ),
        /* @__PURE__ */ jsx89(BiometricCardData, { metric })
      ] })
    }
  ) });
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-no-data/biometric-card-no-data.component.tsx
import {
  StackLayout as StackLayout52,
  Card as Card8,
  HeadingText as HeadingText27,
  Icon as Icon18,
  UtilityText as UtilityText27
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl68 } from "@leagueplatform/locales";
import { jsx as jsx90, jsxs as jsxs62 } from "react/jsx-runtime";
var BiometricCardNoData = ({
  name,
  icon
}) => {
  const { formatMessage } = useIntl68();
  return /* @__PURE__ */ jsx90(BoxBorder, { children: /* @__PURE__ */ jsxs62(Card8.Flat, { css: { width: "100%" }, "data-testid": "biometric-card-no-data", children: [
    /* @__PURE__ */ jsx90(
      HeadingText27,
      {
        emphasis: "base",
        level: "3",
        size: "sm",
        css: { marginBottom: "$one" },
        children: name
      }
    ),
    /* @__PURE__ */ jsxs62(StackLayout52, { orientation: "horizontal", verticalAlignment: "center", children: [
      /* @__PURE__ */ jsx90(Icon18, { icon }),
      /* @__PURE__ */ jsx90(UtilityText27, { css: { typography: "$caption", marginLeft: "$half" }, children: formatMessage({ id: "NO_DATA_AVAILABLE" }) })
    ] })
  ] }) });
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-modal-trigger/biometric-card-modal-trigger.component.tsx
import React42, { useState as useState9 } from "react";
import {
  HeadingText as HeadingText29,
  Modal as Modal8,
  TextAction as TextAction10,
  Card as Card9,
  useClickableCard as useClickableCard5
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME34 } from "@leagueplatform/analytics";

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-details-modal/biometric-details-modal.component.tsx
import {
  Box as Box46,
  Button as Button10,
  HeadingText as HeadingText28,
  Modal as Modal7,
  StackLayout as StackLayout54,
  Icon as Icon19
} from "@leagueplatform/genesis-core";
import {
  LoadingIndicator as LoadingIndicator24,
  ErrorState as ErrorState22
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl70 } from "@leagueplatform/locales";

// src/pages/member-assessments-dashboards-page/components/biometrics/components/health-metric-data-item/health-metric-data-item.component.tsx
import {
  ParagraphText as ParagraphText24,
  UtilityText as UtilityText28,
  StackLayout as StackLayout53,
  Box as Box45,
  styled as styled9
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl69 } from "@leagueplatform/locales";
import { jsx as jsx91, jsxs as jsxs63 } from "react/jsx-runtime";
var StyledListItem = styled9("li", {
  padding: "$one $none",
  listStyle: "none",
  "&:not(:last-child)": {
    borderBottomColor: "$onSurfaceBorderSubdued",
    borderBottomStyle: "solid",
    borderBottomWidth: "$thin"
  }
});
var HealthMetricDataItem = ({
  metric,
  timeZone,
  displayConfigName
}) => {
  var _a;
  const { formatDate } = useIntl69();
  return /* @__PURE__ */ jsx91(StyledListItem, { children: /* @__PURE__ */ jsxs63(
    StackLayout53,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      children: [
        /* @__PURE__ */ jsxs63(Box45, { children: [
          /* @__PURE__ */ jsxs63(UtilityText28, { css: { typography: "$subtitleOne" }, children: [
            metric.value,
            " ",
            (_a = metric.config.data.unit) == null ? void 0 : _a.symbol,
            displayConfigName ? /* @__PURE__ */ jsx91(Box45, { as: "span", "data-testid": "config-display-name", children: ` (${metric.config.data.name.toLocaleLowerCase()})` }) : null
          ] }),
          /* @__PURE__ */ jsx91(ParagraphText24, { css: { typography: "$label" }, emphasis: "subtle", children: metric.source })
        ] }),
        /* @__PURE__ */ jsx91(ParagraphText24, { emphasis: "subtle", children: formatDate(metric.timestamp, getShortDateTimeZone(timeZone)) })
      ]
    }
  ) });
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-details-modal/biometric-details-modal.component.tsx
import { Fragment as Fragment16, jsx as jsx92, jsxs as jsxs64 } from "react/jsx-runtime";
var BiometricDetailsModal = ({
  healthMetric,
  icon
}) => {
  const { formatMessage } = useIntl70();
  const targetUserId = useTargetUserId();
  const targetId = targetUserId;
  const { timeZone } = useGetTargetUserInfo(targetId);
  const {
    isError,
    isLoading,
    isSuccess,
    data: healthMetrics,
    error
  } = useGetHealthMetricsV2({
    interval: BIOMETRIC_API_FILTERS.ALL,
    filter: { type: healthMetric, userId: targetUserId },
    page: { size: BIOMETRIC_API_FILTERS.DISPLAY_NUMBER }
  });
  const isIdle = simulateIsIdle(isLoading, isSuccess, healthMetrics);
  if (isError)
    return /* @__PURE__ */ jsx92(
      Modal7.Content,
      {
        layout: "right",
        width: `${MODAL_POPOUT_WIDTH}rem`,
        padding: "$twoAndHalf",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx92(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx92(
          ErrorState22,
          {
            error,
            headingString: formatMessage({
              id: "SOMETHING_WENT_WRONG_HEADING"
            }),
            bodyString: formatMessage(
              { id: "SOMETHING_WENT_WRONG_BODY" },
              { br: /* @__PURE__ */ jsx92("br", {}) }
            )
          }
        ) })
      }
    );
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx92(
      Modal7.Content,
      {
        layout: "right",
        width: `${MODAL_POPOUT_WIDTH}rem`,
        padding: "$twoAndHalf",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx92(LoadingIndicator24, { inline: true })
      }
    );
  const healthMetricData = healthMetrics.data[0];
  const firstConfigName = healthMetricData.configs.data[0].name;
  const displayConfigName = Boolean(healthMetricData.configs.data.length) && !healthMetricData.configs.data.every(
    (metricConfig) => metricConfig.name === firstConfigName
  );
  return /* @__PURE__ */ jsxs64(
    Modal7.Content,
    {
      layout: "right",
      width: `${MODAL_POPOUT_WIDTH}rem`,
      padding: "$twoAndHalf",
      showCloseButton: false,
      children: [
        /* @__PURE__ */ jsx92(Modal7.Close, { children: /* @__PURE__ */ jsx92(
          StackLayout54,
          {
            orientation: "horizontal",
            horizontalAlignment: "start",
            css: { marginBottom: "$two", width: "100%" },
            children: /* @__PURE__ */ jsx92(
              Button10,
              {
                size: "small",
                priority: "secondary",
                quiet: true,
                icon: "tinyClose",
                hideLabel: true,
                children: formatMessage({ id: "CLOSE_MODAL" })
              }
            )
          }
        ) }),
        /* @__PURE__ */ jsx92(Modal7.Title, { children: /* @__PURE__ */ jsxs64(Fragment16, { children: [
          /* @__PURE__ */ jsx92(Icon19, { size: "$three", icon }),
          /* @__PURE__ */ jsx92(
            HeadingText28,
            {
              level: "2",
              size: "xl",
              css: {
                marginBottom: "$twoAndHalf",
                marginTop: "$threeQuarters"
              },
              children: healthMetricData.metricDisplayName
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx92(Modal7.Description, { children: /* @__PURE__ */ jsx92(Box46, { as: "ul", children: healthMetricData.values.data.map((metric, i) => {
          const key = `${metric.id}-${i}`;
          return /* @__PURE__ */ jsx92(
            HealthMetricDataItem,
            {
              timeZone,
              metric,
              displayConfigName
            },
            key
          );
        }) }) })
      ]
    }
  );
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-modal-trigger/biometric-card-modal-trigger.component.tsx
import { jsx as jsx93, jsxs as jsxs65 } from "react/jsx-runtime";
var BiometricCardModalTrigger = ({
  metric
}) => {
  const [modalOpen, setModalOpen] = useState9(false);
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard5();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    detail: "view biometric details" /* VIEW_BIOMETRIC_DETAILS */
  });
  const sendModalTriggerAnalyticsEvent = React42.useCallback(
    () => sendAnalyticsEvent(EVENT_NAME34.BUTTON_CLICKED, {
      sub_detail: metric.name
    }),
    [sendAnalyticsEvent, metric]
  );
  return /* @__PURE__ */ jsxs65(
    Modal8.Root,
    {
      open: modalOpen,
      onOpenChange: () => {
        setModalOpen((previous) => !previous);
      },
      children: [
        /* @__PURE__ */ jsx93(Card9.Flat, { css: { width: "100%" }, children: /* @__PURE__ */ jsx93(
          Card9.ClickArea,
          {
            ref: clickAreaRef,
            onCardMouseDown,
            onCardMouseUp,
            children: /* @__PURE__ */ jsxs65(BoxBorder, { children: [
              /* @__PURE__ */ jsx93(Modal8.Trigger, { children: /* @__PURE__ */ jsx93(
                TextAction10,
                {
                  as: "button",
                  ref: primaryActionRef,
                  onClick: sendModalTriggerAnalyticsEvent,
                  css: {
                    textAlign: "left"
                  },
                  children: /* @__PURE__ */ jsx93(
                    HeadingText29,
                    {
                      emphasis: "base",
                      level: "3",
                      size: "sm",
                      css: { marginBottom: "$one" },
                      children: metric.name
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsx93(BiometricCardData, { metric })
            ] })
          }
        ) }),
        modalOpen && /* @__PURE__ */ jsx93(BiometricDetailsModal, { healthMetric: metric.id, icon: metric.image })
      ]
    }
  );
};

// src/pages/member-assessments-dashboards-page/components/biometrics/components/biometric-card-list-wrapper/biometric-card-list-wrapper.component.tsx
import { jsx as jsx94, jsxs as jsxs66 } from "react/jsx-runtime";
var FlexListItem = styled10("li", {
  display: "flex",
  width: "calc(50% - 1.2rem)"
});
var BiometricCardListWrapper = ({
  metric
}) => {
  const { enableBiometricsV2 } = useCustomerSupportConfig();
  return /* @__PURE__ */ jsxs66(FlexListItem, { children: [
    !enableBiometricsV2 && (metric.value ? /* @__PURE__ */ jsx94(BiometricCardModalTrigger, { metric }) : /* @__PURE__ */ jsx94(BiometricCardNoData, { name: metric.name, icon: metric.image })),
    enableBiometricsV2 && (metric.value ? /* @__PURE__ */ jsx94(BiometricCardTrigger, { metric }) : /* @__PURE__ */ jsx94(BiometricCardNoData, { name: metric.name, icon: metric.image }))
  ] });
};

// src/pages/member-assessments-dashboards-page/components/biometrics/biometrics-content.component.tsx
import { jsx as jsx95 } from "react/jsx-runtime";
var BiometricsContent = ({ date }) => {
  const { formatMessage } = useIntl71();
  const targetUserId = useTargetUserId();
  const biometrics = Object.values(BIOMETRIC_TYPE).toString();
  const {
    isError,
    isLoading,
    isSuccess,
    data: healthMetrics
  } = useGetLatestHealthMetrics({
    interval: BIOMETRIC_API_FILTERS.INSTANT,
    filter: { type: biometrics, userId: targetUserId },
    from: date.toISOString()
  });
  const isIdle = simulateIsIdle(isLoading, isSuccess, healthMetrics);
  if (isError)
    return /* @__PURE__ */ jsx95(ParagraphText25, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "CS_ERROR_BODY" }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx95(StackItem11, { css: { margin: "auto" }, children: /* @__PURE__ */ jsx95(LoadingIndicator25, { inline: true }) });
  const hasBiometricData = healthMetrics.some(
    (metric) => metric.value !== void 0
  );
  return /* @__PURE__ */ jsx95(StackLayout55, { css: { width: "100%" }, children: hasBiometricData ? /* @__PURE__ */ jsx95(
    StackLayout55,
    {
      as: "ul",
      orientation: "horizontal",
      css: {
        flexWrap: "wrap",
        gap: "$one"
      },
      children: healthMetrics.map((metric) => /* @__PURE__ */ jsx95(BiometricCardListWrapper, { metric }, metric.id))
    }
  ) : /* @__PURE__ */ jsx95(ParagraphText25, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "CS_BIOMETRICS_EMPTY_MESSAGE" }) }) });
};

// src/pages/member-assessments-dashboards-page/components/biometrics/biometrics.component.tsx
import { jsx as jsx96, jsxs as jsxs67 } from "react/jsx-runtime";
var Biometrics = ({ date }) => {
  const { formatMessage } = useIntl72();
  return /* @__PURE__ */ jsxs67(
    StackLayout56,
    {
      "data-testid": "biometrics",
      as: "section",
      css: { marginTop: "$twoAndHalf" },
      children: [
        /* @__PURE__ */ jsx96(HeadingText30, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: formatMessage({ id: "BIOMETRICS" }) }),
        /* @__PURE__ */ jsx96(BiometricsContent, { date })
      ]
    }
  );
};

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/health-risk-assessments.component.tsx
import * as React43 from "react";
import { useIntl as useIntl75 } from "@leagueplatform/locales";
import { StackLayout as StackLayout60, HeadingText as HeadingText31 } from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME35 } from "@leagueplatform/analytics";

// src/components/heading-with-tooltip-modal/heading-with-tooltip-modal.component.tsx
import { StackLayout as StackLayout57, Modal as Modal9, Button as Button11 } from "@leagueplatform/genesis-core";
import { jsx as jsx97, jsxs as jsxs68 } from "react/jsx-runtime";
var HeadingWithTooltipModal = ({
  children,
  tooltipTitle,
  tooltipContents,
  tooltipButtonName,
  onClick
}) => /* @__PURE__ */ jsxs68(StackLayout57, { orientation: "horizontal", children: [
  children,
  /* @__PURE__ */ jsxs68(Modal9.Root, { onOpenChange: (open) => onClick(open), children: [
    /* @__PURE__ */ jsx97(Modal9.Trigger, { children: /* @__PURE__ */ jsx97(
      Button11,
      {
        hideLabel: true,
        quiet: true,
        priority: "secondary",
        size: "small",
        icon: "interfaceQuestionCircle",
        children: tooltipButtonName
      }
    ) }),
    /* @__PURE__ */ jsx97(
      CustomerSupportModal,
      {
        title: tooltipTitle,
        description: tooltipContents
      }
    )
  ] })
] });

// src/components/list-modal-content/list-modal-content.component.tsx
import { UtilityText as UtilityText29, StackLayout as StackLayout58, Box as Box47 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl73 } from "@leagueplatform/locales";
import { jsx as jsx98, jsxs as jsxs69 } from "react/jsx-runtime";
var DefinitionListItem = ({ title, content }) => /* @__PURE__ */ jsxs69(
  UtilityText29,
  {
    as: "li",
    css: {
      typography: "$bodyOne",
      color: "$onSurfaceTextSubdued",
      lineHeight: ""
    },
    children: [
      /* @__PURE__ */ jsxs69(Box47, { as: "span", css: { fontWeight: "700" }, children: [
        title,
        ":",
        " "
      ] }),
      content
    ]
  }
);
var ListModalContent = ({ items }) => {
  const { formatMessage } = useIntl73();
  return /* @__PURE__ */ jsx98(StackLayout58, { as: "ul", spacing: "$half", children: items.map((item, i) => {
    const { title, content } = item;
    const key = `${title}-${i}`;
    return /* @__PURE__ */ jsx98(
      DefinitionListItem,
      {
        title: formatMessage({ id: title }),
        content: formatMessage({ id: content })
      },
      key
    );
  }) });
};

// src/pages/member-assessments-dashboards-page/constants/status-modal-definitions.ts
var consentFormsStatusDefinitions = [
  {
    title: "COMPLETED",
    content: "CS_COMPLETED_DEFINITION"
  },
  {
    title: "REJECTED",
    content: "CS_REJECTED_DEFINITION"
  }
];
var assessmentsStatusDefinitions = [
  {
    title: "NOT_STARTED",
    content: "CS_NOT_STARTED_DEFINITION"
  },
  {
    title: "IN_PROGRESS",
    content: "CS_IN_PROGRESS_DEFINITION"
  },
  {
    title: "COMPLETED",
    content: "CS_COMPLETED_DEFINITION"
  }
];

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/health-risk-assessments-content.component.tsx
import { useIntl as useIntl74 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout59,
  ParagraphText as ParagraphText26,
  StackItem as StackItem12
} from "@leagueplatform/genesis-core";
import { LoadingIndicator as LoadingIndicator26 } from "@leagueplatform/web-common-components";

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/hooks/use-get-health-risk-assessments.hook.ts
import {
  HealthRiskAssessmentsStatus as HealthRiskAssessmentsStatus3
} from "@leagueplatform/cse-customer-support-api";

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/hooks/use-get-health-risk-assessments-query.hook.ts
import { useQuery as useQuery19 } from "@tanstack/react-query";
import { captureError as captureError18 } from "@leagueplatform/observability";
import {
  getHealthRiskAssessments,
  GET_HEALTH_RISK_ASSESSMENTS
} from "@leagueplatform/cse-customer-support-api";
function useGetHealthRiskAssessmentsQuery(userId, options) {
  return useQuery19(
    [GET_HEALTH_RISK_ASSESSMENTS, userId],
    () => getHealthRiskAssessments(userId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError18(
          new Error(
            `Customer Support: Failed to get Health Risk Assessments data: ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/hooks/use-get-health-risk-assessments.hook.ts
function selectHeaHealthRiskAssessments({
  data
}) {
  if (!data.length)
    return data;
  return data.filter(
    (assessment) => Object.values(HealthRiskAssessmentsStatus3).map(
      (status2) => assessment.attributes.status.includes(status2)
    )
  );
}
function useGetHealthRiskAssessments(targetUserId) {
  const userId = targetUserId;
  return useGetHealthRiskAssessmentsQuery(userId, {
    select: selectHeaHealthRiskAssessments
  });
}

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/health-risk-assessments-content.component.tsx
import { jsx as jsx99 } from "react/jsx-runtime";
var { Name: Name2, CompletionDate: CompletionDate2, Status: Status4 } = HealthRiskAssessmentsColumnNames;
var tableColumnArray4 = [Name2, CompletionDate2, Status4];
var HealthRiskAssessmentsContent = ({
  targetUserId,
  timeZone
}) => {
  const {
    data: healthRiskAssessments,
    isError,
    isLoading,
    isSuccess
  } = useGetHealthRiskAssessments(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, healthRiskAssessments);
  const healthRiskAssessmentsLength = healthRiskAssessments == null ? void 0 : healthRiskAssessments.length;
  const { formatMessage } = useIntl74();
  const columns = tableColumnArray4.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  const rows = healthRiskAssessments ? generateHealthRiskAssessmentsListRows(healthRiskAssessments, timeZone) : [];
  if (isError)
    return /* @__PURE__ */ jsx99(ParagraphText26, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "CS_ERROR_BODY" }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx99(StackItem12, { css: { margin: "auto" }, children: /* @__PURE__ */ jsx99(LoadingIndicator26, { inline: true }) });
  return /* @__PURE__ */ jsx99(StackLayout59, { css: { width: "100%" }, children: !healthRiskAssessmentsLength ? /* @__PURE__ */ jsx99(ParagraphText26, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "CS_HEALTH_ASSESSMENTS_EMPTY_MESSAGE" }) }) : /* @__PURE__ */ jsx99(CSTable, { columns, rows, columnWidth: "auto" }) });
};

// src/pages/member-assessments-dashboards-page/components/health-risk-assessments/health-risk-assessments.component.tsx
import { jsx as jsx100, jsxs as jsxs70 } from "react/jsx-runtime";
var HealthRiskAssessments = ({
  targetUserId,
  timeZone
}) => {
  const { formatMessage } = useIntl75();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    detail: "health risk forms more information" /* HEALTH_RISK_FORMS_INFO */
  });
  const sendButtonClickedAnalyticsEvent = React43.useCallback(
    (open) => sendAnalyticsEvent(EVENT_NAME35.BUTTON_CLICKED, {
      sub_detail: open ? "open modal" /* OPEN_MODAL */ : "close modal" /* CLOSE_MODAL */
    }),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsxs70(
    StackLayout60,
    {
      as: "section",
      "data-testid": "assessments",
      css: { marginTop: "$twoAndHalf" },
      children: [
        /* @__PURE__ */ jsx100(
          HeadingWithTooltipModal,
          {
            tooltipButtonName: formatMessage({
              id: "CS_HEALTH_ASSESSMENTS_STATUS_DEFINITIONS"
            }),
            tooltipContents: /* @__PURE__ */ jsx100(ListModalContent, { items: assessmentsStatusDefinitions }),
            tooltipTitle: formatMessage({ id: "CS_HEALTH_ASSESSMENTS_TITLE" }),
            onClick: sendButtonClickedAnalyticsEvent,
            children: /* @__PURE__ */ jsx100(HeadingText31, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: formatMessage({ id: "CS_HEALTH_ASSESSMENTS_TITLE" }) })
          }
        ),
        /* @__PURE__ */ jsx100(
          HealthRiskAssessmentsContent,
          {
            targetUserId,
            timeZone
          }
        )
      ]
    }
  );
};

// src/pages/member-assessments-dashboards-page/components/consent-forms/consent-forms.component.tsx
import * as React44 from "react";
import { StackLayout as StackLayout61, HeadingText as HeadingText32 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl77 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME36 } from "@leagueplatform/analytics";

// src/pages/member-assessments-dashboards-page/components/consent-forms/consent-forms-content.component.tsx
import {
  ParagraphText as ParagraphText27,
  StatusBanner as StatusBanner6,
  StackItem as StackItem13
} from "@leagueplatform/genesis-core";
import { LoadingIndicator as LoadingIndicator27 } from "@leagueplatform/web-common-components";
import { useIntl as useIntl76 } from "@leagueplatform/locales";

// src/pages/member-assessments-dashboards-page/components/consent-forms/hooks/use-get-user-consents.hook.ts
import {
  UserConsentStatus as UserConsentStatus3
} from "@leagueplatform/cse-customer-support-api";

// src/pages/member-assessments-dashboards-page/components/consent-forms/hooks/use-get-user-consents-query.hook.ts
import { useQuery as useQuery20 } from "@tanstack/react-query";
import { captureError as captureError19 } from "@leagueplatform/observability";
import {
  GET_USER_CONSENTS,
  getUserConsents
} from "@leagueplatform/cse-customer-support-api";
function useGetUserConsentQuery(userId, options) {
  return useQuery20(
    [GET_USER_CONSENTS, userId],
    () => getUserConsents(userId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError19(
          new Error(
            `Customer Support: Failed to get User Consents data: ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-assessments-dashboards-page/components/consent-forms/hooks/use-get-user-consents.hook.ts
function selectGetUserConsentQuery({ data }) {
  if (!data.length)
    return data;
  return data.filter(
    (consent) => Object.values(UserConsentStatus3).map(
      (status2) => consent.attributes.status.includes(status2)
    )
  );
}
function useGetUserConsents(targetUserId) {
  const userId = targetUserId;
  return useGetUserConsentQuery(userId, {
    select: selectGetUserConsentQuery
  });
}

// src/pages/member-assessments-dashboards-page/components/consent-forms/consent-forms-content.component.tsx
import { Fragment as Fragment17, jsx as jsx101, jsxs as jsxs71 } from "react/jsx-runtime";
var { FormName: FormName2, FormCompletionDate: FormCompletionDate2, FormValidationPeriod: FormValidationPeriod2, FormStatus: FormStatus2 } = ConsentFormColumnNames;
var tableColumnArray5 = [
  FormName2,
  FormCompletionDate2,
  FormValidationPeriod2,
  FormStatus2
];
var ConsentFormsContent = ({
  targetUserId,
  timeZone
}) => {
  const { formatMessage } = useIntl76();
  const {
    data: userConsents,
    isError,
    isLoading,
    isSuccess
  } = useGetUserConsents(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, userConsents);
  const tableColumns = tableColumnArray5.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column })
  }));
  if (isError)
    return /* @__PURE__ */ jsx101(ParagraphText27, { css: { typography: "$bodyOne" }, children: formatMessage({ id: "CS_ERROR_BODY" }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx101(StackItem13, { css: { margin: "auto" }, children: /* @__PURE__ */ jsx101(LoadingIndicator27, { inline: true }) });
  const hasConsentForms = userConsents.length > 0;
  const tableRows = hasConsentForms ? generateConsentFormListRows(userConsents, timeZone) : [];
  const today2 = /* @__PURE__ */ new Date();
  const consentWithinValidationPeriod = userConsents == null ? void 0 : userConsents.some(
    (c) => today2 >= new Date(c.attributes.validationPeriodStart) && today2 <= new Date(c.attributes.validationPeriodEnd)
  );
  const showBanner = !hasConsentForms || !consentWithinValidationPeriod;
  return /* @__PURE__ */ jsxs71(Fragment17, { children: [
    showBanner && /* @__PURE__ */ jsx101(
      StatusBanner6,
      {
        showIcon: true,
        status: "info",
        css: {
          width: "100%",
          marginBottom: `${hasConsentForms && "$one"}`
        },
        title: !hasConsentForms ? formatMessage({
          id: "CS_EMPTY_CONSENT_FORMS_TITLE"
        }) : formatMessage({
          id: "CS_NO_CONSENTS_IN_VALIDATION_PERIOD"
        }),
        children: !hasConsentForms && /* @__PURE__ */ jsx101(ParagraphText27, { children: formatMessage({ id: "CS_EMPTY_CONSENT_FORMS_BODY" }) })
      }
    ),
    hasConsentForms && /* @__PURE__ */ jsx101(CSTable, { columns: tableColumns, rows: tableRows, columnWidth: "25%" })
  ] });
};

// src/pages/member-assessments-dashboards-page/components/consent-forms/consent-forms.component.tsx
import { jsx as jsx102, jsxs as jsxs72 } from "react/jsx-runtime";
var ConsentForms = ({ targetUserId, timeZone }) => {
  const { formatMessage } = useIntl77();
  const sendAnalyticsEvent = useTrackAnalyticsEvent({
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */,
    detail: "consent forms more information" /* CONSENT_FORMS_INFO */
  });
  const sendButtonClickedAnalyticsEvent = React44.useCallback(
    (open) => sendAnalyticsEvent(EVENT_NAME36.BUTTON_CLICKED, {
      sub_detail: open ? "open modal" /* OPEN_MODAL */ : "close modal" /* CLOSE_MODAL */
    }),
    [sendAnalyticsEvent]
  );
  return /* @__PURE__ */ jsxs72(StackLayout61, { "data-testid": "consent-forms", as: "section", children: [
    /* @__PURE__ */ jsx102(
      HeadingWithTooltipModal,
      {
        tooltipButtonName: formatMessage({
          id: "CS_CONSENT_FORMS_STATUS_DEFINITIONS"
        }),
        tooltipContents: /* @__PURE__ */ jsx102(ListModalContent, { items: consentFormsStatusDefinitions }),
        tooltipTitle: formatMessage({ id: "CS_CONSENT_FORMS" }),
        onClick: sendButtonClickedAnalyticsEvent,
        children: /* @__PURE__ */ jsx102(HeadingText32, { level: "2", size: "xl", css: { marginBottom: "$one" }, children: formatMessage({ id: "CS_CONSENT_FORMS" }) })
      }
    ),
    /* @__PURE__ */ jsx102(ConsentFormsContent, { targetUserId, timeZone })
  ] });
};

// src/pages/member-assessments-dashboards-page/member-assessments-dashboards-page.component.tsx
import { Fragment as Fragment18, jsx as jsx103, jsxs as jsxs73 } from "react/jsx-runtime";
var MemberAssessmentsDashboards = ({
  canShowConsentForms,
  canShowAssessments,
  canShowBiometrics
}) => {
  const { formatMessage } = useIntl78();
  const targetUserId = useTargetUserId();
  const targetId = targetUserId;
  const isViewConsentEnabled = useCustomerSupportConfig("enableAssessmentsAndDashboards.enableConsents") && canShowConsentForms;
  const isViewHRAEnabled = useCustomerSupportConfig("enableAssessmentsAndDashboards.enableHra") && canShowAssessments;
  const isViewBiometricsEnabled = useCustomerSupportConfig(
    "enableAssessmentsAndDashboards.enableBiometrics"
  ) && canShowBiometrics;
  const { timeZone, isError, isLoading, error } = useGetTargetUserInfo(targetId);
  const today2 = /* @__PURE__ */ new Date();
  usePageViewAnalytics11({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */
  });
  if (isError)
    return /* @__PURE__ */ jsx103(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx103(
      ErrorState23,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx103("br", {}) }
        )
      }
    ) });
  if (isLoading)
    return /* @__PURE__ */ jsx103(LoadingIndicator28, { inline: true });
  return /* @__PURE__ */ jsxs73(Fragment18, { children: [
    isViewConsentEnabled && /* @__PURE__ */ jsx103(ConsentForms, { targetUserId, timeZone }),
    isViewHRAEnabled && /* @__PURE__ */ jsx103(
      HealthRiskAssessments,
      {
        targetUserId,
        timeZone
      }
    ),
    isViewBiometricsEnabled && /* @__PURE__ */ jsx103(Biometrics, { date: today2 })
  ] });
};

// src/pages/member-standard-program-detail-page/member-standard-program-detail-page.component.tsx
import {
  LoadingIndicator as LoadingIndicator31,
  ErrorState as ErrorState26
} from "@leagueplatform/web-common-components";
import { usePageViewAnalytics as usePageViewAnalytics12 } from "@leagueplatform/analytics";
import { useIntl as useIntl82 } from "@leagueplatform/locales";

// src/pages/member-standard-program-detail-page/hooks/use-get-standard-details-query.hook.ts
import { useQuery as useQuery21 } from "@tanstack/react-query";
import {
  getHealthGoalProgram,
  GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import { captureError as captureError20 } from "@leagueplatform/observability";
function useGetStandardProgramDetailsQuery(userId, programId, userProgramId, options) {
  return useQuery21(
    [
      GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
      programId,
      userProgramId,
      userId
    ],
    () => getHealthGoalProgram(programId, void 0, userProgramId, userId),
    __spreadValues({
      staleTime: Infinity,
      onError: (error) => {
        captureError20(
          new Error(
            `Customer Support: Failed to get standard program (programId: ${programId}, userProgramId: ${userProgramId}): ${error}`
          )
        );
      }
    }, options)
  );
}

// src/pages/member-standard-program-detail-page/hooks/use-get-standard-details.hook.ts
function selectFormattedData({
  program: {
    name,
    total_activities_count,
    activity_status_counts,
    start_date,
    program_id,
    end_date,
    status: status2,
    long_description,
    goals,
    quit_date,
    health_activities_aggregates: activities,
    user_program_id
  }
}) {
  const newActivities = activities.map((activity) => {
    var _a;
    if (goals === null)
      return __spreadValues({}, activity);
    const { name: activityName } = (_a = goals.find((goal) => goal.goal_id === activity.contentful_id)) != null ? _a : {};
    return __spreadProps(__spreadValues({}, activity), {
      name: activityName,
      dateCompleted: activity.completed_date
    });
  });
  const isDynamicCampaign = newActivities.find(
    (activity) => activity.is_dynamic_campaign === true
  );
  const standardProgram = {
    name,
    programProgress: {
      total: total_activities_count,
      completed: (activity_status_counts == null ? void 0 : activity_status_counts.completed) || 0
    },
    description: long_description,
    activities: newActivities,
    userHealthCampaignId: user_program_id,
    isDynamicCampaign
  };
  const sideDetails = {
    joinedDate: start_date,
    programId: program_id,
    completionDate: end_date,
    quitDate: quit_date,
    status: status2
  };
  return { standardProgram, sideDetails };
}
function useGetStandardProgramDetails(targetUserId) {
  const userId = targetUserId;
  const { programId, userProgramId } = useCustomerSupportParams();
  return useGetStandardProgramDetailsQuery(
    userId,
    programId != null ? programId : "",
    userProgramId != null ? userProgramId : "",
    {
      select: selectFormattedData
    }
  );
}

// src/pages/member-standard-program-detail-page/components/standard-program-dynamic-wrapper/standard-program-dynamic.component.tsx
import { useIntl as useIntl81 } from "@leagueplatform/locales";
import {
  ErrorState as ErrorState25,
  LoadingIndicator as LoadingIndicator30
} from "@leagueplatform/web-common-components";

// src/pages/member-standard-program-detail-page/components/standard-program-section/standard-program-section.component.tsx
import { useIntl as useIntl79 } from "@leagueplatform/locales";
import { Box as Box48, HeadingText as HeadingText33 } from "@leagueplatform/genesis-core";
import { Fragment as Fragment19, jsx as jsx104, jsxs as jsxs74 } from "react/jsx-runtime";
var StandardProgramSection = ({
  description,
  activities
}) => {
  const { formatMessage } = useIntl79();
  return /* @__PURE__ */ jsxs74(Fragment19, { children: [
    description && /* @__PURE__ */ jsxs74(Fragment19, { children: [
      /* @__PURE__ */ jsx104(HeadingText33, { size: "xl", level: "2", css: { marginBottom: "$one" }, children: formatMessage({ id: "DETAILS" }) }),
      /* @__PURE__ */ jsx104(ProgramDetailDescription, { description })
    ] }),
    activities.length ? /* @__PURE__ */ jsx104(Box48, { as: "ul", children: activities.map(
      (activity) => {
        const { id, name, dateCompleted, status: status2 } = activity;
        return /* @__PURE__ */ jsx104(
          ActivityCardLink,
          {
            id,
            name,
            status: status2,
            dateCompleted,
            program: PROGRAM_TYPES.STANDARD
          },
          id
        );
      }
    ) }) : null
  ] });
};

// src/pages/member-standard-program-detail-page/components/standard-side-details/standard-side-details.component.tsx
import { useIntl as useIntl80 } from "@leagueplatform/locales";
import {
  LoadingIndicator as LoadingIndicator29,
  ErrorState as ErrorState24
} from "@leagueplatform/web-common-components";
import { StatusBadge as StatusBadge9, UtilityText as UtilityText30 } from "@leagueplatform/genesis-core";
import { Fragment as Fragment20, jsx as jsx105, jsxs as jsxs75 } from "react/jsx-runtime";
var StandardSideDetails = ({
  sideDetails,
  targetUserId,
  memberUsername
}) => {
  const { formatMessage, formatDate } = useIntl80();
  const { status: status2, joinedDate, completionDate, endDate, programId, quitDate } = sideDetails;
  const targetId = targetUserId;
  const { fullName, memberRelationship, timeZone, isLoading, isError, error } = useGetTargetUserInfo(targetId);
  const showProgramStatusBadge = useProgramStatusStyles(
    status2,
    timeZone,
    completionDate,
    endDate,
    quitDate
  );
  if (isLoading)
    return /* @__PURE__ */ jsx105(LoadingIndicator29, { inline: true });
  if (isError) {
    return /* @__PURE__ */ jsx105(
      ErrorState24,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx105("br", {}) }
        )
      }
    );
  }
  const dateToDisplay = getShortDateTimeZone(timeZone);
  const dateDetails = {
    label: formatMessage({ id: "JOINED_DATE" }),
    formattedStartDate: formatDate(joinedDate, dateToDisplay)
  };
  return /* @__PURE__ */ jsxs75(Fragment20, { children: [
    /* @__PURE__ */ jsx105(
      SideDetailCard,
      {
        header: fullName,
        member: memberRelationship,
        memberUsername
      }
    ),
    /* @__PURE__ */ jsxs75(SideDetailCard, { header: formatMessage({ id: "PROGRAM_DATES" }), children: [
      /* @__PURE__ */ jsx105(ShowDate, { details: dateDetails }),
      showProgramStatusBadge && /* @__PURE__ */ jsx105(
        StatusBadge9,
        {
          status: showProgramStatusBadge.badgeStatus,
          label: showProgramStatusBadge.text
        }
      )
    ] }),
    /* @__PURE__ */ jsx105(SideDetailCard, { header: formatMessage({ id: "IDENTIFICATION" }), children: /* @__PURE__ */ jsx105(UtilityText30, { children: formatMessage(
      { id: "CS_PROGRAM_ID_UNDERSCORE" },
      {
        programId
      }
    ) }) })
  ] });
};

// src/pages/member-standard-program-detail-page/hooks/use-get-user-health-activity-by-campaign-id.hook.ts
import { useQuery as useQuery22 } from "@tanstack/react-query";
import { getUserHealthActivityById as getUserHealthActivityById2 } from "@leagueplatform/health-journey-api";
import { captureError as captureError21 } from "@leagueplatform/observability";
var GET_USER_HEALTH_ACTIVITY_DATA_KEY2 = "userHealthActivityData";
var useGetUserHealthActivityByCampaignId = (userId, userHealthCampaignId, status2, sortBy, options) => useQuery22(
  [GET_USER_HEALTH_ACTIVITY_DATA_KEY2, userId, userHealthCampaignId],
  () => getUserHealthActivityById2(
    void 0,
    void 0,
    void 0,
    userId,
    userHealthCampaignId,
    status2,
    sortBy
  ),
  __spreadValues({
    staleTime: Infinity,
    onError: (error) => {
      captureError21(
        new Error(
          `Customer Support: Failed to get dynamic standard program activities by id (user: ${userId}, id: ${userHealthCampaignId}): ${error}`
        )
      );
    }
  }, options)
);

// src/pages/member-standard-program-detail-page/components/standard-program-dynamic-wrapper/standard-program-dynamic.component.tsx
import { jsx as jsx106 } from "react/jsx-runtime";
var StandardProgramDynamic = ({
  name,
  targetUserId,
  memberUsername,
  programProgress,
  sideDetails,
  description
}) => {
  const { formatMessage } = useIntl81();
  const { userProgramId: userHealthCampaignId } = useCustomerSupportParams();
  const userId = targetUserId;
  const { data, isError, isLoading, isSuccess, error } = useGetUserHealthActivityByCampaignId(userId, userHealthCampaignId != null ? userHealthCampaignId : "");
  const isIdle = simulateIsIdle(isLoading, isSuccess, data);
  const Header = /* @__PURE__ */ jsx106(DetailsHeader, { title: name, programProgress });
  const SideDetailsComponent = /* @__PURE__ */ jsx106(
    StandardSideDetails,
    {
      sideDetails,
      targetUserId,
      memberUsername
    }
  );
  if (isError)
    return /* @__PURE__ */ jsx106(
      DetailPageWrapper,
      {
        header: Header,
        mainSection: /* @__PURE__ */ jsx106(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx106(
          ErrorState25,
          {
            error,
            headingString: formatMessage({
              id: "SOMETHING_WENT_WRONG_HEADING"
            }),
            bodyString: formatMessage(
              { id: "SOMETHING_WENT_WRONG_BODY" },
              { br: /* @__PURE__ */ jsx106("br", {}) }
            )
          }
        ) }),
        sideDetailSection: SideDetailsComponent
      }
    );
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx106(
      DetailPageWrapper,
      {
        header: Header,
        mainSection: /* @__PURE__ */ jsx106(LoadingIndicator30, { inline: true }),
        sideDetailSection: SideDetailsComponent
      }
    );
  const dynamicActivities = data.data;
  return /* @__PURE__ */ jsx106(
    DetailPageWrapper,
    {
      header: Header,
      mainSection: /* @__PURE__ */ jsx106(
        StandardProgramSection,
        {
          description,
          activities: dynamicActivities
        }
      ),
      sideDetailSection: SideDetailsComponent
    }
  );
};

// src/pages/member-standard-program-detail-page/member-standard-program-detail-page.component.tsx
import { jsx as jsx107 } from "react/jsx-runtime";
var StandardProgramDetailPage = ({
  targetUserId,
  memberUsername
}) => {
  const { formatMessage } = useIntl82();
  const { data, isError, isLoading, isSuccess, error } = useGetStandardProgramDetails(targetUserId);
  const isIdle = simulateIsIdle(isLoading, isSuccess, data);
  usePageViewAnalytics12({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "standard program detail" /* STANDARD_PROGRAM_DETAIL */
  });
  if (isError)
    return /* @__PURE__ */ jsx107(PageLayout, { children: /* @__PURE__ */ jsx107(BoxBorder, { children: /* @__PURE__ */ jsx107(
      ErrorState26,
      {
        error,
        headingString: formatMessage({
          id: "SOMETHING_WENT_WRONG_HEADING"
        }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx107("br", {}) }
        )
      }
    ) }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx107(PageLayout, { children: /* @__PURE__ */ jsx107(LoadingIndicator31, { inline: true }) });
  const { standardProgram, sideDetails } = data;
  const { programProgress, name, isDynamicCampaign } = standardProgram;
  const isDynamicProgram = Boolean(isDynamicCampaign == null ? void 0 : isDynamicCampaign.is_dynamic_campaign);
  if (isDynamicProgram) {
    return /* @__PURE__ */ jsx107(
      StandardProgramDynamic,
      {
        name,
        programProgress,
        sideDetails,
        targetUserId,
        memberUsername,
        description: standardProgram.description
      }
    );
  }
  return /* @__PURE__ */ jsx107(
    DetailPageWrapper,
    {
      header: /* @__PURE__ */ jsx107(DetailsHeader, { title: name, programProgress }),
      mainSection: /* @__PURE__ */ jsx107(
        StandardProgramSection,
        {
          description: standardProgram.description,
          activities: standardProgram.activities
        }
      ),
      sideDetailSection: /* @__PURE__ */ jsx107(
        StandardSideDetails,
        {
          sideDetails,
          targetUserId,
          memberUsername
        }
      )
    }
  );
};

// src/pages/member-challenges-detail-page/member-challenges-detail-page.component.tsx
import {
  LoadingIndicator as LoadingIndicator34,
  ErrorState as ErrorState29
} from "@leagueplatform/web-common-components";
import { CHALLENGE_TYPE_SOLO } from "@leagueplatform/health-journey-common";
import { usePageViewAnalytics as usePageViewAnalytics13 } from "@leagueplatform/analytics";
import { useIntl as useIntl85 } from "@leagueplatform/locales";
import { useParams as useParams6 } from "@leagueplatform/routing";

// src/pages/member-challenges-detail-page/challenges-section/challenges-section.component.tsx
import {
  HeadingText as HeadingText34,
  ParagraphText as ParagraphText28,
  StackLayout as StackLayout62
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl83 } from "@leagueplatform/locales";
import {
  ErrorState as ErrorState27,
  LoadingIndicator as LoadingIndicator32
} from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset15 } from "@leagueplatform/asset-config";
import { useParams as useParams4 } from "@leagueplatform/routing";

// src/pages/member-challenges-detail-page/hooks/use-get-challenge-activity-data.hook.ts
function selectActivities({ data }) {
  if (!data)
    return data;
  const activities = data.map((activity, i) => {
    if (activity.status === "completed") {
      Object.assign(data[i], {
        displayDate: activity.dateCompleted
      });
    }
    if (activity.status === "active") {
      Object.assign(data[i], {
        displayDate: activity.startDate
      });
    }
    if (activity.status === "expired" || activity.status === "skipped") {
      Object.assign(data[i], {
        displayDate: activity.endDate
      });
    }
    return activity;
  });
  return activities;
}
function useGetChallengeActivityData(targetUserId, challengeId, status2, sortBy) {
  const userId = targetUserId;
  return useGetUserHealthActivityByCampaignId(
    userId,
    challengeId,
    status2,
    sortBy,
    {
      select: selectActivities
    }
  );
}

// src/pages/member-challenges-detail-page/challenges-section/challenges-section.component.tsx
import { jsx as jsx108, jsxs as jsxs76 } from "react/jsx-runtime";
function useTableData(activities, timeZone) {
  const { formatMessage } = useIntl83();
  const columnNames = ["Date", "Description", "Activity_ID", "Status"];
  const columns = columnNames.map((column) => ({
    id: `column-${column}`,
    name: column,
    value: formatMessage({ id: column.toLocaleUpperCase() })
  }));
  let rows = [];
  if (activities) {
    rows = generateChallengesActivityListRows(activities, columns, timeZone);
  }
  return { columns, rows };
}
var status = [
  "active",
  "upcoming",
  "completed",
  "removed",
  "expired",
  "suspended",
  "received"
];
var ChallengesSection = ({
  challengeDescription,
  timeZone,
  targetUserId
}) => {
  const { formatMessage } = useIntl83();
  const { challengeId } = useParams4();
  const sortBy = [
    "status",
    "-startDate",
    "-endDate"
  ];
  const {
    data: challengeActivities,
    isError,
    isLoading,
    isSuccess,
    error
  } = useGetChallengeActivityData(
    targetUserId,
    challengeId != null ? challengeId : "",
    status,
    sortBy
  );
  const isIdle = simulateIsIdle(isLoading, isSuccess, challengeActivities);
  const { columns, rows } = useTableData(challengeActivities, timeZone);
  if (isError)
    return /* @__PURE__ */ jsx108(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx108(
      ErrorState27,
      {
        error,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx108("br", {}) }
        )
      }
    ) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx108(LoadingIndicator32, { inline: true });
  return /* @__PURE__ */ jsxs76(
    StackLayout62,
    {
      spacing: "$twoAndHalf",
      orientation: "vertical",
      css: { flex: "none", height: "fit-content" },
      children: [
        /* @__PURE__ */ jsxs76(StackLayout62, { spacing: "$one", orientation: "vertical", children: [
          /* @__PURE__ */ jsx108(HeadingText34, { level: "2", size: "md", css: { typography: "$headingTwo" }, children: formatMessage({ id: "RULES" }) }),
          /* @__PURE__ */ jsx108(ParagraphText28, { children: challengeDescription })
        ] }),
        (challengeActivities == null ? void 0 : challengeActivities.length) ? /* @__PURE__ */ jsxs76(
          StackLayout62,
          {
            spacing: "$two",
            orientation: "vertical",
            css: { width: "100%" },
            children: [
              /* @__PURE__ */ jsx108(HeadingText34, { level: "2", size: "md", css: { typography: "$headingTwo" }, children: formatMessage({ id: "ACTIVITIES" }) }),
              /* @__PURE__ */ jsx108(
                CSTable,
                {
                  columns,
                  rows,
                  columnWidth: "150px",
                  rowHeight: "$oneAndHalf"
                }
              )
            ]
          }
        ) : /* @__PURE__ */ jsx108(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx108(
          ErrorState27,
          {
            error: null,
            hideButton: true,
            headingString: formatMessage({ id: "CS_NO_CHALLENGE_ACTIVITIES" }),
            imageSrc: handleStaticAsset15(
              "EMPTY_ICON" /* EMPTY_ICON */
            )
          }
        ) })
      ]
    }
  );
};

// src/pages/member-challenges-detail-page/challenges-side-detail/challenges-side-detail.component.tsx
import { useIntl as useIntl84 } from "@leagueplatform/locales";
import { useParams as useParams5 } from "@leagueplatform/routing";
import {
  LoadingIndicator as LoadingIndicator33,
  ErrorState as ErrorState28
} from "@leagueplatform/web-common-components";
import { StatusBadge as StatusBadge10, UtilityText as UtilityText31 } from "@leagueplatform/genesis-core";

// src/components/user-rank/user-rank.component.tsx
import { Box as Box49, StackLayout as StackLayout63, ParagraphText as ParagraphText29 } from "@leagueplatform/genesis-core";
import { jsx as jsx109, jsxs as jsxs77 } from "react/jsx-runtime";
var UserRank = ({ userRank, rankHeading }) => /* @__PURE__ */ jsxs77(
  StackLayout63,
  {
    orientation: "horizontal",
    verticalAlignment: "center",
    horizontalAlignment: "spaceBetween",
    css: {
      backgroundColor: "$surfaceBackgroundSecondary",
      width: "100%",
      borderRadius: "$medium"
    },
    children: [
      /* @__PURE__ */ jsx109(
        Box49,
        {
          css: {
            padding: "$one"
          },
          children: rankHeading
        }
      ),
      /* @__PURE__ */ jsx109(
        Box49,
        {
          css: {
            padding: "$one"
          },
          children: /* @__PURE__ */ jsx109(ParagraphText29, { css: { typography: "$subtitleTwo" }, children: userRank })
        }
      )
    ]
  }
);

// src/pages/member-challenges-detail-page/hooks/use-get-individual-user-rank.hook.ts
import { useQuery as useQuery23 } from "@tanstack/react-query";
import {
  getIndividualUserRank
} from "@leagueplatform/health-journey-api";
var INDIVIDUAL_USER_RANK_QUERY_KEY = "getIndividualUserRankData";
var useGetIndividualUserRank = (userChallengeId, targetUserId, status2) => {
  const userId = targetUserId;
  const challengeId = userChallengeId;
  return useQuery23(
    [INDIVIDUAL_USER_RANK_QUERY_KEY, challengeId],
    () => getIndividualUserRank(challengeId, userId),
    {
      enabled: status2 !== "enrolled"
    }
  );
};

// src/pages/member-challenges-detail-page/challenges-side-detail/challenges-side-detail.component.tsx
import { Fragment as Fragment21, jsx as jsx110, jsxs as jsxs78 } from "react/jsx-runtime";
var ChallengesSideDetails = ({
  sideDetails,
  targetUserId,
  memberUsername
}) => {
  const { userChallengeId } = useParams5();
  const { formatMessage, formatDate } = useIntl84();
  const {
    status: status2,
    startDate,
    completionDate,
    programId,
    quitDate,
    endDate,
    endEnroll,
    leagueId,
    joinedDate,
    isSoloChallenge
  } = sideDetails;
  const {
    data: userRank,
    isError: isErrorUserRank,
    isLoading: isLoadingUserRank,
    error
  } = useGetIndividualUserRank(userChallengeId != null ? userChallengeId : "", targetUserId, status2);
  const targetId = targetUserId;
  const { fullName, memberRelationship, timeZone, isLoading, isError } = useGetTargetUserInfo(targetId);
  const dateToDisplay = getShortDateTimeZone(timeZone);
  const dateDetails = [
    {
      label: formatMessage({ id: "ACTIVE_PERIOD" }),
      formattedStartDate: formatDate(startDate, dateToDisplay),
      formattedEndDate: formatDate(endDate, dateToDisplay)
    }
  ];
  if (endEnroll) {
    dateDetails.push({
      label: formatMessage({ id: "SIGN_UP_BY_TITLE" }),
      formattedStartDate: formatDate(endEnroll, dateToDisplay)
    });
  }
  if (joinedDate) {
    dateDetails.push({
      label: formatMessage({ id: "JOINED_DATE" }),
      formattedStartDate: formatDate(joinedDate, dateToDisplay)
    });
  }
  const showProgramStatusBadge = useProgramStatusStyles(
    status2,
    timeZone,
    completionDate,
    endDate,
    quitDate,
    isSoloChallenge
  );
  if (isLoadingUserRank)
    return /* @__PURE__ */ jsx110(LoadingIndicator33, { inline: true });
  if (isErrorUserRank)
    return /* @__PURE__ */ jsx110(ErrorState28, { error });
  return /* @__PURE__ */ jsxs78(Fragment21, { children: [
    /* @__PURE__ */ jsx110(
      SideDetailCard,
      {
        header: !isError && !isLoading ? fullName : void 0,
        member: memberRelationship,
        memberUsername
      }
    ),
    /* @__PURE__ */ jsx110(SideDetailCard, { header: formatMessage({ id: "PROGRAM_DATES" }), children: /* @__PURE__ */ jsxs78(Fragment21, { children: [
      dateDetails.map((details) => /* @__PURE__ */ jsx110(ShowDate, { details }, details.label)),
      showProgramStatusBadge && /* @__PURE__ */ jsx110(
        StatusBadge10,
        {
          status: showProgramStatusBadge.badgeStatus,
          label: showProgramStatusBadge.text
        }
      )
    ] }) }),
    (userRank == null ? void 0 : userRank.data.length) ? /* @__PURE__ */ jsx110(SideDetailCard, { header: formatMessage({ id: "MEMBER_RANKING" }), children: /* @__PURE__ */ jsx110(
      UserRank,
      {
        userRank: formatMessage(
          { id: "XTH_PLACE" },
          { currentRank: userRank.data[0].rank }
        ),
        rankHeading: formatMessage({ id: "LEADERBOARD_RANKING" })
      }
    ) }) : null,
    /* @__PURE__ */ jsxs78(SideDetailCard, { header: formatMessage({ id: "IDENTIFICATION" }), children: [
      /* @__PURE__ */ jsx110(UtilityText31, { children: formatMessage(
        { id: "CS_CHALLENGE_ID_UNDERSCORE" },
        {
          programId
        }
      ) }),
      /* @__PURE__ */ jsx110(UtilityText31, { children: formatMessage(
        { id: "CS_LEAGUE_ID_UNDERSCORE" },
        {
          leagueId
        }
      ) })
    ] })
  ] });
};

// src/pages/member-challenges-detail-page/hooks/use-challenge-data.hook.ts
import { useQuery as useQuery24 } from "@tanstack/react-query";
import {
  GET_USER_CHALLENGES as GET_USER_CHALLENGES2,
  getUserChallenge
} from "@leagueplatform/cse-customer-support-api";
var useGetChallengeData = (userId, challengeId) => useQuery24(
  [GET_USER_CHALLENGES2, userId, challengeId],
  () => getUserChallenge(userId, challengeId)
);

// src/pages/member-challenges-detail-page/member-challenges-detail-page.component.tsx
import { jsx as jsx111 } from "react/jsx-runtime";
var ChallengesDetailPage = ({
  targetUserId,
  memberUsername
}) => {
  const { formatMessage } = useIntl85();
  const { challengeId } = useParams6();
  const {
    data: userChallenge,
    isLoading,
    isError,
    isSuccess,
    error
  } = useGetChallengeData(targetUserId, challengeId != null ? challengeId : "");
  const isIdle = simulateIsIdle(isLoading, isSuccess, userChallenge);
  const { timeZone } = useGetTargetUserInfo(targetUserId);
  usePageViewAnalytics13({
    product_area: "customer support" /* CUSTOMER_SUPPORT */,
    sub_product_area: "journey" /* JOURNEY */,
    screen_name: "challenges detail" /* CHALLENGES_DETAIL */
  });
  if (isError)
    return /* @__PURE__ */ jsx111(PageLayout, { children: /* @__PURE__ */ jsx111(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx111(
      ErrorState29,
      {
        error,
        headingString: formatMessage({
          id: "SOMETHING_WENT_WRONG_HEADING"
        }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx111("br", {}) }
        )
      }
    ) }) });
  if (isLoading || isIdle)
    return /* @__PURE__ */ jsx111(PageLayout, { children: /* @__PURE__ */ jsx111(LoadingIndicator34, { inline: true }) });
  const { challenge, joinedDate } = userChallenge.data;
  const isSoloChallenge = challenge.data.challengeType === CHALLENGE_TYPE_SOLO;
  const endEnroll = challenge.data.endEnroll === "0001-01-01T00:00:00Z" ? void 0 : challenge.data.endEnroll;
  return /* @__PURE__ */ jsx111(
    DetailPageWrapper,
    {
      header: /* @__PURE__ */ jsx111(
        DetailsHeader,
        {
          isChallenge: {
            isSoloChallenge
          },
          title: challenge.data.title
        }
      ),
      mainSection: /* @__PURE__ */ jsx111(
        ChallengesSection,
        {
          timeZone,
          challengeDescription: challenge.data.descriptionRichText,
          targetUserId
        }
      ),
      sideDetailSection: /* @__PURE__ */ jsx111(
        ChallengesSideDetails,
        {
          targetUserId,
          memberUsername,
          sideDetails: {
            status: userChallenge.data.status,
            programId: challenge.data.externalCampaignId,
            quitDate: userChallenge.data.quitDate,
            completionDate: userChallenge.data.completedDate,
            endDate: challenge.data.endDate,
            startDate: challenge.data.startDate,
            endEnroll,
            leagueId: challenge.data.id,
            joinedDate,
            isSoloChallenge
          }
        }
      )
    }
  );
};

// src/hooks/use-customer-support-routes.hook.tsx
import { jsx as jsx112 } from "react/jsx-runtime";
var useCustomerSupportRoutes = () => {
  const { formatMessage } = useIntl86();
  const {
    enableWalletInquiry,
    enableClaimsInquiry,
    enableJourneyInquiry,
    enableBiometricsV2
  } = useCustomerSupportConfig();
  const enableMemberOverview = useCustomerSupportConfig("enableMemberOverview");
  const enableAssessmentsAndDashboards = useCustomerSupportConfig(
    "enableAssessmentsAndDashboards"
  );
  const isViewRewardProgramsEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableRewardsProgramsInquiry"
  );
  const isViewChallengesEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableChallengesInquiry"
  );
  const isViewStandardProgramsEnabled = useCustomerSupportConfig(
    "enableJourneyInquiry.enableStandardProgramsInquiry"
  );
  const targetUserId = useTargetUserId();
  const memberUsername = useMemberUsername();
  const entitlements = useEntitlements();
  const hasPermissions = (permissionsToCheck) => permissionsToCheck == null ? void 0 : permissionsToCheck.some(
    (permission) => entitlements == null ? void 0 : entitlements.includes(permission)
  );
  const hasJourneyPermission = hasPermissions(
    CUSTOMER_SUPPORT_PAGE_PERMISSIONS.JOURNEY
  );
  const mainRoutes = [
    {
      label: formatMessage({ id: "OVERVIEW" }),
      content: enableMemberOverview && hasPermissions(CUSTOMER_SUPPORT_PAGE_PERMISSIONS.OVERVIEW) && /* @__PURE__ */ jsx112(
        MemberOverviewPage,
        {
          canShowRecommendedDevice: hasPermissions([
            "customer_apps:read" /* CUSTOMER_APPS */
          ]),
          canShowUserSessions: hasPermissions([
            "user_sessions:read" /* USER_SESSIONS */
          ])
        }
      ),
      path: `${CUSTOMER_SUPPORT_ROUTES.customerSupportOverview}`,
      analytics: "overview"
    },
    {
      label: formatMessage({ id: "ASSESSMENTS_AND_DASHBOARDS" }),
      content: enableAssessmentsAndDashboards && hasPermissions(
        CUSTOMER_SUPPORT_PAGE_PERMISSIONS.ASSESSMENTS_AND_DASHBOARDS
      ) && /* @__PURE__ */ jsx112(
        MemberAssessmentsDashboards,
        {
          canShowConsentForms: hasPermissions([
            "dqm:read" /* CONSENT_FORMS */
          ]),
          canShowAssessments: hasPermissions([
            "dqm:read" /* HEALTH_RISK_ASSESSMENTS */
          ]),
          canShowBiometrics: hasPermissions([
            "health_profile:read" /* HEALTH_PROFILE */
          ])
        }
      ),
      path: `${CUSTOMER_SUPPORT_ROUTES.customerSupportAssessmentsAndDashboards}`,
      analytics: "assessments and dashboard" /* ASSESSMENTS_DASHBOARD */
    },
    {
      label: formatMessage({ id: "WALLET" }),
      content: enableWalletInquiry && hasPermissions(CUSTOMER_SUPPORT_PAGE_PERMISSIONS.WALLET) && /* @__PURE__ */ jsx112(MemberWalletPage, { targetUserId }),
      path: `${CUSTOMER_SUPPORT_ROUTES.customerSupportWallet}`,
      analytics: "wallet"
    },
    {
      label: formatMessage({ id: "CLAIMS" }),
      content: enableClaimsInquiry && hasPermissions(CUSTOMER_SUPPORT_PAGE_PERMISSIONS.CLAIMS) && /* @__PURE__ */ jsx112(MemberClaimsPage, {}),
      path: `${CUSTOMER_SUPPORT_ROUTES.customerSupportClaims}`,
      analytics: "claims" /* CLAIMS_PAGE */
    },
    {
      label: formatMessage({ id: "JOURNEY" }),
      content: enableJourneyInquiry && hasJourneyPermission && /* @__PURE__ */ jsx112(MemberJourneyPage, { targetUserId }),
      path: `${CUSTOMER_SUPPORT_ROUTES.customerSupportJourney}`,
      analytics: "journey" /* JOURNEY */
    }
  ];
  const allowedRoutes = mainRoutes.filter(
    (route) => route.content
  );
  const subRoutes = [
    {
      content: enableBiometricsV2 && hasPermissions(["health_profile:read" /* HEALTH_PROFILE */]) && /* @__PURE__ */ jsx112(MemberBiometricDetailPage, {}),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportBiometricDetails}`
    },
    {
      content: enableWalletInquiry && hasPermissions(CUSTOMER_SUPPORT_PAGE_PERMISSIONS.WALLET) && /* @__PURE__ */ jsx112(MemberWalletDetailPage, {}),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportWalletDetails}`
    },
    {
      content: enableClaimsInquiry && hasPermissions(CUSTOMER_SUPPORT_PAGE_PERMISSIONS.CLAIMS) && /* @__PURE__ */ jsx112(MemberClaimDetailPage, {}),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportClaimDetails}`
    },
    {
      content: enableJourneyInquiry && hasJourneyPermission && /* @__PURE__ */ jsx112(MemberLandingPage, { allowedRoutes }),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportJourneyDetails}`
    },
    {
      content: isViewRewardProgramsEnabled && hasJourneyPermission && /* @__PURE__ */ jsx112(
        MemberRewardsDetailPage,
        {
          targetUserId,
          memberUsername
        }
      ),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportRewardDetails}`
    },
    {
      content: isViewStandardProgramsEnabled && hasJourneyPermission && /* @__PURE__ */ jsx112(
        StandardProgramDetailPage,
        {
          memberUsername,
          targetUserId
        }
      ),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportStandardDetails}`
    },
    {
      content: isViewChallengesEnabled && hasJourneyPermission && /* @__PURE__ */ jsx112(
        ChallengesDetailPage,
        {
          memberUsername,
          targetUserId
        }
      ),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportChallengesDetails}`
    },
    {
      content: /* @__PURE__ */ jsx112(MemberLandingPage, { allowedRoutes }),
      path: `${CUSTOMER_SUPPORT_SUB_ROUTES.customerSupportDefault}`
    }
  ];
  const allowedSubRoutes = subRoutes.filter((route) => route.content);
  return { allowedSubRoutes, allowedRoutes };
};

// src/customer-support.routes.tsx
import { jsx as jsx113, jsxs as jsxs79 } from "react/jsx-runtime";
function useMultipleQueries(...queries) {
  const isLoading = queries.some((query) => query.isLoading);
  const isError = queries.some((query) => query.isError);
  const errors = queries.map((query) => query.error);
  return { isLoading, isError, errors };
}
var CustomerSupportRoutes = () => {
  const { formatMessage } = useIntl87();
  const { pathname } = useLocation7();
  const [basePath] = useState10(() => inferBasePath(pathname));
  const targetUserId = useTargetUserId();
  const { allowedRoutes, allowedSubRoutes } = useCustomerSupportRoutes();
  const { isLoading, isError, errors } = useMultipleQueries(
    useGetTargetUserInfo(targetUserId),
    useCustomerSupportTokenData(),
    useEntitlementData()
  );
  if (isLoading) {
    return /* @__PURE__ */ jsx113(Box50, { css: { minHeight: "100vh" }, children: /* @__PURE__ */ jsx113(LoadingIndicator35, { inline: true }) });
  }
  if (isError) {
    return /* @__PURE__ */ jsx113(BoxBorder, { css: { width: "100%", alignItems: "center" }, children: /* @__PURE__ */ jsx113(
      ErrorState30,
      {
        error: errors,
        headingString: formatMessage({ id: "SOMETHING_WENT_WRONG_HEADING" }),
        bodyString: formatMessage(
          { id: "SOMETHING_WENT_WRONG_BODY" },
          { br: /* @__PURE__ */ jsx113("br", {}) }
        )
      }
    ) });
  }
  return /* @__PURE__ */ jsx113(BasePathProvider, { value: basePath, children: /* @__PURE__ */ jsxs79(Routes, { children: [
    /* @__PURE__ */ jsx113(Route, { index: true, element: /* @__PURE__ */ jsx113(Navigate, { to: allowedRoutes[0].path, replace: true }) }),
    allowedSubRoutes.map((route) => /* @__PURE__ */ jsx113(Route, { path: route.path, element: route.content }, route.path))
  ] }) });
};

// src/locales/en.json
var en_default = {
  CS_AGENT_COMPLETE_ACTIVITY_DATE: "Are you sure you want to mark {activity} as complete on {date}?",
  CS_AGENT_COMPLETE_ACTIVITY: "Are you sure you want to mark {activity} as complete?",
  CS_AGENT_ASSIGN_ACTIVITY_POINTS: "Are you sure you want to assign {points} points for {activity}?",
  CS_CURRENT_OVER_COMPLETED: "<span>{current}</span> / {total} Complete",
  CS_CURRENT_OVER_COMPLETED_ALT: "You have completed {current} out of {total} activities",
  CS_NO_STANDARD_PROGRAMS: "No standard programs available.",
  CS_NO_CHALLENGES: "No challenges available",
  CS_NO_CHALLENGE_ACTIVITIES: "No challenge activities available",
  CS_NO_REWARD_ACTIVITIES: "No reward activities",
  CS_REWARDS_ID_UNDERSCORE: "Rewards_ID: {rewardId}",
  CS_PROGRAM_ID_UNDERSCORE: "Program_ID: {programId}",
  CS_LEAGUE_ID_UNDERSCORE: "League_ID: {leagueId}",
  CS_CHALLENGE_ID_UNDERSCORE: "Challenge_ID: {programId}",
  CS_FORM_NAME: "Name",
  CS_COMPLETION_DATE: "Completion Date",
  CS_VALIDATION_PERIOD: "Validation Period",
  CS_FORM_STATUS: "Status",
  CS_NOT_STARTED_DEFINITION: "Member has not started the task.",
  CS_IN_PROGRESS_DEFINITION: "Member started task but did not complete.",
  CS_COMPLETED_DEFINITION: "Member successfully completed task.",
  CS_REJECTED_DEFINITION: "Member has rejected task.",
  CS_EMPTY_CONSENT_FORMS_TITLE: "No consent forms on file",
  CS_EMPTY_CONSENT_FORMS_BODY: "Note: Member may have a Pending consent form to be completed this year.",
  CS_CONSENT_FORMS: "Consent forms",
  CS_ERROR_HEADING: "Something went wrong",
  CS_ERROR_BODY: "There was a problem loading data. Please try again later.",
  CS_HEALTH_ASSESSMENTS_TITLE: "Health assessments",
  CS_HEALTH_ASSESSMENTS_STATUS_DEFINITIONS: "Health assessment status definitions",
  CS_CONSENT_FORMS_STATUS_DEFINITIONS: "Consent forms status definitions",
  CS_HEALTH_ASSESSMENTS_EMPTY_MESSAGE: "Member does not have any Health Assessments.",
  CS_VALIDATION_PERIOD_ENDED: "Period ended on {date}",
  CS_NO_CONSENTS_IN_VALIDATION_PERIOD: "No Completed or Rejected consent forms within validation period. Member may have a Pending consent form to be completed this year.",
  CS_BIOMETRICS_EMPTY_MESSAGE: "Member does not have any available Biometrics.",
  CS_END_OF_LIST: "You\u2019ve reached the end of the list",
  CS_NO_DATE_AVAILABLE: "No date(s) available",
  CS_MEMBER_IDENTIFICATION: "Member Identification",
  CS_ACTIVITY_OVERRIDE_DATE_PERIOD_EXPIRED: "*Required field, date should be between start date and end date",
  CS_ACTIVITY_OVERRIDE_DATE_PERIOD_ACTIVE: "*Required field, date should be between start date and today",
  CLAIMS_CLAIMS_LIST_HEADING: "Your Claims",
  SHOW: "Show",
  NUMBER_OF_ENTRIES: "{ number } entries",
  WAIST_CIRCUMFERENCE: "Waist Circumference",
  BMI: "BMI",
  BLOOD_PRESSURE: "Blood Pressure",
  TOTAL_CHOLESTEROL: "Total Cholesterol",
  TRIGLYCERIDES: "Triglycerides",
  CHOLESTEROL_HDL: "Cholesterol HDL",
  CHOLESTEROL_LDL: "Cholesterol LDL",
  FASTING_BLOOD_GLUCOSE: "Fasting Blood Glucose",
  NON_FASTING_BLOOD_GLUCOSE: "Non Fasting Blood Glucose",
  SERVICE_DATE: "Service Date",
  LAUNCH_IMPERSONATION_MODE: "Launch user simulation mode",
  OVERRIDE_IS_NOT_ALLOWED_TITLE: "Override is not allowed.",
  OVERRIDE_IS_NOT_ALLOWED_BODY: "This activity is not eligible for additional points according to the rewards logic. Review the activity completion criteria and program structure on the Program Detail Page for further information.",
  SERVICE_NAME: "Service name",
  JOINED_DATE: "Joined Date",
  QUIT: "Quit",
  USERNAME: "Username",
  USER_ID: "User ID",
  PLATFORM: "Platform",
  IN_PROGRESS: "In progress",
  COMMON_PROPERTY_COPIED_TO_CLIPBOARD: "{property} copied to clipboard",
  COMMON_ERROR_COPYING_PROPERTY_TO_CLIPBOARD: "Unable to copy {property} to clipboard",
  COMPLETED_DATE: "Completed {date}",
  COVERAGE_AND_COSTS_TOOLTIP: "Information about services that are covered under the plan, including the cost of services for both in-network and out-of-network providers.",
  ASSESSMENTS_AND_DASHBOARDS: "Assessments & Dashboards",
  CLAIMS_PLAN_PROGRESS: "Plan Progress",
  MEMBER_DESCRIPTION: "Member Description",
  COMPLETION_DATE: "Completion Date",
  COMPLETION_DATE_REQUIRED: "Completion Date*",
  ACTIVITY_POINTS_EARNED_AVAILABLE: "{earned} / {available} Points Earned",
  ACTION_OVERRIDE_COMPLETED_BY: "{waiverCompletedBy, select, other {} bulk {by Bulk Override Tool} waiver {by Waiver Credit Tool }}",
  ACTIVITY_POINTS_UPDATED_WAIVER_CREDIT: "{earned} / {available} Points Earned by Waiver Credit Tool",
  ACTIVITY_POINTS_MISSED: "{available} Points Missed",
  ACTIVITY_POINTS_EARNED: "{earned} Points Earned",
  ACTIVITY_POINTS_ACTIVE: "{available} Points",
  PROGRAM_DATES: "Program Dates",
  ACTIVE_PERIOD: "Active Period",
  OPEN_ACTIVITY_DETAILS_ARIA: "View more program activity details",
  POINTS_ASSIGNED: "Points Assigned",
  DATE_UPDATED: "Date Updated",
  ACTIVITY_STATUS_UPDATED: "Activity status updated",
  VISIBILITY_PERIOD: "Visibility Period",
  NOT_STARTED: "Not Started",
  ACTIVE_ELIGIBLE_CHALLENGES: "Active Eligible Challenges",
  SKIPPED: "Skipped",
  MEMBER_RANKING: "Member Ranking",
  LOCALIZED_DATE_PLACEHOLDER: "MM/DD/YYYY",
  ERROR_UPDATING_DATA: "Error updating data, try again later.",
  ENROLLED: "Enrolled",
  RECEIVED: "Received",
  X_OF_Y_BENEFITS: "showing {visibleAmount} of {totalAmount} benefits",
  VIEW_DEFINITION: "View definition",
  NO_FILTERED_BENEFITS: "We couldn\u2019t find anything matching those filters.",
  NO_BENEFITS_AVAILABLE_HEADING: "No benefits available",
  NO_REWARDS_AVAILABLE_HEADING: "No campaigns available",
  NO_REWARDS_AVAILABLE_BODY: "Member has no rewards at the moment.",
  SOMETHING_WENT_WRONG_HEADING: "Something went wrong",
  SOMETHING_WENT_WRONG_BODY: "There was a problem loading data.{br}Please try again later.",
  MEMBER_ACTIONS: "Member Actions",
  CALL_TO_ACTION_TEXT: "Call to action text",
  QUICK_LINKS_AGENT: "Quick links and documents available to members.",
  DIGITAL_CARD: "Digital Card",
  DIGITAL_CARD_DEFINITION: "Members can also save, print, download, order a new card, or report it as lost or stolen",
  DIGITAL_CARD_FRONT: "Front image of digital card",
  DIGITAL_CARD_BACK: "Back image of digital card",
  NO_DIGITAL_CARD: "No card expected",
  VIEW_BENEFIT_LABEL_HIDDEN: "View member {from} benefit details",
  VIEW_REWARD_LABEL_HIDDEN: "View member reward details for {from} reward program",
  REWARDS_ID: "Rewards Id",
  BIOMETRICS: "Biometrics",
  PROGRAM: "Program",
  ALL_BENEFITS: "All Benefits",
  RECOMMENDED_DEVICE_TITLE: "Recommended web browsers and app versions",
  RECOMMENDED_DEVICE_DESCRIPTION_WEB_BROWSERS: "<strong>Web browsers:</strong> The most recent version of Chrome, Firefox, Safari, or Microsoft Edge",
  RECOMMENDED_DEVICE_DESCRIPTION_APP_VERSION: "<strong>App version:</strong> {primaryName} {primaryCurrentVersion} or {secondaryName} {secondaryCurrentVersion}",
  APP_VERSION: "App Version",
  DEVICE_TITLE_CASE: "Device",
  BENEFIT_TITLE_CASE: "Benefit",
  LAST_ACCESSED: "Last Accessed",
  RECENT_SESSIONS: "Recent Sessions",
  NO_RECENT_SESSIONS: "No Recent Sessions",
  FAQ: "FAQ",
  POLICYHOLDER: "Policyholder",
  DEPENDENT: "Dependent",
  NETWORK_MISSING_COVERAGE_ADMIN: "This plan doesn't have {network} coverage",
  WHAT_TO_DO: "What to do",
  SEARCH_BENEFITS_PLACEHOLDER: "Search benefit or carrier",
  BENEFITS: "Benefits",
  COVERAGE_COSTS: "Coverage and Costs",
  JOURNEY: "Journey",
  REWARDS_PROGRAMS: "Rewards Programs",
  STANDARD_PROGRAMS: "Standard Programs",
  POLICY_INFORMATION: "Policy Information",
  SERVICE: "Service",
  NO_NETWORK: "No Network",
  FEEDBACK_SURVEY_TITLE: "We value your feedback!",
  FEEDBACK_SURVEY_DESCRIPTION: "Have you used the User Simulation mode? Let us know about your experience by answering a 5-minute survey.",
  FEEDBACK_SURVEY_LINK: "Take our short survey",
  LEAGUE: "League",
  COPY_PROPERTY: "Copy {property}",
  COPIED_PROPERTY: "Copied {property}",
  SIGN_OUT: "Sign Out",
  FEEDBACK_SURVEY_SHOW_BANNER_BUTTON_TEXT: "Feedback"
};

// src/locales/locales.ts
var customerSupportAppLocales = {
  default: en_default,
  en: en_default
};

// src/index.ts
initModule();
export {
  CustomerSupportRoutes,
  MemberLandingPage,
  customerSupportAppLocales
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/cse-customer-support'] = window.leagueSDKsPresent['@leagueplatform/cse-customer-support'] || [];
    window.leagueSDKsPresent['@leagueplatform/cse-customer-support'].push('0.2.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/cse-customer-support'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/cse-customer-support module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map